// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseURL: string;
};

export type ErrorResponse400 = {
    statusCode: number;
    message: Array<string> | string;
    error: string;
};

export type HealthResponseDto = {
    status: string;
    buildTime: string;
    commitSha: string;
};

export type LoginDto = {
    email: string;
};

export type GoogleAuthDto = {
    idToken: string;
};

export enum Role {
    ADMIN = 'ADMIN',
    USER = 'USER',
    VIEWER = 'VIEWER',
    GUEST = 'GUEST'
}

export type AuthResponseDto = {
    role?: Role;
    id: number;
    email: string;
    displayName: string;
    picture?: string;
    userPreferences: Array<{
        key: string;
        data: string;
    }>;
};

export type ImpersonateDto = {
    email: string;
};

export type User = {
    id: number;
    email: string;
    name: string;
    picture: string;
    pictureCachedAt: string | null;
    role: string;
    lastForcedLogoutTime: string;
    preferences: Array<UserPreference>;
    aiDailyEurLimit: number | null;
    aiMonthlyEurLimit: number | null;
    bigqueryDailyEurLimit: number | null;
    createdAt: string;
    deletedAt?: string | null;
    deletedByUserId?: number | null;
};

export type UserPreference = {
    id: number;
    user: User;
    key: string;
    data: string;
    updatedAt: string;
};

export type UsersRequestDto = {
    page?: number;
    pageSize?: number;
    search?: string;
    role?: 'ADMIN' | 'USER' | 'VIEWER' | 'GUEST';
    sortBy?: 'lastActiveAt' | 'email' | 'id' | 'name';
    sortOrder?: 'ASC' | 'DESC';
    includeDeleted?: boolean;
};

export type UserDto = {
    id: number;
    email: string;
    name: string;
    picture: string;
    role: string;
    lastForcedLogoutTime: string;
    createdAt: string;
    lastActiveAt?: string | null;
    deletedAt?: string | null;
    /**
     * EUR per UTC day this user may spend on AI. 0 = no AI access; null = inherit the global setting.
     */
    aiDailyEurLimit: number | null;
    /**
     * EUR per UTC month this user may spend on AI. 0 = no AI access; null = inherit the global setting.
     */
    aiMonthlyEurLimit: number | null;
    /**
     * EUR per UTC day this user may spend on BigQuery. 0 = no BigQuery reads; null = inherit the global setting.
     */
    bigqueryDailyEurLimit: number | null;
};

export type UsersResponseDto = {
    total: number;
    users: Array<UserDto>;
};

export type UpdateUserLimitsDto = {
    /**
     * EUR this user may spend on AI per UTC day. 0 = no AI access (the default). null = inherit the global AI_USER_DAILY_EUR_LIMIT setting. Omit to leave unchanged.
     */
    aiDailyEurLimit?: number | null;
    /**
     * EUR this user may spend on AI per UTC month. 0 = no AI access (the default). null = inherit the global AI_USER_MONTHLY_EUR_LIMIT setting. Omit to leave unchanged.
     */
    aiMonthlyEurLimit?: number | null;
    /**
     * EUR this user may spend on BigQuery per UTC day: their Traffic view and the apps connected to their account together. 0 = no BigQuery reads. null = inherit the global BIGQUERY_USER_DAILY_BUDGET_EUR setting (the default). Omit to leave unchanged.
     */
    bigqueryDailyEurLimit?: number | null;
};

export type UpdateUserRoleDto = {
    /**
     * The role to assign. Admin grants every permission there is.
     */
    role: 'ADMIN' | 'USER' | 'VIEWER' | 'GUEST';
};

export type CreateApiTokenDto = {
    name: string;
    content: {
        [key: string]: unknown;
    };
};

export type UpdateApiTokenDto = {
    name?: string;
    content?: {
        [key: string]: unknown;
    };
};

export type ApiTokenDto = {
    id: number;
    name: string;
    content: {
        [key: string]: unknown;
    };
    createdBy: UserDto;
    createdAt: string;
};

export type ApiTokenCreateResponseDto = {
    token: ApiTokenDto;
    /**
     * JWT token string. Only shown once after creation.
     */
    jwt: string;
};

export type UserPreferenceSaveDto = {
    key: string;
    data: string;
};

export type BrandListQueryDto = {
    page?: number;
    pageSize?: number;
};

export enum ImagePresetKey {
    ORIGINAL = 'original',
    TINY = 'tiny',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
    FULL = 'full',
    BACKGROUND = 'background',
    CUSTOM = 'custom'
}

export type CustomImagePresetDto = {
    layout?: 'fixed' | 'fluid';
    width?: number;
    sizes?: string;
    quality?: number;
};

export type ImageFieldType = {
    type: 'image_field';
    id?: string;
    label?: string;
    presetName?: ImagePresetKey;
    customSettings?: CustomImagePresetDto;
    width?: number;
    height?: number;
    mimeType?: string;
};

export type BrandBaseDto = {
    id: number;
    name: string;
    code: string;
    domain: string;
    favicon?: ImageFieldType | null;
};

export type BrandListResponseDto = {
    items: Array<BrandBaseDto>;
};

export type BrandResponseDto = {
    id: number;
    name: string;
    code: string;
    domain: string;
    favicon?: ImageFieldType | null;
    siteBucketName: string;
    cloudfrontDistId: string;
};

export type BrandListPaginatedResponseDto = {
    items: Array<BrandResponseDto>;
    total: number;
};

export type BrandCreateDto = {
    name: string;
    code: string;
    domain: string;
    siteBucketName?: string;
    cloudfrontDistId?: string;
    favicon?: ImageFieldType | null;
};

export type BrandUpdateDto = {
    id: number;
    domain?: string;
    siteBucketName?: string;
    cloudfrontDistId?: string;
    favicon?: ImageFieldType | null;
};

export type RemovePipeLanguageQueryDto = {
    /**
     * Must equal the language code being removed (case-insensitive). Requests that do not match are rejected.
     */
    confirm: string;
};

export type Language = {
    id: number;
    name: string;
};

export type LanguageListResponseDto = {
    items: Array<Language>;
};

export type AddLanguageToPipeDto = {
    /**
     * ID of the language to link to the pipe
     */
    languageId: number;
};

export type Brand = {
    id: number;
    name: string;
    code: string;
    domain: string;
    siteBucketName: string;
    cloudfrontDistId: string;
    favicon?: ImageFieldType | null;
    pipes?: Array<Pipe>;
};

export type Style = {
    [key: string]: unknown;
};

export type NodeAnimationStep = {
    type: 'none' | 'fade' | 'fade-slide' | 'scale' | 'collapse' | 'collapse-fade';
    /**
     * Milliseconds
     */
    duration?: number;
    /**
     * Milliseconds
     */
    delay?: number;
    easing?: 'linear' | 'ease' | 'ease-in' | 'ease-out' | 'ease-in-out';
    /**
     * Travel direction for fade-slide
     */
    direction?: 'up' | 'down' | 'left' | 'right';
    /**
     * Slide travel in px (fade-slide)
     */
    distance?: number;
};

export type NodeAnimation = {
    in?: NodeAnimationStep;
    /**
     * Leave motion. Only ever plays on a rule-driven hide; mirrors `in` when omitted.
     */
    out?: NodeAnimationStep;
    trigger?: 'rule' | 'mount' | 'visible' | 'click';
    repeat?: 'every' | 'once';
    /**
     * Milliseconds added to each direct child's delay, multiplied by its index
     */
    staggerChildren?: number;
};

export type ComponentNode = {
    nodeId: string;
    type: string;
    fields: {
        [key: string]: unknown;
    };
    /**
     * Map of component events
     */
    events: {
        [key: string]: Array<EvalScriptEvent | ExternalNavigationEvent | InternalNavigationEvent | SetDataEvent | ReemitEvent | ComponentProcessorInvocation | ScrollToEvent | ClearAllPipeDataEvent | SubmitFormEvent | SetCookieConsentEvent>;
    };
    rules?: {
        [key: string]: unknown;
    };
    animation?: NodeAnimation;
    /**
     * Slot name in a parent SharedNodeRef to render in
     */
    slot?: string;
    children?: Array<ComponentNode>;
};

export type ComponentSchema = {
    children: Array<ComponentNode>;
};

export enum TranslationMode {
    DOC = 'doc',
    SINGLE = 'single',
    PLAIN = 'plain'
}

export type TranslationKeyField = {
    type: 'translation_key';
    key: string;
    mode?: TranslationMode;
};

export type Page = {
    content: ComponentSchema;
    id: string;
    title?: TranslationKeyField;
    /**
     * SEO meta description for this page
     */
    description?: TranslationKeyField;
    path: string;
    /**
     * Indicates if this page is used as a landing page
     */
    isLanding?: boolean;
    /**
     * Funnel marker keys assigned to this page
     */
    funnelMarkers?: Array<string>;
    /**
     * Page-level event processors keyed by event name (e.g. onPageShow, onPageLeave)
     */
    events?: {
        [key: string]: Array<EvalScriptEvent | ExternalNavigationEvent | InternalNavigationEvent | SetDataEvent | ReemitEvent | ComponentProcessorInvocation | ScrollToEvent | ClearAllPipeDataEvent | SubmitFormEvent | SetCookieConsentEvent>;
    };
};

export type SharedNode = {
    /**
     * Stable unique identifier for the shared node
     */
    id: string;
    /**
     * Display title for the shared node
     */
    title: string;
    /**
     * Component tree for this shared node
     */
    content: ComponentSchema;
    /**
     * When true, this shared node is auto-rendered on every page (a global component)
     */
    isGlobal?: boolean;
    /**
     * Where a global shared node is injected on each page: 'top' (first child, default) or 'bottom' (last child)
     */
    globalPosition?: 'top' | 'bottom';
    /**
     * Page ids on which a global shared node is NOT injected (per-page exceptions, e.g. checkout / plan-selection). Empty/absent = shown on every page.
     */
    excludedPageIds?: Array<string>;
    /**
     * Shared-node-level event processors keyed by event name (e.g. onPageShow, onPageLeave)
     */
    events?: {
        [key: string]: Array<EvalScriptEvent | ExternalNavigationEvent | InternalNavigationEvent | SetDataEvent | ReemitEvent | ComponentProcessorInvocation | ScrollToEvent | ClearAllPipeDataEvent | SubmitFormEvent | SetCookieConsentEvent>;
    };
};

export type PipeLayoutSettings = {
    mode: 'scaled' | 'responsive';
    /**
     * Responsive only. How wide the page may get: `none` (the full screen) or a px width such as `1200px`. Absent means the stylesheet design width (`md-container`).
     */
    maxPageWidth?: string;
};

export type PipeContentData = {
    pages: Array<Page>;
    /**
     * ID of the main landing page that opens with / url, should be one of the page IDs defined in pages array
     */
    landingPageId?: string;
    /**
     * Reusable named component subtrees shared across pages
     */
    sharedNodes?: Array<SharedNode>;
    /**
     * Pipe-wide default document title; used as a fallback when the current page has no title set
     */
    defaultTitle?: TranslationKeyField;
    /**
     * Pipe-wide default SEO meta description; used as a fallback when the current page has no description set
     */
    defaultDescription?: TranslationKeyField;
    /**
     * Pipe-wide SEO meta keywords, comma-separated, for every page; emitted only where the `global.isKeywordsEnabled` constant is true (overridden per distribution)
     */
    defaultKeywords?: TranslationKeyField;
    /**
     * How pages meet the screen: scaled from the design width (absent) or responsive
     */
    layout?: PipeLayoutSettings;
};

export type PipeFlowEditorMetaDto = {
    /**
     * Source page id → the page its default outgoing navigation connector leads to. The pipe-flow canvas lays that page out directly right of its source, on the same row, instead of by its distance to a landing page. One entry per source page, which is what makes 'only one default connector per page' structural.
     */
    defaultNextPageIds?: {
        [key: string]: string;
    };
};

export type PipeEditorMetaDto = {
    flow?: PipeFlowEditorMetaDto;
    /**
     * Pages the author marked as drafts. A draft that no landing page leads to sits in a row of its own in the pipe flow and raises no reachability warning; the editor drops the mark as soon as a landing page leads to the page.
     */
    draftPageIds?: Array<string>;
};

export type PipeContent = {
    id: number;
    pipe: Pipe;
    user: User;
    content: PipeContentData;
    briefData?: {
        [key: string]: unknown;
    } | null;
    editorMeta?: PipeEditorMetaDto | null;
    createdAt: string;
};

export type PipeLanguage = {
    id: number;
    pipe: Pipe;
    language: Language;
    createdAt: string;
    deletedAt?: string | null;
    deletedByUserId?: number | null;
};

export enum ConstVarGroup {
    BRAND = 'brand',
    GROUP = 'group',
    PIPE = 'pipe',
    GLOBAL = 'global',
    SYSTEM = 'system',
    DISTRIBUTION = 'distribution'
}

export enum ConstVarType {
    STRING = 'string',
    NUMBER = 'number',
    INTEGER = 'integer',
    BOOLEAN = 'boolean',
    DATE = 'date',
    STRING_ARRAY = 'string_array',
    INTEGER_ARRAY = 'integer_array',
    OFFER_GROUP = 'offer_group',
    PRICE_CATEGORY = 'price_category',
    OFFER = 'offer',
    OBJECT = 'object',
    DISTRIBUTION_LINKS = 'distribution_links'
}

export type Geography = {
    id: number;
    name: string;
    isDefault: boolean;
};

export type Currency = {
    id: number;
    name: string;
    code: string;
};

export type DistributionStatus = {
    id: number;
    name: string;
    color: string;
    createdAt: string;
};

export type Release = {
    id: number;
    pipe: Pipe;
    distribution: Distribution;
    path: string;
    content: {
        [key: string]: unknown;
    };
    createdAt: string;
    builtAt?: string;
    publishedAt?: string;
    buildStatus?: {
        [key: string]: unknown;
    };
    deployStatus?: {
        [key: string]: unknown;
    };
    deploymentMessage?: string | null;
    rolledBackFromReleaseId?: number | null;
    deployChangesSummary?: {
        [key: string]: unknown;
    } | null;
    buildLog?: string;
    deployLog?: string;
    artifactSize?: string | null;
    buildCommitSha?: string | null;
    buildCommittedAt?: string | null;
    awsBuildId?: string | null;
    awsBuildStartedAt?: string | null;
    awsDeployId?: string | null;
    awsDeployStartedAt?: string | null;
    createdBy: User;
    deletedAt?: string;
};

export type Distribution = {
    id: number;
    pipe: Pipe;
    language: Language;
    geography: Geography;
    currency: Currency;
    status?: DistributionStatus | null;
    name: string;
    landingPageId?: string | null;
    releases?: Array<Release>;
    createdBy: User;
    deletedAt?: string;
};

export type ConstantRevision = {
    id: number;
    constant: Constant;
    action: {
        [key: string]: unknown;
    };
    group: string;
    name: string;
    description?: string | null;
    type: string;
    value?: {
        [key: string]: unknown;
    } | null;
    ref?: {
        [key: string]: unknown;
    } | null;
    config?: {
        [key: string]: unknown;
    } | null;
    brandId?: number | null;
    pipeId?: number | null;
    distributionId?: number | null;
    overridesConstantId?: number | null;
    deletedAt?: string | null;
    user?: User | null;
    actorKind?: {
        [key: string]: unknown;
    } | null;
    createdAt: string;
};

export type Constant = {
    group: ConstVarGroup;
    type: ConstVarType;
    id: number;
    name: string;
    description?: string;
    brand?: Brand;
    pipe?: Pipe;
    distribution?: Distribution;
    overridesConstant?: Constant;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string;
    deletedByUserId?: number;
    config?: {
        [key: string]: unknown;
    } | null;
    value?: {
        [key: string]: unknown;
    };
    ref?: {
        [key: string]: unknown;
    };
    latestRevision?: ConstantRevision | null;
};

export type Pipe = {
    id: number;
    name: string;
    brand: Brand;
    style: Style;
    description?: string;
    latestContent?: PipeContent | null;
    pipeLanguages?: Array<PipeLanguage>;
    constants?: Array<Constant>;
    distributions?: Array<Distribution>;
    disabledIntegrationIds?: Array<number>;
    deletedAt?: string | null;
    deletedByUserId?: number | null;
};

export type LanguageDto = {
    id: number;
    name: string;
};

export type PipeLanguageUsageDto = {
    language: LanguageDto;
    /**
     * Pipe-scoped translation rows in this language that removal would soft-delete. Brand and global rows are shared with other pipes and are never touched.
     */
    translationCount: number;
    /**
     * Live distributions of this pipe in this language. Any at all blocks removal.
     */
    distributionCount: number;
    /**
     * True when this is the pipe’s last language, which blocks removal.
     */
    isLastLanguage: boolean;
    canRemove: boolean;
};

export type RemovePipeLanguageResultDto = {
    language: LanguageDto;
    /**
     * Translation rows soft-deleted with the language.
     */
    removedTranslations: number;
};

export type GeographyCountryDto = {
    id: number;
    code: string;
    name: string;
};

export type GeographyWithCountriesDto = {
    id: number;
    name: string;
    isDefault: boolean;
    countryCount: number;
    countries: Array<GeographyCountryDto>;
};

export type GeographyWithCountriesListDto = {
    items: Array<GeographyWithCountriesDto>;
};

export type SetGeographyCountriesDto = {
    countryIds: Array<number>;
};

export type GeographyDto = {
    id: number;
    name: string;
    isDefault: boolean;
};

export type GeographyListResponseDto = {
    items: Array<GeographyDto>;
};

export type ListLocaleOverridesQueryDto = {
    languageId?: number;
    geographyId?: number;
};

export type CurrencyOverrideEntryDto = {
    symbol?: string;
    code?: string;
};

export type PeriodUnitNamesDto = {
    singular?: string;
    plural?: string;
};

export type NumberFormatConfigDto = {
    decimalSeparator?: string;
    thousandsSeparator?: string;
};

export type CurrencyFormatRulesDto = {
    decimalSeparator?: string;
    thousandsSeparator?: string;
    decimals?: number;
    spaceBetween?: boolean;
    symbolPosition?: 'before' | 'after';
};

export type UnitNamesDto = {
    short?: string;
    long?: string;
};

export type WeightNamesDto = {
    kilogram?: UnitNamesDto;
    pound?: UnitNamesDto;
    /**
     * Whether a (non-breaking) space sits between the number and the unit (`75 kg`). Defaults to true in every locale.
     */
    spaceBetween?: boolean;
};

export type HeightNamesDto = {
    centimeter?: UnitNamesDto;
    foot?: UnitNamesDto;
    inch?: UnitNamesDto;
};

export type PeriodNamesDto = {
    /**
     * Period unit words keyed by canonical unit (`minute`, `day`, `week`, `month`, `year`). Sparse — a unit with no entry keeps its `period.in.*` translation.
     */
    units?: {
        [key: string]: PeriodUnitNamesDto;
    };
    /**
     * Render a `.` directly after the number (`1. month`).
     */
    dotAfterNumber?: boolean;
    /**
     * Whether a (non-breaking) space sits between the number and the unit (`1 month`). Defaults to true.
     */
    spaceBetween?: boolean;
};

export type LocaleConfigDto = {
    number?: NumberFormatConfigDto;
    currencyShort?: CurrencyFormatRulesDto;
    currencyLong?: CurrencyFormatRulesDto;
    weight?: WeightNamesDto;
    height?: HeightNamesDto;
    period?: PeriodNamesDto;
    measurementSystem?: 'metric' | 'imperial';
    /**
     * Per-currency symbol (short) / code (long) overrides, keyed by currency code.
     */
    currencyOverrides?: {
        [key: string]: CurrencyOverrideEntryDto;
    };
};

export type LocaleOverrideDto = {
    id: number;
    language: LanguageDto;
    geography: GeographyDto;
    config: LocaleConfigDto;
    createdAt: string;
    updatedAt: string;
};

export type UpsertLocaleOverrideDto = {
    languageId: number;
    geographyId: number;
    config: LocaleConfigDto;
};

export type TagListQueryDto = {
    page?: number;
    pageSize?: number;
    /**
     * Partial tag name filter
     */
    name?: string;
};

export type Tag = {
    id: number;
    name: string;
};

export type TagsListResponseUnpaginatedDto = {
    items: Array<Tag>;
};

export type TagResponseDto = {
    id: number;
    name: string;
};

export type TagListResponseDto = {
    items: Array<TagResponseDto>;
    total: number;
};

export type TagCreateDto = {
    name: string;
};

/**
 * Which association states count when `pipeId` is given. No effect without it.
 */
export enum MediaPipeUsageFilter {
    ANY = 'any',
    USED = 'used',
    LINKED = 'linked'
}

export type MediaListQueryDto = {
    /**
     * Search query for media items
     */
    query?: string;
    page?: number;
    pageSize?: number;
    /**
     * Restrict to media associated with this pipe, per `media_pipe_link`. Combine with `pipeUsage` to pick which association states count. Omit to list the whole library.
     */
    pipeId?: number;
    /**
     * Which association states count when `pipeId` is given. No effect without it.
     */
    pipeUsage?: MediaPipeUsageFilter;
    /**
     * Match media carrying ANY of these tags (case-insensitive). Tags are platform-written provenance labels — currently only `by-agent`.
     */
    tags?: Array<string>;
};

export type MediaCreateQueryDto = {
    /**
     * Link the uploaded media to this pipe as `linked` (the upload happened inside that pipe's editor). Ignored if the pipe does not exist.
     */
    pipeId?: number;
};

export type MediaResponseDto = {
    id: string;
    originalName: string;
    name: string;
    mimeType: string;
    type: 'image' | 'video' | 'other';
    size: number;
    width?: number;
    height?: number;
    /**
     * Platform-written provenance labels — currently only `by-agent`, stamped on media the AI agent generated or imported. Read-only: no endpoint sets tags from user input.
     */
    tags: Array<string>;
    createdAt: string;
    updatedAt: string;
};

export type MediaListResponseDto = {
    items: Array<MediaResponseDto>;
    total: number;
    page: number;
    pageSize: number;
};

/**
 * `used` — referenced by the pipe's active content version. `linked` — associated with the pipe (uploaded or generated while editing it) but not referenced by its active content, either not yet placed or since removed.
 */
export enum MediaPipeLinkUsage {
    USED = 'used',
    LINKED = 'linked'
}

export type MediaPipeUsageDto = {
    id: number;
    name: string;
    /**
     * The pipe's brand code, for the pill.
     */
    brandCode?: string;
    /**
     * `used` — referenced by the pipe's active content version. `linked` — associated with the pipe (uploaded or generated while editing it) but not referenced by its active content, either not yet placed or since removed.
     */
    usage: MediaPipeLinkUsage;
    /**
     * When the pipe's active content was last seen referencing this media. Absent for a row that has only ever been `linked`; on a `linked` row it is when the image was removed from the pipe.
     */
    lastUsedAt?: string | null;
};

export type MediaPipeUsageListDto = {
    /**
     * How many pipes this media is associated with, in either state. Exact total; `pipes` may be a truncated sample of it.
     */
    pipeCount: number;
    /**
     * How many of those actually use it.
     */
    usedCount: number;
    /**
     * How many hold it without using it (uploaded, or removed).
     */
    linkedCount: number;
    /**
     * `used` first, then name-sorted within each state, capped so a stock image placed in every pipe cannot blow up the dialog. Compare the length against `pipeCount` to tell whether it was truncated.
     */
    pipes: Array<MediaPipeUsageDto>;
};

export type SettingOptionDto = {
    value: string;
    label: string;
};

export type SystemSettingIntegerValueDto = {
    encryptedValue?: string;
    type: 'integer';
    value?: number;
};

export type SystemSettingStringValueDto = {
    encryptedValue?: string;
    type: 'string';
    value?: string;
};

export type SystemSettingMultilineValueDto = {
    encryptedValue?: string;
    type: 'multiline';
    value?: string;
};

export type SystemSettingBooleanValueDto = {
    encryptedValue?: string;
    type: 'boolean';
    value?: boolean;
};

export type SystemSettingNumberValueDto = {
    encryptedValue?: string;
    type: 'number';
    value?: number;
};

export type SystemSettingJsonValueDto = {
    encryptedValue?: string;
    type: 'json';
    value?: {
        [key: string]: unknown;
    };
};

export type DateRangeDto = {
    from: string;
    to: string;
};

export type SystemSettingDateRangeValueDto = {
    encryptedValue?: string;
    type: 'date_range';
    value?: DateRangeDto;
};

export enum SystemSettingType {
    STRING = 'string',
    MULTILINE = 'multiline',
    NUMBER = 'number',
    BOOLEAN = 'boolean',
    INTEGER = 'integer',
    JSON = 'json',
    DATE_RANGE = 'date_range'
}

export type SystemSettingBaseDto = {
    id?: number;
    /**
     * Dot object string, lowercase
     */
    name: string;
    label: string;
    description: string;
    type: SystemSettingType;
    /**
     * System-managed setting — listed and viewable, but read-only (the API rejects writes).
     */
    systemOnly?: boolean;
    /**
     * Closed set of allowed values. Present → the admin renders a dropdown instead of a free-text input, and the API rejects any value outside this list.
     */
    options?: Array<SettingOptionDto>;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value: SystemSettingIntegerValueDto | SystemSettingStringValueDto | SystemSettingMultilineValueDto | SystemSettingBooleanValueDto | SystemSettingNumberValueDto | SystemSettingJsonValueDto | SystemSettingDateRangeValueDto;
};

export type SystemSettingsListResponseDto = {
    items: Array<SystemSettingBaseDto>;
};

export type SystemSettingsFrontendItemDto = {
    name: string;
    /**
     * Parsed primitive value (string | number | boolean | object | null).
     */
    value: {
        [key: string]: unknown;
    };
};

export type SystemSettingsFrontendListResponseDto = {
    items: Array<SystemSettingsFrontendItemDto>;
};

export type UpdateSystemSettingDto = {
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value: SystemSettingIntegerValueDto | SystemSettingStringValueDto | SystemSettingMultilineValueDto | SystemSettingBooleanValueDto | SystemSettingNumberValueDto | SystemSettingJsonValueDto | SystemSettingDateRangeValueDto;
};

/**
 * Keep only pipes with at least one live distribution in the Draft or Active status (`draft_or_active`), or in the Active status (`active`). The same statuses as the list response `draftStatus` / `activeStatus`.
 */
export enum PipeListDistributionStatusFilter {
    ALL = 'all',
    DRAFT_OR_ACTIVE = 'draft_or_active',
    ACTIVE = 'active'
}

export type PipeListQueryDto = {
    /**
     * Also return deleted pipes. Off by default.
     */
    includeDeleted?: boolean;
    brandId?: number;
    nameQuery?: string;
    hasActiveIngressDestination?: boolean;
    /**
     * Keep only pipes with at least one live distribution in the Draft or Active status (`draft_or_active`), or in the Active status (`active`). The same statuses as the list response `draftStatus` / `activeStatus`.
     */
    distributionStatus?: PipeListDistributionStatusFilter;
    contentUpdatedById?: number;
    page?: number;
    pageSize?: number;
};

export type PipeByIdsQueryDto = {
    ids: Array<number>;
};

export type PipeFindAllQueryDto = {
    /**
     * Also return deleted pipes. Off by default.
     */
    includeDeleted?: boolean;
};

export type PipeNameDto = {
    id: number;
    name: string;
};

export type PipeContentDto = {
    id: number;
    content: PipeContentData;
    editorMeta?: PipeEditorMetaDto | null;
};

export type StyleDataDto = {
    'color-primary-100': StyleColorRecordDto | StyleColorRefDto;
    'color-primary-200': StyleColorRecordDto | StyleColorRefDto;
    'color-primary-300': StyleColorRecordDto | StyleColorRefDto;
    'color-primary-400': StyleColorRecordDto | StyleColorRefDto;
    'color-primary-500': StyleColorRecordDto | StyleColorRefDto;
    'color-primary-600': StyleColorRecordDto | StyleColorRefDto;
    'color-primary-700': StyleColorRecordDto | StyleColorRefDto;
    'color-primary-800': StyleColorRecordDto | StyleColorRefDto;
    'color-primary-900': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-100': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-200': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-300': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-400': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-500': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-600': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-700': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-800': StyleColorRecordDto | StyleColorRefDto;
    'color-secondary-900': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-100': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-200': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-300': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-400': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-500': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-600': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-700': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-800': StyleColorRecordDto | StyleColorRefDto;
    'color-tertiary-900': StyleColorRecordDto | StyleColorRefDto;
    'color-white': StyleColorRecordDto | StyleColorRefDto;
    'color-black': StyleColorRecordDto | StyleColorRefDto;
    'color-grey-100': StyleColorRecordDto | StyleColorRefDto;
    'color-grey-200': StyleColorRecordDto | StyleColorRefDto;
    'color-grey-300': StyleColorRecordDto | StyleColorRefDto;
    'color-grey-400': StyleColorRecordDto | StyleColorRefDto;
    'color-grey-500': StyleColorRecordDto | StyleColorRefDto;
    'color-grey-600': StyleColorRecordDto | StyleColorRefDto;
    'color-warning-100': StyleColorRecordDto | StyleColorRefDto;
    'color-warning-200': StyleColorRecordDto | StyleColorRefDto;
    'color-warning-300': StyleColorRecordDto | StyleColorRefDto;
    'color-warning-400': StyleColorRecordDto | StyleColorRefDto;
    'color-warning-500': StyleColorRecordDto | StyleColorRefDto;
    'color-warning-600': StyleColorRecordDto | StyleColorRefDto;
    'color-success-100': StyleColorRecordDto | StyleColorRefDto;
    'color-success-200': StyleColorRecordDto | StyleColorRefDto;
    'color-success-300': StyleColorRecordDto | StyleColorRefDto;
    'color-success-400': StyleColorRecordDto | StyleColorRefDto;
    'color-success-500': StyleColorRecordDto | StyleColorRefDto;
    'color-success-600': StyleColorRecordDto | StyleColorRefDto;
    'color-danger-100': StyleColorRecordDto | StyleColorRefDto;
    'color-danger-200': StyleColorRecordDto | StyleColorRefDto;
    'color-danger-300': StyleColorRecordDto | StyleColorRefDto;
    'color-danger-400': StyleColorRecordDto | StyleColorRefDto;
    'color-danger-500': StyleColorRecordDto | StyleColorRefDto;
    'color-danger-600': StyleColorRecordDto | StyleColorRefDto;
    'color-background-page': StyleColorRecordDto | StyleColorRefDto;
    'color-background-surface': StyleColorRecordDto | StyleColorRefDto;
    'color-background-surface-raised': StyleColorRecordDto | StyleColorRefDto;
    'color-background-subtle': StyleColorRecordDto | StyleColorRefDto;
    'color-background-inverse': StyleColorRecordDto | StyleColorRefDto;
    'color-background-backdrop': StyleColorRecordDto | StyleColorRefDto;
    'color-background-subtle-accent': StyleColorRecordDto | StyleColorRefDto;
    'color-text-primary': StyleColorRecordDto | StyleColorRefDto;
    'color-text-accent': StyleColorRecordDto | StyleColorRefDto;
    'color-text-secondary': StyleColorRecordDto | StyleColorRefDto;
    'color-text-tertiary': StyleColorRecordDto | StyleColorRefDto;
    'color-text-placeholder': StyleColorRecordDto | StyleColorRefDto;
    'color-text-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-text-inverse': StyleColorRecordDto | StyleColorRefDto;
    'color-text-link': StyleColorRecordDto | StyleColorRefDto;
    'color-text-link-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-icon-default': StyleColorRecordDto | StyleColorRefDto;
    'color-icon-accent': StyleColorRecordDto | StyleColorRefDto;
    'color-icon-subtle': StyleColorRecordDto | StyleColorRefDto;
    'color-icon-inverse': StyleColorRecordDto | StyleColorRefDto;
    'color-icon-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-border-default': StyleColorRecordDto | StyleColorRefDto;
    'color-border-accent': StyleColorRecordDto | StyleColorRefDto;
    'color-border-subtle': StyleColorRecordDto | StyleColorRefDto;
    'color-border-inverse': StyleColorRecordDto | StyleColorRefDto;
    'color-border-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-background': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-background-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-background-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-background-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-text': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-text-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-text-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-text-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-border': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-border-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-primary-border-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-background': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-background-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-background-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-background-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-text': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-text-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-text-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-text-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-border': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-border-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-secondary-border-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-background': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-background-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-background-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-background-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-text': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-text-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-text-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-text-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-border': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-border-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-action-tertiary-border-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-error-background': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-error-subtle': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-error-text': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-error-text-on-bg': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-error-icon': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-error-border': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-warning-background': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-warning-subtle': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-warning-text': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-warning-text-on-bg': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-warning-icon': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-warning-border': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-success-background': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-success-subtle': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-success-text': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-success-text-on-bg': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-success-icon': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-success-border': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-info-background': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-info-subtle': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-info-text': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-info-text-on-bg': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-info-icon': StyleColorRecordDto | StyleColorRefDto;
    'color-feedback-info-border': StyleColorRecordDto | StyleColorRefDto;
    'color-input-background-default': StyleColorRecordDto | StyleColorRefDto;
    'color-input-background-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-input-background-active': StyleColorRecordDto | StyleColorRefDto;
    'color-input-background-error': StyleColorRecordDto | StyleColorRefDto;
    'color-input-background-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-input-text': StyleColorRecordDto | StyleColorRefDto;
    'color-input-text-accent': StyleColorRecordDto | StyleColorRefDto;
    'color-input-text-placeholder': StyleColorRecordDto | StyleColorRefDto;
    'color-input-text-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-input-border': StyleColorRecordDto | StyleColorRefDto;
    'color-input-border-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-input-border-active': StyleColorRecordDto | StyleColorRefDto;
    'color-input-border-error': StyleColorRecordDto | StyleColorRefDto;
    'color-input-border-disabled': StyleColorRecordDto | StyleColorRefDto;
    'color-nav-background': StyleColorRecordDto | StyleColorRefDto;
    'color-nav-item-text-default': StyleColorRecordDto | StyleColorRefDto;
    'color-nav-item-text-hover': StyleColorRecordDto | StyleColorRefDto;
    'color-nav-item-text-pressed': StyleColorRecordDto | StyleColorRefDto;
    'color-nav-progress-bar': StyleColorRecordDto | StyleColorRefDto;
    'color-nav-progress-track': StyleColorRecordDto | StyleColorRefDto;
    'color-nav-progress-text-value': StyleColorRecordDto | StyleColorRefDto;
    'color-nav-item-icon': StyleColorRecordDto | StyleColorRefDto;
    'color-brand-primary': StyleColorRecordDto | StyleColorRefDto;
    'color-brand-primary-subtle': StyleColorRecordDto | StyleColorRefDto;
    'color-brand-secondary': StyleColorRecordDto | StyleColorRefDto;
    'color-brand-secondary-subtle': StyleColorRecordDto | StyleColorRefDto;
    'font-family-heading': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'font-family-body': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'font-weight-regular': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'font-weight-medium': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'font-weight-black': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'font-size-xxs': StyleSizeRecordDto | StyleSizeRefDto;
    'font-size-xs': StyleSizeRecordDto | StyleSizeRefDto;
    'font-size-sm': StyleSizeRecordDto | StyleSizeRefDto;
    'font-size-md': StyleSizeRecordDto | StyleSizeRefDto;
    'font-size-lg': StyleSizeRecordDto | StyleSizeRefDto;
    'font-size-xl': StyleSizeRecordDto | StyleSizeRefDto;
    'font-size-xxl': StyleSizeRecordDto | StyleSizeRefDto;
    'font-size-xxxl': StyleSizeRecordDto | StyleSizeRefDto;
    'font-size-xxxxl': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-xxs': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-xs': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-sm': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-md': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-lg': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-xl': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-xxl': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-xxxl': StyleSizeRecordDto | StyleSizeRefDto;
    'line-height-xxxxl': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-1-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-heading-1-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-heading-1-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-1-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-1-color': StyleColorRecordDto | StyleColorRefDto;
    'text-heading-2-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-heading-2-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-heading-2-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-2-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-2-color': StyleColorRecordDto | StyleColorRefDto;
    'text-heading-3-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-heading-3-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-heading-3-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-3-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-3-color': StyleColorRecordDto | StyleColorRefDto;
    'text-heading-4-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-heading-4-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-heading-4-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-4-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-heading-4-color': StyleColorRecordDto | StyleColorRefDto;
    'text-body-lg-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-body-lg-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-body-lg-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-body-lg-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-body-lg-color': StyleColorRecordDto | StyleColorRefDto;
    'text-body-md-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-body-md-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-body-md-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-body-md-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-body-md-color': StyleColorRecordDto | StyleColorRefDto;
    'text-body-sm-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-body-sm-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-body-sm-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-body-sm-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-body-sm-color': StyleColorRecordDto | StyleColorRefDto;
    'text-label-md-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-label-md-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-label-md-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-label-md-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-label-md-color': StyleColorRecordDto | StyleColorRefDto;
    'text-label-sm-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-label-sm-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-label-sm-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-label-sm-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-label-sm-color': StyleColorRecordDto | StyleColorRefDto;
    'text-caption-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-caption-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-caption-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-caption-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-caption-color': StyleColorRecordDto | StyleColorRefDto;
    'text-button-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-button-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-button-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-button-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-button-color': StyleColorRecordDto | StyleColorRefDto;
    'text-input-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-input-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-input-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-input-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-input-color': StyleColorRecordDto | StyleColorRefDto;
    'text-link-family': StyleTypographyRecordDto | StyleFontFamilyRefDto;
    'text-link-weight': StyleFontWeightRecordDto | StyleFontWeightRefDto;
    'text-link-size': StyleSizeRecordDto | StyleSizeRefDto;
    'text-link-line-height': StyleSizeRecordDto | StyleSizeRefDto;
    'text-link-color': StyleColorRecordDto | StyleColorRefDto;
    'space-2': StyleSizeRecordDto | StyleSizeRefDto;
    'space-4': StyleSizeRecordDto | StyleSizeRefDto;
    'space-8': StyleSizeRecordDto | StyleSizeRefDto;
    'space-12': StyleSizeRecordDto | StyleSizeRefDto;
    'space-16': StyleSizeRecordDto | StyleSizeRefDto;
    'space-20': StyleSizeRecordDto | StyleSizeRefDto;
    'space-24': StyleSizeRecordDto | StyleSizeRefDto;
    'space-28': StyleSizeRecordDto | StyleSizeRefDto;
    'space-32': StyleSizeRecordDto | StyleSizeRefDto;
    'space-40': StyleSizeRecordDto | StyleSizeRefDto;
    'space-48': StyleSizeRecordDto | StyleSizeRefDto;
    'space-56': StyleSizeRecordDto | StyleSizeRefDto;
    'space-64': StyleSizeRecordDto | StyleSizeRefDto;
    'space-96': StyleSizeRecordDto | StyleSizeRefDto;
    'space-128': StyleSizeRecordDto | StyleSizeRefDto;
    'max-container': StyleSizeRecordDto | StyleSizeRefDto;
    'md-container': StyleSizeRecordDto | StyleSizeRefDto;
    'sm-container': StyleSizeRecordDto | StyleSizeRefDto;
    'page-width-mobile': StyleSizeRecordDto | StyleSizeRefDto;
    'page-width-tablet': StyleSizeRecordDto | StyleSizeRefDto;
    'page-width-desktop': StyleSizeRecordDto | StyleSizeRefDto;
    'border-width': StyleSizeRecordDto | StyleSizeRefDto;
    'border-color': StyleColorRecordDto | StyleColorRefDto;
    'radius-xs': StyleSizeRecordDto | StyleSizeRefDto;
    'radius-sm': StyleSizeRecordDto | StyleSizeRefDto;
    'radius-md': StyleSizeRecordDto | StyleSizeRefDto;
    'radius-lg': StyleSizeRecordDto | StyleSizeRefDto;
    'radius-xl': StyleSizeRecordDto | StyleSizeRefDto;
    'shadow-lg': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-md': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-sm': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-accent-lg': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-accent-md': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-accent-sm': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-accent-lg': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-accent-md': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-accent-sm': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-cta-button-default': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-cta-button-hover': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-cta-button-pressed': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-modal': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-surface-raised': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-surface': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-selectors-default': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-selectors-pressed': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-glow-modal': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-glow-surface-raised': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-glow-surface': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-input-hover': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-glow-cta-button-default': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-glow-cta-button-hover': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-glow-cta-button-pressed': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-glow-modal': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-glow-surface-raised': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-glow-surface': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-accent-modal': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-accent-surface-raised': StyleShadowRecordDto | StyleShadowRefDto;
    'shadow-inner-accent-surface': StyleShadowRecordDto | StyleShadowRefDto;
};

export type StyleDto = {
    /**
     * Name of the style
     */
    name: string;
    /**
     * Style data as JSON
     */
    data: StyleDataDto;
    /**
     * Raw CSS appended after the generated :root { --... } block
     */
    baseCss?: string;
    /**
     * Head records emitted into <head> at runtime (unhead compatible)
     */
    headRecords: Array<HeadRecordGoogleFontDto | HeadRecordAdobeFontDto | HeadRecordRawLinkDto | HeadRecordRawScriptDto>;
    /**
     * ID of the style
     */
    id: number;
};

export type PipeRuleGroupDto = {
    id: number;
    /**
     * Scope this group lives at. Only `pipe` rows are editable from the pipe editor; `brand` / `global` are inherited and read-only here.
     */
    group: 'pipe' | 'brand' | 'global';
    /**
     * camelCase dot-notation identifier, unique per scope — same grammar as a constant or variable name. Immutable after create: it is half of the reference key stored inside pipe content.
     */
    name: string;
    /**
     * The `{scope}.{name}` reference key, i.e. what a `{ ruleGroup: … }` leaf holds. Denormalized so the editor never rebuilds it and never disagrees with the server about the grammar.
     */
    key: string;
    description?: string;
    /**
     * json-logic rule tree (JsonEngineNode)
     */
    rules?: {
        [key: string]: unknown;
    };
};

export type PipeFullReleaseDto = {
    id: number;
    name: string;
    brand: BrandBaseDto;
    description?: string;
    latestContent?: PipeContentDto;
    styleId: number;
    style: StyleDto;
    disabledIntegrationIds?: Array<number>;
    /**
     * When the pipe was deleted. A deleted pipe is hidden from pipe lists and pickers, everything else keeps working. Null for a live pipe.
     */
    deletedAt?: string | null;
    ruleGroups?: Array<PipeRuleGroupDto>;
    /**
     * Translations in the format Record<key, object>
     */
    translation: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    /**
     * Language name for the full pipe response. Translation will be returned for this language
     */
    language: string;
    /**
     * Currency code for the full pipe response, e.g. USD, EUR
     */
    currency: string;
    /**
     * Whether the release language is right-to-left. Surfaced to the runtime as system.isRtl and var.global.isRtl. Defaults to false for releases built before RTL support.
     */
    isRtl?: boolean;
    /**
     * Constants in the format Record<key, object>
     */
    constants: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    /**
     * Per-variable default values resolved for this distribution (per-distribution override beats per-pipe default), keyed by "group.name". Only variables with a configured default appear. Seeded into the runtime as var.{group}.{name} when not already persisted.
     */
    variables: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    /**
     * Integrations in the format IntegrationsBaseDto[]
     */
    integrations: Array<IntegrationsBaseDto>;
    /**
     * Geography name for the full pipe response
     */
    geography: string;
    /**
     * Distribution name for the full pipe response - part of the path
     */
    distributionName: string;
    /**
     * Path for the full pipe response, used for release content /{prefix}/{geography}-{language}/{distributionName}/
     */
    distributionPath: string;
    /**
     * Distribution id this release was built for. Surfaced to the runtime as system.distributionId.
     */
    distributionId?: number;
    /**
     * Release id of the build that produced this bundle. Surfaced to the runtime as system.buildId. Stamped at fetch time, not at create time, so it reflects the persisted release row.
     */
    buildId?: number;
    /**
     * Resolved (single-currency) locale config override for this distribution: deep-partial number/currency/unit/measurement config, with the per-currency symbol/code already flattened to this distribution currency. Empty object when no override is configured. Consumed by the render engine via const.system.localeConfig.
     */
    localeConfig?: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
};

export type PipeLanguageDto = {
    id: number;
    pipeId: number;
    language: LanguageDto;
    createdAt: string;
    /**
     * Number of distributions of this pipe in this language. Populated by the pipes list endpoint; absent on other endpoints that return PipeListItemDto.
     */
    distributionCount?: number;
};

export type UserPartialDto = {
    id: number;
    email: string;
    name: string;
};

export type PipeListItemDto = {
    id: number;
    name: string;
    brand: BrandBaseDto;
    description?: string;
    styleId: number;
    style: StyleDto;
    disabledIntegrationIds?: Array<number>;
    /**
     * When the pipe was deleted. A deleted pipe is hidden from pipe lists and pickers, everything else keeps working. Null for a live pipe.
     */
    deletedAt?: string | null;
    ruleGroups?: Array<PipeRuleGroupDto>;
    pipeLanguages: Array<PipeLanguageDto>;
    contentUpdatedAt: string | null;
    contentUpdatedBy: UserPartialDto | null;
    /**
     * Number of this pipe's distributions that have an active ingress destination. Populated by the pipes list endpoint; 0 on other endpoints that return PipeListItemDto.
     */
    activeIngressDistributionCount: number;
    /**
     * Number of this pipe's distributions in the Draft status (the list response's `draftStatus`). Populated by the pipes list endpoint; 0 on other endpoints that return PipeListItemDto.
     */
    draftStatusDistributionCount: number;
    /**
     * Number of this pipe's distributions in the Active status (the list response's `activeStatus`). Populated by the pipes list endpoint; 0 on other endpoints that return PipeListItemDto.
     */
    activeStatusDistributionCount: number;
    /**
     * Who deleted the pipe. Populated by the pipes list endpoint for a deleted pipe; null everywhere else.
     */
    deletedBy: UserPartialDto | null;
};

export type DistributionStatusDto = {
    id: number;
    name: string;
    color: string;
    createdAt: string;
};

export type PipeListPaginatedResponseDto = {
    items: Array<PipeListItemDto>;
    total: number;
    /**
     * The status counted by `draftStatusDistributionCount` and matched by the `draft_or_active` filter; null when no status is named Draft.
     */
    draftStatus: DistributionStatusDto | null;
    /**
     * The status counted by `activeStatusDistributionCount` and matched by the `active` and `draft_or_active` filters; null when no status is named Active.
     */
    activeStatus: DistributionStatusDto | null;
};

export type PipeSearchQueryDto = {
    nameQuery?: string;
    brandId?: number;
    page?: number;
    pageSize?: number;
};

export type PipeSearchItemDto = {
    id: number;
    name: string;
    brandName: string | null;
};

export type PipeSearchResponseDto = {
    items: Array<PipeSearchItemDto>;
    total: number;
};

export type PipeFullReleaseRequestDto = {
    /**
     * Language name for the full pipe request. Translation will be returned for this language
     */
    language: string;
    /**
     * Geography name for the full pipe request
     */
    geography: string;
    /**
     * Currency code for the full pipe request, e.g. USD, EUR
     */
    currency: string;
    /**
     * Distribution name for the full pipe request - part of the path
     */
    distributionName: string;
    /**
     * Path for the full pipe request, used for release content /{prefix}/{geography}-{language}/{distributionName}/
     */
    distributionPath: string;
    /**
     * Distribution id this release was built for. Surfaced on built bundles as system.distributionId.
     */
    distributionId?: number;
    /**
     * Whether the release language is right-to-left. Derived from the language code (RTL_LANGUAGE_CODES) and surfaced to the runtime as system.isRtl / var.global.isRtl.
     */
    isRtl?: boolean;
    /**
     * Per-distribution landing-page override: the id of the page (flagged `isLanding`) to use as this distribution's landing. When set and valid, the built snapshot's `content.landingPageId` points at it so the distribution's root `/` renders that page. Falls back to the pipe default when invalid.
     */
    landingPageIdOverride?: string;
};

export type PipePopulatedConstantsQueryDto = {
    /**
     * Currency code used to resolve reference-type constants. Defaults to the configured pipe default when omitted.
     */
    currency?: string;
};

export type PipePopulatedConstantsDto = {
    /**
     * Map keyed by `{group}.{name}` with reference constants populated for the requested currency.
     */
    constants: {
        [key: string]: ConstantsBaseDto;
    };
};

export type PipeAvailableCurrencyCodesDto = {
    /**
     * All unique currency codes for this pipe distributions (always includes usd)
     */
    codes: Array<string>;
};

export type PipeAvailableGeographyCodesDto = {
    /**
     * All unique geography names across this pipe distributions
     */
    codes: Array<string>;
};

export type PipePageRefDto = {
    id: string;
    path: string;
    /**
     * Whether the page is flagged as a landing page in the editor
     */
    isLanding?: boolean;
};

export type PipeContentHistoryQueryDto = {
    skip?: number;
    take?: number;
};

export type PipeContentHistoryUserDto = {
    id: number;
    name: string;
    picture: string;
};

export type PipeContentHistoryItemDto = {
    id: number;
    createdAt: string;
    user?: PipeContentHistoryUserDto | null;
};

export type PipeContentHistoryListDto = {
    items: Array<PipeContentHistoryItemDto>;
    total: number;
    latestContentId: number | null;
};

export type PipeContentDiffRequestDto = {
    /**
     * Saved pipe_content id for the base side.
     */
    baseContentId?: number;
    baseContent?: PipeContentData;
    /**
     * Saved pipe_content id for the target side.
     */
    targetContentId?: number;
    targetContent?: PipeContentData;
};

export type PageRefDto = {
    id: string;
    path: string;
};

export type ComponentSummaryDto = {
    nodeId: string;
    type: string;
    /**
     * Descendant node count under this subtree root.
     */
    descendantCount: number;
};

export type ValueChangeDto = {
    from?: string | null;
    to?: string | null;
};

export type ComponentChangeDto = {
    nodeId: string;
    type: string;
    changedFields: Array<string>;
    eventsChanged: boolean;
    rulesChanged: boolean;
    animationChanged: boolean;
    slotChanged: boolean;
    moved: boolean;
    typeChanged?: ValueChangeDto;
};

export type PageDiffDto = {
    id: string;
    path: string;
    added: Array<ComponentSummaryDto>;
    removed: Array<ComponentSummaryDto>;
    modified: Array<ComponentChangeDto>;
    pathChanged?: ValueChangeDto;
    titleChanged: boolean;
    funnelMarkersChanged: boolean;
    isLandingChanged: boolean;
    eventsChanged: boolean;
};

export type PagesDiffGroupDto = {
    added: Array<PageRefDto>;
    removed: Array<PageRefDto>;
    modified: Array<PageDiffDto>;
};

export type SharedNodeRefDto = {
    id: string;
    title: string;
};

export type SharedNodeDiffDto = {
    id: string;
    title: string;
    added: Array<ComponentSummaryDto>;
    removed: Array<ComponentSummaryDto>;
    modified: Array<ComponentChangeDto>;
    titleChanged: boolean;
    eventsChanged: boolean;
};

export type SharedNodesDiffGroupDto = {
    added: Array<SharedNodeRefDto>;
    removed: Array<SharedNodeRefDto>;
    modified: Array<SharedNodeDiffDto>;
};

export type PipeContentDiffDto = {
    pages: PagesDiffGroupDto;
    sharedNodes: SharedNodesDiffGroupDto;
    landingPageChanged?: ValueChangeDto;
    defaultTitleChanged: boolean;
    isEmpty: boolean;
    /**
     * True when the diff could not be computed (malformed/legacy row).
     */
    unavailable: boolean;
};

export type UpdateStyleDto = {
    /**
     * Name of the style
     */
    name: string;
    /**
     * Style data as JSON
     */
    data: StyleDataDto;
    /**
     * Raw CSS appended after the generated :root { --... } block
     */
    baseCss?: string;
    /**
     * Head records emitted into <head> at runtime (unhead compatible)
     */
    headRecords: Array<HeadRecordGoogleFontDto | HeadRecordAdobeFontDto | HeadRecordRawLinkDto | HeadRecordRawScriptDto>;
};

export type PipeStyleDiffRequestDto = {
    /**
     * The editor's current (unsaved) stylesheet — the target side.
     */
    targetStyle: UpdateStyleDto;
};

export type PipeStyleUsageDto = {
    id: number;
    name: string;
    /**
     * The pipe's brand code, for the pill.
     */
    brandCode?: string;
};

export type StyleTokenChangeDto = {
    /**
     * Design-token key, e.g. `color-brand-primary`.
     */
    key: string;
    /**
     * Rendered previous value (`16px`, `#fff`, `var(--color-primary-500)`). Absent on an added token or an unreadable value.
     */
    from?: string;
    /**
     * Rendered next value.
     */
    to?: string;
};

export type StyleTokensBucketDto = {
    added: Array<StyleTokenChangeDto>;
    removed: Array<StyleTokenChangeDto>;
    modified: Array<StyleTokenChangeDto>;
};

export type PipeStyleDiffDto = {
    /**
     * Id of the stylesheet this pipe points at.
     */
    styleId: number;
    /**
     * Its current (saved) name.
     */
    styleName: string;
    /**
     * How many OTHER pipes point at this same stylesheet. Stylesheets are shared, so a non-zero count means this save also restyles those pipes. This is the true total; `otherPipes` may be a truncated sample of it.
     */
    otherPipeCount: number;
    /**
     * Those pipes, name-sorted, capped so a legacy stylesheet shared by dozens of pipes cannot blow up the dialog. Compare the length against `otherPipeCount` to tell whether it was truncated.
     */
    otherPipes: Array<PipeStyleUsageDto>;
    nameChanged?: ValueChangeDto;
    tokens: StyleTokensBucketDto;
    baseCssChanged: boolean;
    /**
     * Fonts / raw `<link>` / `<script>` head records.
     */
    headRecordsChanged: boolean;
    /**
     * True when nothing differs.
     */
    isEmpty: boolean;
    /**
     * One-line digest, e.g. `4 style tokens changed`.
     */
    summary: string;
};

export type InternalNavigationEventData = {
    /**
     * Target page ID to navigate to
     */
    pageId: string;
    /**
     * URL anchor tag
     */
    anchor?: string;
};

export type InternalNavigationEvent = {
    type: 'navigate';
    /**
     * Target page ID and URL anchor tag to navigate to
     */
    data: InternalNavigationEventData;
    rules?: {
        [key: string]: unknown;
    };
};

export type ExternalNavigationEvent = {
    type: 'navigate_external';
    /**
     * URL to navigate to
     */
    data: string;
    rules?: {
        [key: string]: unknown;
    };
};

export type EvalScriptEvent = {
    type: 'eval_script';
    /**
     * JS Script to evaluate
     */
    data: string;
    rules?: {
        [key: string]: unknown;
    };
};

export type SetDataPayload = {
    /**
     * Key to set data for
     */
    key: string;
    /**
     * Value to set
     */
    value: string | number;
};

export type SetDataEvent = {
    type: 'set_data';
    data: SetDataPayload;
    rules?: {
        [key: string]: unknown;
    };
};

export type ReemitEvent = {
    type: 'reemit';
    /**
     * Name of the event to reemit on the parent SharedNodeRef
     */
    data: string;
    rules?: {
        [key: string]: unknown;
    };
};

export type ClearAllPipeDataEvent = {
    type: 'clear_all_pipe_data';
    /**
     * No data — kept for discriminated-union uniformity
     */
    data: {
        [key: string]: unknown;
    };
    rules?: {
        [key: string]: unknown;
    };
};

export type ComponentProcessorInvocationData = {
    /**
     * Name of the processor as declared in the target component definition (e.g. "start")
     */
    processor: string;
    /**
     * The target component type (mirrors ComponentNode.type) — kept on the invocation so the editor can regenerate dropdown entries and detect orphans after schema changes
     */
    componentType: string;
    /**
     * Path to the target: [...sharedNodeRefAncestorIds, targetNodeId]. Single-element path = target on the current (page or shared-template) tree root.
     */
    targetPath: Array<string>;
    /**
     * Per-processor user-configured values (structure defined by the target definition's processors.<name>.fields)
     */
    config?: {
        [key: string]: unknown;
    };
};

export type ComponentProcessorInvocation = {
    type: 'component_processor';
    data: ComponentProcessorInvocationData;
    rules?: {
        [key: string]: unknown;
    };
};

export type ScrollToEventData = {
    /**
     * Path to the target: [...sharedNodeRefAncestorIds, targetNodeId]. Same shape as ComponentProcessorInvocationData.targetPath.
     */
    targetPath: Array<string>;
    behavior: 'smooth' | 'instant';
    /**
     * Where the target lands in the viewport: start = top, center = middle, end = bottom, nearest = scroll only if not already in view.
     */
    position: 'start' | 'center' | 'end' | 'nearest';
};

export type ScrollToEvent = {
    type: 'scroll_to';
    data: ScrollToEventData;
    rules?: {
        [key: string]: unknown;
    };
};

export type SubmitFormEvent = {
    type: 'submit_form';
    /**
     * No data — the source instance key resolves the form group at runtime
     */
    data: {
        [key: string]: unknown;
    };
    rules?: {
        [key: string]: unknown;
    };
};

export type SetCookieConsentEventData = {
    /**
     * Cookie-consent decision to apply. 'granted'/'denied' record the choice (dedicated localStorage key + Google Consent Mode update) and hide the banner; 'undecided' re-opens it (clears the stored decision).
     */
    decision: 'granted' | 'denied' | 'undecided';
};

export type SetCookieConsentEvent = {
    type: 'set_cookie_consent';
    data: SetCookieConsentEventData;
    rules?: {
        [key: string]: unknown;
    };
};

export type ComponentField = {
    type: string;
    label: string;
    /**
     * Can be any valid JSON value
     */
    defaultValue?: string | number | unknown | boolean | {
        [key: string]: unknown;
    } | Array<unknown>;
    props?: {
        [key: string]: unknown;
    };
};

export type ComponentDefinitionEvent = {
    /**
     * Label for the event
     */
    label: string;
};

export type ComponentPresetDefinition = {
    /**
     * Name of the preset
     */
    name: string;
    /**
     * Preset field values, should match the component field definitions
     */
    fields: {
        [key: string]: unknown;
    };
};

export type ComponentDefinitionProcessor = {
    /**
     * Human-readable label for the processor
     */
    label: string;
    /**
     * Per-invocation configurable fields (edited by the user when they attach this processor to an event)
     */
    fields?: {
        [key: string]: ComponentField;
    };
};

export type ComponentDefinition = {
    /**
     * Map of component fields
     */
    fields: {
        [key: string]: ComponentField;
    };
    /**
     * Map of component events
     */
    events?: {
        [key: string]: ComponentDefinitionEvent;
    };
    /**
     * Processors this component exposes to be invoked via component_processor events by other components
     */
    processors?: {
        [key: string]: ComponentDefinitionProcessor;
    };
    /**
     * Allowed children components
     */
    allowChildren?: Array<string> | 'all';
    /**
     * Additional presets for this component
     */
    presets?: Array<ComponentPresetDefinition>;
};

export type FieldBase = {
    type: string;
};

export type StyleColorRecordDto = {
    type: 'color';
    data: string;
};

export type ColorFieldRaw = {
    type: 'color_raw';
    data: StyleColorRecordDto;
};

export type ColorFieldStyle = {
    type: 'color_style';
    key: string;
};

export type ColorFieldConstant = {
    type: 'color_constant';
    key: string;
};

export type StyleSizeRecordDto = {
    type: 'size';
    data: string;
    unit: 'px' | 'rem' | 'em' | '%' | '';
};

export type SizeFieldRaw = {
    type: 'size_raw';
    data: StyleSizeRecordDto;
};

export type SizeFieldStyle = {
    type: 'size_style';
    key: string;
};

export type SizeFieldConstant = {
    type: 'size_constant';
    key: string;
};

export type RadiusSeparateCornersField = {
    type: 'separate_corners';
    topLeft?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
    topRight?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
    bottomRight?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
    bottomLeft?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
};

export type ShadowFieldStyle = {
    type: 'shadow_style';
    key: string;
};

export type SpacingAllField = {
    type: 'all';
    all?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
};

export type SpacingTwoSidesField = {
    type: 'two_sides';
    horizontal?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
    vertical?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
};

export type SpacingSeparateSidesField = {
    type: 'separate_sides';
    top?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
    right?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
    bottom?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
    left?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
};

export type ConstantKeyField = {
    type: 'constant_key';
    key: string;
};

export type ConstVarKeyField = {
    type: 'constvar_key';
    key: string;
};

export type VariableKeyField = {
    type: 'variable_key';
    key: string;
};

export type TextMultiselectOption = {
    type: 'text_multiselect_option';
    id: string;
    value: string;
    label: TranslationKeyField;
};

export type TextMultiselectOptionsField = {
    type: 'text_multiselect_options';
    options: Array<TextMultiselectOption>;
};

export type VideoFieldType = {
    type: 'video_field';
    id?: string;
    label?: string;
};

export type OptionSelectOption = {
    type: 'option_select_option';
    id: string;
    value: string;
    label: TranslationKeyField;
    subtext?: TranslationKeyField;
    imagePrimary?: ImageFieldType;
    imageSecondary?: ImageFieldType;
    onSelectBehavior?: string;
    onSelectBehaviorExceptions?: Array<string>;
};

export type OptionSelectOptionsField = {
    type: 'option_select_options';
    options: Array<OptionSelectOption>;
};

export type WalkingLevelStop = {
    type: 'walking_level_stop';
    id: string;
    label: TranslationKeyField;
};

export type WalkingLevelStopsField = {
    type: 'walking_level_stops';
    stops: Array<WalkingLevelStop>;
};

export type ConditionalBadge = {
    id: string;
    /**
     * A TranslationKeyField
     */
    text?: TranslationKeyField;
    rules?: {
        [key: string]: unknown;
    };
};

export type ConditionalBadgesField = {
    type: 'conditional_badges';
    items: Array<ConditionalBadge>;
};

export type PlanSelectionOption = {
    type: 'plan_selection_option';
    id: string;
    offerGroup?: ConstantKeyField;
    categoryKey?: string;
    label: TranslationKeyField;
    badgeVisibility?: 'off' | 'on';
    conditionalBadges?: ConditionalBadgesField;
};

export type PlanSelectionOptionsField = {
    type: 'plan_selection_options';
    options: Array<PlanSelectionOption>;
    defaultOptionId?: string;
};

export type SelectListOption = {
    type: 'select_list_option';
    id: string;
    value: string;
    label: TranslationKeyField;
    image?: ImageFieldType;
    /**
     * A ColorField (color_raw | color_style | color_constant)
     */
    imageBackgroundColor?: {
        [key: string]: unknown;
    };
    /**
     * Multi-select only: "select_all" (a Select All option), "deselect_all" (a None option) or "none" / unset (a regular option)
     */
    onSelectBehavior?: string;
};

export type SelectListOptionsField = {
    type: 'select_list_options';
    options: Array<SelectListOption>;
};

export type ListItem = {
    type: 'list_item';
    id: string;
    text: TranslationKeyField;
};

export type ListItemsField = {
    type: 'list_items';
    items: Array<ListItem>;
};

export type IconListItem = {
    type: 'icon_list_item';
    id: string;
    icon: ImageFieldType;
    heading?: TranslationKeyField;
    body?: TranslationKeyField;
};

export type IconListItemsField = {
    type: 'icon_list_items';
    items: Array<IconListItem>;
};

export type ChatBubble = {
    type: 'chat_bubble';
    id: string;
    text: TranslationKeyField;
    rules?: {
        [key: string]: unknown;
    };
};

export type ChatQuestionOption = {
    type: 'chat_question_option';
    id: string;
    label: TranslationKeyField;
    value: string;
};

export type NutritionistChatMessage = {
    type: 'nutritionist_chat_message';
    id: string;
    replies: Array<ChatBubble>;
    replyVariable?: VariableKeyField;
    replyOptions?: Array<ChatQuestionOption>;
};

export type NutritionistChatMessagesField = {
    type: 'nutritionist_chat_messages';
    messages: Array<NutritionistChatMessage>;
};

export type GradientStop = {
    /**
     * A ColorField (color_raw | color_style | color_constant)
     */
    color?: {
        [key: string]: unknown;
    };
    /**
     * Stop position along the gradient, 0-100
     */
    position: number;
};

export type LinearGradientField = {
    type: 'linear_gradient';
    /**
     * Gradient angle in degrees
     */
    angle: number;
    stops: Array<GradientStop>;
};

export type SlotItemConfig = {
    id: string;
    /**
     * A SizeField
     */
    size?: {
        [key: string]: unknown;
    };
};

export type SlotItemsConfigField = {
    type: 'slot_items_config';
    items: Array<SlotItemConfig>;
};

export type ResponsiveGridBreakpoint = {
    /**
     * One column track size per column of a row: `1fr`, `2fr`, `240px`, `30%`, `12rem`.
     */
    tracks?: Array<string>;
    maxWidth?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
    gap?: SizeFieldRaw | SizeFieldStyle | SizeFieldConstant;
};

export type ResponsiveGridField = {
    type: 'responsive_grid';
    mobile?: ResponsiveGridBreakpoint;
    tablet?: ResponsiveGridBreakpoint;
    desktop?: ResponsiveGridBreakpoint;
};

export type LegacyColumnsConfigItem = {
    id: string;
    /**
     * CSS track size string, or a SizeField
     */
    width?: {
        [key: string]: unknown;
    };
};

export type LegacyColumnsConfigField = {
    type: 'columns_config';
    items: Array<LegacyColumnsConfigItem>;
};

export type TabItemConfig = {
    id: string;
    /**
     * A TranslationKeyField
     */
    title?: TranslationKeyField;
};

export type TabItemsConfigField = {
    type: 'tab_items_config';
    items: Array<TabItemConfig>;
};

export type CarouselSlideConfig = {
    id: string;
};

export type CarouselSlidesConfigField = {
    type: 'carousel_slides_config';
    items: Array<CarouselSlideConfig>;
};

export type BmiVisualStop = {
    type: 'bmi_visual_stop';
    id: string;
    /**
     * BMI value this stop sits at
     */
    value: number;
    /**
     * A TranslationKeyField
     */
    label?: TranslationKeyField;
};

export type BmiVisualStopsField = {
    type: 'bmi_visual_stops';
    stops: Array<BmiVisualStop>;
};

export type SteppedSliderStop = {
    type: 'stepped_slider_stop';
    id: string;
    /**
     * Value written to the bound variable at this stop
     */
    value: number;
    /**
     * An ImageFieldType
     */
    sprite?: ImageFieldType;
};

export type SteppedSliderStopsField = {
    type: 'stepped_slider_stops';
    stops: Array<SteppedSliderStop>;
};

export type SelectFieldProps = {
    type: string;
    options: Array<{
        value: string;
        label: string;
    }>;
    defaultOption?: string;
};

export type SelectField = {
    type: 'select';
    props: SelectFieldProps;
};

export type PipeContentCreateDto = {
    content: PipeContentData;
};

export type PipeCreateDto = {
    name: string;
    description?: string;
    latestContent: PipeContentCreateDto;
    brandId: number;
    styleId: number;
};

export type PipeDto = {
    id: number;
    name: string;
    brand: BrandBaseDto;
    description?: string;
    latestContent?: PipeContentDto;
    styleId: number;
    style: StyleDto;
    disabledIntegrationIds?: Array<number>;
    /**
     * When the pipe was deleted. A deleted pipe is hidden from pipe lists and pickers, everything else keeps working. Null for a live pipe.
     */
    deletedAt?: string | null;
    ruleGroups?: Array<PipeRuleGroupDto>;
};

export type PipeFullExtendedQueryDto = {
    /**
     * Filter by languages
     */
    languages?: Array<string>;
    /**
     * Currency code used to resolve reference-type constants (e.g. OFFER_GROUP). Defaults to the configured pipe default when omitted.
     */
    currency?: string;
};

export type PipeSaveNoticesDto = {
    /**
     * Rule groups this save did not write because they were deleted after this editor loaded them. Their edits were dropped.
     */
    refusedRuleGroupNames: Array<string>;
    /**
     * Translations this save did not write, as `<language>:<key>`, because they were deleted after this editor loaded them. Their edits were dropped.
     */
    refusedTranslationKeys: Array<string>;
};

export type PipeFullExtendedDto = {
    pipe: PipeDto;
    /**
     * Translations modifications
     */
    translations?: {
        [key: string]: {
            [key: string]: SimpleTranslationDto;
        };
    };
    constants: {
        [key: string]: ConstantsBaseDto;
    };
    integrations: {
        [key: string]: IntegrationsBaseDto;
    };
    variables: {
        [key: string]: VariableBaseDto;
    };
    /**
     * All unique currency codes for this pipe distributions (always includes usd)
     */
    availableCurrencyCodes?: Array<string>;
    saveNotices?: PipeSaveNoticesDto;
};

export type SimpleTranslationDto = {
    content: {
        [key: string]: unknown;
    };
    mode: TranslationMode;
    id?: number | null;
    latestRevisionId?: number | null;
};

export type TranslationRevisionUserDto = {
    id: number;
    name: string;
    picture: string;
};

export type TranslationConflictRevisionDto = {
    id: number;
    createdAt: string;
    user?: TranslationRevisionUserDto | null;
};

export type TranslationConflictItemDto = {
    language: string;
    /**
     * `group.name` translation key.
     */
    key: string;
    /**
     * Your edited value.
     */
    mine: SimpleTranslationDto;
    /**
     * Current server value.
     */
    theirs: SimpleTranslationDto;
    theirsRevision: TranslationConflictRevisionDto;
};

export type TranslationSaveConflictDto = {
    translationConflict: true;
    conflicts: Array<TranslationConflictItemDto>;
};

export type VariableVisibilityConfigDto = {
    /**
     * Whether this variable is offered in the visibility-rule picker
     */
    show?: boolean;
    /**
     * Predefined value pool for the visibility rule picker. Strings for string-typed variables, numbers for number/integer-typed variables.
     */
    options?: Array<string | number>;
};

export type VariableConfigDto = {
    visibility?: VariableVisibilityConfigDto;
};

export type CreateVariableDto = {
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    config?: VariableConfigDto;
};

export type PipeMinimalDto = {
    id: number;
    name: string;
    description?: string;
};

export type ConstantVisibilityConfigDto = {
    /**
     * Whether this constant is offered in the visibility-rule picker
     */
    show?: boolean;
    /**
     * Predefined value pool for the visibility rule picker. Strings for string-typed constants, numbers for number/integer-typed constants.
     */
    options?: Array<string | number>;
};

export type ConstantConfigDto = {
    visibility?: ConstantVisibilityConfigDto;
};

export type CreateConstantDto = {
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    brand?: BrandBaseDto;
    pipe?: PipeMinimalDto;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto | ConstantOfferGroupValueDto | ConstantPriceCategoryValueDto | ConstantDistributionLinksValueDto;
    /**
     * Reference configuration object. Required for reference constants, forbidden for statics.
     */
    ref?: {
        [key: string]: unknown;
    };
    config?: ConstantConfigDto;
};

export type PipeSaveVariableUpdateDto = {
    id: number;
    config?: VariableConfigDto;
};

export type PipeSaveConstantUpdateDto = {
    type: ConstVarType;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto | ConstantOfferGroupValueDto | ConstantPriceCategoryValueDto | ConstantDistributionLinksValueDto;
    /**
     * Reference configuration object. Required for reference constants, forbidden for statics.
     */
    ref?: {
        [key: string]: unknown;
    };
    config?: ConstantConfigDto;
    id: number;
};

export type RuleGroupWriteDto = {
    /**
     * camelCase dot-notation identifier, unique within the pipe. Immutable: a row whose name is not already present is created, never renamed.
     */
    name: string;
    description?: string;
    /**
     * json-logic rule tree (JsonEngineNode)
     */
    rules?: {
        [key: string]: unknown;
    };
    group?: 'pipe';
};

export type PipeUpdateDto = {
    id: number;
    name: string;
    description?: string;
    latestContent: PipeContentDto;
    /**
     * Translations modifications
     */
    translations?: {
        [key: string]: {
            [key: string]: SimpleTranslationDto;
        };
    };
    /**
     * Per modified translation key (Record<lang, Record<key, revisionId|null>>), the TranslationRevision id the editor loaded — used for per-key override detection.
     */
    translationBases?: {
        [key: string]: {
            [key: string]: number | null;
        };
    };
    newVariables?: Array<CreateVariableDto>;
    /**
     * Constants the editor created in the buffer (cross-pipe paste migration, the inline "add" in PipeConstantSelect, an agent import). Created inside the save transaction, exactly like newVariables — before this field existed they were written to the buffer and silently dropped on save.
     */
    newConstants?: Array<CreateConstantDto>;
    /**
     * Existing pipe-scoped variable definitions the editor changed in the buffer — today the visibility-rule tester's config. Applied in the save transaction, and refused for any row that is not this pipe's own.
     */
    updatedVariables?: Array<PipeSaveVariableUpdateDto>;
    /**
     * Existing pipe-scoped constants the editor changed in the buffer — their value or ref, and the visibility-rule tester's config. Before this field existed the buffer took the edit, the preview showed it and the save dropped it.
     */
    updatedConstants?: Array<PipeSaveConstantUpdateDto>;
    styleId: number;
    /**
     * The pipe's stylesheet as edited in the editor's Theme tab. Written to the `style` row `styleId` points at — and ONLY when `styleChanged` is true, so a content-only save can never clobber a stylesheet another author changed in the meantime. A stylesheet is shared by every pipe pointing at it, so this write is visible to all of them.
     */
    style?: UpdateStyleDto;
    /**
     * Whether the editor actually changed the stylesheet. The client compares its loaded vs current style in one representation (same reasoning as `contentChanged`) and additionally requires that the pipe still points at the stylesheet it edited. When false/omitted the `style` payload is ignored and the row is left untouched.
     */
    styleChanged?: boolean;
    /**
     * The pipe's OWN (`group='pipe'`) rule groups as they stand in the editor — the full replace-set, not a delta. Written in this save's own transaction and ONLY when `ruleGroupsChanged` is true. Inherited brand/global groups are never included: they are read-only here, and including them would invite a pipe save to rewrite a row other pipes share.
     */
    ruleGroups?: Array<RuleGroupWriteDto>;
    /**
     * Whether the editor actually changed the pipe-scoped rule groups. Same contract as `styleChanged`: when false/omitted the `ruleGroups` payload is ignored entirely, and the client OMITS it rather than sending it to be dropped — `@ValidateNested()` is unconditional, so one malformed group left in the editor buffer would 400 the whole save and take the author's pages and translations with it.
     */
    ruleGroupsChanged?: boolean;
    /**
     * The pipe-scoped rule-group names this editor LOADED. The reconcile deletes `loaded − submitted`, never `db − submitted`: every editor tab is a stale snapshot, so a db-based delete-set would turn any tab left open into a mass-delete of every group created since it loaded. Falls back to the db names only when omitted (non-editor clients).
     */
    loadedRuleGroupNames?: Array<string>;
    loadedLanguageKeys?: Array<string>;
    disabledIntegrationIds?: Array<number>;
    /**
     * Force the save even if a newer version exists, overwriting the intervening work. Set after the user confirms the conflict dialog.
     */
    force?: boolean;
    /**
     * Whether the editor actually changed pipe CONTENT (vs only translations/variables). The client computes this by comparing its loaded vs current content in one representation, avoiding server-side serialize/transform asymmetry. When false, no content version is written and the content conflict is skipped, so translation-only saves never trip it. Falls back to a server-side diff when omitted.
     */
    contentChanged?: boolean;
};

export type PipeSaveConflictDto = {
    conflict: true;
    /**
     * The content version the editor was based on.
     */
    baseContentId: number;
    /**
     * The content version currently latest in the DB.
     */
    currentContentId: number;
    changes: Array<PipeContentHistoryItemDto>;
};

export type PipeTransferBundleRequestDto = {
    /**
     * Take everything on this page of the source pipe. Mutually exclusive with nodeIds / sharedNodeIds.
     */
    pageId?: string;
    /**
     * Take these component subtrees. An id whose ancestor is also listed is dropped server-side.
     */
    nodeIds?: Array<string>;
    /**
     * Take these User Component templates as import roots (their own dependencies travel too).
     */
    sharedNodeIds?: Array<string>;
    /**
     * Include the source page's own events bucket (onPageShow / onPageLeave / onExitIntent). Only meaningful with pageId.
     */
    includePageEvents?: boolean;
};

export type PipeTransferBundleMetaDto = {
    /**
     * Component nodes in the selection, templates included.
     */
    nodeCount: number;
    /**
     * Stylesheet keys the selection names. They resolve against the TARGET pipe’s stylesheet — that is what makes an import re-skin.
     */
    styleKeys: Array<string>;
    /**
     * Media ids the selection references that exist in the library.
     */
    mediaIdsPresent: Array<string>;
    /**
     * Referenced media ids with no row — those images render nothing.
     */
    mediaIdsMissing: Array<string>;
    /**
     * navigate target page ids in the selection. Any that the target pipe does not have are stripped on import.
     */
    navigatePageIds: Array<string>;
    externalProcessorPaths: Array<Array<string>>;
    /**
     * Path of the source page, when one was selected.
     */
    sourcePagePath?: string;
    /**
     * The source pipe’s stylesheet id.
     */
    sourceStyleId?: number;
    /**
     * The source page’s own events, when includePageEvents was set. The human clipboard never copies these (it operates on subtrees); for "replicate this page" they are usually wanted.
     */
    pageEvents?: {
        [key: string]: unknown;
    };
};

export type PipeTransferBundleDto = {
    /**
     * Matches CLIPBOARD_VERSION in the editor.
     */
    version: number;
    copiedAt: string;
    sourcePipeId: number;
    sourceBrandId?: number;
    /**
     * The selected component subtrees, with their original node ids.
     */
    components: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Every User Component template the selection reaches, transitively.
     */
    sharedNodes: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Every rule group the selection references, transitively. Carried verbatim (ids included) because a { ruleGroup: id } reference resolves by id alone.
     */
    ruleGroups: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Referenced variable definitions from the source pipe, keyed by name.
     */
    variables: {
        [key: string]: unknown;
    };
    /**
     * Referenced constants from the source pipe, keyed by name.
     */
    constants: {
        [key: string]: unknown;
    };
    /**
     * Referenced translations, ALL languages the source pipe has: Record<lang, Record<key, {content, mode}>>. The editor only ever loads one language, so this is the only place the rest come from.
     */
    translations: {
        [key: string]: unknown;
    };
    meta: PipeTransferBundleMetaDto;
};

export type PipeCopyRequestDto = {
    name: string;
    targetBrandId?: number | null;
};

export enum PipeCopyItemKind {
    VARIABLE = 'variable',
    CONSTANT = 'constant',
    RULE_GROUP = 'rule_group'
}

export enum PipeCopyItemReason {
    MISSING = 'missing',
    TYPE_MISMATCH = 'type_mismatch',
    RULES_DIFFER = 'rules_differ'
}

export type PipeCopyPreviewItemDto = {
    kind: PipeCopyItemKind;
    name: string;
    type?: ConstVarType | null;
    reason: PipeCopyItemReason;
    existingType?: ConstVarType | null;
};

export type PipeCopyPreviewDto = {
    sourcePipeName: string;
    sourceBrandId: number;
    targetBrandId: number;
    crossBrand: boolean;
    nameConflict: boolean;
    itemsToCreate: Array<PipeCopyPreviewItemDto>;
    itemsWithTypeMismatch: Array<PipeCopyPreviewItemDto>;
};

export type TranslationQueryDto = {
    /**
     * Filter by language name
     */
    language?: string;
    /**
     * Scope to translations belonging to this pipe (group=pipe AND pipe_id=:pipeId), plus globals, plus brand-scoped if brandId is also given.
     */
    pipeId?: number;
    /**
     * Brand id used together with pipeId to additionally include brand-scoped (group=brand AND brand_id=:brandId) translations.
     */
    brandId?: number;
};

export type TranslationListQueryDto = {
    page?: number;
    pageSize?: number;
    /**
     * Filter by language name
     */
    language?: string;
};

export type FetchTranslationsForKeysResponseDto = {
    /**
     * Translations grouped by language name then by key (`group.name`). Languages with no rows for the requested keys are omitted.
     */
    translations: {
        [key: string]: {
            [key: string]: SimpleTranslationDto;
        };
    };
};

export type TranslationRevisionItemDto = {
    id: number;
    createdAt: string;
    user?: TranslationRevisionUserDto | null;
};

export type TranslationRevisionListDto = {
    items: Array<TranslationRevisionItemDto>;
    total: number;
    latestRevisionId: number | null;
};

export enum TranslationGroup {
    BRAND = 'brand',
    GROUP = 'group',
    PIPE = 'pipe',
    GLOBAL = 'global',
    SYSTEM = 'system'
}

export type TranslationDto = {
    language: LanguageDto;
    name: string;
    content: {
        [key: string]: unknown;
    };
    group: TranslationGroup;
    brandId?: number;
    pipeId?: number;
    mode: TranslationMode;
    id: number;
    /**
     * Id of the current TranslationRevision (per-key version pointer).
     */
    latestRevisionId?: number | null;
};

export type TranslationListPaginatedResponseDto = {
    items: Array<TranslationDto>;
    total: number;
};

export enum TranslationListScope {
    GLOBAL = 'global',
    BRAND = 'brand',
    PIPE = 'pipe'
}

export type TranslationKeyListQueryDto = {
    scope?: TranslationListScope;
    /**
     * With `scope=brand`: only this brand's keys.
     */
    brandId?: number;
    /**
     * With `scope=pipe`: only this pipe's keys.
     */
    pipeId?: number;
    /**
     * One phrase, case- and whitespace-insensitive, matched against the dotted key (`.`/`-`/`_` also read as spaces) and against the copy of the requested languages — the same rules as the pipe editor's translations filter.
     */
    search?: string;
    /**
     * Language names to return copy for. `en` is always included, first.
     */
    languages?: Array<string>;
    mode?: TranslationMode;
    /**
     * Only keys that have no copy in this language yet.
     */
    missingLanguage?: string;
    page?: number;
    pageSize?: number;
};

export type TranslationKeyCellDto = {
    id: number;
    content: {
        [key: string]: unknown;
    };
    latestRevisionId?: number | null;
};

export type TranslationKeyBrandDto = {
    id: number;
    name: string;
    code: string;
};

export type TranslationKeyPipeDto = {
    id: number;
    name: string;
    brandCode?: string | null;
};

export type TranslationKeyListItemDto = {
    /**
     * `group.name`, as content references it.
     */
    key: string;
    group: TranslationGroup;
    name: string;
    mode: TranslationMode;
    brandId?: number | null;
    pipeId?: number | null;
    brand?: TranslationKeyBrandDto;
    pipe?: TranslationKeyPipeDto;
    /**
     * Every language the key has copy in, not only the requested ones.
     */
    languages: Array<string>;
    /**
     * Copy by language name — requested languages that have it.
     */
    translations: {
        [key: string]: TranslationKeyCellDto;
    };
};

export type TranslationKeyListResponseDto = {
    items: Array<TranslationKeyListItemDto>;
    total: number;
};

export type SaveTranslationKeyCellDto = {
    /**
     * Language name, e.g. `de`.
     */
    language: string;
    /**
     * TipTap document.
     */
    content: {
        [key: string]: unknown;
    };
    /**
     * The revision this copy was edited from; `null` when the language had no copy. The save is refused when the key has changed since. Omit to overwrite unconditionally.
     */
    baseRevisionId?: number | null;
};

export type SaveTranslationKeyDto = {
    /**
     * One of `global`, `brand`, `pipe`.
     */
    group: TranslationGroup;
    name: string;
    brandId?: number;
    pipeId?: number;
    /**
     * Must be the key's existing mode — a key's mode never changes.
     */
    mode: TranslationMode;
    translations: Array<SaveTranslationKeyCellDto>;
};

export type TranslationKeyConflictDto = {
    statusCode: number;
    message: string;
    /**
     * The languages whose copy changed since it was loaded.
     */
    languages: Array<string>;
};

export type TranslationRevisionDto = {
    id: number;
    content: {
        [key: string]: unknown;
    };
    mode: TranslationMode;
};

export type CreateTranslationDto = {
    name: string;
    content: {
        [key: string]: unknown;
    };
    group: TranslationGroup;
    brandId?: number;
    pipeId?: number;
    mode: TranslationMode;
    languageId: number;
};

export type UpdateTranslationDto = {
    name: string;
    content: {
        [key: string]: unknown;
    };
    group: TranslationGroup;
    brandId?: number;
    pipeId?: number;
    mode: TranslationMode;
    id: number;
    languageId: number;
};

export type BulkUpsertTranslationsDto = {
    /**
     * Translations in the format Record<language, Record<key, SimpleTranslationDto>>>, where the key is the translation name and the value is the translation content and mode.
     */
    translations: {
        [key: string]: {
            [key: string]: SimpleTranslationDto;
        };
    };
};

export type FetchTranslationsForKeysDto = {
    /**
     * Pipe id whose pipe-scoped translations should be included.
     */
    pipeId: number;
    /**
     * Optional brand id to also include brand-scoped translations for these keys.
     */
    brandId?: number;
    /**
     * List of translation keys to fetch, each in `group.name` form (e.g. `pipe.offerTitle`).
     */
    keys: Array<string>;
};

/**
 * Which definitions to list. Without it, `brandId` / `pipeId` list the globals plus that brand's and that pipe's own variables (the pipe editor's view), and only the overrides of that pipe's distributions are attached.
 */
export enum ConstVarListScope {
    GLOBAL = 'global',
    BRAND = 'brand',
    PIPE = 'pipe',
    DISTRIBUTION = 'distribution'
}

export type ListVariablesQueryDto = {
    /**
     * Which definitions to list. Without it, `brandId` / `pipeId` list the globals plus that brand's and that pipe's own variables (the pipe editor's view), and only the overrides of that pipe's distributions are attached.
     */
    scope?: ConstVarListScope;
    /**
     * Brand ID to filter variables
     */
    brandId?: number;
    /**
     * Pipe ID to filter variables
     */
    pipeId?: number;
    /**
     * With `scope=distribution`: only variables overridden in this distribution, with only its overrides attached.
     */
    distributionId?: number;
    /**
     * Free-text search. Matches a substring against `<group>.<name>` (the dotted key) or the description. A leading `var.` prefix is stripped, so `var.global.gender`, `global.gender`, and `gender` all work.
     */
    search?: string;
    page?: number;
    pageSize?: number;
};

export type VariableListBrandDto = {
    id: number;
    name: string;
    code: string;
};

export type VariableListPipeDto = {
    id: number;
    name: string;
    brandCode?: string | null;
};

export enum VariableKind {
    DEFINITION = 'definition',
    PIPE_DEFAULT = 'pipe_default',
    DISTRIBUTION_OVERRIDE = 'distribution_override'
}

export type DistributionPillBrandDto = {
    id: number;
    name: string;
    code: string;
};

export type DistributionPillPipeDto = {
    id: number;
    name: string;
    brand?: DistributionPillBrandDto | null;
};

export type CurrencyDto = {
    id: number;
    name: string;
    code: string;
};

export type DistributionPillDto = {
    id: number;
    name: string;
    pipeId: number;
    pipe: DistributionPillPipeDto;
    geography?: GeographyDto;
    language?: LanguageDto;
    currency?: CurrencyDto;
};

export type VariableListOverrideDto = {
    id: number;
    kind: VariableKind;
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto;
    pipe?: VariableListPipeDto;
    distribution?: DistributionPillDto;
};

export type VariableListItemDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    config?: VariableConfigDto;
    /**
     * The owning brand of a brand variable. Set by the list endpoint only.
     */
    brand?: VariableListBrandDto;
    /**
     * The owning pipe of a pipe variable. Set by the list endpoint only.
     */
    pipe?: VariableListPipeDto;
    /**
     * Pipe defaults and distribution overrides of this variable. Set by the list endpoint only.
     */
    overrides?: Array<VariableListOverrideDto>;
};

export type VariableListResponseDto = {
    items: Array<VariableListItemDto>;
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
};

export type VariableBaseDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    config?: VariableConfigDto;
};

export type UpdateVariableDto = {
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    config?: VariableConfigDto;
};

export type VariableRevision = {
    id: number;
    variable: Variable;
    action: {
        [key: string]: unknown;
    };
    group: string;
    name: string;
    description?: string | null;
    type: string;
    kind: string;
    value?: {
        [key: string]: unknown;
    } | null;
    ref?: {
        [key: string]: unknown;
    } | null;
    config?: {
        [key: string]: unknown;
    } | null;
    brandId?: number | null;
    pipeId?: number | null;
    distributionId?: number | null;
    overridesVariableId?: number | null;
    deletedAt?: string | null;
    user?: User | null;
    actorKind?: {
        [key: string]: unknown;
    } | null;
    createdAt: string;
};

export type Variable = {
    group: ConstVarGroup;
    type: ConstVarType;
    kind: VariableKind;
    id: number;
    name: string;
    description?: string;
    brandId?: number;
    pipeId?: number;
    distribution?: Distribution;
    overridesVariable?: Variable;
    config?: {
        [key: string]: unknown;
    } | null;
    value?: {
        [key: string]: unknown;
    };
    ref?: {
        [key: string]: unknown;
    };
    createdAt: string;
    updatedAt: string;
    deletedAt?: string;
    deletedByUserId?: number;
    latestRevision?: VariableRevision | null;
};

export enum EntityRevisionAction {
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
    RESTORE = 'restore'
}

export type EntityRevisionUserDto = {
    id: number;
    name: string;
    picture?: string | null;
};

export type EntityRevisionItemDto = {
    id: number;
    action: EntityRevisionAction;
    /**
     * How the write arrived: user, api_token, agent or system.
     */
    actorKind?: string | null;
    user?: EntityRevisionUserDto | null;
    createdAt: string;
    /**
     * Versioned state of the row after this change.
     */
    values: {
        [key: string]: unknown;
    };
    changed: Array<string>;
};

export type EntityRevisionListDto = {
    items: Array<EntityRevisionItemDto>;
    total: number;
    latestRevisionId: number | null;
};

export type VariableOverridableDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    config?: VariableConfigDto;
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto;
};

export type PipeVariableDefaultDto = {
    id: number;
    pipeId: number;
    overridesVariableId: number;
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto;
    overridesVariable: VariableBaseDto;
};

export type PipeVariableDefaultsPayloadDto = {
    overridable: Array<VariableOverridableDto>;
    defaults: Array<PipeVariableDefaultDto>;
};

export type CreatePipeVariableDefaultDto = {
    /**
     * Id of the variable definition being defaulted/overridden. Must be in the pipe's scope chain (global / brand / pipe).
     */
    overridesVariableId: number;
    value: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto;
};

export type UpdatePipeVariableDefaultDto = {
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto;
};

export type ListConstantsQueryDto = {
    /**
     * Which definitions to list. Without it, `brandId` / `pipeId` list that brand's and that pipe's own constants (the pipe editor's view), and only the overrides of that pipe's distributions are attached.
     */
    scope?: ConstVarListScope;
    brandId?: number;
    pipeId?: number;
    /**
     * With `scope=distribution`: only constants overridden in this distribution, with only its overrides attached.
     */
    distributionId?: number;
    page?: number;
    pageSize?: number;
    search?: string;
    type?: string;
};

export type ConstantIntegerValueDto = {
    type: 'integer';
    value?: number;
};

export type ConstantStringValueDto = {
    type: 'string';
    value?: string;
};

export type ConstantBooleanValueDto = {
    type: 'boolean';
    value?: boolean;
};

export type ConstantNumberValueDto = {
    type: 'number';
    value?: number;
};

export type ConstantDateValueDto = {
    type: 'date';
    value?: string;
};

export type OfferConst = {
    type: 'offer_const';
    paymentType: 'recurring' | 'recurring_with_trial' | 'one_time' | 'gift';
    ppoId: string;
    ppoTitle: string;
    trialPeriod?: number;
    trialPeriodUnit?: 'minute' | 'day' | 'month';
    trialPriceWoDiscount?: number;
    trialPricePerPeriod?: number;
    trialPriceDiscountPercent?: number;
    trialPriceDiscountAmount?: number;
    apiTrialPrice?: number;
    basePeriod?: number;
    basePeriodUnit?: 'minute' | 'day' | 'month';
    basePriceWoDiscount: number;
    basePricePerPeriod: number;
    basePriceDiscountPercent: number;
    basePriceDiscountAmount?: number;
    apiBasePrice: number;
    /**
     * Whether the product starts with a trial: its paymentType is recurring_with_trial. The trial's price may be above zero.
     */
    isTrial?: boolean;
    /**
     * What the product includes, as payments-api names it: meals, workouts, premium, fasting_timer, shopping_list, live_support, tips, complete_meals.
     */
    features?: Array<string>;
    /**
     * What shows on the customer's bank statement for a regular charge, per payment provider (primer, yuno, …). Providers without one are left out.
     */
    paymentDescriptors?: {
        [key: string]: string;
    };
};

export type OfferGroupDataDto = {
    type: 'offer_group_value';
    regular: OfferConst;
    exit?: OfferConst;
};

export type ConstantOfferGroupValueDto = {
    type: 'offer_group';
    value?: OfferGroupDataDto;
};

export type OfferGroupRefDto = {
    type: 'offer_group_ref';
    regularOfferId: number;
    exitOfferId?: number;
};

export type ConstantOfferGroupRefDto = {
    type: 'offer_group';
    value?: OfferGroupRefDto;
};

export type PriceCategoryDataDto = {
    type: 'price_category_value';
    s?: OfferGroupDataDto;
    m?: OfferGroupDataDto;
    l?: OfferGroupDataDto;
    xl?: OfferGroupDataDto;
};

export type ConstantPriceCategoryValueDto = {
    type: 'price_category';
    value?: PriceCategoryDataDto;
};

export type PriceCategoryRefDto = {
    type: 'price_category_ref';
    priceCategoryId: number;
};

export type ConstantPriceCategoryRefDto = {
    type: 'price_category';
    value?: PriceCategoryRefDto;
};

export type DistributionLinksDataDto = {
    type: 'distribution_links_value';
    links: {
        [key: string]: string;
    };
};

export type ConstantDistributionLinksValueDto = {
    type: 'distribution_links';
    value?: DistributionLinksDataDto;
};

export type DistributionLinkItemDto = {
    distributionId: number;
    key: string;
    pageId: string;
};

export type DistributionLinksRefDto = {
    type: 'distribution_links_ref';
    items: Array<DistributionLinkItemDto>;
};

export type ConstantDistributionLinksRefDto = {
    type: 'distribution_links';
    value?: DistributionLinksRefDto;
};

export type ConstantsBaseDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    brand?: BrandBaseDto;
    pipe?: PipeMinimalDto;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto | ConstantOfferGroupValueDto | ConstantPriceCategoryValueDto | ConstantDistributionLinksValueDto;
    /**
     * Reference configuration object. Required for reference constants, forbidden for statics.
     */
    ref?: {
        [key: string]: unknown;
    };
    config?: ConstantConfigDto;
};

export type ConstantsListResponseDto = {
    items: Array<ConstantsBaseDto>;
    total: number;
};

export type ConstantListOverrideDto = {
    id: number;
    type: ConstVarType;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto | ConstantOfferGroupValueDto | ConstantPriceCategoryValueDto | ConstantDistributionLinksValueDto;
    /**
     * Reference configuration object. Required for reference constants, forbidden for statics.
     */
    ref?: {
        [key: string]: unknown;
    };
    distributionId: number;
    distribution: DistributionPillDto;
};

export type ConstantListItemDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    brand?: BrandBaseDto;
    pipe?: PipeMinimalDto;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto | ConstantOfferGroupValueDto | ConstantPriceCategoryValueDto | ConstantDistributionLinksValueDto;
    /**
     * Reference configuration object. Required for reference constants, forbidden for statics.
     */
    ref?: {
        [key: string]: unknown;
    };
    config?: ConstantConfigDto;
    overrides: Array<ConstantListOverrideDto>;
};

export type ConstantsListFilteredResponseDto = {
    items: Array<ConstantListItemDto>;
    total: number;
};

export type UpdateConstantDto = {
    group: ConstVarGroup;
    description?: string;
    type: ConstVarType;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto | ConstantOfferGroupValueDto | ConstantPriceCategoryValueDto | ConstantDistributionLinksValueDto;
    /**
     * Reference configuration object. Required for reference constants, forbidden for statics.
     */
    ref?: {
        [key: string]: unknown;
    };
    config?: ConstantConfigDto;
};

export type ConstantEvaluationContextDto = {
    pipeId?: number;
    distributionId?: number;
    language?: string;
    geography?: string;
    currency?: string;
};

export type PreviewReferenceDto = {
    type: 'string' | 'number' | 'integer' | 'boolean' | 'date' | 'string_array' | 'integer_array' | 'offer_group' | 'price_category' | 'offer' | 'object' | 'distribution_links';
    /**
     * The reference configuration to evaluate
     */
    ref: {
        [key: string]: unknown;
    };
    /**
     * Optional context for evaluation (e.g. language, geography)
     */
    context?: ConstantEvaluationContextDto;
};

export type PreviewReferenceResultDto = {
    type: 'string' | 'number' | 'integer' | 'boolean' | 'date' | 'string_array' | 'integer_array' | 'offer_group' | 'price_category' | 'offer' | 'object' | 'distribution_links';
    /**
     * The evaluated value of the reference
     */
    evaluatedValue: {
        [key: string]: unknown;
    };
};

export type ReleaseListQueryDto = {
    pipeId?: number;
    brandId?: number;
    distributionId?: number;
    createdById?: number;
    page?: number;
    pageSize?: number;
};

export type ReleaseTimelineQueryDto = {
    /**
     * Only these brands. Omitted or empty: every brand.
     */
    brandIds?: Array<number>;
    /**
     * Only these pipes. Omitted or empty: every pipe.
     */
    pipeIds?: Array<number>;
    /**
     * Also the distributions deleted since, with the releases they served until then.
     */
    includeDeleted?: boolean;
    /**
     * Start of the window, ISO 8601.
     */
    from: string;
    /**
     * End of the window, ISO 8601, excluded.
     */
    to: string;
};

export type ReleaseTimelineScopeQueryDto = {
    /**
     * Only these brands. Omitted or empty: every brand.
     */
    brandIds?: Array<number>;
    /**
     * Only these pipes. Omitted or empty: every pipe.
     */
    pipeIds?: Array<number>;
    /**
     * Also the distributions deleted since, with the releases they served until then.
     */
    includeDeleted?: boolean;
};

export enum ReleaseBuildStatus {
    PENDING = 'PENDING',
    FAILED = 'FAILED',
    FAULT = 'FAULT',
    IN_PROGRESS = 'IN_PROGRESS',
    STOPPED = 'STOPPED',
    SUCCEEDED = 'SUCCEEDED',
    TIMED_OUT = 'TIMED_OUT'
}

export type DeployPagesBucketDto = {
    added: Array<PageRefDto>;
    removed: Array<PageRefDto>;
    modified: Array<PageRefDto>;
};

export type OverrideKeysBucketDto = {
    added: Array<string>;
    removed: Array<string>;
    modified: Array<string>;
};

export type DeployStyleChangesDto = {
    nameChanged?: ValueChangeDto;
    tokens: StyleTokensBucketDto;
    baseCssChanged: boolean;
    headRecordsChanged: boolean;
    isEmpty: boolean;
};

export type DeployChangesSummaryDto = {
    isFirstDeploy: boolean;
    /**
     * One-line human/AI-readable digest of the changes.
     */
    summary: string;
    nameChanged?: ValueChangeDto;
    languageChanged?: ValueChangeDto;
    currencyChanged?: ValueChangeDto;
    geographyChanged?: ValueChangeDto;
    pages: DeployPagesBucketDto;
    constantOverrides: OverrideKeysBucketDto;
    variableOverrides: OverrideKeysBucketDto;
    style?: DeployStyleChangesDto;
};

/**
 * `newer`: the changes its code gained against the release it is compared with. `older` (a rollback, or an older builder image): the changes it no longer has.
 */
export enum ReleaseSystemChangesStatus {
    NEWER = 'newer',
    OLDER = 'older'
}

export type ReleaseSystemChangesBriefDto = {
    /**
     * `newer`: the changes its code gained against the release it is compared with. `older` (a rollback, or an older builder image): the changes it no longer has.
     */
    status: ReleaseSystemChangesStatus;
    /**
     * How many changelog entries for pipes.
     */
    count: number;
    /**
     * When the oldest of them was committed, ISO 8601 as the changelog writes it.
     */
    since: string;
    /**
     * A release did not record its commit, so it is placed by when it was built.
     */
    estimated: boolean;
};

export type ReleaseListItemDistributionDto = {
    id: number;
    name: string;
    language: LanguageDto;
    geography: GeographyDto;
    currency: CurrencyDto;
};

export type ReleaseListItemDto = {
    id: number;
    createdAt: string;
    builtAt?: string;
    publishedAt?: string;
    buildStatus?: ReleaseBuildStatus;
    deployStatus?: ReleaseBuildStatus;
    /**
     * Build artifact size in bytes
     */
    artifactSize?: number | null;
    /**
     * Commit the build artifact was made from. A rollback carries the commit of the build it republishes. Null when not recorded.
     */
    buildCommitSha?: string | null;
    /**
     * Optional note describing why this deployment was triggered.
     */
    deploymentMessage?: string | null;
    /**
     * Set when this release is a rollback: the id of the previously-deployed release whose content snapshot it restores.
     */
    rolledBackFromReleaseId?: number | null;
    /**
     * True when this is the most recent release of its distribution. Lets the release list label the redeploy action honestly: on the latest release with an unfinished deploy it retries in place, anywhere else it creates a rollback release re-publishing this build.
     */
    isLatestForDistribution?: boolean;
    /**
     * System-computed, non-editable summary of what this deploy changed vs the previous one.
     */
    deployChangesSummary?: DeployChangesSummaryDto | null;
    /**
     * Its System changes in brief: the Pipehouse changes for pipes its code gained or lost. Absent when there are none, or nothing to compare with.
     */
    systemChanges?: ReleaseSystemChangesBriefDto;
    pipe: PipeListItemDto;
    distribution: ReleaseListItemDistributionDto;
    createdBy?: UserPartialDto;
};

export type ReleaseListPaginatedResponseDto = {
    items: Array<ReleaseListItemDto>;
    total: number;
};

export type ReleaseTimelineBrandDto = {
    id: number;
    name: string;
    code: string;
};

export type ReleaseTimelinePipeDto = {
    id: number;
    name: string;
    brandId: number;
};

export type ReleaseTimelineDistributionDto = {
    id: number;
    pipeId: number;
    name: string;
    /**
     * Geography name, such as `us`.
     */
    geography: string;
    /**
     * Language name, such as `en`.
     */
    language: string;
    /**
     * Currency code.
     */
    currency: string;
    /**
     * When it was deleted, ISO 8601; null while it exists.
     */
    deletedAt: string | null;
    /**
     * Its first successful deploy, ISO 8601.
     */
    firstPublishedAt: string;
    /**
     * Its latest successful deploy, ISO 8601.
     */
    lastPublishedAt: string;
    /**
     * Successful deploys, code-only ones included.
     */
    releaseCount: number;
    /**
     * Of those, the code-only ones.
     */
    codeOnlyCount: number;
    /**
     * An ingress sends it visitors right now: the distributions list’s "Active ingress".
     */
    activeIngress: boolean;
};

export type ReleaseTimelineAcLinkDto = {
    sourceId: number;
    targetId: number;
    /**
     * The acLinks key, such as `abandonedCart1`.
     */
    linkKey: string;
};

export type ReleaseTimelineRowsDto = {
    brands: Array<ReleaseTimelineBrandDto>;
    pipes: Array<ReleaseTimelinePipeDto>;
    /**
     * Every distribution in scope that has gone live at least once.
     */
    distributions: Array<ReleaseTimelineDistributionDto>;
    /**
     * The abandoned-cart links between those distributions, from live sources only.
     */
    acLinks: Array<ReleaseTimelineAcLinkDto>;
};

export type ReleaseTimelineReleaseDto = {
    id: number;
    distributionId: number;
    /**
     * `codeOnly`: new code with the pipe content of an earlier release. `rollback`: an earlier build published again.
     */
    kind: 'release' | 'codeOnly' | 'rollback';
    /**
     * When its deploy finished, ISO 8601.
     */
    publishedAt: string;
    /**
     * When it stopped being live, ISO 8601; null while it still is. A release or rollback lasts until the next one or the distribution’s deletion; a code-only release until the next deploy of any kind.
     */
    endsAt: string | null;
    /**
     * When it was asked for, ISO 8601.
     */
    createdAt: string;
    /**
     * Who released it.
     */
    createdById: number;
    /**
     * What the person deploying wrote.
     */
    message: string | null;
    /**
     * Rollback: the release whose build it publishes again. Code-only: the release whose pipe content it carries.
     */
    sourceReleaseId: number | null;
    /**
     * What changed against the deploy before it, in one line.
     */
    summary: string | null;
};

export type ReleaseTimelineUserDto = {
    id: number;
    name: string;
    /**
     * Avatar URL.
     */
    picture: string;
};

export type ReleaseTimelineDto = {
    from: string;
    to: string;
    /**
     * Every release live at some point of the window, whole: one that started before it or ends after it is not cut to it.
     */
    releases: Array<ReleaseTimelineReleaseDto>;
    users: Array<ReleaseTimelineUserDto>;
};

export type ReleaseStatusesRequestDto = {
    distributionIds: Array<number>;
};

export type ReleaseDto = {
    id: number;
    pipeId: number;
    distributionId: number;
    createdAt: string;
    builtAt?: string;
    publishedAt?: string;
    buildStatus?: ReleaseBuildStatus;
    deployStatus?: ReleaseBuildStatus;
    /**
     * Build artifact size in bytes
     */
    artifactSize?: number | null;
    /**
     * Commit the build artifact was made from. A rollback carries the commit of the build it republishes. Null when not recorded.
     */
    buildCommitSha?: string | null;
    /**
     * Optional note describing why this deployment was triggered.
     */
    deploymentMessage?: string | null;
    /**
     * Set when this release is a rollback: the id of the previously-deployed release whose content snapshot it restores.
     */
    rolledBackFromReleaseId?: number | null;
    /**
     * System-computed, non-editable summary of what this deploy changed vs the previous one. Null when not computed (legacy / failed-create / compute error).
     */
    deployChangesSummary?: DeployChangesSummaryDto | null;
    createdBy?: UserPartialDto;
};

export type ReleaseStatusesResponseDto = {
    /**
     * The latest release of each requested distribution. Distributions that have never been released are absent.
     */
    items: Array<ReleaseDto>;
};

export type ReleaseChangesDto = {
    id: number;
    summary: DeployChangesSummaryDto | null;
};

export type ReleaseValuePathChangeDto = {
    /**
     * Where in the value: `regular.apiBasePrice`, `steps[2]`.
     */
    path: string;
    /**
     * The previous value, shortened. Absent when it was added.
     */
    from?: string;
    /**
     * The new value, shortened. Absent when it was removed.
     */
    to?: string;
};

export type ReleaseEntryChangeDto = {
    /**
     * The `group.name` of a constant, variable or integration. In `general`: `distributionName`, `language`, `currency`, `geography` or `localeConfig`.
     */
    key: string;
    kind: 'added' | 'removed' | 'modified';
    /**
     * The whole previous value, shortened, unless it is an object on both sides (then see `changes`).
     */
    from?: string;
    /**
     * The whole new value, shortened.
     */
    to?: string;
    /**
     * For a value that is an object on both sides: the first leaves that changed.
     */
    changes: Array<ReleaseValuePathChangeDto>;
    /**
     * Changed leaves left out of `changes`.
     */
    moreChanges: number;
};

export type ReleaseTranslationChangeDto = {
    /**
     * The translation key, `group.name`.
     */
    key: string;
    kind: 'added' | 'removed' | 'modified';
    /**
     * The previous TipTap document.
     */
    from?: {
        [key: string]: unknown;
    };
    /**
     * The new TipTap document.
     */
    to?: {
        [key: string]: unknown;
    };
};

export type ReleaseIntegrationChangeDto = {
    /**
     * The `group.name` of a constant, variable or integration. In `general`: `distributionName`, `language`, `currency`, `geography` or `localeConfig`.
     */
    key: string;
    kind: 'added' | 'removed' | 'modified';
    /**
     * The whole previous value, shortened, unless it is an object on both sides (then see `changes`).
     */
    from?: string;
    /**
     * The whole new value, shortened.
     */
    to?: string;
    /**
     * For a value that is an object on both sides: the first leaves that changed.
     */
    changes: Array<ReleaseValuePathChangeDto>;
    /**
     * Changed leaves left out of `changes`.
     */
    moreChanges: number;
    /**
     * The integration type, e.g. `CHECKOUT`.
     */
    type: string;
};

/**
 * `same`: built from the same commit. `newer`: `entries` is what this release's code gained. `older` (a rollback, or an older builder image): what it no longer has. `unknown`: neither the commit nor when the release was built is recorded.
 */
export enum ReleaseCodeChangeStatus {
    UNKNOWN = 'unknown',
    SAME = 'same',
    NEWER = 'newer',
    OLDER = 'older'
}

export type ChangelogEntryDto = {
    /**
     * Where the entry is on System → Changelog: `/changelog#<slug>`. Made from the title, unique in the changelog.
     */
    slug: string;
    /**
     * The commit the change reached main with; with `after`, the commit it was made on top of.
     */
    commit: string;
    /**
     * The change is in the commit made on top of `commit`: the entry was written together with its change.
     */
    after: boolean;
    /**
     * When `commit` was committed, ISO 8601, as written.
     */
    date: string;
    /**
     * The feature or area, in a few words.
     */
    title: string;
    /**
     * What visitors of a published pipe get, from the first release built with it.
     */
    build: Array<string>;
    /**
     * Everything else: the admin, the pipe editor, the API, Pipeorders, tooling.
     */
    general: Array<string>;
};

export type ReleaseCodeChangesDto = {
    /**
     * `same`: built from the same commit. `newer`: `entries` is what this release's code gained. `older` (a rollback, or an older builder image): what it no longer has. `unknown`: neither the commit nor when the release was built is recorded.
     */
    status: ReleaseCodeChangeStatus;
    /**
     * One of the two releases did not record its commit, so it is placed by when it was built: it may lack the newest of `entries`, built from an image older than its build.
     */
    estimated: boolean;
    /**
     * The commit this release was built from.
     */
    sha: string | null;
    /**
     * The commit the release it is compared with was built from.
     */
    baseSha: string | null;
    /**
     * The changelog entries between the two commits that change built pipes, with their `build` bullets only. Newest first.
     */
    entries: Array<ChangelogEntryDto>;
};

export type ReleaseDiffDto = {
    /**
     * The release compared with — the one the change summary is counted from: the latest earlier release of the distribution that kept a snapshot, live or not. Null when there is none.
     */
    baseReleaseId: number | null;
    /**
     * There is no content to compare: the release kept no snapshot (a failed create), or the pipe to deploy is gone.
     */
    unavailable: boolean;
    /**
     * No earlier release to compare with.
     */
    isFirstDeploy: boolean;
    /**
     * Nothing differs in any section.
     */
    isEmpty: boolean;
    general: Array<ReleaseEntryChangeDto>;
    content: PipeContentDiffDto;
    style: DeployStyleChangesDto;
    translations: Array<ReleaseTranslationChangeDto>;
    /**
     * Every changed translation; `translations` lists the first 200 by key.
     */
    translationCount: number;
    /**
     * Constant values as the release resolved them, overrides included.
     */
    constants: Array<ReleaseEntryChangeDto>;
    /**
     * Variable default values, overrides included.
     */
    variables: Array<ReleaseEntryChangeDto>;
    /**
     * Integrations the release shipped, with their config as overridden for the distribution.
     */
    integrations: Array<ReleaseIntegrationChangeDto>;
    id: number;
    /**
     * Set on a rollback: the release whose build it published.
     */
    rolledBackFromReleaseId: number | null;
    /**
     * How the Pipehouse code that built it differs from the compared release's. Null when there is no release to compare with.
     */
    code: ReleaseCodeChangesDto | null;
};

export type ReleaseLogsDto = {
    buildLog?: string;
    deployLog?: string;
};

export type ReleaseArtifactSizeDto = {
    /**
     * Artifact size in bytes
     */
    bytes: number;
};

export type ReleaseBuildCommitDto = {
    /**
     * Commit hash the builder image was built from
     */
    sha: string;
    /**
     * That commit's committer time, ISO 8601. Places the release among the changelog's entries.
     */
    committedAt?: string;
};

export type ListIntegrationsQueryDto = {
    /**
     * Which integrations to list, as on the constants list. Without it, `brandId` / `pipeId` list that brand's and that pipe's own integrations, and only the overrides of that pipe's distributions are attached.
     */
    scope?: ConstVarListScope;
    brandId?: number;
    pipeId?: number;
    /**
     * With `scope=distribution`: only integrations overridden in this distribution, with only its overrides attached.
     */
    distributionId?: number;
    page?: number;
    pageSize?: number;
    search?: string;
    type?: string;
    /**
     * Also return deleted integrations, which carry `deletedAt` and no facts about where they run. Off by default.
     */
    includeDeleted?: boolean;
};

export enum IntegrationType {
    RAW = 'RAW',
    PIPEORDERS = 'PIPEORDERS',
    GTM = 'GTM',
    BUGSNAG = 'BUGSNAG',
    FITNESS_FUNCTIONS = 'FITNESS_FUNCTIONS',
    TRACKING_PROPERTIES = 'TRACKING_PROPERTIES',
    KLAVIYO = 'KLAVIYO',
    SEGMENT = 'SEGMENT',
    CDP = 'CDP',
    GEO_DEVICE = 'GEO_DEVICE',
    EXIT_INTENT = 'EXIT_INTENT',
    CHECKOUT = 'CHECKOUT',
    FRAUDNET = 'FRAUDNET',
    BUILD_SETTINGS = 'BUILD_SETTINGS',
    PAGE_PRELOAD = 'PAGE_PRELOAD',
    INTERCOM = 'INTERCOM'
}

export type IntegrationListBrandDto = {
    id: number;
    name: string;
    code: string;
};

export type IntegrationListPipeDto = {
    id: number;
    name: string;
    brandCode?: string | null;
};

/**
 * `off`: the pipe switched it off. `outranked`: it is on, but `outrankedBy` comes first in the pipe's scope order, and a build keeps only that one of a singleton type.
 */
export enum IntegrationPipeState {
    OFF = 'off',
    OUTRANKED = 'outranked'
}

export type IntegrationListRefDto = {
    id: number;
    group: ConstVarGroup;
    name: string;
};

export type IntegrationListPipeExceptionDto = {
    pipe: IntegrationListPipeDto;
    /**
     * `off`: the pipe switched it off. `outranked`: it is on, but `outrankedBy` comes first in the pipe's scope order, and a build keeps only that one of a singleton type.
     */
    state: IntegrationPipeState;
    outrankedBy?: IntegrationListRefDto;
};

/**
 * Resolved to 'inherit' when the row stores no forced state, so the client never has to treat null and 'inherit' as different things.
 */
export enum IntegrationOverrideState {
    INHERIT = 'inherit',
    ENABLED = 'enabled',
    DISABLED = 'disabled'
}

export type IntegrationListOverrideDto = {
    id: number;
    distributionId: number;
    distribution: DistributionPillDto;
    /**
     * Resolved to 'inherit' when the row stores no forced state, so the client never has to treat null and 'inherit' as different things.
     */
    enabledState: IntegrationOverrideState;
    /**
     * The distribution has a config of its own.
     */
    hasConfig: boolean;
    /**
     * False when the integration does not reach the distribution's pipe, so the override changes nothing.
     */
    inReach: boolean;
    /**
     * Whether the distribution's next release switches it on: its own on/off, or else its pipe's.
     */
    on: boolean;
    /**
     * The config it runs with here switches it off (an Exit Intent `enabled: false`).
     */
    configOff: boolean;
    /**
     * On, but this row of its type comes first in the distribution, and a build keeps only that one of a singleton type.
     */
    outrankedBy?: IntegrationListRefDto;
};

export type IntegrationListItemDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: IntegrationType;
    brandId?: number;
    pipeId?: number;
    brand?: IntegrationListBrandDto;
    pipe?: IntegrationListPipeDto;
    /**
     * Pipes its scope reaches: every pipe, its brand's pipes, or its own pipe.
     */
    pipeCount: number;
    pipeExceptions: Array<IntegrationListPipeExceptionDto>;
    /**
     * Its own config switches it off (an Exit Intent `enabled: false`).
     */
    configOff: boolean;
    overrides: Array<IntegrationListOverrideDto>;
    /**
     * When it was deleted; only listed with `includeDeleted`. A deleted row runs nowhere.
     */
    deletedAt?: string | null;
};

export type IntegrationsListFilteredResponseDto = {
    items: Array<IntegrationListItemDto>;
    total: number;
};

export type RawHeadAttributeDto = {
    name: string;
    value: string;
};

export type RawHeadTagDto = {
    id: string;
    tagType: 'script' | 'meta' | 'link' | 'style' | 'noscript';
    attributes: Array<RawHeadAttributeDto>;
    innerHTML?: string;
    position?: string;
    priority?: string;
};

export type RawEventProcessorDto = {
    id: string;
    eventName: string;
    jsCode: string;
};

export type RawIntegrationConfigDto = {
    tags: Array<RawHeadTagDto>;
    events: Array<RawEventProcessorDto>;
};

export type IntegrationRawValueDto = {
    type: 'RAW';
    value: RawIntegrationConfigDto;
};

export type PipeOrdersIntegrationConfigDto = {
    apiHost?: string;
};

export type IntegrationPipeOrdersValueDto = {
    type: 'PIPEORDERS';
    value?: PipeOrdersIntegrationConfigDto;
};

export type GtmIntegrationConfigDto = {
    /**
     * GTM Container ID, e.g. GTM-XXXXXXX
     */
    containerId: string;
};

export type IntegrationGtmValueDto = {
    type: 'GTM';
    value: GtmIntegrationConfigDto;
};

export type BugsnagIntegrationConfigDto = {
    /**
     * Bugsnag API key (project notifier key)
     */
    apiKey: string;
    /**
     * Release stage, e.g. production, staging, development
     */
    releaseStage?: string;
    /**
     * App version reported to Bugsnag
     */
    appVersion?: string;
    /**
     * Comma-separated release stages on which events are reported
     */
    enabledReleaseStages?: string;
};

export type IntegrationBugsnagValueDto = {
    type: 'BUGSNAG';
    value: BugsnagIntegrationConfigDto;
};

export type FitnessDaysTillGoalDateOverridesDto = {
    /**
     * Upper bound on the first-week drop, kg. Default 5.
     */
    firstWeekMaxLossKg?: number;
    /**
     * The first-week drop is (weight − goal) divided by this, up to the cap. Default 3.
     */
    firstWeekLossDivisor?: number;
    /**
     * kg/week used when the visitor has not picked a goal pace. Default 1.5.
     */
    defaultGoalPaceKg?: number;
};

export type FitnessEventDateOverridesDto = {
    /**
     * Upper bound on the first-week drop, kg. Default 5.
     */
    firstWeekMaxLossKg?: number;
    /**
     * The first-week drop is (weight − goal) divided by this, up to the cap. Default 3.
     */
    firstWeekLossDivisor?: number;
    /**
     * kg/week used when the visitor has not picked a goal pace. Default 1.5.
     */
    defaultGoalPaceKg?: number;
    /**
     * Spare days past a whole week at which the week count rounds up. 7 never rounds up. Default 4.
     */
    weekRoundUpFromDays?: number;
    /**
     * Length of a month, days. Default 30.
     */
    daysPerMonth?: number;
    /**
     * Spare days past a whole month at which the month count rounds up. Default 14.
     */
    monthRoundUpFromDays?: number;
};

export type FitnessFunctionsIntegrationConfigDto = {
    daysTillGoalDate?: FitnessDaysTillGoalDateOverridesDto;
    eventDate?: FitnessEventDateOverridesDto;
};

export type IntegrationFitnessFunctionsValueDto = {
    type: 'FITNESS_FUNCTIONS';
    value?: FitnessFunctionsIntegrationConfigDto;
};

export type IntegrationTrackingPropertiesValueDto = {
    type: 'TRACKING_PROPERTIES';
};

export type KlaviyoIntegrationConfigDto = {
    /**
     * Klaviyo Public API Key (site ID)
     */
    publicKey: string;
};

export type IntegrationKlaviyoValueDto = {
    type: 'KLAVIYO';
    value: KlaviyoIntegrationConfigDto;
};

export type SegmentIntegrationConfigDto = {
    /**
     * Segment Write Key
     */
    writeKey: string;
    /**
     * Who receives the calls. `segment` (also when absent): Segment alone. `shadow`: Segment, which still delivers, and a copy to the CDP. `cdp`: the CDP alone, without analytics.js.
     */
    delivery?: 'segment' | 'shadow' | 'cdp';
    /**
     * Write key of the CDP source imported from this Segment source, never the funnel source. Required unless `delivery` is `segment`.
     */
    cdpWriteKey?: string;
    /**
     * CDP edge origin (scheme and host, no path). Absent → the edge of the build environment.
     */
    cdpHost?: string;
};

export type IntegrationSegmentValueDto = {
    type: 'SEGMENT';
    value: SegmentIntegrationConfigDto;
};

export type CdpIntegrationConfigDto = {
    /**
     * Write key of the CDP source these events belong to. Public by design — it ships in the page.
     */
    writeKey: string;
    /**
     * Edge origin (scheme and host, no path). Absent → the edge of the build environment.
     */
    host?: string;
    /**
     * Variable keys never sent (e.g. `global.age`), on top of the built-in personal-data list.
     */
    excludeVariables?: Array<string>;
    /**
     * Hold every event until cookie consent is granted, on distributions where the consent banner is enabled.
     */
    honourCookieConsent?: boolean;
    /**
     * Stop sending a `Component Clicked` event for every click.
     */
    disableClickTracking?: boolean;
    /**
     * Log the CDP client's activity to the browser console.
     */
    debug?: boolean;
};

export type IntegrationCdpValueDto = {
    type: 'CDP';
    value: CdpIntegrationConfigDto;
};

export type GeoDeviceIntegrationConfigDto = {
    /**
     * orders/api host that serves GET /api/public/geo
     */
    apiHost?: string;
};

export type IntegrationGeoDeviceValueDto = {
    type: 'GEO_DEVICE';
    value?: GeoDeviceIntegrationConfigDto;
};

export type ExitIntentIntegrationConfigDto = {
    /**
     * Master switch. Only an explicit false disables every trigger.
     */
    enabled?: boolean;
    /**
     * Desktop cursor-leaves-the-top-edge trigger.
     */
    mouseEnabled?: boolean;
    /**
     * The cursor must leave the document at or above this Y coordinate (px) to count. Higher catches more exits and more false positives.
     */
    mouseTopThresholdPx?: number;
    /**
     * How long the cursor must stay outside the page after a top-edge exit before it counts as leaving. A cursor that comes back sooner cancels it. 0 fires on the exit itself.
     */
    mouseAwayMs?: number;
    /**
     * Tab-switch / app-switch trigger (document.visibilitychange).
     */
    tabSwitchEnabled?: boolean;
    /**
     * How long the tab must stay hidden before the switch counts as leaving. Defaults to 5 minutes; under ~300ms a wallet payment sheet is mistaken for a tab switch.
     */
    tabSwitchHiddenMs?: number;
    /**
     * Page-leave trigger (pagehide). Fires when the document is navigated away from, not when the tab is merely backgrounded.
     */
    pageLeaveEnabled?: boolean;
    /**
     * Browser Back trigger. `exitIntentPages` arms it only on pages that wire an onExitIntent handler; `allPages` arms it everywhere.
     */
    backNavigation?: 'off' | 'exitIntentPages' | 'allPages';
    /**
     * Cancel the Back navigation that triggered exit intent so the visitor stays on the page. A second Back always leaves.
     */
    backNavigationBlocks?: boolean;
    /**
     * Timer trigger. `elapsed` fires once the visitor has been on the page that long; `inactivity` restarts the timer on every interaction.
     */
    timeOnPage?: 'off' | 'elapsed' | 'inactivity';
    /**
     * Timer length in ms.
     */
    timeOnPageMs?: number;
    /**
     * Scroll-depth trigger.
     */
    scrollEnabled?: boolean;
    /**
     * Fraction of the page (0-1) that must be scrolled through for the scroll trigger to fire.
     */
    scrollRatio?: number;
    /**
     * Triggers are ignored for this long after each (re-)arm. Absorbs the visibilitychange noise mobile browsers emit around a navigation gesture.
     */
    armDelayMs?: number;
    /**
     * `page` re-arms exit intent on every page show; `session` fires at most once per visit.
     */
    triggerScope?: 'page' | 'session';
};

export type IntegrationExitIntentValueDto = {
    type: 'EXIT_INTENT';
    value?: ExitIntentIntegrationConfigDto;
};

export type CheckoutPrimerConfigDto = {
    /**
     * Primer Web SDK version to load, e.g. 2.62.0. Absent → the version the checkout ships with.
     */
    sdkVersion?: string;
};

export type CheckoutYunoConfigDto = {
    /**
     * Yuno Web SDK version to load, e.g. 1.11 (the latest 1.11.x) or 1.11.1. Absent → the version the checkout ships with.
     */
    sdkVersion?: string;
};

export type CheckoutIntegrationConfigDto = {
    primer?: CheckoutPrimerConfigDto;
    yuno?: CheckoutYunoConfigDto;
};

export type IntegrationCheckoutValueDto = {
    type: 'CHECKOUT';
    value?: CheckoutIntegrationConfigDto;
};

export type IntegrationFraudNetValueDto = {
    type: 'FRAUDNET';
};

export type BuildSettingsIntegrationConfigDto = {
    /**
     * Also build for older browsers (Chrome 64+, Safari 12+): older JavaScript syntax, the polyfills the code uses and CSS fallbacks. Pages get larger.
     */
    legacyBrowsers?: boolean;
    /**
     * Cover each page until it is ready to use, for at most 8 seconds after it has downloaded: no tap reaches it before then, and a loading spinner shows if the wait takes longer than 0.3 seconds. `loadingOverlayMode` decides from when.
     */
    loadingOverlay?: boolean;
    /**
     * When the loading overlay covers a page, with `loadingOverlay` on. `always` (also when absent): from the first paint. `onTap`: only from a tap on a button, link or option before the page is ready, which is then carried out once it is; until then the page shows and scrolls as usual.
     */
    loadingOverlayMode?: 'always' | 'onTap';
};

export type IntegrationBuildSettingsValueDto = {
    type: 'BUILD_SETTINGS';
    value?: BuildSettingsIntegrationConfigDto;
};

export type PagePreloadIntegrationConfigDto = {
    /**
     * Full address of the page to load in the background, e.g. https://app.example.com/. Absent → nothing is loaded.
     */
    url?: string;
    /**
     * How long the page stays after it has finished loading, so that it can fetch what it loads late. Defaults to 2 minutes. It is closed on a plan selection or checkout page either way.
     */
    keepAfterLoadMs?: number;
};

export type IntegrationPagePreloadValueDto = {
    type: 'PAGE_PRELOAD';
    value?: PagePreloadIntegrationConfigDto;
};

export type IntercomDataAttributeDto = {
    /**
     * What the value is, as support reads it in the list of attributes to create, such as "Exact price product". Editor-only.
     */
    label?: string;
    /**
     * The Intercom custom attribute the value is sent as, such as quiz_gender. It must exist in the workspace first.
     */
    attribute: string;
    /**
     * The attribute's type in Intercom: string (the default), integer, float, boolean, or date, sent in Unix seconds, whose name must end in _at.
     */
    type?: 'string' | 'integer' | 'float' | 'boolean' | 'date';
    /**
     * Where the value is read from: variables (global.gender, pipe.ageRange, global.checkoutOffer.ppoId) or system and global constants (const.system.currency). The first one with a value is sent, so pipes that name the same value differently can share the attribute. Payment tokens and keys are refused.
     */
    variables: Array<string>;
};

export type IntercomIntegrationConfigDto = {
    /**
     * The workspace ID (Intercom's app ID). Required: without it nothing loads. Public: every page that loads the Messenger shows it.
     */
    appId?: string;
    /**
     * Where the workspace is hosted: us (app.intercom.com, the default), eu (app.eu.intercom.com) or au (app.au.intercom.com).
     */
    region?: 'us' | 'eu' | 'au';
    /**
     * When and how chat is offered: from the first page, before the visitor has given anything, through the Fin Chat Buttons placed in the pipe (the default), or once they have entered their email, through Intercom's bubble on desktop and phones. Either way for the rest of the visit.
     */
    offerFrom?: 'start' | 'email';
    /**
     * The bubble's distance from the side on desktop, in pixels, where chat is offered once the email is entered. At least 20, the default. The side is the right, the left in a right-to-left pipe.
     */
    horizontalPadding?: number;
    /**
     * The bubble's distance from the bottom on desktop, in pixels, where chat is offered once the email is entered. At least 20, the default.
     */
    verticalPadding?: number;
    /**
     * The Messenger's language: the distribution's (the default), whatever the workspace picks for the visitor, or `fixedLanguage`.
     */
    languageMode?: 'distribution' | 'workspace' | 'fixed';
    /**
     * The language when `languageMode` is fixed: ISO 639-1, such as en or de, or one of zh-CN, zh-TW, pt-BR.
     */
    fixedLanguage?: string;
    /**
     * Send global.firstName as the name, when the pipe asks for it. Defaults to true.
     */
    sendFirstName?: boolean;
    /**
     * Values sent with an Intercom attribute of their own, to filter and route by: answers, the offer, consent, how far the visitor got. Sent only once the order exists. An answer reaches support only through this list.
     */
    dataAttributes?: Array<IntercomDataAttributeDto>;
    /**
     * Send the page address (without its query string), its title and the last funnel marker reached. Defaults to true.
     */
    sendLocation?: boolean;
    /**
     * Send the order ID. Defaults to true.
     */
    sendOrderId?: boolean;
    /**
     * Send the plan picked and how far the purchase got. Defaults to true.
     */
    sendPurchase?: boolean;
    /**
     * Send plan selected, checkout started or failed and paid as Intercom events. Defaults to true.
     */
    sendEvents?: boolean;
    /**
     * Also send exit intent as an Intercom event. Defaults to false.
     */
    sendExitIntentEvent?: boolean;
};

export type IntegrationIntercomValueDto = {
    type: 'INTERCOM';
    value?: IntercomIntegrationConfigDto;
};

export type IntegrationsBaseDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: IntegrationType;
    brandId?: number;
    pipeId?: number;
    brand?: number;
    pipe?: number;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value: IntegrationRawValueDto | IntegrationPipeOrdersValueDto | IntegrationGtmValueDto | IntegrationBugsnagValueDto | IntegrationFitnessFunctionsValueDto | IntegrationTrackingPropertiesValueDto | IntegrationKlaviyoValueDto | IntegrationSegmentValueDto | IntegrationCdpValueDto | IntegrationGeoDeviceValueDto | IntegrationExitIntentValueDto | IntegrationCheckoutValueDto | IntegrationFraudNetValueDto | IntegrationBuildSettingsValueDto | IntegrationPagePreloadValueDto | IntegrationIntercomValueDto;
};

export type CreateIntegrationDto = {
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: IntegrationType;
    brandId?: number;
    pipeId?: number;
    brand?: number;
    pipe?: number;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value: IntegrationRawValueDto | IntegrationPipeOrdersValueDto | IntegrationGtmValueDto | IntegrationBugsnagValueDto | IntegrationFitnessFunctionsValueDto | IntegrationTrackingPropertiesValueDto | IntegrationKlaviyoValueDto | IntegrationSegmentValueDto | IntegrationCdpValueDto | IntegrationGeoDeviceValueDto | IntegrationExitIntentValueDto | IntegrationCheckoutValueDto | IntegrationFraudNetValueDto | IntegrationBuildSettingsValueDto | IntegrationPagePreloadValueDto | IntegrationIntercomValueDto;
};

export type UpdateIntegrationDto = {
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: IntegrationType;
    brandId?: number;
    pipeId?: number;
    brand?: number;
    pipe?: number;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value: IntegrationRawValueDto | IntegrationPipeOrdersValueDto | IntegrationGtmValueDto | IntegrationBugsnagValueDto | IntegrationFitnessFunctionsValueDto | IntegrationTrackingPropertiesValueDto | IntegrationKlaviyoValueDto | IntegrationSegmentValueDto | IntegrationCdpValueDto | IntegrationGeoDeviceValueDto | IntegrationExitIntentValueDto | IntegrationCheckoutValueDto | IntegrationFraudNetValueDto | IntegrationBuildSettingsValueDto | IntegrationPagePreloadValueDto | IntegrationIntercomValueDto;
};

export type PipeDistributionListQueryDto = {
    /**
     * Partial name (case-insensitive, multi-token AND; matches the distribution or its pipe name, or either id for a numeric token)
     */
    nameQuery?: string;
    sortBy?: 'id' | 'name' | 'pipe' | 'brand' | 'language' | 'geography' | 'currency' | 'lastRelease';
    sortOrder?: 'ASC' | 'DESC';
    pipeId?: number;
    languageId?: number;
    currencyId?: number;
    geographyId?: number;
    brandId?: number;
    statusId?: number;
    lastReleasedById?: number;
    page?: number;
    pageSize?: number;
    hasActiveIngressDestination?: boolean;
    outdated?: boolean;
    groupAc?: boolean;
};

export type DistributionGeoLangPairDto = {
    geographyId: number;
    geographyName: string;
    languageId: number;
    languageName: string;
    /**
     * Number of distributions in this geo-lang pair.
     */
    count: number;
};

export type DeployReleaseDto = {
    /**
     * Note describing why this deployment was triggered. Required, at least 5 characters, for a distribution with an active ingress, unless code only.
     */
    deploymentMessage?: string;
    /**
     * Rebuild with the current code but the pipe content of the last successful deploy.
     */
    codeOnly?: boolean;
};

export type DeployDiffDto = {
    /**
     * The release compared with — the one the change summary is counted from: the latest earlier release of the distribution that kept a snapshot, live or not. Null when there is none.
     */
    baseReleaseId: number | null;
    /**
     * There is no content to compare: the release kept no snapshot (a failed create), or the pipe to deploy is gone.
     */
    unavailable: boolean;
    /**
     * No earlier release to compare with.
     */
    isFirstDeploy: boolean;
    /**
     * Nothing differs in any section.
     */
    isEmpty: boolean;
    general: Array<ReleaseEntryChangeDto>;
    content: PipeContentDiffDto;
    style: DeployStyleChangesDto;
    translations: Array<ReleaseTranslationChangeDto>;
    /**
     * Every changed translation; `translations` lists the first 200 by key.
     */
    translationCount: number;
    /**
     * Constant values as the release resolved them, overrides included.
     */
    constants: Array<ReleaseEntryChangeDto>;
    /**
     * Variable default values, overrides included.
     */
    variables: Array<ReleaseEntryChangeDto>;
    /**
     * Integrations the release shipped, with their config as overridden for the distribution.
     */
    integrations: Array<ReleaseIntegrationChangeDto>;
};

export type BulkReleaseDto = {
    ids: Array<number>;
    /**
     * Note describing why this deployment was triggered. Required, at least 5 characters, when any of the distributions has an active ingress, unless code only.
     */
    deploymentMessage?: string;
    /**
     * Rebuild each distribution with the current code but the pipe content of its last successful deploy.
     */
    codeOnly?: boolean;
};

export type BulkReleaseAcceptedDto = {
    /**
     * Number of release-create jobs enqueued.
     */
    accepted: number;
    /**
     * Code-only deploys: distributions skipped for having no successful deploy, or a different URL since it.
     */
    skipped?: number;
    /**
     * Code-only deploys: the distributions actually queued.
     */
    distributionIds?: Array<number>;
};

export type BulkRollbackRequestDto = {
    ids: Array<number>;
    /**
     * Roll each distribution back to whichever of its releases was live at this instant.
     */
    targetAt: string;
};

export type RollbackReleaseRefDto = {
    id: number;
    createdAt: string;
    /**
     * When the deploy finished. Absent for a release that never completed deploying.
     */
    publishedAt?: string;
    /**
     * Set when this release is itself a rollback: the release whose content it restored.
     */
    rolledBackFromReleaseId?: number | null;
};

/**
 * ok = will roll back; already_current = the target is already live; no_target = nothing was deployed by then; path_changed = the distribution's URL changed after that build, so it is refused; in_progress = a build/deploy is in flight. Only `ok` rows are queued.
 */
export enum RollbackItemStatus {
    OK = 'ok',
    ALREADY_CURRENT = 'already_current',
    NO_TARGET = 'no_target',
    PATH_CHANGED = 'path_changed',
    IN_PROGRESS = 'in_progress'
}

export type BulkRollbackItemDto = {
    distributionId: number;
    distributionName: string;
    pipeName?: string;
    /**
     * The distribution's most recent release, whatever its state.
     */
    currentRelease?: RollbackReleaseRefDto;
    /**
     * The successfully-deployed release that was live at the requested datetime — what this row would be rolled back to.
     */
    targetRelease?: RollbackReleaseRefDto;
    /**
     * Only set when the target release is ITSELF a rollback: the first non-rollback release in the chain — the one that owns the build actually re-published, since a rollback release has no build of its own. Rolling back to a rollback is legitimate (the target really was what was live), but the operator should see whose build lands.
     */
    targetOriginRelease?: RollbackReleaseRefDto;
    /**
     * How many rollback hops separate the target from `targetOriginRelease` (0 when the target is not a rollback).
     */
    targetRollbackDepth?: number;
    /**
     * ok = will roll back; already_current = the target is already live; no_target = nothing was deployed by then; path_changed = the distribution's URL changed after that build, so it is refused; in_progress = a build/deploy is in flight. Only `ok` rows are queued.
     */
    status: RollbackItemStatus;
    /**
     * Whole days between the target release and the current one — how far back this rollback reaches.
     */
    diffDays?: number;
    /**
     * True when the target build was made for a different public path than the distribution's current one (it was renamed / moved geography or language since). This is why `status` is `path_changed`: publishing that build to the current URL would serve pages whose internal links point at the old one. `targetPath` / `currentPath` name both sides.
     */
    pathChanged?: boolean;
    /**
     * The path the target build was made for.
     */
    targetPath?: string;
    /**
     * The distribution's current public path — where the rollback deploys.
     */
    currentPath?: string;
};

export type BulkRollbackPreviewDto = {
    targetAt: string;
    items: Array<BulkRollbackItemDto>;
    /**
     * How many items have status `ok`.
     */
    eligibleCount: number;
    /**
     * How many items would be skipped (any non-`ok` status).
     */
    skippedCount: number;
};

export type BulkRollbackDto = {
    ids: Array<number>;
    /**
     * Roll each distribution back to whichever of its releases was live at this instant.
     */
    targetAt: string;
    /**
     * Optional note stored on every release created by this rollback. When omitted the service writes a generated one naming the target datetime and source release.
     */
    deploymentMessage?: string;
};

export type BulkRollbackAcceptedDto = {
    /**
     * Number of rollback release-create jobs enqueued.
     */
    accepted: number;
    /**
     * Number of selected distributions skipped (already at the target, nothing deployed by then, or a build/deploy in flight).
     */
    skipped: number;
    /**
     * The distributions actually queued. Needed, not informational: the caller polls these to discover the new releases, and polling a SKIPPED distribution never resolves — it would spin until the poll budget runs out.
     */
    distributionIds: Array<number>;
};

export type AcChildDistributionDto = {
    pageId?: string;
    pagePath?: string;
    targetDeleted?: boolean;
    linkKey: string;
    distribution: DistributionDto;
};

export type DistributionBuildLagDto = {
    /**
     * The live release it was measured on: the latest deploy that succeeded.
     */
    releaseId: number;
    /**
     * How many changelog entries that change built pipes the live release lacks.
     */
    count: number;
    /**
     * When the oldest of them was committed, ISO 8601 as the changelog writes it.
     */
    since: string;
    /**
     * The live release did not record its commit, so it is placed by when it was built.
     */
    estimated: boolean;
};

export type IngressBadgeIngressDto = {
    /**
     * External ingress id (ingress system).
     */
    ingressId: number;
    /**
     * Display label — the ingress routable path.
     */
    ingressName: string;
    proportion: number;
};

export type IngressBadgeDto = {
    /**
     * Number of active ingress destinations (proportion > 0).
     */
    activeCount: number;
    /**
     * Largest active proportion among them (0–100).
     */
    maxProportion: number;
    /**
     * External ingress id owning the highest-proportion active destination — the badge click target.
     */
    primaryIngressId: number;
    ingresses: Array<IngressBadgeIngressDto>;
};

export type DistributionDto = {
    acChildren?: Array<AcChildDistributionDto>;
    urlCollisionSiblingIds?: Array<number>;
    buildLag?: DistributionBuildLagDto;
    id: number;
    name: string;
    language: LanguageDto;
    geography: GeographyDto;
    pipeId: number;
    pipe: PipeListItemDto;
    createdBy: UserPartialDto;
    latestRelease?: ReleaseDto;
    currency: CurrencyDto;
    status?: DistributionStatusDto;
    overrideCount?: number;
    variableOverrideCount?: number;
    integrationOverrideCount?: number;
    acLinksCount?: number;
    mainLandingPagePath?: string;
    ingressInfo?: IngressBadgeDto;
};

export type DistributionListTimingsDto = {
    totalMs: number;
    /**
     * Wall time of the main entity SELECT + COUNT (run in parallel).
     */
    mainQueryMs: number;
    overridesMs: number;
    acLinksMs: number;
    latestReleasesMs: number;
    pipeLanguagesMs: number;
    ingressInfoMs: number;
    /**
     * Whole-table URL-collision grouping scan.
     */
    collisionMs: number;
    /**
     * Live release code per distribution, for `buildLag`.
     */
    liveCodeMs: number;
    /**
     * In-memory DTO mapping loop.
     */
    mapMs: number;
    /**
     * Group AC: total fetchAcChildren time.
     */
    acChildrenMs?: number;
    /**
     * Group AC: AC edge query.
     */
    acEdgesMs?: number;
    /**
     * Group AC: target distribution load.
     */
    acTargetsMs?: number;
    /**
     * Group AC: batched child aggregates.
     */
    acAggregatesMs?: number;
    /**
     * Group AC: in-memory child DTO build.
     */
    acBuildMs?: number;
};

export type DistributionListPaginatedResponseDto = {
    items: Array<DistributionDto>;
    total: number;
    /**
     * The sort field actually applied to this result. Echoed back so the UI can show the current option even when none was requested (defaults to `lastRelease`).
     */
    sortBy: 'id' | 'name' | 'pipe' | 'brand' | 'language' | 'geography' | 'currency' | 'lastRelease';
    /**
     * The sort direction actually applied to this result.
     */
    sortOrder: 'ASC' | 'DESC';
    /**
     * The newest changelog entry that changes built pipes, with its `build` bullets only: the one `outdated` distributions lack. Absent while there is none.
     */
    latestBuildChange?: ChangelogEntryDto;
    /**
     * Optional per-phase timings (ms). Safe for FE to ignore — added for diagnostic visibility into where time is spent on a given request.
     */
    timings?: DistributionListTimingsDto;
};

export type DistributionSearchQueryDto = {
    /**
     * Partial name (case-insensitive, multi-token AND; matches distribution or pipe name)
     */
    nameQuery?: string;
    /**
     * Restrict to one pipe
     */
    pipeId?: number;
    page?: number;
    pageSize?: number;
};

export type DistributionSearchItemDto = {
    id: number;
    name: string;
    pipeId: number | null;
    pipeName: string | null;
    brandName: string | null;
    geography: string | null;
    language: string | null;
    currency: string | null;
};

export type DistributionSearchResponseDto = {
    items: Array<DistributionSearchItemDto>;
    total: number;
};

export type AcLinkTargetDto = {
    id: number;
    name: string;
    pipeId: number;
    pipeName: string;
    language: LanguageDto;
    geography: GeographyDto;
    currency: CurrencyDto;
    /**
     * Brand's configured domain — used by the FE to construct the live URL identically to the row-level "View live" button.
     */
    brandDomain?: string;
    /**
     * Brand's short code (uppercase) — surfaced on pipe/distribution badges in the AC links expansion.
     */
    brandCode?: string;
    /**
     * Resolved `Page.path` of the target distribution's main landing page. Used when an AC link item has no explicit `pageId`.
     */
    mainLandingPagePath?: string;
};

export type AcLinkDto = {
    key: string;
    /**
     * The linked (target) distribution id as stored in the acLinks item — present even when the target is deleted or missing, so the FE can name it.
     */
    targetDistributionId: number;
    /**
     * True when the target distribution exists but has been (soft-)deleted. The link is broken; `distribution` still carries the deleted target’s details for display. When the target is entirely missing (never existed / hard-removed), this is absent and `distribution` is undefined.
     */
    targetDeleted?: boolean;
    pageId?: string;
    /**
     * Resolved page path inside the target distribution's pipe. Omitted when the link has no pageId or the referenced page was deleted.
     */
    pagePath?: string;
    /**
     * Target distribution details. Populated for a live OR a soft-deleted target (see `targetDeleted`); undefined only when the target is entirely missing (never existed / hard-removed).
     */
    distribution?: AcLinkTargetDto;
};

export type DistributionAcLinksResponseDto = {
    links: Array<AcLinkDto>;
};

export type PipeConfigItemDto = {
    id: string;
    name: string;
    type: string;
    /**
     * Active version number the data came from
     */
    version: number;
    enabled: boolean;
    /**
     * The distribution this row is the winner for, or null for the pipe/brand-level context (a pipe with no distributions yet).
     */
    distributionId?: number | null;
    /**
     * Human label for the distribution (geo-lang + name), resolved by pipehouse. Null for the pipe/brand-level row.
     */
    distributionLabel?: string | null;
    /**
     * Active version rule tree, or null for a global config.
     */
    rules?: {
        [key: string]: unknown;
    } | null;
    publicData: {
        [key: string]: unknown;
    };
    /**
     * `pipe_config` = the winning pipe config; `brand` = the brand's Klaviyo fallback (shown when no KLAVIYO config wins).
     */
    source: 'pipe_config' | 'brand';
};

export type DistributionCreateDto = {
    /**
     * Name / path of distribution. Must end with "-ph" to satisfy S3 IAM policy.
     */
    name: string;
    pipeId: number;
    languageId?: number;
    geographyId?: number;
    currencyId?: number;
};

export type DistributionCopyPreviewDto = {
    /**
     * A name that is free in the source distribution's URL scope (brand + geography + language).
     */
    suggestedName: string;
    constantOverrideCount: number;
    variableOverrideCount: number;
    integrationOverrideCount: number;
    /**
     * True when the source has a per-distribution landing-page override, which the copy inherits.
     */
    hasLandingPageOverride: boolean;
};

export type DistributionCopyDto = {
    /**
     * Name / path of the new distribution. Must end with "-ph" to satisfy S3 IAM policy.
     */
    name: string;
    /**
     * Copy the source distribution's constant overrides (group="distribution"). Defaults to true.
     */
    copyConstantOverrides?: boolean;
    /**
     * Copy the source distribution's variable overrides (kind="distribution_override"). Defaults to true.
     */
    copyVariableOverrides?: boolean;
    /**
     * Copy the source distribution's integration config overrides (group="distribution"). Defaults to true.
     */
    copyIntegrationOverrides?: boolean;
    languageId: number;
    geographyId: number;
    currencyId: number;
};

export type DistributionUpdateDto = {
    /**
     * Name / path of distribution. Must end with "-ph" to satisfy S3 IAM policy.
     */
    name: string;
    pipeId: number;
    languageId?: number;
    geographyId?: number;
    currencyId?: number;
};

export type DistributionUpdateStatusDto = {
    /**
     * DistributionStatus to assign to this distribution — independent of any deploy.
     */
    statusId: number;
};

export type DistributionBulkUpdateStatusDto = {
    ids: Array<number>;
    statusId: number;
};

export type DistributionBulkUpdateStatusResponseDto = {
    updated: number;
};

export type DistributionConstantOverrideDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: ConstVarType;
    brandId?: number;
    pipeId?: number;
    brand?: BrandBaseDto;
    pipe?: PipeMinimalDto;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto | ConstantOfferGroupValueDto | ConstantPriceCategoryValueDto | ConstantDistributionLinksValueDto;
    /**
     * Reference configuration object. Required for reference constants, forbidden for statics.
     */
    ref?: {
        [key: string]: unknown;
    };
    config?: ConstantConfigDto;
    distributionId: number;
    overridesConstantId: number;
    overridesConstant: ConstantsBaseDto;
};

export type DistributionConstantOverridesPayloadDto = {
    overridable: Array<ConstantsBaseDto>;
    overrides: Array<DistributionConstantOverrideDto>;
};

export type CreateDistributionConstantOverrideDto = {
    /**
     * Id of the existing pipe / brand / global constant being overridden. Must be in the distribution pipe's scope chain.
     */
    overridesConstantId: number;
    /**
     * Static override value. Shape must match the original constant's type. Mutually exclusive with `ref`.
     */
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto | ConstantOfferGroupValueDto | ConstantPriceCategoryValueDto;
    /**
     * Reference-based override (e.g. a different OFFER_GROUP ref per distribution). Mutually exclusive with `value`.
     */
    ref?: {
        [key: string]: unknown;
    };
};

export type UpdateDistributionConstantOverrideDto = {
    value?: {
        [key: string]: unknown;
    };
    ref?: {
        [key: string]: unknown;
    };
};

export type DistributionVariableOverrideDto = {
    id: number;
    distributionId: number;
    overridesVariableId: number;
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto;
    overridesVariable: VariableBaseDto;
};

export type DistributionVariableOverridesPayloadDto = {
    overridable: Array<VariableOverridableDto>;
    overrides: Array<DistributionVariableOverrideDto>;
};

export type CreateDistributionVariableOverrideDto = {
    /**
     * Id of the variable definition being defaulted/overridden. Must be in the pipe's scope chain (global / brand / pipe).
     */
    overridesVariableId: number;
    value: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto;
};

export type UpdateDistributionVariableOverrideDto = {
    value?: ConstantIntegerValueDto | ConstantStringValueDto | ConstantBooleanValueDto | ConstantNumberValueDto | ConstantDateValueDto;
};

export type DistributionIntegrationOverrideDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * Dot object string, lowercase
     */
    name: string;
    description?: string;
    type: IntegrationType;
    brandId?: number;
    pipeId?: number;
    brand?: number;
    pipe?: number;
    /**
     * Polymorphic value object containing its own type discriminator
     */
    value: IntegrationRawValueDto | IntegrationPipeOrdersValueDto | IntegrationGtmValueDto | IntegrationBugsnagValueDto | IntegrationFitnessFunctionsValueDto | IntegrationTrackingPropertiesValueDto | IntegrationKlaviyoValueDto | IntegrationSegmentValueDto | IntegrationCdpValueDto | IntegrationGeoDeviceValueDto | IntegrationExitIntentValueDto | IntegrationCheckoutValueDto | IntegrationFraudNetValueDto | IntegrationBuildSettingsValueDto | IntegrationPagePreloadValueDto | IntegrationIntercomValueDto;
    distributionId: number;
    overridesIntegrationId: number;
    /**
     * Resolved to 'inherit' when the row stores no forced state, so the client never has to treat null and 'inherit' as different things.
     */
    enabledState: IntegrationOverrideState;
    overridesIntegration: IntegrationsBaseDto;
};

export type DistributionIntegrationOverridesPayloadDto = {
    /**
     * Every pipe / brand / global integration in scope, in the release build's own precedence order (pipe → brand → global). Integrations the pipe has switched off are included, since a distribution can switch one back on — `pipeDisabledIntegrationIds` says which those are.
     */
    overridable: Array<IntegrationsBaseDto>;
    overrides: Array<DistributionIntegrationOverrideDto>;
    /**
     * The pipe's `disabledIntegrationIds` — the baseline an override's `enabledState` overrides. Lets the panel show the effective on/off without a second round-trip.
     */
    pipeDisabledIntegrationIds: Array<number>;
};

export type CreateDistributionIntegrationOverrideDto = {
    /**
     * Id of the existing pipe / brand / global integration being overridden. Must be in the distribution pipe's scope chain.
     */
    overridesIntegrationId: number;
    /**
     * Complete replacement config for this distribution. Its `type` must match the underlying integration's. Whole-value replace, not a per-field merge — a later edit to the base config does not reach a distribution that has an override. Optional: a row may carry only an `enabledState`, leaving the base config in place.
     */
    value?: IntegrationRawValueDto | IntegrationPipeOrdersValueDto | IntegrationGtmValueDto | IntegrationBugsnagValueDto | IntegrationFitnessFunctionsValueDto | IntegrationTrackingPropertiesValueDto | IntegrationKlaviyoValueDto | IntegrationSegmentValueDto | IntegrationCdpValueDto | IntegrationGeoDeviceValueDto | IntegrationExitIntentValueDto | IntegrationCheckoutValueDto | IntegrationFraudNetValueDto | IntegrationBuildSettingsValueDto | IntegrationPagePreloadValueDto | IntegrationIntercomValueDto;
    /**
     * Per-distribution on/off. 'inherit' (the default) leaves the pipe's own `disabledIntegrationIds` decision standing; 'enabled' and 'disabled' override it in both directions, so a distribution can run an integration the pipe has switched off. Omit on update to leave it unchanged; send 'inherit' to clear it.
     */
    enabledState?: IntegrationOverrideState;
};

export type UpdateDistributionIntegrationOverrideDto = {
    /**
     * Complete replacement config for this distribution. Its `type` must match the underlying integration's. Whole-value replace, not a per-field merge — a later edit to the base config does not reach a distribution that has an override. Optional: a row may carry only an `enabledState`, leaving the base config in place.
     */
    value?: IntegrationRawValueDto | IntegrationPipeOrdersValueDto | IntegrationGtmValueDto | IntegrationBugsnagValueDto | IntegrationFitnessFunctionsValueDto | IntegrationTrackingPropertiesValueDto | IntegrationKlaviyoValueDto | IntegrationSegmentValueDto | IntegrationCdpValueDto | IntegrationGeoDeviceValueDto | IntegrationExitIntentValueDto | IntegrationCheckoutValueDto | IntegrationFraudNetValueDto | IntegrationBuildSettingsValueDto | IntegrationPagePreloadValueDto | IntegrationIntercomValueDto;
    /**
     * Per-distribution on/off. 'inherit' (the default) leaves the pipe's own `disabledIntegrationIds` decision standing; 'enabled' and 'disabled' override it in both directions, so a distribution can run an integration the pipe has switched off. Omit on update to leave it unchanged; send 'inherit' to clear it.
     */
    enabledState?: IntegrationOverrideState;
};

export type DistributionLandingDto = {
    /**
     * The distribution's landing-page id, or null when unset.
     */
    landingPageId: string | null;
};

export type UpdateDistributionLandingDto = {
    /**
     * Id of the page to use as this distribution's landing. Must be a page in the distribution's pipe flagged `isLanding`. Null (or omitted) clears the override and falls back to the pipe default.
     */
    landingPageId?: string | null;
};

export type SyncedIngressResolvedDistributionDto = {
    id: number;
    name: string;
    geographyName: string;
    languageName: string;
    brandCode: string;
};

export type SyncedIngressDestinationDto = {
    id: number;
    url: string;
    proportion: number;
    active: boolean;
    ruleSetId?: number | null;
    /**
     * Resolved pipehouse distribution, or null when the URL did not match one.
     */
    distribution?: SyncedIngressResolvedDistributionDto | null;
};

export type SyncedIngressDto = {
    id: number;
    /**
     * Ingress system ingress id (deep-link target).
     */
    externalId: number;
    path: string;
    /**
     * /{geo}-{lang}/{path} — the gateway match path.
     */
    routablePath: string;
    brandShortName: string;
    brandName: string;
    languageName: string;
    geographyName: string;
    active: boolean;
    /**
     * Tag names attached to the ingress on the source side.
     */
    tags: Array<string>;
    /**
     * True when the ingress carries the `dev-test` tag — test-only, excluded from distribution badges + the "active ingress" filter in production.
     */
    isDevTest: boolean;
    externalUpdatedAt: string;
    syncedAt: string;
    destinationCount: number;
    activeDestinationCount: number;
    destinations: Array<SyncedIngressDestinationDto>;
};

export type IngressSyncStatusDto = {
    enabled: boolean;
    apiHostConfigured: boolean;
    uiBaseUrlConfigured: boolean;
    lastFullPullAt?: string | null;
    watermarkIso?: string | null;
    ingressCount: number;
    activeDestinationCount: number;
    /**
     * Active destinations whose URL did not resolve to a distribution.
     */
    unresolvedActiveDestinationCount: number;
    /**
     * Whether `dev-test`-tagged ingresses are excluded from distribution badges + the "active ingress" filter in this environment (true only in production).
     */
    devTestExcludedFromBadges: boolean;
};

export type SyncedIngressListResponseDto = {
    items: Array<SyncedIngressDto>;
    total: number;
    status: IngressSyncStatusDto;
};

export type IngressSyncRunResponseDto = {
    ok: boolean;
    /**
     * Whether a sync job was enqueued (false when disabled).
     */
    enqueued: boolean;
};

export type StyleDefaultsDto = {
    /**
     * Default style data
     */
    data: StyleDataDto;
    /**
     * Default base CSS for a new stylesheet
     */
    baseCss: string;
};

export type CreateStyleDto = {
    /**
     * Name of the style
     */
    name: string;
    /**
     * Style data as JSON
     */
    data: StyleDataDto;
    /**
     * Raw CSS appended after the generated :root { --... } block
     */
    baseCss?: string;
    /**
     * Head records emitted into <head> at runtime (unhead compatible)
     */
    headRecords: Array<HeadRecordGoogleFontDto | HeadRecordAdobeFontDto | HeadRecordRawLinkDto | HeadRecordRawScriptDto>;
};

export type StyleListQueryDto = {
    page?: number;
    pageSize?: number;
};

export type CloneStyleDto = {
    /**
     * Name for the cloned style
     */
    name: string;
};

export type StylePipeUsageListDto = {
    /**
     * How many pipes point at this stylesheet (excluding `excludePipeId` when given). Exact total; `pipes` may be a truncated sample of it.
     */
    pipeCount: number;
    /**
     * Those pipes, name-sorted, capped so a legacy stylesheet shared by dozens of pipes cannot blow up the UI. Compare the length against `pipeCount` to tell whether it was truncated.
     */
    pipes: Array<PipeStyleUsageDto>;
};

export type StylePipeUsageQueryDto = {
    /**
     * Omit this pipe from the result, so the caller can phrase the answer as "shared with N *other* pipes". Used by the pipe editor's Theme tab.
     */
    excludePipeId?: number;
};

export type StyleColorRefDto = {
    type: 'color_ref';
    /**
     * Name of another StyleDataDto color entry to resolve through
     */
    key: string;
};

export type StyleTypographyRecordDto = {
    type: 'fontfamily';
    data: string;
};

export type StyleFontFamilyRefDto = {
    type: 'fontfamily_ref';
    /**
     * Name of another StyleDataDto font-family entry to resolve through
     */
    key: string;
};

export type StyleSizeRefDto = {
    type: 'size_ref';
    /**
     * Name of another StyleDataDto size entry to resolve through
     */
    key: string;
};

export type StyleFontWeightRecordDto = {
    type: 'weight';
    /**
     * Font weight value
     */
    data: string;
};

export type StyleFontWeightRefDto = {
    type: 'weight_ref';
    /**
     * Name of another StyleDataDto font-weight entry to resolve through
     */
    key: string;
};

export type StyleShadowRecordDto = {
    type: 'shadow';
    offsetX: StyleSizeRecordDto;
    offsetY: StyleSizeRecordDto;
    blur: StyleSizeRecordDto;
    spread: StyleSizeRecordDto;
    color: StyleColorRecordDto;
    inset: boolean;
};

export type StyleShadowRefDto = {
    type: 'shadow_ref';
    /**
     * Name of another StyleDataDto box-shadow entry to resolve through
     */
    key: string;
};

export type HeadRecordGoogleFontDto = {
    kind: 'google_font';
    id: string;
    family: string;
    weights: Array<number>;
    display?: 'auto' | 'swap' | 'block' | 'fallback' | 'optional';
};

export type HeadRecordAdobeFontDto = {
    kind: 'adobe_font';
    id: string;
    /**
     * Adobe Fonts (Typekit) Kit ID — the token before .css in the CDN URL
     */
    kitId: string;
};

export type HeadRecordRawLinkDto = {
    kind: 'raw_link';
    id: string;
    href: string;
    rel: string;
    crossorigin?: boolean;
};

export type HeadRecordRawScriptDto = {
    kind: 'raw_script';
    id: string;
    src?: string;
    innerHTML?: string;
    async?: boolean;
    defer?: boolean;
};

export type StyleListResponseDto = {
    items: Array<StyleDto>;
    total: number;
};

export enum PipeCheckRunStatus {
    QUEUED = 'queued',
    PROCESSING = 'processing',
    SUCCESS = 'success',
    FAILED = 'failed',
    ERROR = 'error'
}

/**
 * manual (Ctrl+D) or deploy (a run after a deploy)
 */
export enum PipeCheckRunTrigger {
    MANUAL = 'manual',
    DEPLOY = 'deploy'
}

export type ListPipeCheckRunsQueryDto = {
    page?: number;
    pageSize?: number;
    /**
     * only this distribution’s runs
     */
    distributionId?: number;
    /**
     * only the runs of this release (the release list’s Check test logs)
     */
    releaseId?: number;
    /**
     * only the runs of this pipe’s distributions
     */
    pipeId?: number;
    /**
     * only the runs of this brand’s pipes
     */
    brandId?: number;
    status?: PipeCheckRunStatus;
    /**
     * manual (Ctrl+D) or deploy (a run after a deploy)
     */
    trigger?: PipeCheckRunTrigger;
};

export type PipeCheckInstructionsDto = {
    /**
     * pipe-check instructions (pipe-check/src/instructions/instructions.schema.ts)
     */
    instructions: {
        [key: string]: unknown;
    };
    /**
     * What the builder could not decide; read before running
     */
    warnings: Array<string>;
    /**
     * Pages walked from the landing page
     */
    pages: number;
};

export type PipeCheckQuestionOptionDto = {
    /**
     * what a config's `answers` stores for it: the option's value, or its id when it has none
     */
    value: string | number | boolean;
    /**
     * the text the visitor sees
     */
    label: string;
};

export type PipeCheckQuestionDto = {
    variableKey: string;
    /**
     * several answers can be picked; a config gives one
     */
    multi: boolean;
    options: Array<PipeCheckQuestionOptionDto>;
};

export type PipeCheckPageQuestionsDto = {
    pageId: string;
    path: string;
    questions: Array<PipeCheckQuestionDto>;
};

export type PipeCheckQuestionsDto = {
    pages: Array<PipeCheckPageQuestionsDto>;
};

export type PipeCheckViewportDto = {
    width?: number;
    height?: number;
};

export type PipeCheckRunConfigDto = {
    /**
     * the address the run signs up with; a fresh automations+pc+<random>@nutrameg.com when not given
     */
    email?: string;
    /**
     * what the visitor types as their name; "Test" when not given
     */
    firstName?: string;
    /**
     * answers global.gender
     */
    gender?: 'female' | 'male';
    age?: number;
    /**
     * cm; the imperial ft + in are derived
     */
    heightCm?: number;
    /**
     * kg; the imperial lb are derived
     */
    weightKg?: number;
    /**
     * kg; the imperial lb are derived
     */
    targetWeightKg?: number;
    units?: 'imperial' | 'metric';
    /**
     * a Playwright device name ("iPhone 13"); its size applies unless viewport is given. iPhone SE (3rd gen) when neither device nor viewport is given
     */
    device?: string;
    viewport?: PipeCheckViewportDto;
    /**
     * answer per question, by variable key: { "global.gender": "female" } (option value, id or label)
     */
    answers?: {
        [key: string]: unknown;
    };
    /**
     * input values by variable key or name: { "firstName": "Andre", "weightLb": 180 }
     */
    fills?: {
        [key: string]: unknown;
    };
};

export type StartPipeCheckRunDto = {
    /**
     * one of the distribution's saved configs to run; `config` is then ignored
     */
    configId?: number;
    /**
     * the dialog's form, for a run of no saved config
     */
    config?: PipeCheckRunConfigDto;
};

export type PipeCheckConfigDto = {
    id: number;
    name: string;
    config: PipeCheckRunConfigDto;
    /**
     * run after every deploy (while runAfterDeploy is on); an inactive one only runs from the dialog
     */
    isActive: boolean;
    /**
     * its place in the list
     */
    position: number;
};

export type PipeCheckSettingDto = {
    /**
     * a run of every active config is queued after every deploy of the distribution
     */
    runAfterDeploy: boolean;
    /**
     * in list order
     */
    configs: Array<PipeCheckConfigDto>;
    updatedByName?: string | null;
    updatedAt?: string | null;
};

export type UpdatePipeCheckSettingDto = {
    /**
     * only while an active config exists
     */
    runAfterDeploy: boolean;
};

export type SavePipeCheckConfigDto = {
    /**
     * unique within the distribution
     */
    name: string;
    /**
     * the dialog sends its form; none = the defaults
     */
    config?: PipeCheckRunConfigDto;
    /**
     * default true
     */
    isActive?: boolean;
};

export type PipeCheckRunListItemDto = {
    /**
     * the runId
     */
    id: string;
    distributionId: number;
    distributionName: string;
    pipeId: number;
    releaseId?: number | null;
    status: PipeCheckRunStatus;
    error?: string | null;
    /**
     * steps that passed
     */
    stepsPassed: number;
    /**
     * every step, 0 until the run is done
     */
    stepsTotal: number;
    durationMs?: number | null;
    createdByName?: string | null;
    /**
     * manual (the Ctrl+D dialog) or deploy (a run after a deploy)
     */
    trigger: PipeCheckRunTrigger;
    /**
     * the saved config it ran (its name then); null for a run of the dialog's form
     */
    configName?: string | null;
    createdAt: string;
    /**
     * the newest run of its distribution: kept, it cannot be deleted
     */
    isLatest: boolean;
};

export type PipeCheckRunListResponseDto = {
    runs: Array<PipeCheckRunListItemDto>;
    total: number;
    page: number;
    pageSize: number;
};

export type PipeCheckPixelChangesDto = {
    /**
     * the run compared with
     */
    previousRunId: string;
    /**
     * share of each step's screenshot that differs (0..1), by step number; a step with nothing to compare is left out
     */
    steps: {
        [key: string]: number;
    };
};

export type PipeCheckRunStepDto = {
    /**
     * 1-based; names the step routes
     */
    number: number;
    action: string;
    label?: string;
    /**
     * the path of the page the step acts on; runs built before it was recorded have none
     */
    page?: string;
    status: 'passed' | 'failed' | 'skipped';
    durationMs: number;
    error?: string;
    /**
     * the whole error when it says more than its first line: Playwright's call log (what it waited for, what it found, what kept it from acting)
     */
    errorDetails?: string;
    /**
     * the step as queued (selector, expect, value, timeout…), without its label and page
     */
    instruction?: {
        [key: string]: unknown;
    } | null;
    /**
     * the page the step failed on
     */
    url?: string;
    /**
     * a screenshot was taken and uploaded
     */
    hasScreenshot: boolean;
    /**
     * a console file was written (only when the step logged)
     */
    hasConsole: boolean;
    consoleErrors: number;
    consoleWarnings: number;
    networkErrors: number;
};

export type PipeCheckRunDto = {
    /**
     * the runId
     */
    id: string;
    distributionId: number;
    distributionName: string;
    pipeId: number;
    releaseId?: number | null;
    status: PipeCheckRunStatus;
    error?: string | null;
    warnings: Array<string>;
    baseUrl?: string | null;
    durationMs?: number | null;
    /**
     * false when the run is done but its files never reached S3 (see uploadError)
     */
    uploaded: boolean;
    uploadError?: string | null;
    createdByName?: string | null;
    /**
     * manual (the Ctrl+D dialog) or deploy (a run after a deploy)
     */
    trigger: PipeCheckRunTrigger;
    /**
     * the saved config it ran (its name then); null for a run of the dialog's form
     */
    configName?: string | null;
    /**
     * how much each step differs from the previous run, worked out once after the run; null until then, and for older runs
     */
    pixelChanges?: PipeCheckPixelChangesDto | null;
    createdAt: string;
    startedAt?: string | null;
    finishedAt?: string | null;
    /**
     * empty until the run is done
     */
    steps: Array<PipeCheckRunStepDto>;
};

export type PipeCheckChangedPageDto = {
    id: string;
    path: string;
    kind: 'added' | 'modified';
};

export type PipeCheckComponentValueChangeDto = {
    /**
     * the field name, or "text (group.key)"
     */
    what: string;
    before?: string | null;
    after?: string | null;
};

export type PipeCheckChangedComponentDto = {
    nodeId: string;
    type: string;
    kind: 'added' | 'modified';
    changes: Array<PipeCheckComponentValueChangeDto>;
    /**
     * changes with no value to show: events, rules, moved…
     */
    notes: Array<string>;
};

export type PipeCheckListedComponentDto = {
    nodeId: string;
    type: string;
    kind: 'added' | 'modified' | 'removed';
    changes: Array<PipeCheckComponentValueChangeDto>;
    /**
     * changes with no value to show: events, rules, moved, "with 3 inside"…
     */
    notes: Array<string>;
};

export type PipeCheckPageChangesDto = {
    /**
     * the page's id, or the User Component's
     */
    id: string;
    what: 'page' | 'userComponent';
    /**
     * the page path, or the User Component's title
     */
    name: string;
    kind: 'added' | 'modified';
    /**
     * what changed on the page itself: its path, title, events…
     */
    notes: Array<string>;
    components: Array<PipeCheckListedComponentDto>;
};

export type PipeCheckBeforeRunDto = {
    runId: string;
    releaseId?: number | null;
    createdAt: string;
};

export type PipeCheckChangedBoxDto = {
    nodeId: string;
    /**
     * the component type, e.g. Button
     */
    type: string;
    kind: 'added' | 'modified';
    x: number;
    y: number;
    width: number;
    height: number;
};

export type PipeCheckChangedStepDto = {
    number: number;
    /**
     * the page the step acts on was added or changed
     */
    pageChanged: boolean;
    /**
     * the screenshot's width in CSS px (boxes are placed against it)
     */
    frameWidth?: number | null;
    frameHeight?: number | null;
    boxes: Array<PipeCheckChangedBoxDto>;
    /**
     * the same step in the before run (its screenshot is the page before)
     */
    beforeStepNumber?: number | null;
};

export type PipeCheckRunChangesDto = {
    /**
     * false when there is nothing to compare: no release, its first deploy, no snapshot
     */
    available: boolean;
    unavailableReason?: string | null;
    releaseId?: number | null;
    /**
     * the release compared with
     */
    baseReleaseId?: number | null;
    pages: Array<PipeCheckChangedPageDto>;
    /**
     * changes no step can show on its own: "3 translations", "stylesheet", "page removed: 7-goal"…
     */
    other: Array<string>;
    /**
     * what each highlighted component was before, by nodeId
     */
    components: Array<PipeCheckChangedComponentDto>;
    /**
     * every added or changed page and User Component with all it added, changed and removed, on a screenshot or not
     */
    pageChanges: Array<PipeCheckPageChangesDto>;
    /**
     * an earlier run of the distribution on an older release (the compared one first), for before screenshots
     */
    before?: PipeCheckBeforeRunDto | null;
    /**
     * only the steps that show a change
     */
    steps: Array<PipeCheckChangedStepDto>;
};

export type PipeCheckPreviousRunDto = {
    runId: string;
    releaseId?: number | null;
    createdAt: string;
    status: PipeCheckRunStatus;
};

export type PipeCheckCompareStepDto = {
    number: number;
    /**
     * the same step in the previous run (same label on the same page, with a screenshot); null when it has none
     */
    previousNumber?: number | null;
};

export type PipeCheckRunCompareDto = {
    /**
     * the latest finished run of the distribution before this one whose files reached S3; null when there is none
     */
    previous?: PipeCheckPreviousRunDto | null;
    steps: Array<PipeCheckCompareStepDto>;
};

export type PriceProductObjectListQueryDto = {
    /**
     * Brand code to filter
     */
    brandCode?: string;
    /**
     * Search text in title or external id
     */
    search?: string;
    /**
     * Filter by Currency Code (e.g., EUR, USD)
     */
    currencyCode?: string;
    /**
     * Filter by payment type
     */
    paymentType?: 'recurring' | 'recurring_with_trial' | 'one_time' | 'gift';
    page?: number;
    pageSize?: number;
};

export type PriceProductObjectDetailsDto = {
    productType: 'digital' | 'physical';
    paymentType: 'recurring' | 'recurring_with_trial' | 'one_time' | 'gift';
    paymentInterval?: number | null;
    paymentIntervalUnit?: 'minute' | 'day' | 'month';
    amount: number;
    amountInEuro: number;
    reducedAmount?: number | null;
    reducedAmountInEuro?: number | null;
    trialPeriod?: number | null;
    trialPeriodUnit?: 'minute' | 'day' | 'month';
    trialAmount?: number | null;
    trialAmountInEuro?: number | null;
    id: string;
    title: string;
    publicTitle: {
        [key: string]: unknown;
    };
    groupTitle?: {
        [key: string]: unknown;
    };
    subscriptionSummary: {
        [key: string]: unknown;
    };
    features: Array<{
        [key: string]: unknown;
    }>;
    organizationalTags?: Array<string>;
    appleProductId?: {
        [key: string]: unknown;
    };
    appleUnsubscribeOfferId?: {
        [key: string]: unknown;
    };
    googleProductId?: {
        [key: string]: unknown;
    };
    googleBasePlanId?: {
        [key: string]: unknown;
    };
    googleUnsubscribeOfferId?: {
        [key: string]: unknown;
    };
    requireDoubleConfirmation: boolean;
    includeInABTest: boolean;
    unsubscribePageCode?: {
        [key: string]: unknown;
    };
    reducedAmountUnsubscribePageCode?: {
        [key: string]: unknown;
    };
    unsubscribeRestrictPeriod?: {
        [key: string]: unknown;
    };
    unsubscribeRestrictPeriodUnit?: {
        [key: string]: unknown;
    };
    currency: {
        id: string;
        code: string;
        symbol: string;
        decimalDigits: number;
        primerDecimalDigits: number;
    };
    paymentProviders: Array<{
        id: string;
        paymentProvider: {
            [key: string]: unknown;
        };
        paymentDescriptor?: string | null;
        originOrderPaymentDescriptor?: string | null;
        trialPaymentDescriptor?: string | null;
    }>;
    pipeProviders: Array<{
        id: string;
        provider: {
            [key: string]: unknown;
        };
        providerPriceObjectId: string;
    }>;
    placeholders: Array<{
        key: string;
        value: string;
        language: string;
    }>;
    priceProductObjectStatistic: {
        id: string;
        signupRevenueInEuro: number;
        signupRevenue: number;
        signupRevenueSynchronizedAt: string | null;
        totalRevenueInEuro: number;
        totalRevenue: number;
        totalRevenueSynchronizedAt: string | null;
    };
    useCase: {
        [key: string]: unknown;
    };
    status: {
        [key: string]: unknown;
    };
    isTest: boolean;
    createdAt: string;
    updatedAt?: string;
    prices: Array<{
        id: string;
        currency: {
            id?: string;
            code?: string;
            symbol?: string;
            decimalDigits?: number;
            primerDecimalDigits?: number;
        };
        currencyId: string;
        amount: number;
        amountInEuro: number;
        trialAmount?: number | null;
        trialAmountInEuro?: number | null;
        createdAt: string;
        updatedAt: string;
    }>;
};

export type PriceProductObjectPriceDto = {
    id: number;
    currency: CurrencyDto;
    amount: number;
    amountInEuro: number;
    trialAmount?: number;
    trialAmountInEuro?: number;
};

export type PriceProductObjectListItemDto = {
    id: number;
    externalId: string;
    brandCode: string;
    title: string;
    status: string;
    paymentType?: string | null;
    offerCount?: number;
    prices: Array<PriceProductObjectPriceDto>;
    createdAt: string;
};

export type PriceProductObjectListResponseDto = {
    items: Array<PriceProductObjectListItemDto>;
    total: number;
};

export type PriceProductObjectFullDto = {
    id: number;
    externalId: string;
    brandCode: string;
    title: string;
    status: string;
    paymentType?: string | null;
    offerCount?: number;
    prices: Array<PriceProductObjectPriceDto>;
    createdAt: string;
    details: PriceProductObjectDetailsDto;
};

export type PriceProductObjectOfferListQueryDto = {
    /**
     * Filter by PriceProductObject ID
     */
    priceProductObjectId?: number;
    /**
     * Search by PriceProductObject title
     */
    ppoTitle?: string;
    /**
     * Free-text search matching offer name (partial), offer id, or external PPO id (partial).
     */
    search?: string;
    /**
     * Filter by currency code
     */
    currencyCode?: string;
    /**
     * Filter by offer type. Pass '__none__' to find offers with no type set.
     */
    offerType?: 'BASIC' | 'PREMIUM' | 'SHOPPING_LIST' | 'SHOPPING_LIST_AND_PREMIUM' | 'BASIC_ANNUAL' | 'CHAT' | 'WORKOUTS' | 'BASIC_EXIT_INTENT' | 'PREMIUM_EXIT_INTENT' | '__none__';
    /**
     * Page number
     */
    page?: number;
    /**
     * Page size
     */
    pageSize?: number;
    sortBy?: 'id' | 'name';
    sortOrder?: 'ASC' | 'DESC';
};

export type OfferUsageQueryDto = {
    /**
     * Offer ids
     */
    ids: Array<number>;
    /**
     * Leave this price category out — the one whose form asks, so its own rungs are not reported as use elsewhere.
     */
    excludePriceCategoryId?: number;
};

export type PpopDetails = {
    type: 'ppop_details';
    trialPriceWoDiscount: number;
    trialPricePerPeriod: number;
    /**
     * The unit of the trial price per period
     */
    trialPricePeriodUnit?: 'minute' | 'day' | 'month';
    trialPriceDiscountPercent: number;
    trialPriceDiscountAmount?: number;
    basePriceWoDiscount: number;
    basePricePerPeriod: number;
    /**
     * The unit of the base price per period
     */
    basePricePeriodUnit?: 'minute' | 'day' | 'month';
    basePriceDiscountPercent: number;
    basePriceDiscountAmount?: number;
};

export type PriceProductObjectPriceOfferCreateDto = {
    currencyCode: string;
    details: PpopDetails;
};

export type CreatePriceProductObjectOfferDto = {
    priceProductObjectId: number;
    name: string;
    prices: Array<PriceProductObjectPriceOfferCreateDto>;
    offerType: 'BASIC' | 'PREMIUM' | 'SHOPPING_LIST' | 'SHOPPING_LIST_AND_PREMIUM' | 'BASIC_ANNUAL' | 'CHAT' | 'WORKOUTS' | 'BASIC_EXIT_INTENT' | 'PREMIUM_EXIT_INTENT';
};

export type PriceProductObjectPriceOfferDto = {
    id: number;
    externalPPOPId: string;
    priceProductObjectOfferId: number;
    currencyCode: string;
    details: PpopDetails;
};

export type PriceProductObjectOfferDto = {
    id: number;
    priceProductObjectId: number;
    externalPPOId: string;
    name: string;
    offerType?: string | null;
    prices: Array<PriceProductObjectPriceOfferDto>;
};

export type UpdatePriceProductObjectOfferDto = {
    name: string;
    prices: Array<PriceProductObjectPriceOfferCreateDto>;
    offerType: 'BASIC' | 'PREMIUM' | 'SHOPPING_LIST' | 'SHOPPING_LIST_AND_PREMIUM' | 'BASIC_ANNUAL' | 'CHAT' | 'WORKOUTS' | 'BASIC_EXIT_INTENT' | 'PREMIUM_EXIT_INTENT';
};

export type PriceProductObjectPrice = {
    id: number;
    externalId: string;
    priceProductObject: PriceProductObject;
    priceProductObjectId: number;
    currency: Currency;
    amount: number;
    amountInEuro: number;
    trialAmount?: number;
    trialAmountInEuro?: number;
    details: {
        [key: string]: unknown;
    };
};

export type PriceProductObject = {
    id: number;
    externalId: string;
    brandCode: string;
    title: string;
    details: {
        [key: string]: unknown;
    };
    status: string;
    prices: Array<PriceProductObjectPrice>;
    createdAt: string;
    updatedAt: string;
};

export type PriceProductObjectOfferRevision = {
    id: number;
    priceProductObjectOffer: PriceProductObjectOffer;
    action: {
        [key: string]: unknown;
    };
    name: string;
    offerType?: string | null;
    priceProductObjectId?: number | null;
    prices?: {
        [key: string]: unknown;
    } | null;
    user?: User | null;
    actorKind?: {
        [key: string]: unknown;
    } | null;
    createdAt: string;
};

export type PriceProductObjectOffer = {
    id: number;
    externalPPOId: string;
    priceProductObject: PriceProductObject;
    name: string;
    offerType?: string | null;
    prices: Array<PriceProductObjectPriceOffer>;
    latestRevision?: PriceProductObjectOfferRevision | null;
};

export type PriceProductObjectPriceOffer = {
    id: number;
    externalPPOPId: string;
    externalPPOId: string;
    priceProductObjectOffer: PriceProductObjectOffer;
    currency: Currency;
    details: PpopDetails;
};

export type OfferUsageSlotDto = {
    /**
     * Ladder key — s | m | l | xl
     */
    key: string;
    role: 'regular' | 'exit';
};

export type UsagePipeDto = {
    id: number;
    name: string;
    brandCode?: string | null;
};

export type UsageBrandDto = {
    id: number;
    name: string;
    code: string;
};

export type ConstantUsageDto = {
    id: number;
    group: string;
    name: string;
    pipe?: UsagePipeDto | null;
    brand?: UsageBrandDto | null;
};

export type ConstantOverrideUsageDto = {
    id: number;
    /**
     * `group.name` of the constant the override replaces
     */
    constantKey: string;
    distribution: DistributionPillDto;
};

export type ConstantReferencesDto = {
    constants: Array<ConstantUsageDto>;
    constantOverrides: Array<ConstantOverrideUsageDto>;
};

export type OfferUsagePriceCategoryDto = {
    id: number;
    name: string;
    slots: Array<OfferUsageSlotDto>;
    /**
     * Where the category itself is used — the pipes the offer reaches through it
     */
    usedBy: ConstantReferencesDto;
};

export type OfferUsageConstantDto = {
    id: number;
    group: string;
    name: string;
    pipe?: UsagePipeDto | null;
    brand?: UsageBrandDto | null;
    roles: Array<'regular' | 'exit'>;
};

export type OfferUsageOverrideDto = {
    id: number;
    /**
     * `group.name` of the constant the override replaces
     */
    constantKey: string;
    distribution: DistributionPillDto;
    roles: Array<'regular' | 'exit'>;
};

export type OfferUsageDto = {
    offerId: number;
    priceCategories: Array<OfferUsagePriceCategoryDto>;
    constants: Array<OfferUsageConstantDto>;
    constantOverrides: Array<OfferUsageOverrideDto>;
};

export type OfferUsageListDto = {
    items: Array<OfferUsageDto>;
};

export type PriceProductObjectOfferListDto = {
    items: Array<PriceProductObjectOfferDto>;
    total: number;
    page: number;
    pageSize: number;
};

export type CurrencyListQueryDto = {
    /**
     * Search by name or code
     */
    search?: string;
    /**
     * Page number
     */
    page?: number;
    /**
     * Page size
     */
    pageSize?: number;
};

export type CurrencyListResponseDto = {
    items: Array<CurrencyDto>;
    total: number;
};

export type ListDevJobsQueryDto = {
    /**
     * Page number
     */
    page?: number;
    /**
     * Page size
     */
    pageSize?: number;
};

export type CreateDevJobDto = {
    type: 'seed_currencies' | 'seed_geographies' | 'seed_languages' | 'seed_variables' | 'sample_live_logs' | 'seed_translations' | 'seed_media' | 'migrate_storage_to_subfolders' | 'cleanup_legacy_storage_root' | 'heal_overlapping_keys' | 'heal_image_fields' | 'seed_funnel_markers' | 'detect_entity_duplicates' | 'remove_entity_duplicates' | 'seed_constants' | 'validate_jsonb_conversion' | 'materialize_distribution_links' | 'backfill_pipe_content_brief' | 'detect_distribution_url_collisions' | 'heal_ingress_distributions' | 'detect_invalid_field_values' | 'backfill_media_pipe_links' | 'seed_countries' | 'import_default_pipe_redirects' | 'publish_default_pipe_redirects' | 'heal_orphaned_integrations' | 'backfill_translation_revision_tz' | 'backfill_release_build_commits' | 'pipe_check_ping' | 'pipe_check_screenshot';
    params?: {
        [key: string]: unknown;
    };
};

export type DevJobResponseDto = {
    id: number;
    type: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    /**
     * Created by user name
     */
    createdByName: string;
    logs?: Array<{
        [key: string]: unknown;
    }>;
    params?: {
        [key: string]: unknown;
    };
};

export type DevJobListItemDto = {
    id: number;
    type: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    /**
     * Created by user name
     */
    createdByName: string;
    /**
     * Whether the job was created as a dry run (wrote nothing)
     */
    dryRun: boolean;
};

export type DevJobListResponseDto = {
    jobs: Array<DevJobListItemDto>;
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
};

export type JobTypeResponseDto = {
    /**
     * The unique identifier/value for the job type
     */
    value: 'seed_currencies' | 'seed_geographies' | 'seed_languages' | 'seed_variables' | 'sample_live_logs' | 'seed_translations' | 'seed_media' | 'migrate_storage_to_subfolders' | 'cleanup_legacy_storage_root' | 'heal_overlapping_keys' | 'heal_image_fields' | 'seed_funnel_markers' | 'detect_entity_duplicates' | 'remove_entity_duplicates' | 'seed_constants' | 'validate_jsonb_conversion' | 'materialize_distribution_links' | 'backfill_pipe_content_brief' | 'detect_distribution_url_collisions' | 'heal_ingress_distributions' | 'detect_invalid_field_values' | 'backfill_media_pipe_links' | 'seed_countries' | 'import_default_pipe_redirects' | 'publish_default_pipe_redirects' | 'heal_orphaned_integrations' | 'backfill_translation_revision_tz' | 'backfill_release_build_commits' | 'pipe_check_ping' | 'pipe_check_screenshot';
    /**
     * Human-readable label for the UI dropdown
     */
    label: string;
    /**
     * Detailed description of what the job does
     */
    description: string;
    /**
     * When true, the UI must gate the Create button behind a "type CONFIRM to enable" input.
     */
    requiresConfirmation: boolean;
    /**
     * When true, the job accepts { dryRun: true } and writes nothing under it, so the UI offers a Dry run switch.
     */
    supportsDryRun: boolean;
};

export type DefaultPipeDistributionDto = {
    id: number;
    name: string;
    geographyName: string;
    languageName: string;
    pipeId: number;
    pipeName: string;
};

export type DefaultPipeDto = {
    id: number;
    brandId: number;
    distribution?: DefaultPipeDistributionDto | null;
    isLegacy: boolean;
    targetPath: string;
    targetMissing: boolean;
    geographies: Array<GeographyDto>;
    servedCountryCodes: Array<string>;
    createdAt: string;
    updatedAt: string;
};

export type DefaultPipeBrandGroupDto = {
    brandId: number;
    brandName: string;
    brandCode: string;
    domain: string;
    siteBucketName: string;
    publishable: boolean;
    hasWorldwideDefault: boolean;
    plannedRedirectCount: number;
    appliedRedirectCount: number;
    pendingRedirectCount: number;
    legacyCount: number;
    defaultPipes: Array<DefaultPipeDto>;
};

export type DefaultPipeGeographyRefDto = {
    id: number;
    name: string;
    isDefault: boolean;
    countryCount: number;
    countryCodes: Array<string>;
};

export type DefaultPipeListResponseDto = {
    items: Array<DefaultPipeBrandGroupDto>;
    geographies: Array<DefaultPipeGeographyRefDto>;
};

export type DefaultPipeRedirectChangeDto = {
    fromKey: string;
    toPath: string;
    previousToPath?: string;
};

export type DefaultPipePublishResultDto = {
    brandId: number;
    dryRun: boolean;
    skippedReason?: string;
    plannedCount: number;
    created: Array<DefaultPipeRedirectChangeDto>;
    updated: Array<DefaultPipeRedirectChangeDto>;
    deleted: Array<DefaultPipeRedirectChangeDto>;
    unchangedCount: number;
    conflicts: Array<string>;
};

export type DefaultPipeAlignResultDto = {
    brandId: number;
    brandName: string;
    dryRun: boolean;
    skippedReason?: string;
    discovered: number;
    created: number;
    retargeted: number;
    removed: number;
    unchanged: number;
    unpublished: number;
    notes: Array<string>;
};

export type DefaultPipePublishRequestDto = {
    dryRun?: boolean;
};

export type DefaultPipeAlignRequestDto = {
    dryRun?: boolean;
    prune?: boolean;
};

export type DefaultPipeCreateDto = {
    distributionId: number;
    geographyIds: Array<number>;
};

export type DefaultPipeUpdateDto = {
    distributionId?: number;
    geographyIds?: Array<number>;
};

export type FigmaFileListQueryDto = {
    pipeId?: number;
    page?: number;
    pageSize?: number;
    search?: string;
};

export enum FigmaSyncStatus {
    IDLE = 'idle',
    QUEUED = 'queued',
    RUNNING = 'running',
    SUCCESS = 'success',
    ERROR = 'error'
}

export type FigmaFileDto = {
    id: number;
    name: string;
    fileKey: string;
    url: string;
    pipeId?: number;
    pipe?: PipeMinimalDto;
    figmaLastModified?: string;
    figmaThumbnailUrl?: string;
    lastSyncedAt?: string;
    lastSyncStatus: FigmaSyncStatus;
    lastSyncError?: string;
    previewCount: number;
    createdAt: string;
    updatedAt: string;
};

export type FigmaFileListResponseDto = {
    items: Array<FigmaFileDto>;
    total: number;
};

export type FigmaFramePreviewDto = {
    id: number;
    figmaFileId: number;
    canvasNodeId: string;
    canvasName: string;
    frameNodeId: string;
    frameName: string;
    orderIndex: number;
    width?: number;
    height?: number;
    /**
     * Relative URL to fetch the PNG image from the API
     */
    imageUrl: string;
};

export type FigmaFileWithPreviewsDto = {
    id: number;
    name: string;
    fileKey: string;
    url: string;
    pipeId?: number;
    pipe?: PipeMinimalDto;
    figmaLastModified?: string;
    figmaThumbnailUrl?: string;
    lastSyncedAt?: string;
    lastSyncStatus: FigmaSyncStatus;
    lastSyncError?: string;
    previewCount: number;
    createdAt: string;
    updatedAt: string;
    previews: Array<FigmaFramePreviewDto>;
};

export type FigmaFileCreateDto = {
    /**
     * Figma file URL (figma.com/design/<key>/... or /file/<key>)
     */
    url: string;
    name?: string;
    pipeId?: number;
};

export type FigmaFileUpdateDto = {
    name?: string;
    pipeId?: number | null;
};

export type TargetUserQueryDto = {
    /**
     * Whose data to read. Omitted = the caller’s own. Any other id is Admin-only.
     */
    userId?: number;
};

export type FigmaConnectionDto = {
    /**
     * Whether this author has a Figma connection at all. False means the agent’s Figma tools answer FIGMA_NOT_CONNECTED.
     */
    connected: boolean;
    /**
     * Present when connected, null when not. 'active' = usable; 'needs_reauth' = the grant is dead (revoked at Figma, or the server encryption key changed) and only a fresh Connect fixes it.
     */
    status?: 'active' | 'needs_reauth' | null;
    /**
     * Figma handle, so the card can say “Connected as …”.
     */
    figmaHandle?: string | null;
    /**
     * Figma account email as reported by GET /v1/me.
     */
    figmaEmail?: string | null;
    /**
     * Figma’s own user id. A STRING — Figma warns its user ids “appear to be numeric, but many cannot be represented in common number formats such as JavaScript numbers”.
     */
    figmaUserId?: string | null;
    /**
     * Space-separated scopes as GRANTED. Lets the card show “connected, but not for this” after a scope set widens, instead of failing at call time.
     */
    scopes?: string | null;
    /**
     * When the current access token expires. Refresh is lazy and transparent — this is shown for support, not as something the author must act on.
     */
    expiresAt?: string | null;
    /**
     * Last exchange or refresh failure, for the card and for support.
     */
    lastError?: string | null;
    /**
     * Whether this installation has a Figma OAuth app configured at all. False ⇒ the Connect button cannot work and an administrator has to set FIGMA_OAUTH_CLIENT_ID / _SECRET / _REDIRECT_URI.
     */
    configured: boolean;
};

export enum PipeExportType {
    EXPORT = 'export',
    IMPORT = 'import'
}

export enum PipeExportStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    AWAITING_USER = 'awaiting_user',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

export type PipeExportListQueryDto = {
    type?: PipeExportType;
    status?: PipeExportStatus;
    pipeId?: number;
    page?: number;
    pageSize?: number;
};

export type PipeExportListPaginatedResponseDto = {
    items: Array<{
        [key: string]: unknown;
    }>;
    total: number;
};

export type PipeExportUserSummaryDto = {
    id: number;
    name: string;
    email: string;
};

export type PipeExportDto = {
    id: string;
    type: PipeExportType;
    status: PipeExportStatus;
    sourcePipeId?: number | null;
    sourcePipeName?: string | null;
    targetBrandId?: number | null;
    targetPipeName?: string | null;
    createdPipeId?: number | null;
    fileSize?: number | null;
    errorMessage?: string | null;
    /**
     * 0–100 progress of the export/import job
     */
    progress: number;
    progressMessage?: string | null;
    analysisReport?: {
        [key: string]: unknown;
    } | null;
    createdBy: PipeExportUserSummaryDto | null;
    createdAt: string;
    updatedAt: string;
};

export type PipeExportCreateDto = {
    pipeId: number;
};

export type OfferGroupMappingTargetDto = {
    regularOfferId?: number | null;
    exitOfferId?: number | null;
};

export type OfferGroupMappingDto = {
    /**
     * Source constant name in the archive
     */
    sourceConstantName: string;
    target: OfferGroupMappingTargetDto;
};

export type PriceCategoryMappingDto = {
    /**
     * Source constant name in the archive
     */
    sourceConstantName: string;
    priceCategoryId?: number | null;
};

export type PipeExportConfirmDto = {
    targetBrandId: number;
    targetPipeName: string;
    offerGroupMappings?: Array<OfferGroupMappingDto>;
    priceCategoryMappings?: Array<PriceCategoryMappingDto>;
    ackWarnings?: boolean;
};

export type TranslationRequestKeyDto = {
    mode: string;
    html: string;
    uploaded?: string;
};

export type TranslationRequestResponseKeyDto = {
    html: string;
    /**
     * Verbatim TipTap document. Set by the JSON import path; when present the apply dialog writes this instead of re-parsing `html`, which is what makes a JSON round trip lossless.
     */
    content?: {
        [key: string]: unknown;
    };
};

export type TranslationRequestOptionsDto = {
    includeBrandKeys: boolean;
    onlyEmpty: boolean;
};

export enum TranslationRequestStatus {
    PENDING = 'pending',
    RUNNING = 'running',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

export type TranslationRequestListQueryDto = {
    pipeId?: number;
    targetLanguage?: string;
    status?: TranslationRequestStatus;
};

export type CreateTranslationRequestDto = {
    /**
     * Pipe id when launched from a pipe; omit for a global / brand-only translation request.
     */
    pipeId?: number;
    /**
     * Target language code (e.g. lv, de). Reference language is en.
     */
    targetLanguage: string;
    includeBrandKeys: boolean;
    onlyEmpty: boolean;
};

export enum TranslationRequestSource {
    AI = 'ai',
    XLSX = 'xlsx',
    JSON = 'json'
}

export type TranslationRequestDto = {
    id: number;
    pipeId?: number | null;
    brandId?: number | null;
    targetLanguage: string;
    referenceLanguage: string;
    model: string;
    requestKeys: {
        [key: string]: TranslationRequestKeyDto;
    };
    responseKeys?: {
        [key: string]: TranslationRequestResponseKeyDto;
    } | null;
    options: TranslationRequestOptionsDto;
    status: TranslationRequestStatus;
    source: TranslationRequestSource;
    /**
     * Total number of translation batches (set once processing starts)
     */
    totalChunks?: number | null;
    /**
     * Number of translation batches completed so far
     */
    completedChunks: number;
    errorMessage?: string | null;
    createdById: number;
    /**
     * Created by user name
     */
    createdByName?: string;
    createdAt: string;
    updatedAt: string;
    completedAt?: string | null;
};

export type TranslationRequestListResponseDto = {
    items: Array<TranslationRequestDto>;
};

export type TranslationKeyNameSuggestItemDto = {
    /**
     * The full temporary key as it stands in the pipe, e.g. "pipe.tmp.a1b2c3d4e5". Echoed back on the suggestion so the client can correlate.
     */
    tmpKey: string;
    /**
     * The visible copy of that translation, as plain text. Only its opening is used — the name describes the role of the copy, not its wording.
     */
    text: string;
    /**
     * The component the key is used by, e.g. "CTAButton".
     */
    componentType?: string;
    /**
     * The component field the copy fills, e.g. "label".
     */
    fieldName?: string;
    /**
     * Other translation key names used by the same component. The main namespace signal — a new key normally joins the namespace its siblings already use.
     */
    siblingKeys?: Array<string>;
    /**
     * Variable keys the same component reads or writes, e.g. "var.global.age". Says what the component is about — a component writing an age variable usually has age-label copy.
     */
    variableKeys?: Array<string>;
    /**
     * The page or user-component the key appears on.
     */
    pageName?: string;
};

export type TranslationKeyNameSuggestRequestDto = {
    /**
     * The pipe being saved (attribution / logging).
     */
    pipeId: number;
    /**
     * The temporary keys to name. Capped at 50 — the call sits on a dialog's open path.
     */
    items: Array<TranslationKeyNameSuggestItemDto>;
};

export type TranslationKeyNameSuggestionDto = {
    /**
     * The temporary key this suggestion is for, echoed verbatim from the request so the client can correlate without relying on ordering.
     */
    tmpKey: string;
    /**
     * The suggested name WITHOUT the "pipe." group prefix, e.g. "hero.ctaLabel". Validated server-side (camelCase dot path, never a reserved "tmp" first segment); `null` when the model gave nothing usable for this item.
     */
    name: string | null;
};

export type TranslationKeyNameSuggestResponseDto = {
    /**
     * One entry per requested item, in request order. Always the same length as `items`.
     */
    suggestions: Array<TranslationKeyNameSuggestionDto>;
    /**
     * True when the model call failed or produced nothing usable at all (provider error, timeout, malformed JSON). The response is still 200; the client simply has no suggestions to offer.
     */
    failed: boolean;
};

export type AiUsageSummaryQueryDto = {
    /**
     * Restrict to one user.
     */
    userId?: number;
    /**
     * Inclusive UTC start date (YYYY-MM-DD). Defaults to the first of the current month.
     */
    from?: string;
    /**
     * Inclusive UTC end date (YYYY-MM-DD). Defaults to today.
     */
    to?: string;
};

export type AiUsageSummaryRowDto = {
    /**
     * Null for unattributed calls.
     */
    userId: number | null;
    userName: string | null;
    /**
     * UTC calendar day, YYYY-MM-DD.
     */
    day: string;
    /**
     * agent | translate | translate_glossary | …
     */
    feature: string;
    /**
     * Number of model calls.
     */
    calls: number;
    promptTokens: number;
    outputTokens: number;
    costEur: number;
};

export type AiUsageTotalsDto = {
    calls: number;
    promptTokens: number;
    outputTokens: number;
    costEur: number;
};

export type AiUsageSummaryDto = {
    /**
     * Inclusive UTC start date, YYYY-MM-DD.
     */
    from: string;
    /**
     * Inclusive UTC end date, YYYY-MM-DD.
     */
    to: string;
    rows: Array<AiUsageSummaryRowDto>;
    totals: AiUsageTotalsDto;
};

export type AiUsageLimitWindowDto = {
    /**
     * EUR spent in this window so far.
     */
    spentEur: number;
    /**
     * Configured cap in EUR; null when this window is uncapped.
     */
    limitEur: number | null;
    /**
     * Null when uncapped.
     */
    remainingEur: number | null;
    /**
     * ISO timestamp when the window rolls over (UTC).
     */
    resetAt: string;
    exceeded: boolean;
    /**
     * Where the cap came from: 'user' = the account's own allowance (the normal case), 'global' = the AI_USER_*_EUR_LIMIT fallback, used only for accounts explicitly left unset.
     */
    source: 'user' | 'global';
};

export type AiUsageLimitsDto = {
    /**
     * False when either window is exhausted.
     */
    allowed: boolean;
    reason?: string | null;
    /**
     * Set when `allowed` is false. 'NO_ALLOWANCE' = the account has no AI budget at all and an admin must grant one (nothing resets); 'BUDGET_EXHAUSTED' = a real allowance was spent and returns at `resetAt`.
     */
    reasonCode?: 'NO_ALLOWANCE' | 'BUDGET_EXHAUSTED';
    day: AiUsageLimitWindowDto;
    month: AiUsageLimitWindowDto;
    /**
     * Whether this account has connected a third-party agent that can edit pipes through an open editor. Independent of the AI budget: such an agent runs its own model.
     */
    externalAgentConnected: boolean;
};

export type FunnelMarkerListQueryDto = {
    key?: string;
    page?: number;
    pageSize?: number;
};

export type FunnelMarkerCreatorSummaryDto = {
    id: number;
    name: string;
    email: string;
};

export type FunnelMarkerDto = {
    id: string;
    key: string;
    /**
     * Position in the funnel, 1 = first.
     */
    step: number;
    creator?: FunnelMarkerCreatorSummaryDto | null;
    createdAt: string;
    updatedAt: string;
};

export type FunnelMarkerListPaginatedResponseDto = {
    items: Array<FunnelMarkerDto>;
    total: number;
};

export type FunnelMarkerCreateDto = {
    key: string;
};

export type FunnelMarkerOrderDto = {
    /**
     * Every funnel marker id, first step first.
     */
    ids: Array<string>;
};

export type FunnelMarkerUpdateDto = {
    key?: string;
};

export type DistributionStatusListQueryDto = {
    name?: string;
    page?: number;
    pageSize?: number;
};

export type DistributionStatusListPaginatedResponseDto = {
    items: Array<DistributionStatusDto>;
    total: number;
};

export type DistributionStatusUsageDto = {
    distributionCount: number;
    pipeCount: number;
};

export type DistributionStatusCreateDto = {
    name: string;
    color: string;
};

export type DistributionStatusUpdateDto = {
    name?: string;
    color?: string;
};

export type CountryListQueryDto = {
    search?: string;
    geographyId?: number;
    page?: number;
    pageSize?: number;
    sortBy?: 'code' | 'name' | 'geography';
    sortOrder?: 'ASC' | 'DESC';
};

export type CountryDto = {
    id: number;
    code: string;
    name: string;
    geographyId: number;
    geography: GeographyDto;
};

export type CountryListResponseDto = {
    items: Array<CountryDto>;
    total: number;
};

export type OauthConsentScopeDto = {
    name: string;
    /**
     * What this scope lets the app do, in the words shown to the user.
     */
    consentLabel: string;
};

export type OauthAuthorizeRequestDto = {
    /**
     * The name the app registered itself under.
     */
    clientName: string;
    clientUri: string | null;
    /**
     * Host the browser will be sent back to once approved.
     */
    redirectHost: string;
    /**
     * What the app is asking to reach.
     */
    resourceName: string;
    resourceDescription: string;
    scopes: Array<OauthConsentScopeDto>;
    /**
     * Extra abilities the app did not ask for. Never pre-selected — the user opts in. Present because a scope a client never requests is otherwise unreachable: it cannot be a default, so nothing would ever grant it.
     */
    offeredScopes: Array<OauthConsentScopeDto>;
};

export type OauthConsentDto = {
    /**
     * The pending request id, from the `request` query parameter the authorize endpoint redirected with.
     */
    request: string;
    /**
     * True to grant the app the scopes it asked for, false to decline.
     */
    approve: boolean;
    /**
     * Scopes from `offeredScopes` the user chose to grant on top of what the app asked for. Anything the resource does not declare is dropped server-side.
     */
    additionalScopes?: Array<string>;
};

export type OauthConsentResponseDto = {
    /**
     * Absolute URL to navigate to. Carries the authorization code on approval, or `error=access_denied` on refusal.
     */
    redirectUrl: string;
};

export type OauthConnectionDto = {
    /**
     * Grant id — pass to DELETE to disconnect.
     */
    id: number;
    clientName: string;
    clientUri: string | null;
    /**
     * What this app was granted access to.
     */
    resourceName: string;
    scopes: Array<string>;
    connectedAt: string;
    /**
     * When the app last obtained a token. Null if it never has.
     */
    lastUsedAt: string | null;
};

export type FunnelTrafficOptionsQueryDto = {
    from: string;
    to: string;
};

export type FunnelTrafficSliceFilterDto = {
    dimension: 'brand' | 'distribution' | 'release' | 'language' | 'geography' | 'currency' | 'visitorCountry' | 'utmSource' | 'ingressDestination' | 'device' | 'screenClass' | 'textSize' | 'os' | 'osVersion' | 'browser' | 'browserVersion' | 'deviceBrand' | 'deviceModel' | 'gender' | 'ageGroup' | 'testGroup' | 'utmMedium' | 'utmCampaign' | 'utmContent' | 'utmTerm' | 'creativeBrand' | 'creativeAngle' | 'creativeForWhom' | 'creativeForWhat' | 'creativeMessage' | 'creativeLanguage' | 'creativeYearWeek' | 'creativeDesigner' | 'creativeBriefHook' | 'creativeChannel' | 'creativeRatio' | 'creativeFormat' | 'creativeIteration' | 'creativeBodyId' | 'creativeLength' | 'creativeGeography' | 'creativeType';
    /**
     * Any of these values.
     */
    values?: Array<string>;
    /**
     * Also match traffic where this is unknown — no answer yet, no traffic source.
     */
    includeMissing?: boolean;
};

export type FunnelTrafficKeyFilterDto = {
    /**
     * `group.name` of a variable or constant, e.g. `pipe.goal`.
     */
    key: string;
    values?: Array<string>;
    /**
     * Answers only: also match runs that never gave one.
     */
    includeMissing?: boolean;
};

export type FunnelTrafficSegmentsQueryDto = {
    /**
     * Start, ISO 8601. Widened down to the whole hour.
     */
    from: string;
    /**
     * End (exclusive), ISO 8601. Widened up to the whole hour, never past now.
     */
    to: string;
    /**
     * IANA time zone that day and week points start in. Default UTC.
     */
    timeZone?: string;
    /**
     * A `campaign` slice (UTM parameters, ad-name fields) counts from the clean events, like an answer (see `exact`).
     */
    filters?: Array<FunnelTrafficSliceFilterDto>;
    /**
     * Visitor answers by variable key. Each run is matched on the last answer it gave in the range — any of a multi-select’s values counts — or, for a variable no answer wrote, on its last value. Filtering by an answer counts from the clean events (see `exact`).
     */
    answers?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Pipe constants by key. Resolved to the releases that were built with those values.
     */
    constants?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Whose visits to count: `clients` (default) leaves out every browser that ever gave an @nutrameg.com address and the visits the model reads as automation, `nutrameg` counts only those browsers, `bots` only the automation, `all` everyone.
     */
    audience?: 'clients' | 'nutrameg' | 'bots' | 'all';
    /**
     * How the visits arrived: `via` only those an ingress link sent (they carry its destination), `notVia` only those that opened a distribution directly, abandoned-cart retargeting ads among them, `all` (default) both.
     */
    ingress?: 'all' | 'via' | 'notVia';
    /**
     * Count exactly from the clean events instead of the hourly tables. Reads gigabytes rather than megabytes; implied by any answer or campaign filter.
     */
    exact?: boolean;
    /**
     * The dimension whose values are compared.
     */
    dimension: 'brand' | 'distribution' | 'release' | 'language' | 'geography' | 'currency' | 'visitorCountry' | 'utmSource' | 'ingressDestination' | 'device' | 'screenClass' | 'textSize' | 'os' | 'osVersion' | 'browser' | 'browserVersion' | 'deviceBrand' | 'deviceModel' | 'gender' | 'ageGroup' | 'testGroup' | 'utmMedium' | 'utmCampaign' | 'utmContent' | 'utmTerm' | 'creativeBrand' | 'creativeAngle' | 'creativeForWhom' | 'creativeForWhat' | 'creativeMessage' | 'creativeLanguage' | 'creativeYearWeek' | 'creativeDesigner' | 'creativeBriefHook' | 'creativeChannel' | 'creativeRatio' | 'creativeFormat' | 'creativeIteration' | 'creativeBodyId' | 'creativeLength' | 'creativeGeography' | 'creativeType';
};

export type FunnelTrafficArrivalQueryDto = {
    /**
     * Start, ISO 8601. Widened down to the whole hour.
     */
    from: string;
    /**
     * End (exclusive), ISO 8601. Widened up to the whole hour, never past now.
     */
    to: string;
    /**
     * IANA time zone that day and week points start in. Default UTC.
     */
    timeZone?: string;
    /**
     * A `campaign` slice (UTM parameters, ad-name fields) counts from the clean events, like an answer (see `exact`).
     */
    filters?: Array<FunnelTrafficSliceFilterDto>;
    /**
     * Visitor answers by variable key. Each run is matched on the last answer it gave in the range — any of a multi-select’s values counts — or, for a variable no answer wrote, on its last value. Filtering by an answer counts from the clean events (see `exact`).
     */
    answers?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Pipe constants by key. Resolved to the releases that were built with those values.
     */
    constants?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Whose visits to count: `clients` (default) leaves out every browser that ever gave an @nutrameg.com address and the visits the model reads as automation, `nutrameg` counts only those browsers, `bots` only the automation, `all` everyone.
     */
    audience?: 'clients' | 'nutrameg' | 'bots' | 'all';
    /**
     * How the visits arrived: `via` only those an ingress link sent (they carry its destination), `notVia` only those that opened a distribution directly, abandoned-cart retargeting ads among them, `all` (default) both.
     */
    ingress?: 'all' | 'via' | 'notVia';
    /**
     * Count exactly from the clean events instead of the hourly tables. Reads gigabytes rather than megabytes; implied by any answer or campaign filter.
     */
    exact?: boolean;
    /**
     * The page reached.
     */
    targetPageId?: string;
    /**
     * The funnel step reached: any page that carries the marker.
     */
    targetMarker?: string;
};

export type FunnelTrafficCombinationsQueryDto = {
    /**
     * Start, ISO 8601. Widened down to the whole hour.
     */
    from: string;
    /**
     * End (exclusive), ISO 8601. Widened up to the whole hour, never past now.
     */
    to: string;
    /**
     * IANA time zone that day and week points start in. Default UTC.
     */
    timeZone?: string;
    /**
     * A `campaign` slice (UTM parameters, ad-name fields) counts from the clean events, like an answer (see `exact`).
     */
    filters?: Array<FunnelTrafficSliceFilterDto>;
    /**
     * Visitor answers by variable key. Each run is matched on the last answer it gave in the range — any of a multi-select’s values counts — or, for a variable no answer wrote, on its last value. Filtering by an answer counts from the clean events (see `exact`).
     */
    answers?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Pipe constants by key. Resolved to the releases that were built with those values.
     */
    constants?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Whose visits to count: `clients` (default) leaves out every browser that ever gave an @nutrameg.com address and the visits the model reads as automation, `nutrameg` counts only those browsers, `bots` only the automation, `all` everyone.
     */
    audience?: 'clients' | 'nutrameg' | 'bots' | 'all';
    /**
     * How the visits arrived: `via` only those an ingress link sent (they carry its destination), `notVia` only those that opened a distribution directly, abandoned-cart retargeting ads among them, `all` (default) both.
     */
    ingress?: 'all' | 'via' | 'notVia';
    /**
     * Count exactly from the clean events instead of the hourly tables. Reads gigabytes rather than megabytes; implied by any answer or campaign filter.
     */
    exact?: boolean;
    /**
     * The page reached.
     */
    targetPageId?: string;
    /**
     * The funnel step reached: any page that carries the marker.
     */
    targetMarker?: string;
    /**
     * The questions to combine, as `group.name`; one to 3.
     */
    keys: Array<string>;
};

export type FunnelTrafficOrdersCheckQueryDto = {
    /**
     * Start, ISO 8601; rounded down to the hour.
     */
    from: string;
    /**
     * End, ISO 8601, excluded; rounded up to the hour.
     */
    to: string;
    /**
     * IANA zone the days are cut in. Default UTC.
     */
    timeZone?: string;
    /**
     * `pairs`: find each order’s events by its id (its email where the ids disagree). `counts`: only how many each side has.
     */
    mode: 'pairs' | 'counts';
    /**
     * Only these pipes. Omitted or empty: every pipe.
     */
    pipeIds?: Array<number>;
    /**
     * Only these distributions. Omitted or empty: every one.
     */
    distributionIds?: Array<number>;
};

export type FunnelTrafficStatusDto = {
    /**
     * Enabled and configured: the Traffic view can be shown.
     */
    available: boolean;
    /**
     * The numbers are generated sample traffic, not real visitors.
     */
    sample: boolean;
};

export type FunnelTrafficAllowanceDto = {
    /**
     * EUR this person may spend per UTC day; 0 = no BigQuery reads.
     */
    limitEur: number;
    /**
     * Their own limit, set on the Users page, or the per-person setting.
     */
    limitSource: 'user' | 'default';
    spentTodayBytes: number;
    spentTodayEur: number;
    /**
     * What a read for this person may still spend today: theirs or Pipehouse’s, whichever is less.
     */
    leftTodayEur: number;
    /**
     * Pipehouse’s spend today, everyone together.
     */
    teamSpentTodayEur: number;
    teamBudgetEur: number;
    /**
     * What one GB billed is counted at.
     */
    eurPerGb: number;
    /**
     * Sample data: what BigQuery would have billed, on a counter of its own.
     */
    simulated: boolean;
    /**
     * The next midnight UTC, ISO 8601.
     */
    resetsAt: string;
};

export type FunnelTrafficQueryDto = {
    /**
     * Start, ISO 8601. Widened down to the whole hour.
     */
    from: string;
    /**
     * End (exclusive), ISO 8601. Widened up to the whole hour, never past now.
     */
    to: string;
    /**
     * IANA time zone that day and week points start in. Default UTC.
     */
    timeZone?: string;
    /**
     * A `campaign` slice (UTM parameters, ad-name fields) counts from the clean events, like an answer (see `exact`).
     */
    filters?: Array<FunnelTrafficSliceFilterDto>;
    /**
     * Visitor answers by variable key. Each run is matched on the last answer it gave in the range — any of a multi-select’s values counts — or, for a variable no answer wrote, on its last value. Filtering by an answer counts from the clean events (see `exact`).
     */
    answers?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Pipe constants by key. Resolved to the releases that were built with those values.
     */
    constants?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Whose visits to count: `clients` (default) leaves out every browser that ever gave an @nutrameg.com address and the visits the model reads as automation, `nutrameg` counts only those browsers, `bots` only the automation, `all` everyone.
     */
    audience?: 'clients' | 'nutrameg' | 'bots' | 'all';
    /**
     * How the visits arrived: `via` only those an ingress link sent (they carry its destination), `notVia` only those that opened a distribution directly, abandoned-cart retargeting ads among them, `all` (default) both.
     */
    ingress?: 'all' | 'via' | 'notVia';
    /**
     * Count exactly from the clean events instead of the hourly tables. Reads gigabytes rather than megabytes; implied by any answer or campaign filter.
     */
    exact?: boolean;
};

export type FunnelTrafficRangeDto = {
    /**
     * Start actually queried, ISO 8601 (whole hour).
     */
    from: string;
    /**
     * Exclusive end actually queried, ISO 8601 (whole hour).
     */
    to: string;
    timeZone: string;
    granularity: 'hour' | 'day' | 'week';
};

export type FunnelTrafficTotalsDto = {
    views: number;
    /**
     * Unique visitors (device ids), approximate to ±1.15% from the hourly tables.
     */
    visitors: number;
    runs: number;
    /**
     * Visitors who gave an email address.
     */
    emails: number;
};

export type FunnelTrafficPageDto = {
    pageId: string;
    views: number;
    firstViews: number;
    /**
     * Views with no page before them in the run. Null when it cannot be told apart under these filters.
     */
    entries: number | null;
    visitors: number;
    runs: number;
    emails: number;
    /**
     * Views that were the last of their run so far.
     */
    exitViews: number | null;
    /**
     * Visitors who never moved on from this page.
     */
    leftVisitors: number | null;
    /**
     * The page shown again straight after itself.
     */
    repeatViews: number;
    /**
     * Latest hour with a view, ISO 8601.
     */
    lastHour: string | null;
};

export type FunnelTrafficMoveDto = {
    fromPageId: string;
    toPageId: string;
    moves: number;
    /**
     * Moves to a page the run had already seen (Back, or a loop). Null when the model does not record it.
     */
    revisitMoves: number | null;
    visitors: number;
    /**
     * Average time on the page left behind, capped at 30 min.
     */
    avgDwellMs: number | null;
};

export type FunnelTrafficMarkerDto = {
    marker: string;
    views: number;
    visitors: number;
    runs: number;
};

export type FunnelTrafficMarkerSeriesDto = {
    marker: string;
    views: Array<number>;
    visitors: Array<number>;
};

export type FunnelTrafficSeriesDto = {
    /**
     * Start of each point, ISO 8601.
     */
    buckets: Array<string>;
    views: Array<number>;
    visitors: Array<number>;
    markers: Array<FunnelTrafficMarkerSeriesDto>;
};

export type FunnelTrafficInteractionDto = {
    pageId: string;
    /**
     * Component Clicked, Tracked Click, Exit Intent Triggered, Checkout …
     */
    eventName: string;
    componentId: string | null;
    componentType: string | null;
    /**
     * What was under the pointer (button, a, input:email). Empty on a click that could do nothing.
     */
    element: string | null;
    clickName: string | null;
    /**
     * The component that reacts to the click: the one whose control was clicked, or the nearest one with a click action. Null before the v3 model.
     */
    handlerId: string | null;
    /**
     * What a click led to: another page, an answer, a control reacting on its own, or nothing at all (a dead click). Null for other events.
     */
    outcome: 'navigate' | 'answer' | 'control' | 'none' | null;
    /**
     * The page a navigating click led to.
     */
    toPageId: string | null;
    events: number;
    visitors: number;
};

export type FunnelTrafficClickPartDto = {
    /**
     * The item of the component clicked (an option, a plan card): its id within that component. Null for the clicks on none of its items.
     */
    partId: string | null;
    clicks: number;
    visitors: number;
    deadClicks: number;
    navClicks: number;
    answerClicks: number;
};

export type FunnelTrafficClickTargetDto = {
    pageId: string;
    /**
     * The component that reacts to the clicks (else the one clicked), as drawn on the click map.
     */
    componentId: string;
    /**
     * Its clicks per item, busiest first; empty for a component without items or before the model records them.
     */
    parts: Array<FunnelTrafficClickPartDto>;
    clicks: number;
    visitors: number;
    /**
     * Clicks that led to nothing at all.
     */
    deadClicks: number;
    /**
     * Clicks that led to another page.
     */
    navClicks: number;
    /**
     * Clicks that gave an answer.
     */
    answerClicks: number;
};

export type FunnelTrafficAnswerValueDto = {
    /**
     * The value as stored; null for typed free text, whose value is never sent.
     */
    value: string | null;
    /**
     * Answers that included this value.
     */
    picks: number;
    /**
     * Runs that picked it at some point.
     */
    runs: number;
    /**
     * Runs whose last answer includes it.
     */
    finalRuns: number;
    /**
     * Of those, runs that completed a checkout.
     */
    convertedRuns: number;
};

export type FunnelTrafficAnswerDto = {
    pageId: string;
    /**
     * The variable answered, as `group.name`.
     */
    answerKey: string;
    componentId: string | null;
    componentType: string | null;
    /**
     * `component` when a component’s own field wrote it, `action` when an authored click action did.
     */
    answerSource: string | null;
    picks: number;
    /**
     * Runs that answered it.
     */
    runs: number;
    finalRuns: number;
    convertedRuns: number;
    /**
     * Runs that answered it more than once.
     */
    changedRuns: number | null;
    values: Array<FunnelTrafficAnswerValueDto>;
};

export type FunnelTrafficQualityDto = {
    /**
     * Rows the CDP appended, duplicates included.
     */
    rowsAppended: number;
    events: number;
    duplicateRows: number;
    lagP50S: number | null;
    /**
     * Worst hourly p99 delivery delay.
     */
    lagP99S: number | null;
    runsChecked: number;
    /**
     * Runs with a gap in their event sequence: events lost or still queued.
     */
    runsWithGaps: number;
    missingEvents: number;
    eventsWithoutPage: number;
};

export type FunnelTrafficMetaDto = {
    /**
     * Hourly tables, or exact counts from the clean events.
     */
    source: 'buckets' | 'events';
    /**
     * Generated sample traffic, not real visitors.
     */
    sample: boolean;
    /**
     * 1, 2 or 3; null when the tables cannot be read.
     */
    modelVersion: number | null;
    /**
     * Bytes billed to answer this request; 0 when it came from a cache.
     */
    bytesBilled: number;
    /**
     * Whether every part of the answer came from the Pipehouse cache.
     */
    cached: boolean;
    /**
     * When the answer was computed, ISO 8601.
     */
    computedAt: string;
    /**
     * Last rebuild of the hourly tables, ISO 8601.
     */
    modelUpdatedAt: string | null;
    /**
     * Latest hour that has traffic, ISO 8601.
     */
    dataThrough: string | null;
    /**
     * Parts of the answer a filter could not narrow, as `part:dimension` (e.g. `moves:gender`, or `pages:audience` where Nutrameg’s own visits could not be told apart); those numbers are for every visitor.
     */
    ignoredFilters: Array<string>;
    /**
     * Anything else the reader should know, worded for them.
     */
    notices: Array<string>;
    /**
     * The reader’s BigQuery day after this read; null when no person is behind the request.
     */
    allowance: FunnelTrafficAllowanceDto | null;
};

export type FunnelTrafficFlowDto = {
    range: FunnelTrafficRangeDto;
    totals: FunnelTrafficTotalsDto;
    pages: Array<FunnelTrafficPageDto>;
    moves: Array<FunnelTrafficMoveDto>;
    markers: Array<FunnelTrafficMarkerDto>;
    series: FunnelTrafficSeriesDto;
    interactions: Array<FunnelTrafficInteractionDto>;
    clickTargets: Array<FunnelTrafficClickTargetDto>;
    answers: Array<FunnelTrafficAnswerDto>;
    quality?: FunnelTrafficQualityDto | null;
    meta: FunnelTrafficMetaDto;
};

export type FunnelTrafficEstimateDto = {
    source: 'buckets' | 'events';
    /**
     * Bytes BigQuery would read, from a dry run (free).
     */
    bytes: number;
    /**
     * What those bytes cost at BIGQUERY_EUR_PER_GB, in EUR.
     */
    eur: number;
    maxBytesPerQuery: number;
    budgetLeftBytes: number;
    /**
     * False when the per-query limit, or what is left of the reader’s or Pipehouse’s budget today, would refuse it.
     */
    allowed: boolean;
};

export type FunnelTrafficDistributionValueDto = {
    name: string;
    pipeId: number;
    pipeName: string;
    brandName: string | null;
    brandCode: string | null;
    geography: string;
    language: string;
    currency: string | null;
    deleted: boolean;
};

export type FunnelTrafficOptionValueDto = {
    value: string;
    /**
     * What to show for it: the distribution path, the release date…
     */
    label: string;
    /**
     * Page views with this value in the range; null for an events-only slice, whose values are listed without counting them.
     */
    views: number | null;
    /**
     * A distribution only: whether it has an active ingress destination, so ingress sends visitors to it.
     */
    activeIngress?: boolean;
    /**
     * A distribution only: its names, for its pill.
     */
    distribution?: FunnelTrafficDistributionValueDto;
};

export type FunnelTrafficDimensionOptionsDto = {
    key: 'brand' | 'distribution' | 'release' | 'language' | 'geography' | 'currency' | 'visitorCountry' | 'utmSource' | 'ingressDestination' | 'device' | 'screenClass' | 'textSize' | 'os' | 'osVersion' | 'browser' | 'browserVersion' | 'deviceBrand' | 'deviceModel' | 'gender' | 'ageGroup' | 'testGroup' | 'utmMedium' | 'utmCampaign' | 'utmContent' | 'utmTerm' | 'creativeBrand' | 'creativeAngle' | 'creativeForWhom' | 'creativeForWhat' | 'creativeMessage' | 'creativeLanguage' | 'creativeYearWeek' | 'creativeDesigner' | 'creativeBriefHook' | 'creativeChannel' | 'creativeRatio' | 'creativeFormat' | 'creativeIteration' | 'creativeBodyId' | 'creativeLength' | 'creativeGeography' | 'creativeType';
    label: string;
    /**
     * `campaign`: the landing’s UTM parameters and the ad name’s fields. Filtering by one counts from every event, and their values are listed by `campaign-options`, never here.
     */
    group: 'distribution' | 'visit' | 'device' | 'answer' | 'campaign';
    /**
     * False when the model has no such column: the filter would do nothing.
     */
    available: boolean;
    /**
     * Whether moves between pages can be split by it too.
     */
    splitsMoves: boolean;
    /**
     * Page views in the range where it is not known: no visitor country located, no answer given yet. Null for an events-only or campaign slice, whose values are not counted here, and where the model has no such column.
     */
    missingViews: number | null;
    values: Array<FunnelTrafficOptionValueDto>;
};

export type FunnelTrafficConstantValueDto = {
    value: string;
    /**
     * Releases built with this value.
     */
    releases: number;
};

export type FunnelTrafficConstantOptionsDto = {
    /**
     * `group.name`.
     */
    key: string;
    values: Array<FunnelTrafficConstantValueDto>;
};

export type FunnelTrafficOptionsDto = {
    dimensions: Array<FunnelTrafficDimensionOptionsDto>;
    /**
     * Constants whose value differs between releases of this pipe — the only ones that can split its traffic.
     */
    constants: Array<FunnelTrafficConstantOptionsDto>;
    /**
     * Whether the model tells Nutrameg’s own visits apart, so `audience` narrows the counts.
     */
    audienceAvailable: boolean;
    /**
     * Whether the model tells automation apart from people, so `audience: bots` narrows the counts.
     */
    botsAvailable: boolean;
    /**
     * Whether exact counts (and filtering by any answer) are possible.
     */
    exactAvailable: boolean;
    /**
     * Whether the clean events carry each answer, so the answers that led to a page can be shown.
     */
    answersAvailable: boolean;
    modelVersion: number | null;
};

export type FunnelTrafficPartMetaDto = {
    /**
     * Generated sample traffic, not real visitors.
     */
    sample: boolean;
    /**
     * Bytes billed to answer this; 0 when it came from a cache.
     */
    bytesBilled: number;
    cached: boolean;
    /**
     * When the answer was computed, ISO 8601.
     */
    computedAt: string;
    /**
     * Filters that could not narrow these numbers (a dimension key, `audience` or `bots`); they are for every visitor.
     */
    ignoredFilters: Array<string>;
    /**
     * The reader’s BigQuery day after this read; null when no person is behind the request.
     */
    allowance: FunnelTrafficAllowanceDto | null;
};

export type FunnelTrafficCampaignOptionsDto = {
    /**
     * Each campaign slice with its busiest values in the range; the same slices the options list, there without values.
     */
    dimensions: Array<FunnelTrafficDimensionOptionsDto>;
    meta: FunnelTrafficPartMetaDto;
};

export type FunnelTrafficPipeDto = {
    id: number;
    name: string;
    brand: string | null;
    /**
     * The code its events carry, which the `brand` filter takes; null when the brand has none.
     */
    brandCode: string | null;
    /**
     * Its distributions with an active ingress destination — those ingress sends visitors to.
     */
    activeIngressDistributions: number;
};

export type FunnelTrafficStepsQueryDto = {
    /**
     * Start, ISO 8601. Widened down to the whole hour.
     */
    from: string;
    /**
     * End (exclusive), ISO 8601. Widened up to the whole hour, never past now.
     */
    to: string;
    /**
     * IANA time zone that day and week points start in. Default UTC.
     */
    timeZone?: string;
    /**
     * A `campaign` slice (UTM parameters, ad-name fields) counts from the clean events, like an answer (see `exact`).
     */
    filters?: Array<FunnelTrafficSliceFilterDto>;
    /**
     * Visitor answers by variable key. Each run is matched on the last answer it gave in the range — any of a multi-select’s values counts — or, for a variable no answer wrote, on its last value. Filtering by an answer counts from the clean events (see `exact`).
     */
    answers?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Pipe constants by key. Resolved to the releases that were built with those values.
     */
    constants?: Array<FunnelTrafficKeyFilterDto>;
    /**
     * Whose visits to count: `clients` (default) leaves out every browser that ever gave an @nutrameg.com address and the visits the model reads as automation, `nutrameg` counts only those browsers, `bots` only the automation, `all` everyone.
     */
    audience?: 'clients' | 'nutrameg' | 'bots' | 'all';
    /**
     * How the visits arrived: `via` only those an ingress link sent (they carry its destination), `notVia` only those that opened a distribution directly, abandoned-cart retargeting ads among them, `all` (default) both.
     */
    ingress?: 'all' | 'via' | 'notVia';
    /**
     * Count exactly from the clean events instead of the hourly tables. Reads gigabytes rather than megabytes; implied by any answer or campaign filter.
     */
    exact?: boolean;
    /**
     * The pipes to read, at most 50. Omitted or empty: every pipe.
     */
    pipeIds?: Array<number>;
};

export type FunnelTrafficStepsDto = {
    /**
     * The pipes read, ascending; null for every pipe.
     */
    pipeIds: Array<number> | null;
    range: FunnelTrafficRangeDto;
    /**
     * Everyone in the slice, at any step or none.
     */
    totals: FunnelTrafficTotalsDto;
    /**
     * Each funnel marker the slice reached, busiest first. A visitor counts once per step however many of the pipes they reached it in.
     */
    steps: Array<FunnelTrafficMarkerDto>;
    meta: FunnelTrafficMetaDto;
};

export type FunnelTrafficScopeOptionsQueryDto = {
    from: string;
    to: string;
    /**
     * The pipes to read, at most 50. Omitted or empty: every pipe.
     */
    pipeIds?: Array<number>;
    /**
     * Brand codes, at most 20, as the `brand` filter takes them: every other filter lists only these brands' values.
     */
    brands?: Array<string>;
};

export type FunnelTrafficSegmentStepDto = {
    marker: string;
    /**
     * Runs that reached the step.
     */
    runs: number;
};

export type FunnelTrafficSegmentDto = {
    /**
     * The value; null for "not known", for the summed rest (`other`) and for the total.
     */
    value: string | null;
    /**
     * The values past the busiest ones, summed into one row.
     */
    other: boolean;
    /**
     * Runs: approximate to ±1.15% from the hourly tables, exact from the clean events.
     */
    runs: number;
    views: number;
    steps: Array<FunnelTrafficSegmentStepDto>;
};

export type FunnelTrafficSegmentsMetaDto = {
    /**
     * Generated sample traffic, not real visitors.
     */
    sample: boolean;
    /**
     * Bytes billed to answer this; 0 when it came from a cache.
     */
    bytesBilled: number;
    cached: boolean;
    /**
     * When the answer was computed, ISO 8601.
     */
    computedAt: string;
    /**
     * Filters that could not narrow these numbers (a dimension key, `audience` or `bots`); they are for every visitor.
     */
    ignoredFilters: Array<string>;
    /**
     * The reader’s BigQuery day after this read; null when no person is behind the request.
     */
    allowance: FunnelTrafficAllowanceDto | null;
    /**
     * Hourly tables, or the clean events while an answer or campaign filter is set.
     */
    source: 'buckets' | 'events';
};

export type FunnelTrafficSegmentsDto = {
    dimension: 'brand' | 'distribution' | 'release' | 'language' | 'geography' | 'currency' | 'visitorCountry' | 'utmSource' | 'ingressDestination' | 'device' | 'screenClass' | 'textSize' | 'os' | 'osVersion' | 'browser' | 'browserVersion' | 'deviceBrand' | 'deviceModel' | 'gender' | 'ageGroup' | 'testGroup' | 'utmMedium' | 'utmCampaign' | 'utmContent' | 'utmTerm' | 'creativeBrand' | 'creativeAngle' | 'creativeForWhom' | 'creativeForWhat' | 'creativeMessage' | 'creativeLanguage' | 'creativeYearWeek' | 'creativeDesigner' | 'creativeBriefHook' | 'creativeChannel' | 'creativeRatio' | 'creativeFormat' | 'creativeIteration' | 'creativeBodyId' | 'creativeLength' | 'creativeGeography' | 'creativeType';
    /**
     * Busiest first; the summed rest and "not known" last.
     */
    segments: Array<FunnelTrafficSegmentDto>;
    total: FunnelTrafficSegmentDto;
    meta: FunnelTrafficSegmentsMetaDto;
};

export type FunnelTrafficArrivalValueDto = {
    /**
     * The value; null for typed free text. A `number` answer is counted in ranges of a round width: `60..65` (from 60, under 65), and the end ranges open, `..50` (under 50) and `100..` (100 and over).
     */
    value: string | null;
    /**
     * Runs that had picked it by the time they reached the target.
     */
    arrived: number;
    /**
     * Runs that never reached it whose last answer included it.
     */
    others: number;
};

export type FunnelTrafficArrivalQuestionDto = {
    /**
     * The variable answered, as `group.name`.
     */
    answerKey: string;
    /**
     * The page most runs answered it on.
     */
    askedOnPageId: string | null;
    /**
     * `choice`, `multi`, `number`, `boolean` or `text`.
     */
    answerKind: string | null;
    componentId: string | null;
    componentType: string | null;
    /**
     * Runs that reached the target having answered it on the way.
     */
    arrivedAnswered: number;
    /**
     * Runs that never reached the target and answered it.
     */
    othersAnswered: number;
    values: Array<FunnelTrafficArrivalValueDto>;
};

export type FunnelTrafficArrivalAnswersDto = {
    targetPageId: string | null;
    targetMarker: string | null;
    /**
     * Runs that started in the range and reached the target, counted exactly.
     */
    arrivals: number;
    /**
     * Runs that reached it but started before the range: their earlier answers were not read, so they are left out.
     */
    leftOut: number;
    /**
     * The questions answered on the way, most answered first. A run counts with its answer as it stood on arrival; the others with their last one.
     */
    questions: Array<FunnelTrafficArrivalQuestionDto>;
    meta: FunnelTrafficPartMetaDto;
};

export type FunnelTrafficCombinationPartDto = {
    /**
     * Whether the question was answered.
     */
    answered: boolean;
    /**
     * The values picked; empty for typed text.
     */
    values: Array<string>;
};

export type FunnelTrafficCombinationDto = {
    /**
     * One part per key, in the order asked.
     */
    parts: Array<FunnelTrafficCombinationPartDto>;
    arrived: number;
    others: number;
};

export type FunnelTrafficCombinationsDto = {
    keys: Array<string>;
    /**
     * Runs that reached the target.
     */
    arrived: number;
    /**
     * Runs that started in the range and did not.
     */
    others: number;
    /**
     * The commonest among the runs that reached the target first.
     */
    combinations: Array<FunnelTrafficCombinationDto>;
    meta: FunnelTrafficPartMetaDto;
};

export type FunnelTrafficSettingProblemDto = {
    setting: 'project' | 'location' | 'dataset' | 'credentials';
    /**
     * The system-settings key to edit.
     */
    settingKey: string;
    message: string;
};

export type FunnelTrafficReaderDto = {
    userId: number;
    /**
     * Their name, else their email.
     */
    name: string;
    spentTodayBytes: number;
    spentTodayEur: number;
    /**
     * Their daily limit in EUR; 0 = no BigQuery reads.
     */
    limitEur: number;
    limitSource: 'user' | 'default';
};

export type FunnelTrafficSetupDto = {
    enabled: boolean;
    /**
     * Where the view reads, after the production rule.
     */
    source: 'bigquery' | 'sample';
    /**
     * Whether this environment may use sample data (every environment but production).
     */
    sampleAllowed: boolean;
    configured: boolean;
    projectId: string | null;
    location: string;
    datasetProjectId: string | null;
    datasetId: string;
    credentialKind: 'service_account' | 'external_account';
    /**
     * The service account the credential acts as — the principal every grant must name.
     */
    principal: string | null;
    problems: Array<FunnelTrafficSettingProblemDto>;
    maxGbPerQuery: number;
    /**
     * What one GB billed is counted at.
     */
    eurPerGb: number;
    /**
     * What Pipehouse may spend per UTC day.
     */
    dailyBudgetEur: number;
    /**
     * What one person may spend of that, unless their own account says otherwise.
     */
    userDailyBudgetEur: number;
    spentTodayBytes: number;
    spentTodayEur: number;
    /**
     * The numbers are what the sample source would have billed, counted apart from BigQuery’s own.
     */
    usageSimulated: boolean;
    /**
     * Who spent the most today (UTC), most first; at most 10.
     */
    readersToday: Array<FunnelTrafficReaderDto>;
    /**
     * Setting keys, in the order the page shows them.
     */
    settingKeys: Array<string>;
};

export type FunnelTrafficCheckDto = {
    key: string;
    label: string;
    status: 'ok' | 'warning' | 'error' | 'skipped';
    detail: string;
};

export type FunnelTrafficTableDto = {
    table: string;
    purpose: string;
    exists: boolean;
    optional: boolean;
    missingRequired: Array<string>;
    missingOptional: Array<string>;
    numRows: number | null;
    numBytes: number | null;
    lastModified: string | null;
    requirePartitionFilter: boolean;
};

export type FunnelTrafficCheckResultDto = {
    checks: Array<FunnelTrafficCheckDto>;
    tables: Array<FunnelTrafficTableDto>;
    modelVersion: number | null;
    checkedAt: string;
};

export type FunnelTrafficOrdersCheckRangeDto = {
    /**
     * ISO 8601.
     */
    from: string;
    /**
     * ISO 8601, excluded.
     */
    to: string;
    /**
     * Where the comparison stops, ISO 8601: `to`, or earlier where the warehouse has not taken in the events after it yet.
     */
    comparedTo: string;
    timeZone: string;
};

export type FunnelTrafficOrdersCheckBreakdownDto = {
    /**
     * Pipeorders’ records.
     */
    backend: number;
    /**
     * The CDP’s events.
     */
    cdp: number;
    /**
     * Records the CDP sent at least once.
     */
    matched: number | null;
    /**
     * Records the CDP never sent.
     */
    missing: number | null;
    /**
     * Events beyond the first for a record.
     */
    duplicates: number | null;
    /**
     * Events with no record in Pipeorders.
     */
    unmatched: number | null;
    /**
     * A distribution id, or a day as YYYY-MM-DD.
     */
    key: string;
};

export type FunnelTrafficOrdersCheckSampleDto = {
    orderId: string | null;
    /**
     * ISO 8601.
     */
    at: string;
    email: string | null;
    distributionId: number | null;
    releaseId: number | null;
    /**
     * A duplicated record: how many events it got.
     */
    events: number | null;
    /**
     * A duplicated record: how many funnel runs its events came from — one is the same page sending twice, several are tabs or devices.
     */
    runs: number | null;
};

export type FunnelTrafficOrdersCheckSamplesDto = {
    missing: Array<FunnelTrafficOrdersCheckSampleDto>;
    duplicated: Array<FunnelTrafficOrdersCheckSampleDto>;
    unmatched: Array<FunnelTrafficOrdersCheckSampleDto>;
};

export type FunnelTrafficOrdersCheckKindDto = {
    /**
     * Pipeorders’ records.
     */
    backend: number;
    /**
     * The CDP’s events.
     */
    cdp: number;
    /**
     * Records the CDP sent at least once.
     */
    matched: number | null;
    /**
     * Records the CDP never sent.
     */
    missing: number | null;
    /**
     * Events beyond the first for a record.
     */
    duplicates: number | null;
    /**
     * Events with no record in Pipeorders.
     */
    unmatched: number | null;
    kind: 'lead' | 'firstPayment';
    /**
     * The CDP event it is sent as.
     */
    cdpEvent: string;
    /**
     * Against the thresholds: `tooFew` below 20 on both sides, `noData` with nothing on either.
     */
    status: 'ok' | 'warning' | 'failing' | 'tooFew' | 'noData';
    /**
     * Of `matched`, those found by the email alone.
     */
    matchedByEmail: number | null;
    /**
     * Events whose record is just outside the window, or from a release not compared for this kind; counted on neither side’s mismatches.
     */
    pairedOutside: number | null;
    /**
     * First payments: events of a later payment of the same order (an upsell), left out.
     */
    otherPayments: number | null;
    /**
     * Records the CDP sent more than once.
     */
    duplicatedRecords: number | null;
    /**
     * Records in the window whose browser ran a release this kind is not compared for — no CDP, or a build that predates its event. Pipes the check read only.
     */
    notCompared: number;
    byDistribution: Array<FunnelTrafficOrdersCheckBreakdownDto>;
    byDay: Array<FunnelTrafficOrdersCheckBreakdownDto>;
    samples: FunnelTrafficOrdersCheckSamplesDto;
};

export type FunnelTrafficOrdersCheckSegmentDto = {
    /**
     * ISO 8601.
     */
    from: string;
    /**
     * ISO 8601, excluded.
     */
    to: string;
    releaseId: number;
    /**
     * The build carried the CDP, with a write key.
     */
    cdp: boolean;
    /**
     * The build carried Pipeorders.
     */
    pipeorders: boolean;
    /**
     * Its CDP waited for cookie consent: who declined sent nothing.
     */
    consentGated: boolean;
    /**
     * Its CDP sent to an edge of its own.
     */
    customHost: boolean;
    /**
     * Compared for first payments.
     */
    compared: boolean;
    /**
     * Compared for leads too.
     */
    leadsCompared: boolean;
    /**
     * CDP events it delivered in the window; null where nothing was read.
     */
    events: number | null;
    schemaVersion: number | null;
};

export type FunnelTrafficOrdersCheckDistributionDto = {
    distributionId: number;
    /**
     * pipe · geo-lang/name
     */
    label: string;
    pipeId: number;
    brand: string | null;
    deleted: boolean;
    /**
     * Ingress sends visitors to it now.
     */
    activeIngress: boolean;
    /**
     * Hours a release served it in the window.
     */
    liveHours: number;
    /**
     * Of those, hours compared.
     */
    comparedHours: number;
    segments: Array<FunnelTrafficOrdersCheckSegmentDto>;
};

export type FunnelTrafficOrdersCheckThresholdsDto = {
    /**
     * Below this many on both sides, nothing is judged.
     */
    minItems: number;
    /**
     * Missing, only in the CDP, or (counting) the difference: a share past this is worth a look.
     */
    rateWarning: number;
    /**
     * The same, past this it fails.
     */
    rateFailing: number;
    /**
     * Sent more than once: worth a look past this.
     */
    duplicateWarning: number;
    /**
     * Sent more than once: fails past this.
     */
    duplicateFailing: number;
};

export type FunnelTrafficOrdersCheckMetaDto = {
    /**
     * The CDP side was generated, not read.
     */
    sample: boolean;
    bytesBilled: number;
    /**
     * ISO 8601.
     */
    computedAt: string;
    /**
     * When the clean events were last written, ISO 8601.
     */
    modelUpdatedAt: string | null;
    /**
     * Pipeorders stopped at its row limit; narrow the range.
     */
    ordersTruncated: boolean;
    /**
     * The CDP events stopped at the row limit; narrow the range.
     */
    eventsTruncated: boolean;
    /**
     * What the reader should know, worded for them.
     */
    notices: Array<string>;
    thresholds: FunnelTrafficOrdersCheckThresholdsDto;
    allowance: FunnelTrafficAllowanceDto | null;
};

export type FunnelTrafficOrdersCheckDto = {
    range: FunnelTrafficOrdersCheckRangeDto;
    mode: 'pairs' | 'counts';
    /**
     * The worst kind’s status: what an automated run alerts on.
     */
    status: 'ok' | 'warning' | 'failing' | 'tooFew' | 'noData';
    kinds: Array<FunnelTrafficOrdersCheckKindDto>;
    /**
     * Every distribution a release served in the window, compared ones first.
     */
    distributions: Array<FunnelTrafficOrdersCheckDistributionDto>;
    meta: FunnelTrafficOrdersCheckMetaDto;
};

export type AgentChangeFieldDto = {
    label: string;
    value: string;
};

export type AgentChangeItemDto = {
    id: number;
    seq: number;
    op: 'create' | 'update';
    targetType: {
        [key: string]: unknown;
    };
    itemClass: 'value' | 'url_move' | 'deploy';
    targetId?: number | null;
    distributionId?: number | null;
    pipeId?: number | null;
    label: string;
    warnings: Array<string>;
    beforePreview?: string | null;
    afterPreview?: string | null;
    beforeFields?: Array<AgentChangeFieldDto>;
    afterFields?: Array<AgentChangeFieldDto>;
    status: 'staged' | 'applied' | 'skipped' | 'failed';
    stale: boolean;
    staleReason?: string | null;
    dependsOnItemIds: Array<number>;
    targetRouteName?: string | null;
    targetRouteParams?: {
        [key: string]: unknown;
    };
    error?: string | null;
};

export type AgentChangeBatchDto = {
    id: number;
    sessionId: number;
    pipeId: number;
    status: {
        [key: string]: unknown;
    };
    itemClass: 'value' | 'url_move' | 'deploy';
    summary?: string | null;
    note?: string | null;
    promptId?: string | null;
    items: Array<AgentChangeItemDto>;
    impact: Array<string>;
    batchToken: string;
    expiresAt: string;
    expired: boolean;
    hasStaleItems: boolean;
    createdAt: string;
    error?: string | null;
};

export type ListAgentSessionsQueryDto = {
    /**
     * List the caller’s sessions for this pipe.
     */
    pipeId: number;
};

export type AgentModelOptionsDto = {
    /**
     * The AGENT_MODEL setting's current value.
     */
    defaultModel: string;
    /**
     * The AI_ADVANCED_MODEL setting's current value, or null if an operator has not configured one.
     */
    advancedModel?: string | null;
};

export type CreateAgentSessionDto = {
    /**
     * The pipe the session operates on.
     */
    pipeId: number;
    /**
     * Model to start this session on, picked from the panel before the first message — must be exactly the current AGENT_MODEL or AI_ADVANCED_MODEL value. Omitted ⇒ AGENT_MODEL, same as before this existed.
     */
    model?: string;
};

export type AgentSessionDto = {
    id: number;
    pipeId: number;
    status: 'IDLE' | 'RUNNING' | 'INTERRUPTED' | 'AWAITING_INPUT' | 'COMPLETED' | 'FAILED' | 'CANCELLED';
    model: string;
    /**
     * The AGENT_MODEL setting's current value. Distinct from `model` once a session has switched away from it — the panel's toggle needs to know what to switch back to.
     */
    defaultModel: string;
    /**
     * The AI_ADVANCED_MODEL setting's current value, or null if an operator has not configured one. The panel's model dropdown offers exactly `defaultModel` and this — nothing else.
     */
    advancedModel?: string | null;
    /**
     * Who drives this conversation. 'editor' is the built-in agent; 'external_mcp' is a third-party app connected over OAuth, which runs its own model — the editor shows it as connected, renders its prompts and its transcript, but cannot send it messages.
     */
    origin: 'editor' | 'external_mcp';
    /**
     * The connected app’s name, for external sessions. This is what the author is shown as the thing currently editing their pipe.
     */
    externalClientName?: string | null;
    /**
     * When the connected app last called a tool, ISO 8601. Drives the editor’s “active just now” indicator.
     */
    externalLastCallAt?: string | null;
    /**
     * Ordered user / assistant / tool entries.
     */
    transcript: Array<{
        [key: string]: unknown;
    }>;
    promptTokens: number;
    outputTokens: number;
    /**
     * Running EUR cost (numeric string).
     */
    costEur: string;
    lastError?: string | null;
    /**
     * Pending author prompt: `{id, kind: "choice" | "confirmation", question, options?, multiSelect?, allowFreeText?, impact?, gatedCall?, changeBatchId?, createdAt}`. Answer it via POST /sessions/:id/prompt-response. With `changeBatchId` set, fetch GET /api/agent-changes/batches/:id first and send its token back to approve.
     */
    pendingPrompt?: {
        [key: string]: unknown;
    } | null;
    createdAt: string;
    updatedAt: string;
};

export type SwitchAgentSessionModelDto = {
    /**
     * The model to switch this session to — must be exactly the current AGENT_MODEL or AI_ADVANCED_MODEL setting value; anything else is rejected.
     */
    model: string;
};

export type SendAgentMessageDto = {
    /**
     * Bound this run by AI spend instead of the per-message step cap. The run is still metered before every turn (so it stops within one model call of the account’s EUR limit), still stoppable, and still subject to a high runaway backstop.
     */
    unlimitedSteps?: boolean;
    /**
     * Let the agent generate new images with AI during this run (task 021). Off by default: the agent works from the existing media library — the seeded stock placeholders and anything uploaded — which costs nothing. With it on, the generate_image tool is declared to the model and each image is charged against the author’s AI budget. Reading the media library (list_images) is unaffected either way.
     */
    allowImageGeneration?: boolean;
    /**
     * The author message to run one agent loop for.
     */
    content: string;
};

export type TranslationFixResultDto = {
    /**
     * The translation key this row was for.
     */
    key: string;
    /**
     * Language code, if the fix named one.
     */
    lang?: string;
    /**
     * Whether the author applied this fix.
     */
    applied: boolean;
};

export type AgentPromptResponseDto = {
    /**
     * Bound this run by AI spend instead of the per-message step cap. The run is still metered before every turn (so it stops within one model call of the account’s EUR limit), still stoppable, and still subject to a high runaway backstop.
     */
    unlimitedSteps?: boolean;
    /**
     * Let the agent generate new images with AI during this run (task 021). Off by default: the agent works from the existing media library — the seeded stock placeholders and anything uploaded — which costs nothing. With it on, the generate_image tool is declared to the model and each image is charged against the author’s AI budget. Reading the media library (list_images) is unaffected either way.
     */
    allowImageGeneration?: boolean;
    /**
     * Id of the prompt being answered. Must match the session’s pending prompt — a stale answer (another tab already replied, or the author sent a message instead) is rejected with 409.
     */
    promptId: string;
    /**
     * Selected option values for a `choice` prompt. Values the prompt did not offer are dropped; all but the first are dropped unless the prompt is multi-select.
     */
    values?: Array<string>;
    /**
     * Free-text answer, for an open question or a `choice` prompt that allowed one alongside its options.
     */
    text?: string;
    /**
     * Verdict on a `confirmation` prompt. `approve` unlocks the approved removal once; `approve_all` stops asking for the rest of this conversation (on a connector-driven session, which has no end here, for a few hours); `decline` tells the agent not to do it. On a prompt carrying `changeBatchId`, `approve_all` means the same as `approve` — a database change is never made without being shown.
     */
    decision?: 'approve' | 'approve_all' | 'decline';
    /**
     * Required to approve a prompt carrying `changeBatchId`: the token GET /api/agent-changes/batches/:id returned with the changes that were displayed. It is rejected (409) if it does not match the batch as it now stands, so an approval can only ever cover what the author actually saw.
     */
    batchToken?: string;
    /**
     * Which staged changes the author left ticked. Omit to approve every change in the batch; anything left out is skipped, and so is any change that depends on it.
     */
    approvedItemIds?: Array<number>;
    /**
     * Required to answer a prompt carrying `translationFixes`: what the author did with each row. The FE applies (or skips) every fix client-side before submitting — this only reports it. A key left out is treated as skipped.
     */
    translationFixResults?: Array<TranslationFixResultDto>;
};

export type AgentRunOptionsDto = {
    /**
     * Bound this run by AI spend instead of the per-message step cap. The run is still metered before every turn (so it stops within one model call of the account’s EUR limit), still stoppable, and still subject to a high runaway backstop.
     */
    unlimitedSteps?: boolean;
    /**
     * Let the agent generate new images with AI during this run (task 021). Off by default: the agent works from the existing media library — the seeded stock placeholders and anything uploaded — which costs nothing. With it on, the generate_image tool is declared to the model and each image is charged against the author’s AI budget. Reading the media library (list_images) is unaffected either way.
     */
    allowImageGeneration?: boolean;
};

export type ListRuleGroupsQueryDto = {
    brandId?: number;
    pipeId?: number;
    group?: ConstVarGroup;
    search?: string;
    page?: number;
    pageSize?: number;
};

export type RuleGroupDto = {
    id: number;
    group: ConstVarGroup;
    /**
     * camelCase dot-notation identifier, unique within its scope. Immutable after create — it is part of the reference key stored in pipe content.
     */
    name: string;
    description?: string;
    /**
     * json-logic rule tree (JsonEngineNode)
     */
    rules?: {
        [key: string]: unknown;
    };
    brandId?: number;
    pipeId?: number;
    createdAt: string;
    updatedAt: string;
};

export type RuleGroupListResponseDto = {
    items: Array<RuleGroupDto>;
    total: number;
};

export type CreateRuleGroupDto = {
    group: ConstVarGroup;
    /**
     * camelCase dot-notation identifier, unique within its scope. Immutable after create — it is part of the reference key stored in pipe content.
     */
    name: string;
    description?: string;
    /**
     * json-logic rule tree (JsonEngineNode)
     */
    rules?: {
        [key: string]: unknown;
    };
    brandId?: number;
    pipeId?: number;
};

export type UpdateRuleGroupDto = {
    description?: string;
    /**
     * json-logic rule tree (JsonEngineNode)
     */
    rules?: {
        [key: string]: unknown;
    };
};

export type PriceCategoryListQueryDto = {
    /**
     * Search by category name (partial)
     */
    search?: string;
    /**
     * Page number
     */
    page?: number;
    /**
     * Page size
     */
    pageSize?: number;
};

export type PriceCategoryOfferGroupDto = {
    id: number;
    /**
     * Ladder key — s | m | l | xl. Server-assigned.
     */
    key: string;
    regularOfferId: number;
    exitOfferId?: number | null;
    sortOrder: number;
};

export type PriceCategoryDto = {
    id: number;
    name: string;
    description?: string | null;
    offerGroups: Array<PriceCategoryOfferGroupDto>;
    createdAt: string;
    updatedAt: string;
};

export type PriceCategoryListDto = {
    items: Array<PriceCategoryDto>;
    total: number;
    page: number;
    pageSize: number;
};

export type PriceCategoryCurrenciesDto = {
    /**
     * Lowercase currency codes
     */
    currencies: Array<string>;
};

export type PriceCategoryUsageDto = {
    constants: Array<ConstantUsageDto>;
    constantOverrides: Array<ConstantOverrideUsageDto>;
    /**
     * Keys of the constants whose ref names this category, distribution overrides included
     */
    constantKeys: Array<string>;
    constantCount: number;
};

export type PriceCategoryOfferInputDto = {
    name: string;
    prices: Array<PriceProductObjectPriceOfferCreateDto>;
    offerType: 'BASIC' | 'PREMIUM' | 'SHOPPING_LIST' | 'SHOPPING_LIST_AND_PREMIUM' | 'BASIC_ANNUAL' | 'CHAT' | 'WORKOUTS' | 'BASIC_EXIT_INTENT' | 'PREMIUM_EXIT_INTENT';
    /**
     * The offer this edits; omitted for a new offer
     */
    id?: number;
    /**
     * Required for a new offer
     */
    priceProductObjectId?: number;
};

export type PriceCategoryOfferGroupInputDto = {
    /**
     * Existing member id, when kept
     */
    id?: number;
    /**
     * Required unless `regularOffer` is given
     */
    regularOfferId?: number;
    regularOffer?: PriceCategoryOfferInputDto;
    exitOfferId?: number;
    exitOffer?: PriceCategoryOfferInputDto;
};

export type CreatePriceCategoryDto = {
    /**
     * camelCase identifier, unique among live rows
     */
    name: string;
    description?: string;
    offerGroups?: Array<PriceCategoryOfferGroupInputDto>;
};

export type ConvertOfferGroupsDto = {
    /**
     * camelCase identifier for the new category
     */
    name: string;
    description?: string;
    /**
     * offer_group constant ids, in the order the plans should read
     */
    constantIds: Array<number>;
};

export type ConvertedOfferGroupDto = {
    constantId: number;
    constantKey: string;
    /**
     * Ladder key the constant became
     */
    key: string;
};

export type ConvertOfferGroupsResultDto = {
    category: PriceCategoryDto;
    converted: Array<ConvertedOfferGroupDto>;
    /**
     * Constants that carried no usable offer pair and were left out
     */
    skipped: Array<string>;
};

export type UpdatePriceCategoryDto = {
    description?: string;
    offerGroups?: Array<PriceCategoryOfferGroupInputDto>;
    name?: string;
};

export type PipeUsageBufferDto = {
    /**
     * Unsaved pipe content; falls back to the saved version.
     */
    content?: {
        [key: string]: unknown;
    };
    /**
     * The pipe-scoped rule groups a save would submit — a full replace-set, including ones created in the buffer.
     */
    ruleGroups?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Unsaved translation bodies, keyed language -> key -> { content }. Overlaid per key AND per language, so languages the editor never loaded keep their stored copy.
     */
    translationModifications?: {
        [key: string]: unknown;
    };
    /**
     * Constants and variables that exist only in the buffer (id -1), so a just-created entity appears in the report immediately.
     */
    draftEntities?: Array<{
        [key: string]: unknown;
    }>;
};

export type UsageFindingDto = {
    kind: 'constant' | 'variable' | 'translation' | 'ruleGroup';
    id: number;
    scope: 'pipe' | 'brand' | 'global';
    name: string;
    /**
     * `{scope}.{name}` — the key stored in content.
     */
    key: string;
    type?: string;
    status: 'used' | 'unused' | 'protected';
    deletable: boolean;
    reason?: string;
    /**
     * Override / pipe-default rows a delete would cascade.
     */
    overrideCount?: number;
    referencedOnlyBy?: Array<string>;
};

export type UsageCountsDto = {
    used: number;
    unused: number;
    protected: number;
    deletable: number;
};

export type PipeUsageReportDto = {
    findings: Array<UsageFindingDto>;
    counts: UsageCountsDto;
    /**
     * Rule-group references that resolve to nothing. These fail closed and silently at runtime — the gated component simply never renders.
     */
    danglingRuleGroupKeys: Array<string>;
};

export type PipeUsageDeleteDto = {
    /**
     * Unsaved pipe content; falls back to the saved version.
     */
    content?: {
        [key: string]: unknown;
    };
    /**
     * The pipe-scoped rule groups a save would submit — a full replace-set, including ones created in the buffer.
     */
    ruleGroups?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Unsaved translation bodies, keyed language -> key -> { content }. Overlaid per key AND per language, so languages the editor never loaded keep their stored copy.
     */
    translationModifications?: {
        [key: string]: unknown;
    };
    /**
     * Constants and variables that exist only in the buffer (id -1), so a just-created entity appears in the report immediately.
     */
    draftEntities?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * The entities to delete, as `{kind, id}` pairs.
     */
    targets: Array<{
        [key: string]: unknown;
    }>;
};

export type PipeUsageDeleteResultDto = {
    deleted: Array<UsageFindingDto>;
    /**
     * Targets that were NOT deleted, each with the reason the re-run refused it.
     */
    skipped: Array<{
        [key: string]: unknown;
    }>;
};

export type ChangelogDto = {
    /**
     * Newest first.
     */
    entries: Array<ChangelogEntryDto>;
};

export type AppControllerHealthCheckData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/health';
};

export type AppControllerHealthCheckErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AppControllerHealthCheckError = AppControllerHealthCheckErrors[keyof AppControllerHealthCheckErrors];

export type AppControllerHealthCheckResponses = {
    200: HealthResponseDto;
};

export type AppControllerHealthCheckResponse = AppControllerHealthCheckResponses[keyof AppControllerHealthCheckResponses];

export type AuthControllerLoginData = {
    body: LoginDto;
    path?: never;
    query?: never;
    url: '/api/auth/login-dev';
};

export type AuthControllerLoginErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AuthControllerLoginError = AuthControllerLoginErrors[keyof AuthControllerLoginErrors];

export type AuthControllerLoginResponses = {
    201: unknown;
};

export type AuthControllerGoogleAuthData = {
    body: GoogleAuthDto;
    path?: never;
    query?: never;
    url: '/api/auth/google';
};

export type AuthControllerGoogleAuthErrors = {
    400: ErrorResponse400;
    403: unknown;
    500: unknown;
};

export type AuthControllerGoogleAuthError = AuthControllerGoogleAuthErrors[keyof AuthControllerGoogleAuthErrors];

export type AuthControllerGoogleAuthResponses = {
    201: AuthResponseDto;
};

export type AuthControllerGoogleAuthResponse = AuthControllerGoogleAuthResponses[keyof AuthControllerGoogleAuthResponses];

export type AuthControllerImpersionateData = {
    body: ImpersonateDto;
    path?: never;
    query?: never;
    url: '/api/auth/impersionate';
};

export type AuthControllerImpersionateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AuthControllerImpersionateError = AuthControllerImpersionateErrors[keyof AuthControllerImpersionateErrors];

export type AuthControllerImpersionateResponses = {
    201: AuthResponseDto;
};

export type AuthControllerImpersionateResponse = AuthControllerImpersionateResponses[keyof AuthControllerImpersionateResponses];

export type AuthControllerLogoutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/logout';
};

export type AuthControllerLogoutErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AuthControllerLogoutError = AuthControllerLogoutErrors[keyof AuthControllerLogoutErrors];

export type AuthControllerLogoutResponses = {
    201: unknown;
};

export type AuthControllerGetProfileData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/auth/profile';
};

export type AuthControllerGetProfileErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AuthControllerGetProfileError = AuthControllerGetProfileErrors[keyof AuthControllerGetProfileErrors];

export type AuthControllerGetProfileResponses = {
    200: User;
};

export type AuthControllerGetProfileResponse = AuthControllerGetProfileResponses[keyof AuthControllerGetProfileResponses];

export type UsersControllerListUsersData = {
    body: UsersRequestDto;
    path?: never;
    query?: never;
    url: '/api/users';
};

export type UsersControllerListUsersErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type UsersControllerListUsersError = UsersControllerListUsersErrors[keyof UsersControllerListUsersErrors];

export type UsersControllerListUsersResponses = {
    201: UsersResponseDto;
};

export type UsersControllerListUsersResponse = UsersControllerListUsersResponses[keyof UsersControllerListUsersResponses];

export type UsersControllerDeleteUserData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/users/{id}';
};

export type UsersControllerDeleteUserErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type UsersControllerDeleteUserError = UsersControllerDeleteUserErrors[keyof UsersControllerDeleteUserErrors];

export type UsersControllerDeleteUserResponses = {
    200: UserDto;
};

export type UsersControllerDeleteUserResponse = UsersControllerDeleteUserResponses[keyof UsersControllerDeleteUserResponses];

export type UsersControllerGetUserData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/users/{id}';
};

export type UsersControllerGetUserErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type UsersControllerGetUserError = UsersControllerGetUserErrors[keyof UsersControllerGetUserErrors];

export type UsersControllerGetUserResponses = {
    200: UserDto;
};

export type UsersControllerGetUserResponse = UsersControllerGetUserResponses[keyof UsersControllerGetUserResponses];

export type UsersControllerUpdateLimitsData = {
    body: UpdateUserLimitsDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/users/{id}/limits';
};

export type UsersControllerUpdateLimitsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type UsersControllerUpdateLimitsError = UsersControllerUpdateLimitsErrors[keyof UsersControllerUpdateLimitsErrors];

export type UsersControllerUpdateLimitsResponses = {
    200: UserDto;
};

export type UsersControllerUpdateLimitsResponse = UsersControllerUpdateLimitsResponses[keyof UsersControllerUpdateLimitsResponses];

export type UsersControllerUpdateRoleData = {
    body: UpdateUserRoleDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/users/{id}/role';
};

export type UsersControllerUpdateRoleErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type UsersControllerUpdateRoleError = UsersControllerUpdateRoleErrors[keyof UsersControllerUpdateRoleErrors];

export type UsersControllerUpdateRoleResponses = {
    200: UserDto;
};

export type UsersControllerUpdateRoleResponse = UsersControllerUpdateRoleResponses[keyof UsersControllerUpdateRoleResponses];

export type UsersControllerRestoreUserData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/users/{id}/restore';
};

export type UsersControllerRestoreUserErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type UsersControllerRestoreUserError = UsersControllerRestoreUserErrors[keyof UsersControllerRestoreUserErrors];

export type UsersControllerRestoreUserResponses = {
    200: UserDto;
};

export type UsersControllerRestoreUserResponse = UsersControllerRestoreUserResponses[keyof UsersControllerRestoreUserResponses];

export type AvatarsControllerGetAvatarData = {
    body?: never;
    path: {
        userId: number;
    };
    query?: never;
    url: '/api/avatars/{userId}';
};

export type AvatarsControllerGetAvatarErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AvatarsControllerGetAvatarError = AvatarsControllerGetAvatarErrors[keyof AvatarsControllerGetAvatarErrors];

export type AvatarsControllerGetAvatarResponses = {
    200: unknown;
};

export type ApiTokensControllerFindAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/api-tokens';
};

export type ApiTokensControllerFindAllErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ApiTokensControllerFindAllError = ApiTokensControllerFindAllErrors[keyof ApiTokensControllerFindAllErrors];

export type ApiTokensControllerFindAllResponses = {
    200: Array<ApiTokenDto>;
};

export type ApiTokensControllerFindAllResponse = ApiTokensControllerFindAllResponses[keyof ApiTokensControllerFindAllResponses];

export type ApiTokensControllerCreateData = {
    body: CreateApiTokenDto;
    path?: never;
    query?: never;
    url: '/api/api-tokens';
};

export type ApiTokensControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ApiTokensControllerCreateError = ApiTokensControllerCreateErrors[keyof ApiTokensControllerCreateErrors];

export type ApiTokensControllerCreateResponses = {
    201: ApiTokenCreateResponseDto;
};

export type ApiTokensControllerCreateResponse = ApiTokensControllerCreateResponses[keyof ApiTokensControllerCreateResponses];

export type ApiTokensControllerRemoveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/api-tokens/{id}';
};

export type ApiTokensControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ApiTokensControllerRemoveError = ApiTokensControllerRemoveErrors[keyof ApiTokensControllerRemoveErrors];

export type ApiTokensControllerRemoveResponses = {
    200: unknown;
};

export type ApiTokensControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/api-tokens/{id}';
};

export type ApiTokensControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ApiTokensControllerFindOneError = ApiTokensControllerFindOneErrors[keyof ApiTokensControllerFindOneErrors];

export type ApiTokensControllerFindOneResponses = {
    200: ApiTokenDto;
};

export type ApiTokensControllerFindOneResponse = ApiTokensControllerFindOneResponses[keyof ApiTokensControllerFindOneResponses];

export type UserPreferencesControllerUpsertPreferenceData = {
    body: UserPreferenceSaveDto;
    path?: never;
    query?: never;
    url: '/api/user-preferences/upsert';
};

export type UserPreferencesControllerUpsertPreferenceErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type UserPreferencesControllerUpsertPreferenceError = UserPreferencesControllerUpsertPreferenceErrors[keyof UserPreferencesControllerUpsertPreferenceErrors];

export type UserPreferencesControllerUpsertPreferenceResponses = {
    201: unknown;
};

export type BrandsControllerListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/brands';
};

export type BrandsControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type BrandsControllerListError = BrandsControllerListErrors[keyof BrandsControllerListErrors];

export type BrandsControllerListResponses = {
    200: BrandListResponseDto;
};

export type BrandsControllerListResponse = BrandsControllerListResponses[keyof BrandsControllerListResponses];

export type BrandsControllerCreateData = {
    body: BrandCreateDto;
    path?: never;
    query?: never;
    url: '/api/brands';
};

export type BrandsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type BrandsControllerCreateError = BrandsControllerCreateErrors[keyof BrandsControllerCreateErrors];

export type BrandsControllerCreateResponses = {
    201: BrandResponseDto;
};

export type BrandsControllerCreateResponse = BrandsControllerCreateResponses[keyof BrandsControllerCreateResponses];

export type BrandsControllerUpdateData = {
    body: BrandUpdateDto;
    path?: never;
    query?: never;
    url: '/api/brands';
};

export type BrandsControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type BrandsControllerUpdateError = BrandsControllerUpdateErrors[keyof BrandsControllerUpdateErrors];

export type BrandsControllerUpdateResponses = {
    200: BrandResponseDto;
};

export type BrandsControllerUpdateResponse = BrandsControllerUpdateResponses[keyof BrandsControllerUpdateResponses];

export type BrandsControllerListPaginatedData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        pageSize?: number;
    };
    url: '/api/brands/paginated';
};

export type BrandsControllerListPaginatedErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type BrandsControllerListPaginatedError = BrandsControllerListPaginatedErrors[keyof BrandsControllerListPaginatedErrors];

export type BrandsControllerListPaginatedResponses = {
    200: BrandListPaginatedResponseDto;
};

export type BrandsControllerListPaginatedResponse = BrandsControllerListPaginatedResponses[keyof BrandsControllerListPaginatedResponses];

export type BrandsControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/brands/{id}';
};

export type BrandsControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type BrandsControllerFindOneError = BrandsControllerFindOneErrors[keyof BrandsControllerFindOneErrors];

export type BrandsControllerFindOneResponses = {
    200: BrandResponseDto;
};

export type BrandsControllerFindOneResponse = BrandsControllerFindOneResponses[keyof BrandsControllerFindOneResponses];

export type LanguagesControllerListPipeLanguagesByPipeIdData = {
    body?: never;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/languages/pipe/{pipeId}';
};

export type LanguagesControllerListPipeLanguagesByPipeIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LanguagesControllerListPipeLanguagesByPipeIdError = LanguagesControllerListPipeLanguagesByPipeIdErrors[keyof LanguagesControllerListPipeLanguagesByPipeIdErrors];

export type LanguagesControllerListPipeLanguagesByPipeIdResponses = {
    200: LanguageListResponseDto;
};

export type LanguagesControllerListPipeLanguagesByPipeIdResponse = LanguagesControllerListPipeLanguagesByPipeIdResponses[keyof LanguagesControllerListPipeLanguagesByPipeIdResponses];

export type LanguagesControllerAddLanguageToPipeData = {
    body: AddLanguageToPipeDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/languages/pipe/{pipeId}';
};

export type LanguagesControllerAddLanguageToPipeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LanguagesControllerAddLanguageToPipeError = LanguagesControllerAddLanguageToPipeErrors[keyof LanguagesControllerAddLanguageToPipeErrors];

export type LanguagesControllerAddLanguageToPipeResponses = {
    201: PipeLanguage;
};

export type LanguagesControllerAddLanguageToPipeResponse = LanguagesControllerAddLanguageToPipeResponses[keyof LanguagesControllerAddLanguageToPipeResponses];

export type LanguagesControllerListLanguagesNotInPipeData = {
    body?: never;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/languages/pipe/{pipeId}/unlinked';
};

export type LanguagesControllerListLanguagesNotInPipeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LanguagesControllerListLanguagesNotInPipeError = LanguagesControllerListLanguagesNotInPipeErrors[keyof LanguagesControllerListLanguagesNotInPipeErrors];

export type LanguagesControllerListLanguagesNotInPipeResponses = {
    200: LanguageListResponseDto;
};

export type LanguagesControllerListLanguagesNotInPipeResponse = LanguagesControllerListLanguagesNotInPipeResponses[keyof LanguagesControllerListLanguagesNotInPipeResponses];

export type LanguagesControllerGetPipeLanguageUsageData = {
    body?: never;
    path: {
        pipeId: number;
        languageId: number;
    };
    query?: never;
    url: '/api/languages/pipe/{pipeId}/{languageId}/usage';
};

export type LanguagesControllerGetPipeLanguageUsageErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LanguagesControllerGetPipeLanguageUsageError = LanguagesControllerGetPipeLanguageUsageErrors[keyof LanguagesControllerGetPipeLanguageUsageErrors];

export type LanguagesControllerGetPipeLanguageUsageResponses = {
    200: PipeLanguageUsageDto;
};

export type LanguagesControllerGetPipeLanguageUsageResponse = LanguagesControllerGetPipeLanguageUsageResponses[keyof LanguagesControllerGetPipeLanguageUsageResponses];

export type LanguagesControllerRemoveLanguageFromPipeData = {
    body?: never;
    path: {
        pipeId: number;
        languageId: number;
    };
    query: {
        /**
         * Must equal the language code being removed (case-insensitive). Requests that do not match are rejected.
         */
        confirm: string;
    };
    url: '/api/languages/pipe/{pipeId}/{languageId}';
};

export type LanguagesControllerRemoveLanguageFromPipeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LanguagesControllerRemoveLanguageFromPipeError = LanguagesControllerRemoveLanguageFromPipeErrors[keyof LanguagesControllerRemoveLanguageFromPipeErrors];

export type LanguagesControllerRemoveLanguageFromPipeResponses = {
    200: RemovePipeLanguageResultDto;
};

export type LanguagesControllerRemoveLanguageFromPipeResponse = LanguagesControllerRemoveLanguageFromPipeResponses[keyof LanguagesControllerRemoveLanguageFromPipeResponses];

export type LanguagesControllerGetByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/languages/{id}';
};

export type LanguagesControllerGetByIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LanguagesControllerGetByIdError = LanguagesControllerGetByIdErrors[keyof LanguagesControllerGetByIdErrors];

export type LanguagesControllerGetByIdResponses = {
    200: Language;
};

export type LanguagesControllerGetByIdResponse = LanguagesControllerGetByIdResponses[keyof LanguagesControllerGetByIdResponses];

export type LanguagesControllerListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/languages';
};

export type LanguagesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LanguagesControllerListError = LanguagesControllerListErrors[keyof LanguagesControllerListErrors];

export type LanguagesControllerListResponses = {
    200: LanguageListResponseDto;
};

export type LanguagesControllerListResponse = LanguagesControllerListResponses[keyof LanguagesControllerListResponses];

export type GeographiesControllerListWithCountriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/geographies/with-countries';
};

export type GeographiesControllerListWithCountriesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type GeographiesControllerListWithCountriesError = GeographiesControllerListWithCountriesErrors[keyof GeographiesControllerListWithCountriesErrors];

export type GeographiesControllerListWithCountriesResponses = {
    200: GeographyWithCountriesListDto;
};

export type GeographiesControllerListWithCountriesResponse = GeographiesControllerListWithCountriesResponses[keyof GeographiesControllerListWithCountriesResponses];

export type GeographiesControllerGetByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/geographies/{id}';
};

export type GeographiesControllerGetByIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type GeographiesControllerGetByIdError = GeographiesControllerGetByIdErrors[keyof GeographiesControllerGetByIdErrors];

export type GeographiesControllerGetByIdResponses = {
    200: Geography;
};

export type GeographiesControllerGetByIdResponse = GeographiesControllerGetByIdResponses[keyof GeographiesControllerGetByIdResponses];

export type GeographiesControllerSetCountriesData = {
    body: SetGeographyCountriesDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/geographies/{id}/countries';
};

export type GeographiesControllerSetCountriesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type GeographiesControllerSetCountriesError = GeographiesControllerSetCountriesErrors[keyof GeographiesControllerSetCountriesErrors];

export type GeographiesControllerSetCountriesResponses = {
    200: GeographyWithCountriesDto;
};

export type GeographiesControllerSetCountriesResponse = GeographiesControllerSetCountriesResponses[keyof GeographiesControllerSetCountriesResponses];

export type GeographiesControllerListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/geographies';
};

export type GeographiesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type GeographiesControllerListError = GeographiesControllerListErrors[keyof GeographiesControllerListErrors];

export type GeographiesControllerListResponses = {
    200: GeographyListResponseDto;
};

export type GeographiesControllerListResponse = GeographiesControllerListResponses[keyof GeographiesControllerListResponses];

export type LocalesControllerListData = {
    body?: never;
    path?: never;
    query?: {
        languageId?: number;
        geographyId?: number;
    };
    url: '/api/locales';
};

export type LocalesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LocalesControllerListError = LocalesControllerListErrors[keyof LocalesControllerListErrors];

export type LocalesControllerListResponses = {
    200: Array<LocaleOverrideDto>;
};

export type LocalesControllerListResponse = LocalesControllerListResponses[keyof LocalesControllerListResponses];

export type LocalesControllerUpsertData = {
    body: UpsertLocaleOverrideDto;
    path?: never;
    query?: never;
    url: '/api/locales';
};

export type LocalesControllerUpsertErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LocalesControllerUpsertError = LocalesControllerUpsertErrors[keyof LocalesControllerUpsertErrors];

export type LocalesControllerUpsertResponses = {
    200: LocaleOverrideDto;
};

export type LocalesControllerUpsertResponse = LocalesControllerUpsertResponses[keyof LocalesControllerUpsertResponses];

export type LocalesControllerFindByPairData = {
    body?: never;
    path?: never;
    query: {
        languageId: number;
        geographyId: number;
    };
    url: '/api/locales/by-pair';
};

export type LocalesControllerFindByPairErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LocalesControllerFindByPairError = LocalesControllerFindByPairErrors[keyof LocalesControllerFindByPairErrors];

export type LocalesControllerFindByPairResponses = {
    200: {
        [key: string]: unknown;
    };
};

export type LocalesControllerFindByPairResponse = LocalesControllerFindByPairResponses[keyof LocalesControllerFindByPairResponses];

export type LocalesControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/locales/{id}';
};

export type LocalesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type LocalesControllerRemoveError = LocalesControllerRemoveErrors[keyof LocalesControllerRemoveErrors];

export type LocalesControllerRemoveResponses = {
    204: void;
};

export type LocalesControllerRemoveResponse = LocalesControllerRemoveResponses[keyof LocalesControllerRemoveResponses];

export type TagsControllerListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/tags';
};

export type TagsControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TagsControllerListError = TagsControllerListErrors[keyof TagsControllerListErrors];

export type TagsControllerListResponses = {
    200: TagsListResponseUnpaginatedDto;
};

export type TagsControllerListResponse = TagsControllerListResponses[keyof TagsControllerListResponses];

export type TagsControllerCreateData = {
    body: TagCreateDto;
    path?: never;
    query?: never;
    url: '/api/tags';
};

export type TagsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TagsControllerCreateError = TagsControllerCreateErrors[keyof TagsControllerCreateErrors];

export type TagsControllerCreateResponses = {
    201: TagResponseDto;
};

export type TagsControllerCreateResponse = TagsControllerCreateResponses[keyof TagsControllerCreateResponses];

export type TagsControllerListPaginatedData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        pageSize?: number;
        /**
         * Partial tag name filter
         */
        name?: string;
    };
    url: '/api/tags/paginated';
};

export type TagsControllerListPaginatedErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TagsControllerListPaginatedError = TagsControllerListPaginatedErrors[keyof TagsControllerListPaginatedErrors];

export type TagsControllerListPaginatedResponses = {
    200: TagListResponseDto;
};

export type TagsControllerListPaginatedResponse = TagsControllerListPaginatedResponses[keyof TagsControllerListPaginatedResponses];

export type TagsControllerGetByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/tags/{id}';
};

export type TagsControllerGetByIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TagsControllerGetByIdError = TagsControllerGetByIdErrors[keyof TagsControllerGetByIdErrors];

export type TagsControllerGetByIdResponses = {
    200: TagResponseDto;
};

export type TagsControllerGetByIdResponse = TagsControllerGetByIdResponses[keyof TagsControllerGetByIdResponses];

export type MediaControllerSearchImagesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Search query for media items
         */
        query?: string;
        page?: number;
        pageSize?: number;
        /**
         * Restrict to media associated with this pipe, per `media_pipe_link`. Combine with `pipeUsage` to pick which association states count. Omit to list the whole library.
         */
        pipeId?: number;
        /**
         * Which association states count when `pipeId` is given. No effect without it.
         */
        pipeUsage?: MediaPipeUsageFilter;
        /**
         * Match media carrying ANY of these tags (case-insensitive). Tags are platform-written provenance labels — currently only `by-agent`.
         */
        tags?: Array<string>;
    };
    url: '/api/media/search/images';
};

export type MediaControllerSearchImagesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerSearchImagesError = MediaControllerSearchImagesErrors[keyof MediaControllerSearchImagesErrors];

export type MediaControllerSearchImagesResponses = {
    200: MediaListResponseDto;
};

export type MediaControllerSearchImagesResponse = MediaControllerSearchImagesResponses[keyof MediaControllerSearchImagesResponses];

export type MediaControllerSearchVideosData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Search query for media items
         */
        query?: string;
        page?: number;
        pageSize?: number;
        /**
         * Restrict to media associated with this pipe, per `media_pipe_link`. Combine with `pipeUsage` to pick which association states count. Omit to list the whole library.
         */
        pipeId?: number;
        /**
         * Which association states count when `pipeId` is given. No effect without it.
         */
        pipeUsage?: MediaPipeUsageFilter;
        /**
         * Match media carrying ANY of these tags (case-insensitive). Tags are platform-written provenance labels — currently only `by-agent`.
         */
        tags?: Array<string>;
    };
    url: '/api/media/search/videos';
};

export type MediaControllerSearchVideosErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerSearchVideosError = MediaControllerSearchVideosErrors[keyof MediaControllerSearchVideosErrors];

export type MediaControllerSearchVideosResponses = {
    200: MediaListResponseDto;
};

export type MediaControllerSearchVideosResponse = MediaControllerSearchVideosResponses[keyof MediaControllerSearchVideosResponses];

export type MediaControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Search query for media items
         */
        query?: string;
        page?: number;
        pageSize?: number;
        /**
         * Restrict to media associated with this pipe, per `media_pipe_link`. Combine with `pipeUsage` to pick which association states count. Omit to list the whole library.
         */
        pipeId?: number;
        /**
         * Which association states count when `pipeId` is given. No effect without it.
         */
        pipeUsage?: MediaPipeUsageFilter;
        /**
         * Match media carrying ANY of these tags (case-insensitive). Tags are platform-written provenance labels — currently only `by-agent`.
         */
        tags?: Array<string>;
    };
    url: '/api/media';
};

export type MediaControllerFindAllErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerFindAllError = MediaControllerFindAllErrors[keyof MediaControllerFindAllErrors];

export type MediaControllerFindAllResponses = {
    200: MediaListResponseDto;
};

export type MediaControllerFindAllResponse = MediaControllerFindAllResponses[keyof MediaControllerFindAllResponses];

export type MediaControllerCreateData = {
    body: {
        file?: Blob | File;
    };
    path?: never;
    query?: {
        /**
         * Link the uploaded media to this pipe as `linked` (the upload happened inside that pipe's editor). Ignored if the pipe does not exist.
         */
        pipeId?: number;
    };
    url: '/api/media';
};

export type MediaControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerCreateError = MediaControllerCreateErrors[keyof MediaControllerCreateErrors];

export type MediaControllerCreateResponses = {
    201: MediaResponseDto;
};

export type MediaControllerCreateResponse = MediaControllerCreateResponses[keyof MediaControllerCreateResponses];

export type MediaControllerFindOneData = {
    body?: never;
    path: {
        uuid: string;
    };
    query?: never;
    url: '/api/media/info/{uuid}';
};

export type MediaControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerFindOneError = MediaControllerFindOneErrors[keyof MediaControllerFindOneErrors];

export type MediaControllerFindOneResponses = {
    200: MediaResponseDto;
};

export type MediaControllerFindOneResponse = MediaControllerFindOneResponses[keyof MediaControllerFindOneResponses];

export type MediaControllerFindPipesData = {
    body?: never;
    path: {
        uuid: string;
    };
    query?: never;
    url: '/api/media/{uuid}/pipes';
};

export type MediaControllerFindPipesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerFindPipesError = MediaControllerFindPipesErrors[keyof MediaControllerFindPipesErrors];

export type MediaControllerFindPipesResponses = {
    200: MediaPipeUsageListDto;
};

export type MediaControllerFindPipesResponse = MediaControllerFindPipesResponses[keyof MediaControllerFindPipesResponses];

export type MediaControllerRemoveData = {
    body?: never;
    path: {
        uuid: string;
    };
    query?: never;
    url: '/api/media/{uuid}';
};

export type MediaControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerRemoveError = MediaControllerRemoveErrors[keyof MediaControllerRemoveErrors];

export type MediaControllerRemoveResponses = {
    204: void;
};

export type MediaControllerRemoveResponse = MediaControllerRemoveResponses[keyof MediaControllerRemoveResponses];

export type MediaControllerStreamMediaData = {
    body?: never;
    path: {
        uuid: string;
    };
    query?: {
        w?: string;
        q?: string;
        f?: string;
    };
    url: '/api/media/{uuid}';
};

export type MediaControllerStreamMediaErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerStreamMediaError = MediaControllerStreamMediaErrors[keyof MediaControllerStreamMediaErrors];

export type MediaControllerStreamMediaResponses = {
    200: unknown;
};

export type MediaControllerUpdateData = {
    body: {
        file?: Blob | File;
        name?: string;
    };
    path: {
        uuid: string;
    };
    query?: never;
    url: '/api/media/{uuid}';
};

export type MediaControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type MediaControllerUpdateError = MediaControllerUpdateErrors[keyof MediaControllerUpdateErrors];

export type MediaControllerUpdateResponses = {
    200: MediaResponseDto;
};

export type MediaControllerUpdateResponse = MediaControllerUpdateResponses[keyof MediaControllerUpdateResponses];

export type SystemSettingsControllerListSettingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/system-settings';
};

export type SystemSettingsControllerListSettingsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type SystemSettingsControllerListSettingsError = SystemSettingsControllerListSettingsErrors[keyof SystemSettingsControllerListSettingsErrors];

export type SystemSettingsControllerListSettingsResponses = {
    200: SystemSettingsListResponseDto;
};

export type SystemSettingsControllerListSettingsResponse = SystemSettingsControllerListSettingsResponses[keyof SystemSettingsControllerListSettingsResponses];

export type SystemSettingsControllerListSettingsExposedToFrontendData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/system-settings/frontend';
};

export type SystemSettingsControllerListSettingsExposedToFrontendErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type SystemSettingsControllerListSettingsExposedToFrontendError = SystemSettingsControllerListSettingsExposedToFrontendErrors[keyof SystemSettingsControllerListSettingsExposedToFrontendErrors];

export type SystemSettingsControllerListSettingsExposedToFrontendResponses = {
    200: SystemSettingsFrontendListResponseDto;
};

export type SystemSettingsControllerListSettingsExposedToFrontendResponse = SystemSettingsControllerListSettingsExposedToFrontendResponses[keyof SystemSettingsControllerListSettingsExposedToFrontendResponses];

export type SystemSettingsControllerUpdateSettingData = {
    body: UpdateSystemSettingDto;
    path: {
        key: string;
    };
    query?: never;
    url: '/api/system-settings/{key}';
};

export type SystemSettingsControllerUpdateSettingErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type SystemSettingsControllerUpdateSettingError = SystemSettingsControllerUpdateSettingErrors[keyof SystemSettingsControllerUpdateSettingErrors];

export type SystemSettingsControllerUpdateSettingResponses = {
    200: unknown;
};

export type PipesControllerFindNamesByIdsData = {
    body?: never;
    path?: never;
    query: {
        ids: Array<number>;
    };
    url: '/api/pipes/names';
};

export type PipesControllerFindNamesByIdsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerFindNamesByIdsError = PipesControllerFindNamesByIdsErrors[keyof PipesControllerFindNamesByIdsErrors];

export type PipesControllerFindNamesByIdsResponses = {
    200: Array<PipeNameDto>;
};

export type PipesControllerFindNamesByIdsResponse = PipesControllerFindNamesByIdsResponses[keyof PipesControllerFindNamesByIdsResponses];

export type PipesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Also return deleted pipes. Off by default.
         */
        includeDeleted?: boolean;
    };
    url: '/api/pipes';
};

export type PipesControllerFindAllErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerFindAllError = PipesControllerFindAllErrors[keyof PipesControllerFindAllErrors];

export type PipesControllerFindAllResponses = {
    200: Array<PipeListItemDto>;
};

export type PipesControllerFindAllResponse = PipesControllerFindAllResponses[keyof PipesControllerFindAllResponses];

export type PipesControllerCreateData = {
    body: PipeCreateDto;
    path?: never;
    query?: never;
    url: '/api/pipes';
};

export type PipesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerCreateError = PipesControllerCreateErrors[keyof PipesControllerCreateErrors];

export type PipesControllerCreateResponses = {
    201: PipeDto;
};

export type PipesControllerCreateResponse = PipesControllerCreateResponses[keyof PipesControllerCreateResponses];

export type PipesControllerListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Also return deleted pipes. Off by default.
         */
        includeDeleted?: boolean;
        brandId?: number;
        nameQuery?: string;
        hasActiveIngressDestination?: boolean;
        /**
         * Keep only pipes with at least one live distribution in the Draft or Active status (`draft_or_active`), or in the Active status (`active`). The same statuses as the list response `draftStatus` / `activeStatus`.
         */
        distributionStatus?: PipeListDistributionStatusFilter;
        contentUpdatedById?: number;
        page?: number;
        pageSize?: number;
    };
    url: '/api/pipes/list';
};

export type PipesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerListError = PipesControllerListErrors[keyof PipesControllerListErrors];

export type PipesControllerListResponses = {
    200: PipeListPaginatedResponseDto;
};

export type PipesControllerListResponse = PipesControllerListResponses[keyof PipesControllerListResponses];

export type PipesControllerSearchData = {
    body?: never;
    path?: never;
    query?: {
        nameQuery?: string;
        brandId?: number;
        page?: number;
        pageSize?: number;
    };
    url: '/api/pipes/search';
};

export type PipesControllerSearchErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerSearchError = PipesControllerSearchErrors[keyof PipesControllerSearchErrors];

export type PipesControllerSearchResponses = {
    200: PipeSearchResponseDto;
};

export type PipesControllerSearchResponse = PipesControllerSearchResponses[keyof PipesControllerSearchResponses];

export type PipesControllerFindOneFullReleaseData = {
    body: PipeFullReleaseRequestDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/full';
};

export type PipesControllerFindOneFullReleaseErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerFindOneFullReleaseError = PipesControllerFindOneFullReleaseErrors[keyof PipesControllerFindOneFullReleaseErrors];

export type PipesControllerFindOneFullReleaseResponses = {
    201: {
        [key: string]: unknown;
    };
};

export type PipesControllerFindOneFullReleaseResponse = PipesControllerFindOneFullReleaseResponses[keyof PipesControllerFindOneFullReleaseResponses];

export type PipesControllerFindPopulatedConstantsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        /**
         * Currency code used to resolve reference-type constants. Defaults to the configured pipe default when omitted.
         */
        currency?: string;
    };
    url: '/api/pipes/{id}/constants';
};

export type PipesControllerFindPopulatedConstantsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerFindPopulatedConstantsError = PipesControllerFindPopulatedConstantsErrors[keyof PipesControllerFindPopulatedConstantsErrors];

export type PipesControllerFindPopulatedConstantsResponses = {
    200: PipePopulatedConstantsDto;
};

export type PipesControllerFindPopulatedConstantsResponse = PipesControllerFindPopulatedConstantsResponses[keyof PipesControllerFindPopulatedConstantsResponses];

export type PipesControllerGetAvailableCurrencyCodesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/available-currency-codes';
};

export type PipesControllerGetAvailableCurrencyCodesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerGetAvailableCurrencyCodesError = PipesControllerGetAvailableCurrencyCodesErrors[keyof PipesControllerGetAvailableCurrencyCodesErrors];

export type PipesControllerGetAvailableCurrencyCodesResponses = {
    200: PipeAvailableCurrencyCodesDto;
};

export type PipesControllerGetAvailableCurrencyCodesResponse = PipesControllerGetAvailableCurrencyCodesResponses[keyof PipesControllerGetAvailableCurrencyCodesResponses];

export type PipesControllerGetAvailableGeographyCodesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/available-geography-codes';
};

export type PipesControllerGetAvailableGeographyCodesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerGetAvailableGeographyCodesError = PipesControllerGetAvailableGeographyCodesErrors[keyof PipesControllerGetAvailableGeographyCodesErrors];

export type PipesControllerGetAvailableGeographyCodesResponses = {
    200: PipeAvailableGeographyCodesDto;
};

export type PipesControllerGetAvailableGeographyCodesResponse = PipesControllerGetAvailableGeographyCodesResponses[keyof PipesControllerGetAvailableGeographyCodesResponses];

export type PipesControllerFindPagesForPipeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/pages';
};

export type PipesControllerFindPagesForPipeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerFindPagesForPipeError = PipesControllerFindPagesForPipeErrors[keyof PipesControllerFindPagesForPipeErrors];

export type PipesControllerFindPagesForPipeResponses = {
    200: Array<PipePageRefDto>;
};

export type PipesControllerFindPagesForPipeResponse = PipesControllerFindPagesForPipeResponses[keyof PipesControllerFindPagesForPipeResponses];

export type PipesControllerListContentHistoryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        skip?: number;
        take?: number;
    };
    url: '/api/pipes/{id}/content-history';
};

export type PipesControllerListContentHistoryErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerListContentHistoryError = PipesControllerListContentHistoryErrors[keyof PipesControllerListContentHistoryErrors];

export type PipesControllerListContentHistoryResponses = {
    200: PipeContentHistoryListDto;
};

export type PipesControllerListContentHistoryResponse = PipesControllerListContentHistoryResponses[keyof PipesControllerListContentHistoryResponses];

export type PipesControllerFindContentData = {
    body?: never;
    path: {
        id: string;
        contentId: string;
    };
    query?: never;
    url: '/api/pipes/{id}/content/{contentId}';
};

export type PipesControllerFindContentErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerFindContentError = PipesControllerFindContentErrors[keyof PipesControllerFindContentErrors];

export type PipesControllerFindContentResponses = {
    200: PipeContentDto;
};

export type PipesControllerFindContentResponse = PipesControllerFindContentResponses[keyof PipesControllerFindContentResponses];

export type PipesControllerContentDiffData = {
    body: PipeContentDiffRequestDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/content-diff';
};

export type PipesControllerContentDiffErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerContentDiffError = PipesControllerContentDiffErrors[keyof PipesControllerContentDiffErrors];

export type PipesControllerContentDiffResponses = {
    200: PipeContentDiffDto;
};

export type PipesControllerContentDiffResponse = PipesControllerContentDiffResponses[keyof PipesControllerContentDiffResponses];

export type PipesControllerStyleDiffData = {
    body: PipeStyleDiffRequestDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/style-diff';
};

export type PipesControllerStyleDiffErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerStyleDiffError = PipesControllerStyleDiffErrors[keyof PipesControllerStyleDiffErrors];

export type PipesControllerStyleDiffResponses = {
    200: PipeStyleDiffDto;
};

export type PipesControllerStyleDiffResponse = PipesControllerStyleDiffResponses[keyof PipesControllerStyleDiffResponses];

export type PipesControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipes/{id}';
};

export type PipesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * A distribution of the pipe has an active ingress destination.
     */
    409: unknown;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerRemoveError = PipesControllerRemoveErrors[keyof PipesControllerRemoveErrors];

export type PipesControllerRemoveResponses = {
    200: unknown;
};

export type PipesControllerFindOneData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}';
};

export type PipesControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerFindOneError = PipesControllerFindOneErrors[keyof PipesControllerFindOneErrors];

export type PipesControllerFindOneResponses = {
    200: {
        [key: string]: unknown;
    };
};

export type PipesControllerFindOneResponse = PipesControllerFindOneResponses[keyof PipesControllerFindOneResponses];

export type PipesControllerFindOneForUpdateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        /**
         * Filter by languages
         */
        languages?: Array<string>;
        /**
         * Currency code used to resolve reference-type constants (e.g. OFFER_GROUP). Defaults to the configured pipe default when omitted.
         */
        currency?: string;
    };
    url: '/api/pipes/update/{id}';
};

export type PipesControllerFindOneForUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerFindOneForUpdateError = PipesControllerFindOneForUpdateErrors[keyof PipesControllerFindOneForUpdateErrors];

export type PipesControllerFindOneForUpdateResponses = {
    200: {
        [key: string]: unknown;
    };
};

export type PipesControllerFindOneForUpdateResponse = PipesControllerFindOneForUpdateResponses[keyof PipesControllerFindOneForUpdateResponses];

export type PipesControllerUpdateData = {
    body: PipeUpdateDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/update/{id}';
};

export type PipesControllerUpdateErrors = {
    400: ErrorResponse400;
    409: PipeSaveConflictDto;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerUpdateError = PipesControllerUpdateErrors[keyof PipesControllerUpdateErrors];

export type PipesControllerUpdateResponses = {
    200: PipeFullExtendedDto;
};

export type PipesControllerUpdateResponse = PipesControllerUpdateResponses[keyof PipesControllerUpdateResponses];

export type PipesControllerTransferBundleData = {
    body: PipeTransferBundleRequestDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/transfer-bundle';
};

export type PipesControllerTransferBundleErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerTransferBundleError = PipesControllerTransferBundleErrors[keyof PipesControllerTransferBundleErrors];

export type PipesControllerTransferBundleResponses = {
    200: PipeTransferBundleDto;
};

export type PipesControllerTransferBundleResponse = PipesControllerTransferBundleResponses[keyof PipesControllerTransferBundleResponses];

export type PipesControllerPreviewCopyData = {
    body: PipeCopyRequestDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/copy/preview';
};

export type PipesControllerPreviewCopyErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerPreviewCopyError = PipesControllerPreviewCopyErrors[keyof PipesControllerPreviewCopyErrors];

export type PipesControllerPreviewCopyResponses = {
    200: PipeCopyPreviewDto;
};

export type PipesControllerPreviewCopyResponse = PipesControllerPreviewCopyResponses[keyof PipesControllerPreviewCopyResponses];

export type PipesControllerCopyData = {
    body: PipeCopyRequestDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipes/{id}/copy';
};

export type PipesControllerCopyErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerCopyError = PipesControllerCopyErrors[keyof PipesControllerCopyErrors];

export type PipesControllerCopyResponses = {
    200: PipeDto;
};

export type PipesControllerCopyResponse = PipesControllerCopyResponses[keyof PipesControllerCopyResponses];

export type PipesControllerRestoreData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipes/{id}/restore';
};

export type PipesControllerRestoreErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipesControllerRestoreError = PipesControllerRestoreErrors[keyof PipesControllerRestoreErrors];

export type PipesControllerRestoreResponses = {
    201: unknown;
};

export type TranslationsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter by language name
         */
        language?: string;
        /**
         * Scope to translations belonging to this pipe (group=pipe AND pipe_id=:pipeId), plus globals, plus brand-scoped if brandId is also given.
         */
        pipeId?: number;
        /**
         * Brand id used together with pipeId to additionally include brand-scoped (group=brand AND brand_id=:brandId) translations.
         */
        brandId?: number;
    };
    url: '/api/translations';
};

export type TranslationsControllerFindAllErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerFindAllError = TranslationsControllerFindAllErrors[keyof TranslationsControllerFindAllErrors];

export type TranslationsControllerFindAllResponses = {
    200: Array<TranslationDto>;
};

export type TranslationsControllerFindAllResponse = TranslationsControllerFindAllResponses[keyof TranslationsControllerFindAllResponses];

export type TranslationsControllerCreateData = {
    body: CreateTranslationDto;
    path?: never;
    query?: never;
    url: '/api/translations';
};

export type TranslationsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerCreateError = TranslationsControllerCreateErrors[keyof TranslationsControllerCreateErrors];

export type TranslationsControllerCreateResponses = {
    201: TranslationDto;
};

export type TranslationsControllerCreateResponse = TranslationsControllerCreateResponses[keyof TranslationsControllerCreateResponses];

export type TranslationsControllerFindAllPaginatedData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        pageSize?: number;
        /**
         * Filter by language name
         */
        language?: string;
    };
    url: '/api/translations/paginated';
};

export type TranslationsControllerFindAllPaginatedErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerFindAllPaginatedError = TranslationsControllerFindAllPaginatedErrors[keyof TranslationsControllerFindAllPaginatedErrors];

export type TranslationsControllerFindAllPaginatedResponses = {
    200: TranslationListPaginatedResponseDto;
};

export type TranslationsControllerFindAllPaginatedResponse = TranslationsControllerFindAllPaginatedResponses[keyof TranslationsControllerFindAllPaginatedResponses];

export type TranslationsControllerListKeysData = {
    body: TranslationKeyListQueryDto;
    path?: never;
    query?: never;
    url: '/api/translations/keys';
};

export type TranslationsControllerListKeysErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerListKeysError = TranslationsControllerListKeysErrors[keyof TranslationsControllerListKeysErrors];

export type TranslationsControllerListKeysResponses = {
    200: TranslationKeyListResponseDto;
};

export type TranslationsControllerListKeysResponse = TranslationsControllerListKeysResponses[keyof TranslationsControllerListKeysResponses];

export type TranslationsControllerSaveKeyData = {
    body: SaveTranslationKeyDto;
    path?: never;
    query?: never;
    url: '/api/translations/keys';
};

export type TranslationsControllerSaveKeyErrors = {
    400: ErrorResponse400;
    409: TranslationKeyConflictDto;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerSaveKeyError = TranslationsControllerSaveKeyErrors[keyof TranslationsControllerSaveKeyErrors];

export type TranslationsControllerSaveKeyResponses = {
    200: TranslationKeyListItemDto;
};

export type TranslationsControllerSaveKeyResponse = TranslationsControllerSaveKeyResponses[keyof TranslationsControllerSaveKeyResponses];

export type TranslationsControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/translations/{id}';
};

export type TranslationsControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerRemoveError = TranslationsControllerRemoveErrors[keyof TranslationsControllerRemoveErrors];

export type TranslationsControllerRemoveResponses = {
    200: TranslationDto;
};

export type TranslationsControllerRemoveResponse = TranslationsControllerRemoveResponses[keyof TranslationsControllerRemoveResponses];

export type TranslationsControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/translations/{id}';
};

export type TranslationsControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerFindOneError = TranslationsControllerFindOneErrors[keyof TranslationsControllerFindOneErrors];

export type TranslationsControllerFindOneResponses = {
    200: TranslationDto;
};

export type TranslationsControllerFindOneResponse = TranslationsControllerFindOneResponses[keyof TranslationsControllerFindOneResponses];

export type TranslationsControllerUpdateData = {
    body: UpdateTranslationDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/translations/{id}';
};

export type TranslationsControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerUpdateError = TranslationsControllerUpdateErrors[keyof TranslationsControllerUpdateErrors];

export type TranslationsControllerUpdateResponses = {
    200: TranslationDto;
};

export type TranslationsControllerUpdateResponse = TranslationsControllerUpdateResponses[keyof TranslationsControllerUpdateResponses];

export type TranslationsControllerListRevisionsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        skip?: number;
        take?: number;
    };
    url: '/api/translations/{id}/revisions';
};

export type TranslationsControllerListRevisionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerListRevisionsError = TranslationsControllerListRevisionsErrors[keyof TranslationsControllerListRevisionsErrors];

export type TranslationsControllerListRevisionsResponses = {
    200: TranslationRevisionListDto;
};

export type TranslationsControllerListRevisionsResponse = TranslationsControllerListRevisionsResponses[keyof TranslationsControllerListRevisionsResponses];

export type TranslationsControllerFindRevisionData = {
    body?: never;
    path: {
        id: number;
        revisionId: number;
    };
    query?: never;
    url: '/api/translations/{id}/revisions/{revisionId}';
};

export type TranslationsControllerFindRevisionErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerFindRevisionError = TranslationsControllerFindRevisionErrors[keyof TranslationsControllerFindRevisionErrors];

export type TranslationsControllerFindRevisionResponses = {
    200: TranslationRevisionDto;
};

export type TranslationsControllerFindRevisionResponse = TranslationsControllerFindRevisionResponses[keyof TranslationsControllerFindRevisionResponses];

export type TranslationsControllerBulkUpsertData = {
    body: BulkUpsertTranslationsDto;
    path?: never;
    query?: never;
    url: '/api/translations/bulk-upsert';
};

export type TranslationsControllerBulkUpsertErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerBulkUpsertError = TranslationsControllerBulkUpsertErrors[keyof TranslationsControllerBulkUpsertErrors];

export type TranslationsControllerBulkUpsertResponses = {
    201: unknown;
};

export type TranslationsControllerFetchForKeysData = {
    body: FetchTranslationsForKeysDto;
    path?: never;
    query?: never;
    url: '/api/translations/fetch-for-keys';
};

export type TranslationsControllerFetchForKeysErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationsControllerFetchForKeysError = TranslationsControllerFetchForKeysErrors[keyof TranslationsControllerFetchForKeysErrors];

export type TranslationsControllerFetchForKeysResponses = {
    201: FetchTranslationsForKeysResponseDto;
};

export type TranslationsControllerFetchForKeysResponse = TranslationsControllerFetchForKeysResponses[keyof TranslationsControllerFetchForKeysResponses];

export type VariablesControllerGetPathsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/variables/paths';
};

export type VariablesControllerGetPathsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type VariablesControllerGetPathsError = VariablesControllerGetPathsErrors[keyof VariablesControllerGetPathsErrors];

export type VariablesControllerGetPathsResponses = {
    /**
     * A map of variable types and their nested paths
     */
    200: {
        [key: string]: Array<string>;
    };
};

export type VariablesControllerGetPathsResponse = VariablesControllerGetPathsResponses[keyof VariablesControllerGetPathsResponses];

export type VariablesControllerListFilteredData = {
    body: ListVariablesQueryDto;
    path?: never;
    query?: never;
    url: '/api/variables/list';
};

export type VariablesControllerListFilteredErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type VariablesControllerListFilteredError = VariablesControllerListFilteredErrors[keyof VariablesControllerListFilteredErrors];

export type VariablesControllerListFilteredResponses = {
    201: VariableListResponseDto;
};

export type VariablesControllerListFilteredResponse = VariablesControllerListFilteredResponses[keyof VariablesControllerListFilteredResponses];

export type VariablesControllerFindForPipeOrBrandData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Which definitions to list. Without it, `brandId` / `pipeId` list the globals plus that brand's and that pipe's own variables (the pipe editor's view), and only the overrides of that pipe's distributions are attached.
         */
        scope?: ConstVarListScope;
        /**
         * Brand ID to filter variables
         */
        brandId?: number;
        /**
         * Pipe ID to filter variables
         */
        pipeId?: number;
        /**
         * With `scope=distribution`: only variables overridden in this distribution, with only its overrides attached.
         */
        distributionId?: number;
        /**
         * Free-text search. Matches a substring against `<group>.<name>` (the dotted key) or the description. A leading `var.` prefix is stripped, so `var.global.gender`, `global.gender`, and `gender` all work.
         */
        search?: string;
        page?: number;
        pageSize?: number;
    };
    url: '/api/variables/for_pipe_or_brand';
};

export type VariablesControllerFindForPipeOrBrandErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type VariablesControllerFindForPipeOrBrandError = VariablesControllerFindForPipeOrBrandErrors[keyof VariablesControllerFindForPipeOrBrandErrors];

export type VariablesControllerFindForPipeOrBrandResponses = {
    200: VariableListResponseDto;
};

export type VariablesControllerFindForPipeOrBrandResponse = VariablesControllerFindForPipeOrBrandResponses[keyof VariablesControllerFindForPipeOrBrandResponses];

export type VariablesControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/variables/{id}';
};

export type VariablesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type VariablesControllerRemoveError = VariablesControllerRemoveErrors[keyof VariablesControllerRemoveErrors];

export type VariablesControllerRemoveResponses = {
    200: Variable;
};

export type VariablesControllerRemoveResponse = VariablesControllerRemoveResponses[keyof VariablesControllerRemoveResponses];

export type VariablesControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/variables/{id}';
};

export type VariablesControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type VariablesControllerFindOneError = VariablesControllerFindOneErrors[keyof VariablesControllerFindOneErrors];

export type VariablesControllerFindOneResponses = {
    200: VariableBaseDto;
};

export type VariablesControllerFindOneResponse = VariablesControllerFindOneResponses[keyof VariablesControllerFindOneResponses];

export type VariablesControllerUpdateData = {
    body: UpdateVariableDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/variables/{id}';
};

export type VariablesControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type VariablesControllerUpdateError = VariablesControllerUpdateErrors[keyof VariablesControllerUpdateErrors];

export type VariablesControllerUpdateResponses = {
    200: VariableBaseDto;
};

export type VariablesControllerUpdateResponse = VariablesControllerUpdateResponses[keyof VariablesControllerUpdateResponses];

export type VariablesControllerCreateData = {
    body: CreateVariableDto;
    path?: never;
    query?: never;
    url: '/api/variables';
};

export type VariablesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type VariablesControllerCreateError = VariablesControllerCreateErrors[keyof VariablesControllerCreateErrors];

export type VariablesControllerCreateResponses = {
    201: VariableBaseDto;
};

export type VariablesControllerCreateResponse = VariablesControllerCreateResponses[keyof VariablesControllerCreateResponses];

export type VariablesControllerListRevisionsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        skip?: number;
        take?: number;
    };
    url: '/api/variables/{id}/revisions';
};

export type VariablesControllerListRevisionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type VariablesControllerListRevisionsError = VariablesControllerListRevisionsErrors[keyof VariablesControllerListRevisionsErrors];

export type VariablesControllerListRevisionsResponses = {
    200: EntityRevisionListDto;
};

export type VariablesControllerListRevisionsResponse = VariablesControllerListRevisionsResponses[keyof VariablesControllerListRevisionsResponses];

export type PipeVariableDefaultsControllerListData = {
    body?: never;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/pipes/{pipeId}/variable-defaults';
};

export type PipeVariableDefaultsControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeVariableDefaultsControllerListError = PipeVariableDefaultsControllerListErrors[keyof PipeVariableDefaultsControllerListErrors];

export type PipeVariableDefaultsControllerListResponses = {
    200: PipeVariableDefaultsPayloadDto;
};

export type PipeVariableDefaultsControllerListResponse = PipeVariableDefaultsControllerListResponses[keyof PipeVariableDefaultsControllerListResponses];

export type PipeVariableDefaultsControllerCreateData = {
    body: CreatePipeVariableDefaultDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/pipes/{pipeId}/variable-defaults';
};

export type PipeVariableDefaultsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeVariableDefaultsControllerCreateError = PipeVariableDefaultsControllerCreateErrors[keyof PipeVariableDefaultsControllerCreateErrors];

export type PipeVariableDefaultsControllerCreateResponses = {
    201: PipeVariableDefaultDto;
};

export type PipeVariableDefaultsControllerCreateResponse = PipeVariableDefaultsControllerCreateResponses[keyof PipeVariableDefaultsControllerCreateResponses];

export type PipeVariableDefaultsControllerRemoveData = {
    body?: never;
    path: {
        pipeId: number;
        defaultId: number;
    };
    query?: never;
    url: '/api/pipes/{pipeId}/variable-defaults/{defaultId}';
};

export type PipeVariableDefaultsControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeVariableDefaultsControllerRemoveError = PipeVariableDefaultsControllerRemoveErrors[keyof PipeVariableDefaultsControllerRemoveErrors];

export type PipeVariableDefaultsControllerRemoveResponses = {
    204: void;
};

export type PipeVariableDefaultsControllerRemoveResponse = PipeVariableDefaultsControllerRemoveResponses[keyof PipeVariableDefaultsControllerRemoveResponses];

export type PipeVariableDefaultsControllerUpdateData = {
    body: UpdatePipeVariableDefaultDto;
    path: {
        pipeId: number;
        defaultId: number;
    };
    query?: never;
    url: '/api/pipes/{pipeId}/variable-defaults/{defaultId}';
};

export type PipeVariableDefaultsControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeVariableDefaultsControllerUpdateError = PipeVariableDefaultsControllerUpdateErrors[keyof PipeVariableDefaultsControllerUpdateErrors];

export type PipeVariableDefaultsControllerUpdateResponses = {
    200: PipeVariableDefaultDto;
};

export type PipeVariableDefaultsControllerUpdateResponse = PipeVariableDefaultsControllerUpdateResponses[keyof PipeVariableDefaultsControllerUpdateResponses];

export type ConstantsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/constants';
};

export type ConstantsControllerFindAllErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerFindAllError = ConstantsControllerFindAllErrors[keyof ConstantsControllerFindAllErrors];

export type ConstantsControllerFindAllResponses = {
    200: ConstantsListResponseDto;
};

export type ConstantsControllerFindAllResponse = ConstantsControllerFindAllResponses[keyof ConstantsControllerFindAllResponses];

export type ConstantsControllerCreateData = {
    body: CreateConstantDto;
    path?: never;
    query?: never;
    url: '/api/constants';
};

export type ConstantsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerCreateError = ConstantsControllerCreateErrors[keyof ConstantsControllerCreateErrors];

export type ConstantsControllerCreateResponses = {
    201: ConstantsBaseDto;
};

export type ConstantsControllerCreateResponse = ConstantsControllerCreateResponses[keyof ConstantsControllerCreateResponses];

export type ConstantsControllerListFilteredData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Which definitions to list. Without it, `brandId` / `pipeId` list that brand's and that pipe's own constants (the pipe editor's view), and only the overrides of that pipe's distributions are attached.
         */
        scope?: ConstVarListScope;
        brandId?: number;
        pipeId?: number;
        /**
         * With `scope=distribution`: only constants overridden in this distribution, with only its overrides attached.
         */
        distributionId?: number;
        page?: number;
        pageSize?: number;
        search?: string;
        type?: string;
    };
    url: '/api/constants/list';
};

export type ConstantsControllerListFilteredErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerListFilteredError = ConstantsControllerListFilteredErrors[keyof ConstantsControllerListFilteredErrors];

export type ConstantsControllerListFilteredResponses = {
    200: ConstantsListFilteredResponseDto;
};

export type ConstantsControllerListFilteredResponse = ConstantsControllerListFilteredResponses[keyof ConstantsControllerListFilteredResponses];

export type ConstantsControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/constants/{id}';
};

export type ConstantsControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerRemoveError = ConstantsControllerRemoveErrors[keyof ConstantsControllerRemoveErrors];

export type ConstantsControllerRemoveResponses = {
    200: Constant;
};

export type ConstantsControllerRemoveResponse = ConstantsControllerRemoveResponses[keyof ConstantsControllerRemoveResponses];

export type ConstantsControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/constants/{id}';
};

export type ConstantsControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerFindOneError = ConstantsControllerFindOneErrors[keyof ConstantsControllerFindOneErrors];

export type ConstantsControllerFindOneResponses = {
    200: ConstantsBaseDto;
};

export type ConstantsControllerFindOneResponse = ConstantsControllerFindOneResponses[keyof ConstantsControllerFindOneResponses];

export type ConstantsControllerUpdateData = {
    body: UpdateConstantDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/constants/{id}';
};

export type ConstantsControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerUpdateError = ConstantsControllerUpdateErrors[keyof ConstantsControllerUpdateErrors];

export type ConstantsControllerUpdateResponses = {
    200: ConstantsBaseDto;
};

export type ConstantsControllerUpdateResponse = ConstantsControllerUpdateResponses[keyof ConstantsControllerUpdateResponses];

export type ConstantsControllerFindForPipeData = {
    body?: never;
    path: {
        pipeId: string;
    };
    query?: never;
    url: '/api/constants/pipe/{pipeId}';
};

export type ConstantsControllerFindForPipeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerFindForPipeError = ConstantsControllerFindForPipeErrors[keyof ConstantsControllerFindForPipeErrors];

export type ConstantsControllerFindForPipeResponses = {
    200: Array<Constant>;
};

export type ConstantsControllerFindForPipeResponse = ConstantsControllerFindForPipeResponses[keyof ConstantsControllerFindForPipeResponses];

export type ConstantsControllerPreviewReferenceData = {
    body: PreviewReferenceDto;
    path?: never;
    query?: never;
    url: '/api/constants/preview';
};

export type ConstantsControllerPreviewReferenceErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerPreviewReferenceError = ConstantsControllerPreviewReferenceErrors[keyof ConstantsControllerPreviewReferenceErrors];

export type ConstantsControllerPreviewReferenceResponses = {
    200: PreviewReferenceResultDto;
};

export type ConstantsControllerPreviewReferenceResponse = ConstantsControllerPreviewReferenceResponses[keyof ConstantsControllerPreviewReferenceResponses];

export type ConstantsControllerListRevisionsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        skip?: number;
        take?: number;
    };
    url: '/api/constants/{id}/revisions';
};

export type ConstantsControllerListRevisionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ConstantsControllerListRevisionsError = ConstantsControllerListRevisionsErrors[keyof ConstantsControllerListRevisionsErrors];

export type ConstantsControllerListRevisionsResponses = {
    200: EntityRevisionListDto;
};

export type ConstantsControllerListRevisionsResponse = ConstantsControllerListRevisionsResponses[keyof ConstantsControllerListRevisionsResponses];

export type ReleaseControllerListData = {
    body?: never;
    path?: never;
    query?: {
        pipeId?: number;
        brandId?: number;
        distributionId?: number;
        createdById?: number;
        page?: number;
        pageSize?: number;
    };
    url: '/api/releases';
};

export type ReleaseControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerListError = ReleaseControllerListErrors[keyof ReleaseControllerListErrors];

export type ReleaseControllerListResponses = {
    200: ReleaseListPaginatedResponseDto;
};

export type ReleaseControllerListResponse = ReleaseControllerListResponses[keyof ReleaseControllerListResponses];

export type ReleaseControllerTimelineRowsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Only these brands. Omitted or empty: every brand.
         */
        brandIds?: Array<number>;
        /**
         * Only these pipes. Omitted or empty: every pipe.
         */
        pipeIds?: Array<number>;
        /**
         * Also the distributions deleted since, with the releases they served until then.
         */
        includeDeleted?: boolean;
    };
    url: '/api/releases/timeline/rows';
};

export type ReleaseControllerTimelineRowsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerTimelineRowsError = ReleaseControllerTimelineRowsErrors[keyof ReleaseControllerTimelineRowsErrors];

export type ReleaseControllerTimelineRowsResponses = {
    200: ReleaseTimelineRowsDto;
};

export type ReleaseControllerTimelineRowsResponse = ReleaseControllerTimelineRowsResponses[keyof ReleaseControllerTimelineRowsResponses];

export type ReleaseControllerTimelineData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Only these brands. Omitted or empty: every brand.
         */
        brandIds?: Array<number>;
        /**
         * Only these pipes. Omitted or empty: every pipe.
         */
        pipeIds?: Array<number>;
        /**
         * Also the distributions deleted since, with the releases they served until then.
         */
        includeDeleted?: boolean;
        /**
         * Start of the window, ISO 8601.
         */
        from: string;
        /**
         * End of the window, ISO 8601, excluded.
         */
        to: string;
    };
    url: '/api/releases/timeline';
};

export type ReleaseControllerTimelineErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerTimelineError = ReleaseControllerTimelineErrors[keyof ReleaseControllerTimelineErrors];

export type ReleaseControllerTimelineResponses = {
    200: ReleaseTimelineDto;
};

export type ReleaseControllerTimelineResponse = ReleaseControllerTimelineResponses[keyof ReleaseControllerTimelineResponses];

export type ReleaseControllerGetStatusesData = {
    body: ReleaseStatusesRequestDto;
    path?: never;
    query?: never;
    url: '/api/releases/statuses';
};

export type ReleaseControllerGetStatusesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerGetStatusesError = ReleaseControllerGetStatusesErrors[keyof ReleaseControllerGetStatusesErrors];

export type ReleaseControllerGetStatusesResponses = {
    200: ReleaseStatusesResponseDto;
};

export type ReleaseControllerGetStatusesResponse = ReleaseControllerGetStatusesResponses[keyof ReleaseControllerGetStatusesResponses];

export type ReleaseControllerGetChangesData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/changes';
};

export type ReleaseControllerGetChangesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerGetChangesError = ReleaseControllerGetChangesErrors[keyof ReleaseControllerGetChangesErrors];

export type ReleaseControllerGetChangesResponses = {
    200: ReleaseChangesDto;
};

export type ReleaseControllerGetChangesResponse = ReleaseControllerGetChangesResponses[keyof ReleaseControllerGetChangesResponses];

export type ReleaseControllerGetDiffData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/diff';
};

export type ReleaseControllerGetDiffErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerGetDiffError = ReleaseControllerGetDiffErrors[keyof ReleaseControllerGetDiffErrors];

export type ReleaseControllerGetDiffResponses = {
    200: ReleaseDiffDto;
};

export type ReleaseControllerGetDiffResponse = ReleaseControllerGetDiffResponses[keyof ReleaseControllerGetDiffResponses];

export type ReleaseControllerGetLogsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/logs';
};

export type ReleaseControllerGetLogsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerGetLogsError = ReleaseControllerGetLogsErrors[keyof ReleaseControllerGetLogsErrors];

export type ReleaseControllerGetLogsResponses = {
    200: ReleaseLogsDto;
};

export type ReleaseControllerGetLogsResponse = ReleaseControllerGetLogsResponses[keyof ReleaseControllerGetLogsResponses];

export type ReleaseControllerGetReleaseContentData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/content';
};

export type ReleaseControllerGetReleaseContentErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerGetReleaseContentError = ReleaseControllerGetReleaseContentErrors[keyof ReleaseControllerGetReleaseContentErrors];

export type ReleaseControllerGetReleaseContentResponses = {
    200: {
        [key: string]: unknown;
    };
};

export type ReleaseControllerGetReleaseContentResponse = ReleaseControllerGetReleaseContentResponses[keyof ReleaseControllerGetReleaseContentResponses];

export type ReleaseControllerSetArtifactSizeData = {
    body: ReleaseArtifactSizeDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/artifact-size';
};

export type ReleaseControllerSetArtifactSizeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerSetArtifactSizeError = ReleaseControllerSetArtifactSizeErrors[keyof ReleaseControllerSetArtifactSizeErrors];

export type ReleaseControllerSetArtifactSizeResponses = {
    201: unknown;
};

export type ReleaseControllerSetBuildCommitData = {
    body: ReleaseBuildCommitDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/build-commit';
};

export type ReleaseControllerSetBuildCommitErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerSetBuildCommitError = ReleaseControllerSetBuildCommitErrors[keyof ReleaseControllerSetBuildCommitErrors];

export type ReleaseControllerSetBuildCommitResponses = {
    201: unknown;
};

export type ReleaseControllerBuildReleaseSyncData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/build-sync';
};

export type ReleaseControllerBuildReleaseSyncErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerBuildReleaseSyncError = ReleaseControllerBuildReleaseSyncErrors[keyof ReleaseControllerBuildReleaseSyncErrors];

export type ReleaseControllerBuildReleaseSyncResponses = {
    201: unknown;
};

export type ReleaseControllerDeployReleaseSyncData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/deploy-sync';
};

export type ReleaseControllerDeployReleaseSyncErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerDeployReleaseSyncError = ReleaseControllerDeployReleaseSyncErrors[keyof ReleaseControllerDeployReleaseSyncErrors];

export type ReleaseControllerDeployReleaseSyncResponses = {
    201: unknown;
};

export type ReleaseControllerGetReleaseByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}';
};

export type ReleaseControllerGetReleaseByIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerGetReleaseByIdError = ReleaseControllerGetReleaseByIdErrors[keyof ReleaseControllerGetReleaseByIdErrors];

export type ReleaseControllerGetReleaseByIdResponses = {
    200: ReleaseDto;
};

export type ReleaseControllerGetReleaseByIdResponse = ReleaseControllerGetReleaseByIdResponses[keyof ReleaseControllerGetReleaseByIdResponses];

export type ReleaseControllerCancelReleaseData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/cancel';
};

export type ReleaseControllerCancelReleaseErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerCancelReleaseError = ReleaseControllerCancelReleaseErrors[keyof ReleaseControllerCancelReleaseErrors];

export type ReleaseControllerCancelReleaseResponses = {
    201: ReleaseDto;
};

export type ReleaseControllerCancelReleaseResponse = ReleaseControllerCancelReleaseResponses[keyof ReleaseControllerCancelReleaseResponses];

export type ReleaseControllerRedeployReleaseData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/releases/{id}/redeploy';
};

export type ReleaseControllerRedeployReleaseErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ReleaseControllerRedeployReleaseError = ReleaseControllerRedeployReleaseErrors[keyof ReleaseControllerRedeployReleaseErrors];

export type ReleaseControllerRedeployReleaseResponses = {
    201: ReleaseDto;
};

export type ReleaseControllerRedeployReleaseResponse = ReleaseControllerRedeployReleaseResponses[keyof ReleaseControllerRedeployReleaseResponses];

export type IntegrationsControllerListFilteredData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Which integrations to list, as on the constants list. Without it, `brandId` / `pipeId` list that brand's and that pipe's own integrations, and only the overrides of that pipe's distributions are attached.
         */
        scope?: ConstVarListScope;
        brandId?: number;
        pipeId?: number;
        /**
         * With `scope=distribution`: only integrations overridden in this distribution, with only its overrides attached.
         */
        distributionId?: number;
        page?: number;
        pageSize?: number;
        search?: string;
        type?: string;
        /**
         * Also return deleted integrations, which carry `deletedAt` and no facts about where they run. Off by default.
         */
        includeDeleted?: boolean;
    };
    url: '/api/integrations/list';
};

export type IntegrationsControllerListFilteredErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IntegrationsControllerListFilteredError = IntegrationsControllerListFilteredErrors[keyof IntegrationsControllerListFilteredErrors];

export type IntegrationsControllerListFilteredResponses = {
    200: IntegrationsListFilteredResponseDto;
};

export type IntegrationsControllerListFilteredResponse = IntegrationsControllerListFilteredResponses[keyof IntegrationsControllerListFilteredResponses];

export type IntegrationsControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/integrations/{id}';
};

export type IntegrationsControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IntegrationsControllerRemoveError = IntegrationsControllerRemoveErrors[keyof IntegrationsControllerRemoveErrors];

export type IntegrationsControllerRemoveResponses = {
    200: IntegrationsBaseDto;
};

export type IntegrationsControllerRemoveResponse = IntegrationsControllerRemoveResponses[keyof IntegrationsControllerRemoveResponses];

export type IntegrationsControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/integrations/{id}';
};

export type IntegrationsControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IntegrationsControllerFindOneError = IntegrationsControllerFindOneErrors[keyof IntegrationsControllerFindOneErrors];

export type IntegrationsControllerFindOneResponses = {
    200: IntegrationsBaseDto;
};

export type IntegrationsControllerFindOneResponse = IntegrationsControllerFindOneResponses[keyof IntegrationsControllerFindOneResponses];

export type IntegrationsControllerUpdateData = {
    body: UpdateIntegrationDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/integrations/{id}';
};

export type IntegrationsControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IntegrationsControllerUpdateError = IntegrationsControllerUpdateErrors[keyof IntegrationsControllerUpdateErrors];

export type IntegrationsControllerUpdateResponses = {
    200: IntegrationsBaseDto;
};

export type IntegrationsControllerUpdateResponse = IntegrationsControllerUpdateResponses[keyof IntegrationsControllerUpdateResponses];

export type IntegrationsControllerCreateData = {
    body: CreateIntegrationDto;
    path?: never;
    query?: never;
    url: '/api/integrations';
};

export type IntegrationsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IntegrationsControllerCreateError = IntegrationsControllerCreateErrors[keyof IntegrationsControllerCreateErrors];

export type IntegrationsControllerCreateResponses = {
    201: IntegrationsBaseDto;
};

export type IntegrationsControllerCreateResponse = IntegrationsControllerCreateResponses[keyof IntegrationsControllerCreateResponses];

export type IntegrationsControllerRestoreData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/integrations/{id}/restore';
};

export type IntegrationsControllerRestoreErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IntegrationsControllerRestoreError = IntegrationsControllerRestoreErrors[keyof IntegrationsControllerRestoreErrors];

export type IntegrationsControllerRestoreResponses = {
    200: IntegrationsBaseDto;
};

export type IntegrationsControllerRestoreResponse = IntegrationsControllerRestoreResponses[keyof IntegrationsControllerRestoreResponses];

export type IntegrationsControllerFindForPipeData = {
    body?: never;
    path: {
        pipeId: string;
    };
    query?: never;
    url: '/api/integrations/pipe/{pipeId}';
};

export type IntegrationsControllerFindForPipeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IntegrationsControllerFindForPipeError = IntegrationsControllerFindForPipeErrors[keyof IntegrationsControllerFindForPipeErrors];

export type IntegrationsControllerFindForPipeResponses = {
    200: Array<IntegrationsBaseDto>;
};

export type IntegrationsControllerFindForPipeResponse = IntegrationsControllerFindForPipeResponses[keyof IntegrationsControllerFindForPipeResponses];

export type IntegrationsControllerListRevisionsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        skip?: number;
        take?: number;
    };
    url: '/api/integrations/{id}/revisions';
};

export type IntegrationsControllerListRevisionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IntegrationsControllerListRevisionsError = IntegrationsControllerListRevisionsErrors[keyof IntegrationsControllerListRevisionsErrors];

export type IntegrationsControllerListRevisionsResponses = {
    200: EntityRevisionListDto;
};

export type IntegrationsControllerListRevisionsResponse = IntegrationsControllerListRevisionsResponses[keyof IntegrationsControllerListRevisionsResponses];

export type DistributionsControllerCreateReleaseData = {
    body: DeployReleaseDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}/release';
};

export type DistributionsControllerCreateReleaseErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerCreateReleaseError = DistributionsControllerCreateReleaseErrors[keyof DistributionsControllerCreateReleaseErrors];

export type DistributionsControllerCreateReleaseResponses = {
    201: ReleaseDto;
};

export type DistributionsControllerCreateReleaseResponse = DistributionsControllerCreateReleaseResponses[keyof DistributionsControllerCreateReleaseResponses];

export type DistributionsControllerDeployChangesPreviewData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}/deploy-changes-preview';
};

export type DistributionsControllerDeployChangesPreviewErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerDeployChangesPreviewError = DistributionsControllerDeployChangesPreviewErrors[keyof DistributionsControllerDeployChangesPreviewErrors];

export type DistributionsControllerDeployChangesPreviewResponses = {
    200: DeployChangesSummaryDto;
};

export type DistributionsControllerDeployChangesPreviewResponse = DistributionsControllerDeployChangesPreviewResponses[keyof DistributionsControllerDeployChangesPreviewResponses];

export type DistributionsControllerDeployDiffData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}/deploy-diff';
};

export type DistributionsControllerDeployDiffErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerDeployDiffError = DistributionsControllerDeployDiffErrors[keyof DistributionsControllerDeployDiffErrors];

export type DistributionsControllerDeployDiffResponses = {
    200: DeployDiffDto;
};

export type DistributionsControllerDeployDiffResponse = DistributionsControllerDeployDiffResponses[keyof DistributionsControllerDeployDiffResponses];

export type DistributionsControllerBulkCreateReleaseData = {
    body: BulkReleaseDto;
    path?: never;
    query?: never;
    url: '/api/distributions/bulk-release';
};

export type DistributionsControllerBulkCreateReleaseErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerBulkCreateReleaseError = DistributionsControllerBulkCreateReleaseErrors[keyof DistributionsControllerBulkCreateReleaseErrors];

export type DistributionsControllerBulkCreateReleaseResponses = {
    200: BulkReleaseAcceptedDto;
};

export type DistributionsControllerBulkCreateReleaseResponse = DistributionsControllerBulkCreateReleaseResponses[keyof DistributionsControllerBulkCreateReleaseResponses];

export type DistributionsControllerBulkRollbackPreviewData = {
    body: BulkRollbackRequestDto;
    path?: never;
    query?: never;
    url: '/api/distributions/bulk-rollback-preview';
};

export type DistributionsControllerBulkRollbackPreviewErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerBulkRollbackPreviewError = DistributionsControllerBulkRollbackPreviewErrors[keyof DistributionsControllerBulkRollbackPreviewErrors];

export type DistributionsControllerBulkRollbackPreviewResponses = {
    200: BulkRollbackPreviewDto;
};

export type DistributionsControllerBulkRollbackPreviewResponse = DistributionsControllerBulkRollbackPreviewResponses[keyof DistributionsControllerBulkRollbackPreviewResponses];

export type DistributionsControllerBulkRollbackData = {
    body: BulkRollbackDto;
    path?: never;
    query?: never;
    url: '/api/distributions/bulk-rollback';
};

export type DistributionsControllerBulkRollbackErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerBulkRollbackError = DistributionsControllerBulkRollbackErrors[keyof DistributionsControllerBulkRollbackErrors];

export type DistributionsControllerBulkRollbackResponses = {
    200: BulkRollbackAcceptedDto;
};

export type DistributionsControllerBulkRollbackResponse = DistributionsControllerBulkRollbackResponses[keyof DistributionsControllerBulkRollbackResponses];

export type DistributionsControllerListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Partial name (case-insensitive, multi-token AND; matches the distribution or its pipe name, or either id for a numeric token)
         */
        nameQuery?: string;
        sortBy?: 'id' | 'name' | 'pipe' | 'brand' | 'language' | 'geography' | 'currency' | 'lastRelease';
        sortOrder?: 'ASC' | 'DESC';
        pipeId?: number;
        languageId?: number;
        currencyId?: number;
        geographyId?: number;
        brandId?: number;
        statusId?: number;
        lastReleasedById?: number;
        page?: number;
        pageSize?: number;
        hasActiveIngressDestination?: boolean;
        outdated?: boolean;
        groupAc?: boolean;
    };
    url: '/api/distributions';
};

export type DistributionsControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerListError = DistributionsControllerListErrors[keyof DistributionsControllerListErrors];

export type DistributionsControllerListResponses = {
    200: DistributionListPaginatedResponseDto;
};

export type DistributionsControllerListResponse = DistributionsControllerListResponses[keyof DistributionsControllerListResponses];

export type DistributionsControllerCreateData = {
    body: DistributionCreateDto;
    path?: never;
    query?: never;
    url: '/api/distributions';
};

export type DistributionsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerCreateError = DistributionsControllerCreateErrors[keyof DistributionsControllerCreateErrors];

export type DistributionsControllerCreateResponses = {
    201: DistributionDto;
};

export type DistributionsControllerCreateResponse = DistributionsControllerCreateResponses[keyof DistributionsControllerCreateResponses];

export type DistributionsControllerSearchData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Partial name (case-insensitive, multi-token AND; matches distribution or pipe name)
         */
        nameQuery?: string;
        /**
         * Restrict to one pipe
         */
        pipeId?: number;
        page?: number;
        pageSize?: number;
    };
    url: '/api/distributions/search';
};

export type DistributionsControllerSearchErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerSearchError = DistributionsControllerSearchErrors[keyof DistributionsControllerSearchErrors];

export type DistributionsControllerSearchResponses = {
    200: DistributionSearchResponseDto;
};

export type DistributionsControllerSearchResponse = DistributionsControllerSearchResponses[keyof DistributionsControllerSearchResponses];

export type DistributionsControllerGeoLangPairsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Partial name (case-insensitive, multi-token AND; matches the distribution or its pipe name, or either id for a numeric token)
         */
        nameQuery?: string;
        sortBy?: 'id' | 'name' | 'pipe' | 'brand' | 'language' | 'geography' | 'currency' | 'lastRelease';
        sortOrder?: 'ASC' | 'DESC';
        pipeId?: number;
        languageId?: number;
        currencyId?: number;
        geographyId?: number;
        brandId?: number;
        statusId?: number;
        lastReleasedById?: number;
        page?: number;
        pageSize?: number;
        hasActiveIngressDestination?: boolean;
        outdated?: boolean;
        groupAc?: boolean;
    };
    url: '/api/distributions/geo-lang-pairs';
};

export type DistributionsControllerGeoLangPairsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerGeoLangPairsError = DistributionsControllerGeoLangPairsErrors[keyof DistributionsControllerGeoLangPairsErrors];

export type DistributionsControllerGeoLangPairsResponses = {
    200: Array<DistributionGeoLangPairDto>;
};

export type DistributionsControllerGeoLangPairsResponse = DistributionsControllerGeoLangPairsResponses[keyof DistributionsControllerGeoLangPairsResponses];

export type DistributionsControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}';
};

export type DistributionsControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerRemoveError = DistributionsControllerRemoveErrors[keyof DistributionsControllerRemoveErrors];

export type DistributionsControllerRemoveResponses = {
    200: unknown;
};

export type DistributionsControllerGetData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}';
};

export type DistributionsControllerGetErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerGetError = DistributionsControllerGetErrors[keyof DistributionsControllerGetErrors];

export type DistributionsControllerGetResponses = {
    200: DistributionDto;
};

export type DistributionsControllerGetResponse = DistributionsControllerGetResponses[keyof DistributionsControllerGetResponses];

export type DistributionsControllerUpdateData = {
    body: DistributionUpdateDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}';
};

export type DistributionsControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerUpdateError = DistributionsControllerUpdateErrors[keyof DistributionsControllerUpdateErrors];

export type DistributionsControllerUpdateResponses = {
    200: DistributionDto;
};

export type DistributionsControllerUpdateResponse = DistributionsControllerUpdateResponses[keyof DistributionsControllerUpdateResponses];

export type DistributionsControllerGetAcLinksData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}/ac-links';
};

export type DistributionsControllerGetAcLinksErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerGetAcLinksError = DistributionsControllerGetAcLinksErrors[keyof DistributionsControllerGetAcLinksErrors];

export type DistributionsControllerGetAcLinksResponses = {
    200: DistributionAcLinksResponseDto;
};

export type DistributionsControllerGetAcLinksResponse = DistributionsControllerGetAcLinksResponses[keyof DistributionsControllerGetAcLinksResponses];

export type DistributionsControllerFindPipeConfigsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}/pipe-configs';
};

export type DistributionsControllerFindPipeConfigsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerFindPipeConfigsError = DistributionsControllerFindPipeConfigsErrors[keyof DistributionsControllerFindPipeConfigsErrors];

export type DistributionsControllerFindPipeConfigsResponses = {
    200: Array<PipeConfigItemDto>;
};

export type DistributionsControllerFindPipeConfigsResponse = DistributionsControllerFindPipeConfigsResponses[keyof DistributionsControllerFindPipeConfigsResponses];

export type DistributionsControllerCopyPreviewData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}/copy-preview';
};

export type DistributionsControllerCopyPreviewErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerCopyPreviewError = DistributionsControllerCopyPreviewErrors[keyof DistributionsControllerCopyPreviewErrors];

export type DistributionsControllerCopyPreviewResponses = {
    200: DistributionCopyPreviewDto;
};

export type DistributionsControllerCopyPreviewResponse = DistributionsControllerCopyPreviewResponses[keyof DistributionsControllerCopyPreviewResponses];

export type DistributionsControllerCopyData = {
    body: DistributionCopyDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}/copy';
};

export type DistributionsControllerCopyErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerCopyError = DistributionsControllerCopyErrors[keyof DistributionsControllerCopyErrors];

export type DistributionsControllerCopyResponses = {
    200: DistributionDto;
};

export type DistributionsControllerCopyResponse = DistributionsControllerCopyResponses[keyof DistributionsControllerCopyResponses];

export type DistributionsControllerUpdateStatusData = {
    body: DistributionUpdateStatusDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distributions/{id}/status';
};

export type DistributionsControllerUpdateStatusErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerUpdateStatusError = DistributionsControllerUpdateStatusErrors[keyof DistributionsControllerUpdateStatusErrors];

export type DistributionsControllerUpdateStatusResponses = {
    200: DistributionDto;
};

export type DistributionsControllerUpdateStatusResponse = DistributionsControllerUpdateStatusResponses[keyof DistributionsControllerUpdateStatusResponses];

export type DistributionsControllerBulkUpdateStatusData = {
    body: DistributionBulkUpdateStatusDto;
    path?: never;
    query?: never;
    url: '/api/distributions/bulk-status';
};

export type DistributionsControllerBulkUpdateStatusErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionsControllerBulkUpdateStatusError = DistributionsControllerBulkUpdateStatusErrors[keyof DistributionsControllerBulkUpdateStatusErrors];

export type DistributionsControllerBulkUpdateStatusResponses = {
    200: DistributionBulkUpdateStatusResponseDto;
};

export type DistributionsControllerBulkUpdateStatusResponse = DistributionsControllerBulkUpdateStatusResponses[keyof DistributionsControllerBulkUpdateStatusResponses];

export type DistributionConstantOverridesControllerListData = {
    body?: never;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/constant-overrides';
};

export type DistributionConstantOverridesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionConstantOverridesControllerListError = DistributionConstantOverridesControllerListErrors[keyof DistributionConstantOverridesControllerListErrors];

export type DistributionConstantOverridesControllerListResponses = {
    200: DistributionConstantOverridesPayloadDto;
};

export type DistributionConstantOverridesControllerListResponse = DistributionConstantOverridesControllerListResponses[keyof DistributionConstantOverridesControllerListResponses];

export type DistributionConstantOverridesControllerCreateData = {
    body: CreateDistributionConstantOverrideDto;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/constant-overrides';
};

export type DistributionConstantOverridesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionConstantOverridesControllerCreateError = DistributionConstantOverridesControllerCreateErrors[keyof DistributionConstantOverridesControllerCreateErrors];

export type DistributionConstantOverridesControllerCreateResponses = {
    201: DistributionConstantOverrideDto;
};

export type DistributionConstantOverridesControllerCreateResponse = DistributionConstantOverridesControllerCreateResponses[keyof DistributionConstantOverridesControllerCreateResponses];

export type DistributionConstantOverridesControllerRemoveData = {
    body?: never;
    path: {
        distributionId: number;
        overrideId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/constant-overrides/{overrideId}';
};

export type DistributionConstantOverridesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionConstantOverridesControllerRemoveError = DistributionConstantOverridesControllerRemoveErrors[keyof DistributionConstantOverridesControllerRemoveErrors];

export type DistributionConstantOverridesControllerRemoveResponses = {
    204: void;
};

export type DistributionConstantOverridesControllerRemoveResponse = DistributionConstantOverridesControllerRemoveResponses[keyof DistributionConstantOverridesControllerRemoveResponses];

export type DistributionConstantOverridesControllerUpdateData = {
    body: UpdateDistributionConstantOverrideDto;
    path: {
        distributionId: number;
        overrideId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/constant-overrides/{overrideId}';
};

export type DistributionConstantOverridesControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionConstantOverridesControllerUpdateError = DistributionConstantOverridesControllerUpdateErrors[keyof DistributionConstantOverridesControllerUpdateErrors];

export type DistributionConstantOverridesControllerUpdateResponses = {
    200: DistributionConstantOverrideDto;
};

export type DistributionConstantOverridesControllerUpdateResponse = DistributionConstantOverridesControllerUpdateResponses[keyof DistributionConstantOverridesControllerUpdateResponses];

export type DistributionVariableOverridesControllerListData = {
    body?: never;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/variable-overrides';
};

export type DistributionVariableOverridesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionVariableOverridesControllerListError = DistributionVariableOverridesControllerListErrors[keyof DistributionVariableOverridesControllerListErrors];

export type DistributionVariableOverridesControllerListResponses = {
    200: DistributionVariableOverridesPayloadDto;
};

export type DistributionVariableOverridesControllerListResponse = DistributionVariableOverridesControllerListResponses[keyof DistributionVariableOverridesControllerListResponses];

export type DistributionVariableOverridesControllerCreateData = {
    body: CreateDistributionVariableOverrideDto;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/variable-overrides';
};

export type DistributionVariableOverridesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionVariableOverridesControllerCreateError = DistributionVariableOverridesControllerCreateErrors[keyof DistributionVariableOverridesControllerCreateErrors];

export type DistributionVariableOverridesControllerCreateResponses = {
    201: DistributionVariableOverrideDto;
};

export type DistributionVariableOverridesControllerCreateResponse = DistributionVariableOverridesControllerCreateResponses[keyof DistributionVariableOverridesControllerCreateResponses];

export type DistributionVariableOverridesControllerRemoveData = {
    body?: never;
    path: {
        distributionId: number;
        overrideId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/variable-overrides/{overrideId}';
};

export type DistributionVariableOverridesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionVariableOverridesControllerRemoveError = DistributionVariableOverridesControllerRemoveErrors[keyof DistributionVariableOverridesControllerRemoveErrors];

export type DistributionVariableOverridesControllerRemoveResponses = {
    204: void;
};

export type DistributionVariableOverridesControllerRemoveResponse = DistributionVariableOverridesControllerRemoveResponses[keyof DistributionVariableOverridesControllerRemoveResponses];

export type DistributionVariableOverridesControllerUpdateData = {
    body: UpdateDistributionVariableOverrideDto;
    path: {
        distributionId: number;
        overrideId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/variable-overrides/{overrideId}';
};

export type DistributionVariableOverridesControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionVariableOverridesControllerUpdateError = DistributionVariableOverridesControllerUpdateErrors[keyof DistributionVariableOverridesControllerUpdateErrors];

export type DistributionVariableOverridesControllerUpdateResponses = {
    200: DistributionVariableOverrideDto;
};

export type DistributionVariableOverridesControllerUpdateResponse = DistributionVariableOverridesControllerUpdateResponses[keyof DistributionVariableOverridesControllerUpdateResponses];

export type DistributionIntegrationOverridesControllerListData = {
    body?: never;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/integration-overrides';
};

export type DistributionIntegrationOverridesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionIntegrationOverridesControllerListError = DistributionIntegrationOverridesControllerListErrors[keyof DistributionIntegrationOverridesControllerListErrors];

export type DistributionIntegrationOverridesControllerListResponses = {
    200: DistributionIntegrationOverridesPayloadDto;
};

export type DistributionIntegrationOverridesControllerListResponse = DistributionIntegrationOverridesControllerListResponses[keyof DistributionIntegrationOverridesControllerListResponses];

export type DistributionIntegrationOverridesControllerCreateData = {
    body: CreateDistributionIntegrationOverrideDto;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/integration-overrides';
};

export type DistributionIntegrationOverridesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionIntegrationOverridesControllerCreateError = DistributionIntegrationOverridesControllerCreateErrors[keyof DistributionIntegrationOverridesControllerCreateErrors];

export type DistributionIntegrationOverridesControllerCreateResponses = {
    201: DistributionIntegrationOverrideDto;
};

export type DistributionIntegrationOverridesControllerCreateResponse = DistributionIntegrationOverridesControllerCreateResponses[keyof DistributionIntegrationOverridesControllerCreateResponses];

export type DistributionIntegrationOverridesControllerRemoveData = {
    body?: never;
    path: {
        distributionId: number;
        overrideId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/integration-overrides/{overrideId}';
};

export type DistributionIntegrationOverridesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionIntegrationOverridesControllerRemoveError = DistributionIntegrationOverridesControllerRemoveErrors[keyof DistributionIntegrationOverridesControllerRemoveErrors];

export type DistributionIntegrationOverridesControllerRemoveResponses = {
    204: void;
};

export type DistributionIntegrationOverridesControllerRemoveResponse = DistributionIntegrationOverridesControllerRemoveResponses[keyof DistributionIntegrationOverridesControllerRemoveResponses];

export type DistributionIntegrationOverridesControllerUpdateData = {
    body: UpdateDistributionIntegrationOverrideDto;
    path: {
        distributionId: number;
        overrideId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/integration-overrides/{overrideId}';
};

export type DistributionIntegrationOverridesControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionIntegrationOverridesControllerUpdateError = DistributionIntegrationOverridesControllerUpdateErrors[keyof DistributionIntegrationOverridesControllerUpdateErrors];

export type DistributionIntegrationOverridesControllerUpdateResponses = {
    200: DistributionIntegrationOverrideDto;
};

export type DistributionIntegrationOverridesControllerUpdateResponse = DistributionIntegrationOverridesControllerUpdateResponses[keyof DistributionIntegrationOverridesControllerUpdateResponses];

export type DistributionLandingControllerGetData = {
    body?: never;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/landing-page';
};

export type DistributionLandingControllerGetErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionLandingControllerGetError = DistributionLandingControllerGetErrors[keyof DistributionLandingControllerGetErrors];

export type DistributionLandingControllerGetResponses = {
    200: DistributionLandingDto;
};

export type DistributionLandingControllerGetResponse = DistributionLandingControllerGetResponses[keyof DistributionLandingControllerGetResponses];

export type DistributionLandingControllerUpdateData = {
    body: UpdateDistributionLandingDto;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/distributions/{distributionId}/landing-page';
};

export type DistributionLandingControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionLandingControllerUpdateError = DistributionLandingControllerUpdateErrors[keyof DistributionLandingControllerUpdateErrors];

export type DistributionLandingControllerUpdateResponses = {
    200: DistributionLandingDto;
};

export type DistributionLandingControllerUpdateResponse = DistributionLandingControllerUpdateResponses[keyof DistributionLandingControllerUpdateResponses];

export type IngressSyncControllerListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/ingress-sync/ingresses';
};

export type IngressSyncControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IngressSyncControllerListError = IngressSyncControllerListErrors[keyof IngressSyncControllerListErrors];

export type IngressSyncControllerListResponses = {
    200: SyncedIngressListResponseDto;
};

export type IngressSyncControllerListResponse = IngressSyncControllerListResponses[keyof IngressSyncControllerListResponses];

export type IngressSyncControllerStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/ingress-sync/status';
};

export type IngressSyncControllerStatusErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IngressSyncControllerStatusError = IngressSyncControllerStatusErrors[keyof IngressSyncControllerStatusErrors];

export type IngressSyncControllerStatusResponses = {
    200: IngressSyncStatusDto;
};

export type IngressSyncControllerStatusResponse = IngressSyncControllerStatusResponses[keyof IngressSyncControllerStatusResponses];

export type IngressSyncControllerRunData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/ingress-sync/run';
};

export type IngressSyncControllerRunErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type IngressSyncControllerRunError = IngressSyncControllerRunErrors[keyof IngressSyncControllerRunErrors];

export type IngressSyncControllerRunResponses = {
    200: IngressSyncRunResponseDto;
};

export type IngressSyncControllerRunResponse = IngressSyncControllerRunResponses[keyof IngressSyncControllerRunResponses];

export type StylesControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        pageSize?: number;
    };
    url: '/api/styles';
};

export type StylesControllerFindAllErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type StylesControllerFindAllError = StylesControllerFindAllErrors[keyof StylesControllerFindAllErrors];

export type StylesControllerFindAllResponses = {
    default: StyleListResponseDto;
};

export type StylesControllerFindAllResponse = StylesControllerFindAllResponses[keyof StylesControllerFindAllResponses];

export type StylesControllerCreateData = {
    body: CreateStyleDto;
    path?: never;
    query?: never;
    url: '/api/styles';
};

export type StylesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type StylesControllerCreateError = StylesControllerCreateErrors[keyof StylesControllerCreateErrors];

export type StylesControllerCreateResponses = {
    default: StyleDto;
};

export type StylesControllerCreateResponse = StylesControllerCreateResponses[keyof StylesControllerCreateResponses];

export type StylesControllerGetDefaultsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/styles/defaults';
};

export type StylesControllerGetDefaultsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type StylesControllerGetDefaultsError = StylesControllerGetDefaultsErrors[keyof StylesControllerGetDefaultsErrors];

export type StylesControllerGetDefaultsResponses = {
    default: StyleDefaultsDto;
};

export type StylesControllerGetDefaultsResponse = StylesControllerGetDefaultsResponses[keyof StylesControllerGetDefaultsResponses];

export type StylesControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/styles/{id}';
};

export type StylesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type StylesControllerRemoveError = StylesControllerRemoveErrors[keyof StylesControllerRemoveErrors];

export type StylesControllerRemoveResponses = {
    204: void;
};

export type StylesControllerRemoveResponse = StylesControllerRemoveResponses[keyof StylesControllerRemoveResponses];

export type StylesControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/styles/{id}';
};

export type StylesControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type StylesControllerFindOneError = StylesControllerFindOneErrors[keyof StylesControllerFindOneErrors];

export type StylesControllerFindOneResponses = {
    default: StyleDto;
};

export type StylesControllerFindOneResponse = StylesControllerFindOneResponses[keyof StylesControllerFindOneResponses];

export type StylesControllerUpdateData = {
    body: UpdateStyleDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/styles/{id}';
};

export type StylesControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type StylesControllerUpdateError = StylesControllerUpdateErrors[keyof StylesControllerUpdateErrors];

export type StylesControllerUpdateResponses = {
    default: StyleDto;
};

export type StylesControllerUpdateResponse = StylesControllerUpdateResponses[keyof StylesControllerUpdateResponses];

export type StylesControllerFindPipesData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        /**
         * Omit this pipe from the result, so the caller can phrase the answer as "shared with N *other* pipes". Used by the pipe editor's Theme tab.
         */
        excludePipeId?: number;
    };
    url: '/api/styles/{id}/pipes';
};

export type StylesControllerFindPipesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type StylesControllerFindPipesError = StylesControllerFindPipesErrors[keyof StylesControllerFindPipesErrors];

export type StylesControllerFindPipesResponses = {
    default: StylePipeUsageListDto;
};

export type StylesControllerFindPipesResponse = StylesControllerFindPipesResponses[keyof StylesControllerFindPipesResponses];

export type StylesControllerCloneData = {
    body: CloneStyleDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/styles/{id}/clone';
};

export type StylesControllerCloneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type StylesControllerCloneError = StylesControllerCloneErrors[keyof StylesControllerCloneErrors];

export type StylesControllerCloneResponses = {
    default: StyleDto;
};

export type StylesControllerCloneResponse = StylesControllerCloneResponses[keyof StylesControllerCloneResponses];

export type PipeChecksControllerGetInstructionsData = {
    body?: never;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/pipe-checks/distributions/{distributionId}/instructions';
};

export type PipeChecksControllerGetInstructionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerGetInstructionsError = PipeChecksControllerGetInstructionsErrors[keyof PipeChecksControllerGetInstructionsErrors];

export type PipeChecksControllerGetInstructionsResponses = {
    200: PipeCheckInstructionsDto;
};

export type PipeChecksControllerGetInstructionsResponse = PipeChecksControllerGetInstructionsResponses[keyof PipeChecksControllerGetInstructionsResponses];

export type PipeChecksControllerGetQuestionsData = {
    body?: never;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/pipe-checks/distributions/{distributionId}/questions';
};

export type PipeChecksControllerGetQuestionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerGetQuestionsError = PipeChecksControllerGetQuestionsErrors[keyof PipeChecksControllerGetQuestionsErrors];

export type PipeChecksControllerGetQuestionsResponses = {
    200: PipeCheckQuestionsDto;
};

export type PipeChecksControllerGetQuestionsResponse = PipeChecksControllerGetQuestionsResponses[keyof PipeChecksControllerGetQuestionsResponses];

export type PipeChecksControllerStartRunData = {
    body: StartPipeCheckRunDto;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/pipe-checks/distributions/{distributionId}/runs';
};

export type PipeChecksControllerStartRunErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerStartRunError = PipeChecksControllerStartRunErrors[keyof PipeChecksControllerStartRunErrors];

export type PipeChecksControllerStartRunResponses = {
    201: PipeCheckInstructionsDto;
};

export type PipeChecksControllerStartRunResponse = PipeChecksControllerStartRunResponses[keyof PipeChecksControllerStartRunResponses];

export type PipeChecksControllerGetSettingsData = {
    body?: never;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/pipe-checks/distributions/{distributionId}/settings';
};

export type PipeChecksControllerGetSettingsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerGetSettingsError = PipeChecksControllerGetSettingsErrors[keyof PipeChecksControllerGetSettingsErrors];

export type PipeChecksControllerGetSettingsResponses = {
    200: PipeCheckSettingDto;
};

export type PipeChecksControllerGetSettingsResponse = PipeChecksControllerGetSettingsResponses[keyof PipeChecksControllerGetSettingsResponses];

export type PipeChecksControllerSaveSettingsData = {
    body: UpdatePipeCheckSettingDto;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/pipe-checks/distributions/{distributionId}/settings';
};

export type PipeChecksControllerSaveSettingsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerSaveSettingsError = PipeChecksControllerSaveSettingsErrors[keyof PipeChecksControllerSaveSettingsErrors];

export type PipeChecksControllerSaveSettingsResponses = {
    200: PipeCheckSettingDto;
};

export type PipeChecksControllerSaveSettingsResponse = PipeChecksControllerSaveSettingsResponses[keyof PipeChecksControllerSaveSettingsResponses];

export type PipeChecksControllerAddConfigData = {
    body: SavePipeCheckConfigDto;
    path: {
        distributionId: number;
    };
    query?: never;
    url: '/api/pipe-checks/distributions/{distributionId}/configs';
};

export type PipeChecksControllerAddConfigErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerAddConfigError = PipeChecksControllerAddConfigErrors[keyof PipeChecksControllerAddConfigErrors];

export type PipeChecksControllerAddConfigResponses = {
    201: PipeCheckSettingDto;
};

export type PipeChecksControllerAddConfigResponse = PipeChecksControllerAddConfigResponses[keyof PipeChecksControllerAddConfigResponses];

export type PipeChecksControllerDeleteConfigData = {
    body?: never;
    path: {
        configId: number;
    };
    query?: never;
    url: '/api/pipe-checks/configs/{configId}';
};

export type PipeChecksControllerDeleteConfigErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerDeleteConfigError = PipeChecksControllerDeleteConfigErrors[keyof PipeChecksControllerDeleteConfigErrors];

export type PipeChecksControllerDeleteConfigResponses = {
    200: PipeCheckSettingDto;
};

export type PipeChecksControllerDeleteConfigResponse = PipeChecksControllerDeleteConfigResponses[keyof PipeChecksControllerDeleteConfigResponses];

export type PipeChecksControllerUpdateConfigData = {
    body: SavePipeCheckConfigDto;
    path: {
        configId: number;
    };
    query?: never;
    url: '/api/pipe-checks/configs/{configId}';
};

export type PipeChecksControllerUpdateConfigErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerUpdateConfigError = PipeChecksControllerUpdateConfigErrors[keyof PipeChecksControllerUpdateConfigErrors];

export type PipeChecksControllerUpdateConfigResponses = {
    200: PipeCheckSettingDto;
};

export type PipeChecksControllerUpdateConfigResponse = PipeChecksControllerUpdateConfigResponses[keyof PipeChecksControllerUpdateConfigResponses];

export type PipeChecksControllerListRunsData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        pageSize?: number;
        /**
         * only this distribution’s runs
         */
        distributionId?: number;
        /**
         * only the runs of this release (the release list’s Check test logs)
         */
        releaseId?: number;
        /**
         * only the runs of this pipe’s distributions
         */
        pipeId?: number;
        /**
         * only the runs of this brand’s pipes
         */
        brandId?: number;
        status?: PipeCheckRunStatus;
        /**
         * manual (Ctrl+D) or deploy (a run after a deploy)
         */
        trigger?: PipeCheckRunTrigger;
    };
    url: '/api/pipe-checks/runs';
};

export type PipeChecksControllerListRunsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerListRunsError = PipeChecksControllerListRunsErrors[keyof PipeChecksControllerListRunsErrors];

export type PipeChecksControllerListRunsResponses = {
    200: PipeCheckRunListResponseDto;
};

export type PipeChecksControllerListRunsResponse = PipeChecksControllerListRunsResponses[keyof PipeChecksControllerListRunsResponses];

export type PipeChecksControllerDeleteRunData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/pipe-checks/runs/{runId}';
};

export type PipeChecksControllerDeleteRunErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerDeleteRunError = PipeChecksControllerDeleteRunErrors[keyof PipeChecksControllerDeleteRunErrors];

export type PipeChecksControllerDeleteRunResponses = {
    204: void;
};

export type PipeChecksControllerDeleteRunResponse = PipeChecksControllerDeleteRunResponses[keyof PipeChecksControllerDeleteRunResponses];

export type PipeChecksControllerGetRunData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/pipe-checks/runs/{runId}';
};

export type PipeChecksControllerGetRunErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerGetRunError = PipeChecksControllerGetRunErrors[keyof PipeChecksControllerGetRunErrors];

export type PipeChecksControllerGetRunResponses = {
    200: PipeCheckRunDto;
};

export type PipeChecksControllerGetRunResponse = PipeChecksControllerGetRunResponses[keyof PipeChecksControllerGetRunResponses];

export type PipeChecksControllerGetRunChangesData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/pipe-checks/runs/{runId}/changes';
};

export type PipeChecksControllerGetRunChangesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerGetRunChangesError = PipeChecksControllerGetRunChangesErrors[keyof PipeChecksControllerGetRunChangesErrors];

export type PipeChecksControllerGetRunChangesResponses = {
    200: PipeCheckRunChangesDto;
};

export type PipeChecksControllerGetRunChangesResponse = PipeChecksControllerGetRunChangesResponses[keyof PipeChecksControllerGetRunChangesResponses];

export type PipeChecksControllerGetRunCompareData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/pipe-checks/runs/{runId}/compare';
};

export type PipeChecksControllerGetRunCompareErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerGetRunCompareError = PipeChecksControllerGetRunCompareErrors[keyof PipeChecksControllerGetRunCompareErrors];

export type PipeChecksControllerGetRunCompareResponses = {
    200: PipeCheckRunCompareDto;
};

export type PipeChecksControllerGetRunCompareResponse = PipeChecksControllerGetRunCompareResponses[keyof PipeChecksControllerGetRunCompareResponses];

export type PipeChecksControllerStreamStepScreenshotData = {
    body?: never;
    path: {
        runId: string;
        stepNumber: number;
    };
    query?: never;
    url: '/api/pipe-checks/runs/{runId}/steps/{stepNumber}/screenshot';
};

export type PipeChecksControllerStreamStepScreenshotErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerStreamStepScreenshotError = PipeChecksControllerStreamStepScreenshotErrors[keyof PipeChecksControllerStreamStepScreenshotErrors];

export type PipeChecksControllerStreamStepScreenshotResponses = {
    200: unknown;
};

export type PipeChecksControllerStreamStepNodesData = {
    body?: never;
    path: {
        runId: string;
        stepNumber: number;
    };
    query?: never;
    url: '/api/pipe-checks/runs/{runId}/steps/{stepNumber}/nodes';
};

export type PipeChecksControllerStreamStepNodesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerStreamStepNodesError = PipeChecksControllerStreamStepNodesErrors[keyof PipeChecksControllerStreamStepNodesErrors];

export type PipeChecksControllerStreamStepNodesResponses = {
    200: unknown;
};

export type PipeChecksControllerDownloadStepConsoleData = {
    body?: never;
    path: {
        runId: string;
        stepNumber: number;
    };
    query?: never;
    url: '/api/pipe-checks/runs/{runId}/steps/{stepNumber}/console';
};

export type PipeChecksControllerDownloadStepConsoleErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeChecksControllerDownloadStepConsoleError = PipeChecksControllerDownloadStepConsoleErrors[keyof PipeChecksControllerDownloadStepConsoleErrors];

export type PipeChecksControllerDownloadStepConsoleResponses = {
    200: unknown;
};

export type PriceProductObjectControllerListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Brand code to filter
         */
        brandCode?: string;
        /**
         * Search text in title or external id
         */
        search?: string;
        /**
         * Filter by Currency Code (e.g., EUR, USD)
         */
        currencyCode?: string;
        /**
         * Filter by payment type
         */
        paymentType?: 'recurring' | 'recurring_with_trial' | 'one_time' | 'gift';
        page?: number;
        pageSize?: number;
    };
    url: '/api/price-product-object/list';
};

export type PriceProductObjectControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectControllerListError = PriceProductObjectControllerListErrors[keyof PriceProductObjectControllerListErrors];

export type PriceProductObjectControllerListResponses = {
    200: PriceProductObjectListResponseDto;
};

export type PriceProductObjectControllerListResponse = PriceProductObjectControllerListResponses[keyof PriceProductObjectControllerListResponses];

export type PriceProductObjectControllerGetFullData = {
    body?: never;
    path?: never;
    query: {
        id: number;
    };
    url: '/api/price-product-object/full';
};

export type PriceProductObjectControllerGetFullErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectControllerGetFullError = PriceProductObjectControllerGetFullErrors[keyof PriceProductObjectControllerGetFullErrors];

export type PriceProductObjectControllerGetFullResponses = {
    200: PriceProductObjectFullDto;
};

export type PriceProductObjectControllerGetFullResponse = PriceProductObjectControllerGetFullResponses[keyof PriceProductObjectControllerGetFullResponses];

export type PriceProductObjectControllerSyncData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/price-product-object/sync';
};

export type PriceProductObjectControllerSyncErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectControllerSyncError = PriceProductObjectControllerSyncErrors[keyof PriceProductObjectControllerSyncErrors];

export type PriceProductObjectControllerSyncResponses = {
    201: unknown;
};

export type PriceProductObjectOffersControllerListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter by PriceProductObject ID
         */
        priceProductObjectId?: number;
        /**
         * Search by PriceProductObject title
         */
        ppoTitle?: string;
        /**
         * Free-text search matching offer name (partial), offer id, or external PPO id (partial).
         */
        search?: string;
        /**
         * Filter by currency code
         */
        currencyCode?: string;
        /**
         * Filter by offer type. Pass '__none__' to find offers with no type set.
         */
        offerType?: 'BASIC' | 'PREMIUM' | 'SHOPPING_LIST' | 'SHOPPING_LIST_AND_PREMIUM' | 'BASIC_ANNUAL' | 'CHAT' | 'WORKOUTS' | 'BASIC_EXIT_INTENT' | 'PREMIUM_EXIT_INTENT' | '__none__';
        /**
         * Page number
         */
        page?: number;
        /**
         * Page size
         */
        pageSize?: number;
        sortBy?: 'id' | 'name';
        sortOrder?: 'ASC' | 'DESC';
    };
    url: '/api/price-product-object-offers';
};

export type PriceProductObjectOffersControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectOffersControllerListError = PriceProductObjectOffersControllerListErrors[keyof PriceProductObjectOffersControllerListErrors];

export type PriceProductObjectOffersControllerListResponses = {
    200: PriceProductObjectOfferListDto;
};

export type PriceProductObjectOffersControllerListResponse = PriceProductObjectOffersControllerListResponses[keyof PriceProductObjectOffersControllerListResponses];

export type PriceProductObjectOffersControllerCreateData = {
    body: CreatePriceProductObjectOfferDto;
    path?: never;
    query?: never;
    url: '/api/price-product-object-offers';
};

export type PriceProductObjectOffersControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectOffersControllerCreateError = PriceProductObjectOffersControllerCreateErrors[keyof PriceProductObjectOffersControllerCreateErrors];

export type PriceProductObjectOffersControllerCreateResponses = {
    201: PriceProductObjectOfferDto;
};

export type PriceProductObjectOffersControllerCreateResponse = PriceProductObjectOffersControllerCreateResponses[keyof PriceProductObjectOffersControllerCreateResponses];

export type PriceProductObjectOffersControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/price-product-object-offers/{id}';
};

export type PriceProductObjectOffersControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectOffersControllerFindOneError = PriceProductObjectOffersControllerFindOneErrors[keyof PriceProductObjectOffersControllerFindOneErrors];

export type PriceProductObjectOffersControllerFindOneResponses = {
    200: PriceProductObjectOfferDto;
};

export type PriceProductObjectOffersControllerFindOneResponse = PriceProductObjectOffersControllerFindOneResponses[keyof PriceProductObjectOffersControllerFindOneResponses];

export type PriceProductObjectOffersControllerUpdateData = {
    body: UpdatePriceProductObjectOfferDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/price-product-object-offers/{id}';
};

export type PriceProductObjectOffersControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectOffersControllerUpdateError = PriceProductObjectOffersControllerUpdateErrors[keyof PriceProductObjectOffersControllerUpdateErrors];

export type PriceProductObjectOffersControllerUpdateResponses = {
    200: PriceProductObjectOffer;
};

export type PriceProductObjectOffersControllerUpdateResponse = PriceProductObjectOffersControllerUpdateResponses[keyof PriceProductObjectOffersControllerUpdateResponses];

export type PriceProductObjectOffersControllerUsageData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Offer ids
         */
        ids: Array<number>;
        /**
         * Leave this price category out — the one whose form asks, so its own rungs are not reported as use elsewhere.
         */
        excludePriceCategoryId?: number;
    };
    url: '/api/price-product-object-offers/usage';
};

export type PriceProductObjectOffersControllerUsageErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectOffersControllerUsageError = PriceProductObjectOffersControllerUsageErrors[keyof PriceProductObjectOffersControllerUsageErrors];

export type PriceProductObjectOffersControllerUsageResponses = {
    200: OfferUsageListDto;
};

export type PriceProductObjectOffersControllerUsageResponse = PriceProductObjectOffersControllerUsageResponses[keyof PriceProductObjectOffersControllerUsageResponses];

export type PriceProductObjectOffersControllerListRevisionsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        skip?: number;
        take?: number;
    };
    url: '/api/price-product-object-offers/{id}/revisions';
};

export type PriceProductObjectOffersControllerListRevisionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceProductObjectOffersControllerListRevisionsError = PriceProductObjectOffersControllerListRevisionsErrors[keyof PriceProductObjectOffersControllerListRevisionsErrors];

export type PriceProductObjectOffersControllerListRevisionsResponses = {
    200: EntityRevisionListDto;
};

export type PriceProductObjectOffersControllerListRevisionsResponse = PriceProductObjectOffersControllerListRevisionsResponses[keyof PriceProductObjectOffersControllerListRevisionsResponses];

export type CurrencyControllerListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Search by name or code
         */
        search?: string;
        /**
         * Page number
         */
        page?: number;
        /**
         * Page size
         */
        pageSize?: number;
    };
    url: '/api/currencies';
};

export type CurrencyControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type CurrencyControllerListError = CurrencyControllerListErrors[keyof CurrencyControllerListErrors];

export type CurrencyControllerListResponses = {
    200: CurrencyListResponseDto;
};

export type CurrencyControllerListResponse = CurrencyControllerListResponses[keyof CurrencyControllerListResponses];

export type CurrencyControllerFindAllData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/currencies/all';
};

export type CurrencyControllerFindAllErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type CurrencyControllerFindAllError = CurrencyControllerFindAllErrors[keyof CurrencyControllerFindAllErrors];

export type CurrencyControllerFindAllResponses = {
    200: Array<CurrencyDto>;
};

export type CurrencyControllerFindAllResponse = CurrencyControllerFindAllResponses[keyof CurrencyControllerFindAllResponses];

export type DevJobsControllerListJobsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Page number
         */
        page?: number;
        /**
         * Page size
         */
        pageSize?: number;
    };
    url: '/api/dev-jobs';
};

export type DevJobsControllerListJobsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DevJobsControllerListJobsError = DevJobsControllerListJobsErrors[keyof DevJobsControllerListJobsErrors];

export type DevJobsControllerListJobsResponses = {
    200: DevJobListResponseDto;
};

export type DevJobsControllerListJobsResponse = DevJobsControllerListJobsResponses[keyof DevJobsControllerListJobsResponses];

export type DevJobsControllerCreateJobData = {
    body: CreateDevJobDto;
    path?: never;
    query?: never;
    url: '/api/dev-jobs';
};

export type DevJobsControllerCreateJobErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DevJobsControllerCreateJobError = DevJobsControllerCreateJobErrors[keyof DevJobsControllerCreateJobErrors];

export type DevJobsControllerCreateJobResponses = {
    201: DevJobResponseDto;
};

export type DevJobsControllerCreateJobResponse = DevJobsControllerCreateJobResponses[keyof DevJobsControllerCreateJobResponses];

export type DevJobsControllerGetJobTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/dev-jobs/types';
};

export type DevJobsControllerGetJobTypesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DevJobsControllerGetJobTypesError = DevJobsControllerGetJobTypesErrors[keyof DevJobsControllerGetJobTypesErrors];

export type DevJobsControllerGetJobTypesResponses = {
    /**
     * List of available job types
     */
    200: Array<JobTypeResponseDto>;
};

export type DevJobsControllerGetJobTypesResponse = DevJobsControllerGetJobTypesResponses[keyof DevJobsControllerGetJobTypesResponses];

export type DevJobsControllerGetJobData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/dev-jobs/{id}';
};

export type DevJobsControllerGetJobErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DevJobsControllerGetJobError = DevJobsControllerGetJobErrors[keyof DevJobsControllerGetJobErrors];

export type DevJobsControllerGetJobResponses = {
    200: DevJobResponseDto;
};

export type DevJobsControllerGetJobResponse = DevJobsControllerGetJobResponses[keyof DevJobsControllerGetJobResponses];

export type DevJobsControllerGetJobLogsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/dev-jobs/{id}/logs';
};

export type DevJobsControllerGetJobLogsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DevJobsControllerGetJobLogsError = DevJobsControllerGetJobLogsErrors[keyof DevJobsControllerGetJobLogsErrors];

export type DevJobsControllerGetJobLogsResponses = {
    200: DevJobResponseDto;
};

export type DevJobsControllerGetJobLogsResponse = DevJobsControllerGetJobLogsResponses[keyof DevJobsControllerGetJobLogsResponses];

export type DefaultPipesControllerListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/default-pipes';
};

export type DefaultPipesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DefaultPipesControllerListError = DefaultPipesControllerListErrors[keyof DefaultPipesControllerListErrors];

export type DefaultPipesControllerListResponses = {
    200: DefaultPipeListResponseDto;
};

export type DefaultPipesControllerListResponse = DefaultPipesControllerListResponses[keyof DefaultPipesControllerListResponses];

export type DefaultPipesControllerCreateData = {
    body: DefaultPipeCreateDto;
    path?: never;
    query?: {
        publish?: string;
        reassign?: string;
    };
    url: '/api/default-pipes';
};

export type DefaultPipesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DefaultPipesControllerCreateError = DefaultPipesControllerCreateErrors[keyof DefaultPipesControllerCreateErrors];

export type DefaultPipesControllerCreateResponses = {
    200: DefaultPipeDto;
};

export type DefaultPipesControllerCreateResponse = DefaultPipesControllerCreateResponses[keyof DefaultPipesControllerCreateResponses];

export type DefaultPipesControllerPublishData = {
    body: DefaultPipePublishRequestDto;
    path: {
        brandId: number;
    };
    query?: never;
    url: '/api/default-pipes/brands/{brandId}/publish';
};

export type DefaultPipesControllerPublishErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DefaultPipesControllerPublishError = DefaultPipesControllerPublishErrors[keyof DefaultPipesControllerPublishErrors];

export type DefaultPipesControllerPublishResponses = {
    200: DefaultPipePublishResultDto;
};

export type DefaultPipesControllerPublishResponse = DefaultPipesControllerPublishResponses[keyof DefaultPipesControllerPublishResponses];

export type DefaultPipesControllerAlignData = {
    body: DefaultPipeAlignRequestDto;
    path: {
        brandId: number;
    };
    query?: never;
    url: '/api/default-pipes/brands/{brandId}/align';
};

export type DefaultPipesControllerAlignErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DefaultPipesControllerAlignError = DefaultPipesControllerAlignErrors[keyof DefaultPipesControllerAlignErrors];

export type DefaultPipesControllerAlignResponses = {
    200: DefaultPipeAlignResultDto;
};

export type DefaultPipesControllerAlignResponse = DefaultPipesControllerAlignResponses[keyof DefaultPipesControllerAlignResponses];

export type DefaultPipesControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        publish?: string;
    };
    url: '/api/default-pipes/{id}';
};

export type DefaultPipesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DefaultPipesControllerRemoveError = DefaultPipesControllerRemoveErrors[keyof DefaultPipesControllerRemoveErrors];

export type DefaultPipesControllerRemoveResponses = {
    200: unknown;
};

export type DefaultPipesControllerGetByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/default-pipes/{id}';
};

export type DefaultPipesControllerGetByIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DefaultPipesControllerGetByIdError = DefaultPipesControllerGetByIdErrors[keyof DefaultPipesControllerGetByIdErrors];

export type DefaultPipesControllerGetByIdResponses = {
    200: DefaultPipeDto;
};

export type DefaultPipesControllerGetByIdResponse = DefaultPipesControllerGetByIdResponses[keyof DefaultPipesControllerGetByIdResponses];

export type DefaultPipesControllerUpdateData = {
    body: DefaultPipeUpdateDto;
    path: {
        id: number;
    };
    query?: {
        publish?: string;
        reassign?: string;
    };
    url: '/api/default-pipes/{id}';
};

export type DefaultPipesControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DefaultPipesControllerUpdateError = DefaultPipesControllerUpdateErrors[keyof DefaultPipesControllerUpdateErrors];

export type DefaultPipesControllerUpdateResponses = {
    200: DefaultPipeDto;
};

export type DefaultPipesControllerUpdateResponse = DefaultPipesControllerUpdateResponses[keyof DefaultPipesControllerUpdateResponses];

export type DefaultPipesControllerPublishOneData = {
    body: DefaultPipePublishRequestDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/default-pipes/{id}/publish';
};

export type DefaultPipesControllerPublishOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DefaultPipesControllerPublishOneError = DefaultPipesControllerPublishOneErrors[keyof DefaultPipesControllerPublishOneErrors];

export type DefaultPipesControllerPublishOneResponses = {
    200: DefaultPipePublishResultDto;
};

export type DefaultPipesControllerPublishOneResponse = DefaultPipesControllerPublishOneResponses[keyof DefaultPipesControllerPublishOneResponses];

export type FigmaControllerListData = {
    body?: never;
    path?: never;
    query?: {
        pipeId?: number;
        page?: number;
        pageSize?: number;
        search?: string;
    };
    url: '/api/figma/files';
};

export type FigmaControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaControllerListError = FigmaControllerListErrors[keyof FigmaControllerListErrors];

export type FigmaControllerListResponses = {
    200: FigmaFileListResponseDto;
};

export type FigmaControllerListResponse = FigmaControllerListResponses[keyof FigmaControllerListResponses];

export type FigmaControllerCreateData = {
    body: FigmaFileCreateDto;
    path?: never;
    query?: never;
    url: '/api/figma/files';
};

export type FigmaControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaControllerCreateError = FigmaControllerCreateErrors[keyof FigmaControllerCreateErrors];

export type FigmaControllerCreateResponses = {
    201: FigmaFileDto;
};

export type FigmaControllerCreateResponse = FigmaControllerCreateResponses[keyof FigmaControllerCreateResponses];

export type FigmaControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/figma/files/{id}';
};

export type FigmaControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaControllerRemoveError = FigmaControllerRemoveErrors[keyof FigmaControllerRemoveErrors];

export type FigmaControllerRemoveResponses = {
    204: void;
};

export type FigmaControllerRemoveResponse = FigmaControllerRemoveResponses[keyof FigmaControllerRemoveResponses];

export type FigmaControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/figma/files/{id}';
};

export type FigmaControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaControllerFindOneError = FigmaControllerFindOneErrors[keyof FigmaControllerFindOneErrors];

export type FigmaControllerFindOneResponses = {
    200: FigmaFileWithPreviewsDto;
};

export type FigmaControllerFindOneResponse = FigmaControllerFindOneResponses[keyof FigmaControllerFindOneResponses];

export type FigmaControllerUpdateData = {
    body: FigmaFileUpdateDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/figma/files/{id}';
};

export type FigmaControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaControllerUpdateError = FigmaControllerUpdateErrors[keyof FigmaControllerUpdateErrors];

export type FigmaControllerUpdateResponses = {
    200: FigmaFileDto;
};

export type FigmaControllerUpdateResponse = FigmaControllerUpdateResponses[keyof FigmaControllerUpdateResponses];

export type FigmaControllerSyncData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/figma/files/{id}/sync';
};

export type FigmaControllerSyncErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaControllerSyncError = FigmaControllerSyncErrors[keyof FigmaControllerSyncErrors];

export type FigmaControllerSyncResponses = {
    201: unknown;
};

export type FigmaControllerStreamImageData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/figma/previews/{id}/image';
};

export type FigmaControllerStreamImageErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaControllerStreamImageError = FigmaControllerStreamImageErrors[keyof FigmaControllerStreamImageErrors];

export type FigmaControllerStreamImageResponses = {
    200: unknown;
};

export type FigmaOauthControllerDisconnectData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/figma/oauth/connection';
};

export type FigmaOauthControllerDisconnectErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaOauthControllerDisconnectError = FigmaOauthControllerDisconnectErrors[keyof FigmaOauthControllerDisconnectErrors];

export type FigmaOauthControllerDisconnectResponses = {
    204: void;
};

export type FigmaOauthControllerDisconnectResponse = FigmaOauthControllerDisconnectResponses[keyof FigmaOauthControllerDisconnectResponses];

export type FigmaOauthControllerConnectionData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Whose data to read. Omitted = the caller’s own. Any other id is Admin-only.
         */
        userId?: number;
    };
    url: '/api/figma/oauth/connection';
};

export type FigmaOauthControllerConnectionErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FigmaOauthControllerConnectionError = FigmaOauthControllerConnectionErrors[keyof FigmaOauthControllerConnectionErrors];

export type FigmaOauthControllerConnectionResponses = {
    200: FigmaConnectionDto;
};

export type FigmaOauthControllerConnectionResponse = FigmaOauthControllerConnectionResponses[keyof FigmaOauthControllerConnectionResponses];

export type PipeExportsControllerListData = {
    body?: never;
    path?: never;
    query?: {
        type?: PipeExportType;
        status?: PipeExportStatus;
        pipeId?: number;
        page?: number;
        pageSize?: number;
    };
    url: '/api/pipe-exports';
};

export type PipeExportsControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeExportsControllerListError = PipeExportsControllerListErrors[keyof PipeExportsControllerListErrors];

export type PipeExportsControllerListResponses = {
    200: PipeExportListPaginatedResponseDto;
};

export type PipeExportsControllerListResponse = PipeExportsControllerListResponses[keyof PipeExportsControllerListResponses];

export type PipeExportsControllerCreateExportData = {
    body: PipeExportCreateDto;
    path?: never;
    query?: never;
    url: '/api/pipe-exports';
};

export type PipeExportsControllerCreateExportErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeExportsControllerCreateExportError = PipeExportsControllerCreateExportErrors[keyof PipeExportsControllerCreateExportErrors];

export type PipeExportsControllerCreateExportResponses = {
    200: PipeExportDto;
};

export type PipeExportsControllerCreateExportResponse = PipeExportsControllerCreateExportResponses[keyof PipeExportsControllerCreateExportResponses];

export type PipeExportsControllerAnalyzeImportData = {
    body: {
        file?: Blob | File;
    };
    path?: never;
    query?: never;
    url: '/api/pipe-exports/analyze';
};

export type PipeExportsControllerAnalyzeImportErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeExportsControllerAnalyzeImportError = PipeExportsControllerAnalyzeImportErrors[keyof PipeExportsControllerAnalyzeImportErrors];

export type PipeExportsControllerAnalyzeImportResponses = {
    200: PipeExportDto;
};

export type PipeExportsControllerAnalyzeImportResponse = PipeExportsControllerAnalyzeImportResponses[keyof PipeExportsControllerAnalyzeImportResponses];

export type PipeExportsControllerConfirmImportData = {
    body: PipeExportConfirmDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipe-exports/{id}/confirm';
};

export type PipeExportsControllerConfirmImportErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeExportsControllerConfirmImportError = PipeExportsControllerConfirmImportErrors[keyof PipeExportsControllerConfirmImportErrors];

export type PipeExportsControllerConfirmImportResponses = {
    200: PipeExportDto;
};

export type PipeExportsControllerConfirmImportResponse = PipeExportsControllerConfirmImportResponses[keyof PipeExportsControllerConfirmImportResponses];

export type PipeExportsControllerDeleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipe-exports/{id}';
};

export type PipeExportsControllerDeleteErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeExportsControllerDeleteError = PipeExportsControllerDeleteErrors[keyof PipeExportsControllerDeleteErrors];

export type PipeExportsControllerDeleteResponses = {
    200: unknown;
};

export type PipeExportsControllerGetByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipe-exports/{id}';
};

export type PipeExportsControllerGetByIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeExportsControllerGetByIdError = PipeExportsControllerGetByIdErrors[keyof PipeExportsControllerGetByIdErrors];

export type PipeExportsControllerGetByIdResponses = {
    200: PipeExportDto;
};

export type PipeExportsControllerGetByIdResponse = PipeExportsControllerGetByIdResponses[keyof PipeExportsControllerGetByIdResponses];

export type PipeExportsControllerDownloadData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/pipe-exports/{id}/download';
};

export type PipeExportsControllerDownloadErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeExportsControllerDownloadError = PipeExportsControllerDownloadErrors[keyof PipeExportsControllerDownloadErrors];

export type PipeExportsControllerDownloadResponses = {
    200: unknown;
};

export type TranslationRequestsControllerFindAllData = {
    body?: never;
    path?: never;
    query?: {
        pipeId?: number;
        targetLanguage?: string;
        status?: TranslationRequestStatus;
    };
    url: '/api/translation-requests';
};

export type TranslationRequestsControllerFindAllErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationRequestsControllerFindAllError = TranslationRequestsControllerFindAllErrors[keyof TranslationRequestsControllerFindAllErrors];

export type TranslationRequestsControllerFindAllResponses = {
    200: TranslationRequestListResponseDto;
};

export type TranslationRequestsControllerFindAllResponse = TranslationRequestsControllerFindAllResponses[keyof TranslationRequestsControllerFindAllResponses];

export type TranslationRequestsControllerCreateData = {
    body: CreateTranslationRequestDto;
    path?: never;
    query?: never;
    url: '/api/translation-requests';
};

export type TranslationRequestsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationRequestsControllerCreateError = TranslationRequestsControllerCreateErrors[keyof TranslationRequestsControllerCreateErrors];

export type TranslationRequestsControllerCreateResponses = {
    201: TranslationRequestDto;
};

export type TranslationRequestsControllerCreateResponse = TranslationRequestsControllerCreateResponses[keyof TranslationRequestsControllerCreateResponses];

export type TranslationRequestsControllerExportXlsxData = {
    body?: never;
    path?: never;
    query: {
        pipeId?: number;
        targetLanguage: string;
        includeBrandKeys: boolean;
    };
    url: '/api/translation-requests/export.xlsx';
};

export type TranslationRequestsControllerExportXlsxErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationRequestsControllerExportXlsxError = TranslationRequestsControllerExportXlsxErrors[keyof TranslationRequestsControllerExportXlsxErrors];

export type TranslationRequestsControllerExportXlsxResponses = {
    200: unknown;
};

export type TranslationRequestsControllerImportXlsxData = {
    body: {
        file: Blob | File;
        pipeId?: number;
        targetLanguage: string;
        includeBrandKeys: boolean;
        force?: boolean;
    };
    path?: never;
    query?: never;
    url: '/api/translation-requests/import.xlsx';
};

export type TranslationRequestsControllerImportXlsxErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationRequestsControllerImportXlsxError = TranslationRequestsControllerImportXlsxErrors[keyof TranslationRequestsControllerImportXlsxErrors];

export type TranslationRequestsControllerImportXlsxResponses = {
    200: TranslationRequestDto;
};

export type TranslationRequestsControllerImportXlsxResponse = TranslationRequestsControllerImportXlsxResponses[keyof TranslationRequestsControllerImportXlsxResponses];

export type TranslationRequestsControllerExportJsonData = {
    body?: never;
    path?: never;
    query: {
        pipeId?: number;
        targetLanguage: string;
        includeBrandKeys: boolean;
    };
    url: '/api/translation-requests/export.json';
};

export type TranslationRequestsControllerExportJsonErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationRequestsControllerExportJsonError = TranslationRequestsControllerExportJsonErrors[keyof TranslationRequestsControllerExportJsonErrors];

export type TranslationRequestsControllerExportJsonResponses = {
    200: unknown;
};

export type TranslationRequestsControllerImportJsonData = {
    body: {
        file: Blob | File;
        pipeId?: number;
        targetLanguage: string;
        includeBrandKeys: boolean;
        force?: boolean;
    };
    path?: never;
    query?: never;
    url: '/api/translation-requests/import.json';
};

export type TranslationRequestsControllerImportJsonErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationRequestsControllerImportJsonError = TranslationRequestsControllerImportJsonErrors[keyof TranslationRequestsControllerImportJsonErrors];

export type TranslationRequestsControllerImportJsonResponses = {
    200: TranslationRequestDto;
};

export type TranslationRequestsControllerImportJsonResponse = TranslationRequestsControllerImportJsonResponses[keyof TranslationRequestsControllerImportJsonResponses];

export type TranslationRequestsControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/translation-requests/{id}';
};

export type TranslationRequestsControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationRequestsControllerFindOneError = TranslationRequestsControllerFindOneErrors[keyof TranslationRequestsControllerFindOneErrors];

export type TranslationRequestsControllerFindOneResponses = {
    200: TranslationRequestDto;
};

export type TranslationRequestsControllerFindOneResponse = TranslationRequestsControllerFindOneResponses[keyof TranslationRequestsControllerFindOneResponses];

export type TranslationKeyNamesControllerSuggestData = {
    body: TranslationKeyNameSuggestRequestDto;
    path?: never;
    query?: never;
    url: '/api/translation-key-names/suggest';
};

export type TranslationKeyNamesControllerSuggestErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type TranslationKeyNamesControllerSuggestError = TranslationKeyNamesControllerSuggestErrors[keyof TranslationKeyNamesControllerSuggestErrors];

export type TranslationKeyNamesControllerSuggestResponses = {
    200: TranslationKeyNameSuggestResponseDto;
};

export type TranslationKeyNamesControllerSuggestResponse = TranslationKeyNamesControllerSuggestResponses[keyof TranslationKeyNamesControllerSuggestResponses];

export type AiUsageControllerSummaryData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Restrict to one user.
         */
        userId?: number;
        /**
         * Inclusive UTC start date (YYYY-MM-DD). Defaults to the first of the current month.
         */
        from?: string;
        /**
         * Inclusive UTC end date (YYYY-MM-DD). Defaults to today.
         */
        to?: string;
    };
    url: '/api/ai-usage/summary';
};

export type AiUsageControllerSummaryErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AiUsageControllerSummaryError = AiUsageControllerSummaryErrors[keyof AiUsageControllerSummaryErrors];

export type AiUsageControllerSummaryResponses = {
    200: AiUsageSummaryDto;
};

export type AiUsageControllerSummaryResponse = AiUsageControllerSummaryResponses[keyof AiUsageControllerSummaryResponses];

export type AiUsageControllerLimitsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Whose data to read. Omitted = the caller’s own. Any other id is Admin-only.
         */
        userId?: number;
    };
    url: '/api/ai-usage/limits';
};

export type AiUsageControllerLimitsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AiUsageControllerLimitsError = AiUsageControllerLimitsErrors[keyof AiUsageControllerLimitsErrors];

export type AiUsageControllerLimitsResponses = {
    200: AiUsageLimitsDto;
};

export type AiUsageControllerLimitsResponse = AiUsageControllerLimitsResponses[keyof AiUsageControllerLimitsResponses];

export type FunnelMarkersControllerListData = {
    body?: never;
    path?: never;
    query?: {
        key?: string;
        page?: number;
        pageSize?: number;
    };
    url: '/api/funnel-markers';
};

export type FunnelMarkersControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelMarkersControllerListError = FunnelMarkersControllerListErrors[keyof FunnelMarkersControllerListErrors];

export type FunnelMarkersControllerListResponses = {
    200: FunnelMarkerListPaginatedResponseDto;
};

export type FunnelMarkersControllerListResponse = FunnelMarkersControllerListResponses[keyof FunnelMarkersControllerListResponses];

export type FunnelMarkersControllerCreateData = {
    body: FunnelMarkerCreateDto;
    path?: never;
    query?: never;
    url: '/api/funnel-markers';
};

export type FunnelMarkersControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelMarkersControllerCreateError = FunnelMarkersControllerCreateErrors[keyof FunnelMarkersControllerCreateErrors];

export type FunnelMarkersControllerCreateResponses = {
    200: FunnelMarkerDto;
};

export type FunnelMarkersControllerCreateResponse = FunnelMarkersControllerCreateResponses[keyof FunnelMarkersControllerCreateResponses];

export type FunnelMarkersControllerDeleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/funnel-markers/{id}';
};

export type FunnelMarkersControllerDeleteErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelMarkersControllerDeleteError = FunnelMarkersControllerDeleteErrors[keyof FunnelMarkersControllerDeleteErrors];

export type FunnelMarkersControllerDeleteResponses = {
    200: unknown;
};

export type FunnelMarkersControllerGetByIdData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/funnel-markers/{id}';
};

export type FunnelMarkersControllerGetByIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelMarkersControllerGetByIdError = FunnelMarkersControllerGetByIdErrors[keyof FunnelMarkersControllerGetByIdErrors];

export type FunnelMarkersControllerGetByIdResponses = {
    200: FunnelMarkerDto;
};

export type FunnelMarkersControllerGetByIdResponse = FunnelMarkersControllerGetByIdResponses[keyof FunnelMarkersControllerGetByIdResponses];

export type FunnelMarkersControllerUpdateData = {
    body: FunnelMarkerUpdateDto;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/funnel-markers/{id}';
};

export type FunnelMarkersControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelMarkersControllerUpdateError = FunnelMarkersControllerUpdateErrors[keyof FunnelMarkersControllerUpdateErrors];

export type FunnelMarkersControllerUpdateResponses = {
    200: FunnelMarkerDto;
};

export type FunnelMarkersControllerUpdateResponse = FunnelMarkersControllerUpdateResponses[keyof FunnelMarkersControllerUpdateResponses];

export type FunnelMarkersControllerReorderData = {
    body: FunnelMarkerOrderDto;
    path?: never;
    query?: never;
    url: '/api/funnel-markers/order';
};

export type FunnelMarkersControllerReorderErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelMarkersControllerReorderError = FunnelMarkersControllerReorderErrors[keyof FunnelMarkersControllerReorderErrors];

export type FunnelMarkersControllerReorderResponses = {
    200: Array<FunnelMarkerDto>;
};

export type FunnelMarkersControllerReorderResponse = FunnelMarkersControllerReorderResponses[keyof FunnelMarkersControllerReorderResponses];

export type DistributionStatusesControllerListData = {
    body?: never;
    path?: never;
    query?: {
        name?: string;
        page?: number;
        pageSize?: number;
    };
    url: '/api/distribution-statuses';
};

export type DistributionStatusesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionStatusesControllerListError = DistributionStatusesControllerListErrors[keyof DistributionStatusesControllerListErrors];

export type DistributionStatusesControllerListResponses = {
    200: DistributionStatusListPaginatedResponseDto;
};

export type DistributionStatusesControllerListResponse = DistributionStatusesControllerListResponses[keyof DistributionStatusesControllerListResponses];

export type DistributionStatusesControllerCreateData = {
    body: DistributionStatusCreateDto;
    path?: never;
    query?: never;
    url: '/api/distribution-statuses';
};

export type DistributionStatusesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionStatusesControllerCreateError = DistributionStatusesControllerCreateErrors[keyof DistributionStatusesControllerCreateErrors];

export type DistributionStatusesControllerCreateResponses = {
    200: DistributionStatusDto;
};

export type DistributionStatusesControllerCreateResponse = DistributionStatusesControllerCreateResponses[keyof DistributionStatusesControllerCreateResponses];

export type DistributionStatusesControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distribution-statuses/{id}';
};

export type DistributionStatusesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionStatusesControllerRemoveError = DistributionStatusesControllerRemoveErrors[keyof DistributionStatusesControllerRemoveErrors];

export type DistributionStatusesControllerRemoveResponses = {
    200: unknown;
};

export type DistributionStatusesControllerGetByIdData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distribution-statuses/{id}';
};

export type DistributionStatusesControllerGetByIdErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionStatusesControllerGetByIdError = DistributionStatusesControllerGetByIdErrors[keyof DistributionStatusesControllerGetByIdErrors];

export type DistributionStatusesControllerGetByIdResponses = {
    200: DistributionStatusDto;
};

export type DistributionStatusesControllerGetByIdResponse = DistributionStatusesControllerGetByIdResponses[keyof DistributionStatusesControllerGetByIdResponses];

export type DistributionStatusesControllerUpdateData = {
    body: DistributionStatusUpdateDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distribution-statuses/{id}';
};

export type DistributionStatusesControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionStatusesControllerUpdateError = DistributionStatusesControllerUpdateErrors[keyof DistributionStatusesControllerUpdateErrors];

export type DistributionStatusesControllerUpdateResponses = {
    200: DistributionStatusDto;
};

export type DistributionStatusesControllerUpdateResponse = DistributionStatusesControllerUpdateResponses[keyof DistributionStatusesControllerUpdateResponses];

export type DistributionStatusesControllerGetUsageData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/distribution-statuses/{id}/usage';
};

export type DistributionStatusesControllerGetUsageErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type DistributionStatusesControllerGetUsageError = DistributionStatusesControllerGetUsageErrors[keyof DistributionStatusesControllerGetUsageErrors];

export type DistributionStatusesControllerGetUsageResponses = {
    200: DistributionStatusUsageDto;
};

export type DistributionStatusesControllerGetUsageResponse = DistributionStatusesControllerGetUsageResponses[keyof DistributionStatusesControllerGetUsageResponses];

export type CountriesControllerListData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
        geographyId?: number;
        page?: number;
        pageSize?: number;
        sortBy?: 'code' | 'name' | 'geography';
        sortOrder?: 'ASC' | 'DESC';
    };
    url: '/api/countries';
};

export type CountriesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type CountriesControllerListError = CountriesControllerListErrors[keyof CountriesControllerListErrors];

export type CountriesControllerListResponses = {
    200: CountryListResponseDto;
};

export type CountriesControllerListResponse = CountriesControllerListResponses[keyof CountriesControllerListResponses];

export type OauthConsentControllerAuthorizeRequestData = {
    body?: never;
    path?: never;
    query: {
        request: string;
    };
    url: '/api/oauth/authorize-request';
};

export type OauthConsentControllerAuthorizeRequestErrors = {
    400: ErrorResponse400;
    /**
     * No such pending request, or it has expired.
     */
    404: unknown;
    /**
     * Internal server error
     */
    500: unknown;
};

export type OauthConsentControllerAuthorizeRequestError = OauthConsentControllerAuthorizeRequestErrors[keyof OauthConsentControllerAuthorizeRequestErrors];

export type OauthConsentControllerAuthorizeRequestResponses = {
    200: OauthAuthorizeRequestDto;
};

export type OauthConsentControllerAuthorizeRequestResponse = OauthConsentControllerAuthorizeRequestResponses[keyof OauthConsentControllerAuthorizeRequestResponses];

export type OauthConsentControllerConsentData = {
    body: OauthConsentDto;
    path?: never;
    query?: never;
    url: '/api/oauth/consent';
};

export type OauthConsentControllerConsentErrors = {
    400: ErrorResponse400;
    /**
     * No such pending request, or it has expired.
     */
    404: unknown;
    /**
     * Internal server error
     */
    500: unknown;
};

export type OauthConsentControllerConsentError = OauthConsentControllerConsentErrors[keyof OauthConsentControllerConsentErrors];

export type OauthConsentControllerConsentResponses = {
    200: OauthConsentResponseDto;
};

export type OauthConsentControllerConsentResponse = OauthConsentControllerConsentResponses[keyof OauthConsentControllerConsentResponses];

export type OauthConsentControllerConnectionsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Whose data to read. Omitted = the caller’s own. Any other id is Admin-only.
         */
        userId?: number;
    };
    url: '/api/oauth/connections';
};

export type OauthConsentControllerConnectionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type OauthConsentControllerConnectionsError = OauthConsentControllerConnectionsErrors[keyof OauthConsentControllerConnectionsErrors];

export type OauthConsentControllerConnectionsResponses = {
    200: Array<OauthConnectionDto>;
};

export type OauthConsentControllerConnectionsResponse = OauthConsentControllerConnectionsResponses[keyof OauthConsentControllerConnectionsResponses];

export type OauthConsentControllerDisconnectData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/oauth/connections/{id}';
};

export type OauthConsentControllerDisconnectErrors = {
    400: ErrorResponse400;
    /**
     * No such connection for this user.
     */
    404: unknown;
    /**
     * Internal server error
     */
    500: unknown;
};

export type OauthConsentControllerDisconnectError = OauthConsentControllerDisconnectErrors[keyof OauthConsentControllerDisconnectErrors];

export type OauthConsentControllerDisconnectResponses = {
    204: void;
};

export type OauthConsentControllerDisconnectResponse = OauthConsentControllerDisconnectResponses[keyof OauthConsentControllerDisconnectResponses];

export type FunnelTrafficControllerStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/status';
};

export type FunnelTrafficControllerStatusErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerStatusError = FunnelTrafficControllerStatusErrors[keyof FunnelTrafficControllerStatusErrors];

export type FunnelTrafficControllerStatusResponses = {
    200: FunnelTrafficStatusDto;
};

export type FunnelTrafficControllerStatusResponse = FunnelTrafficControllerStatusResponses[keyof FunnelTrafficControllerStatusResponses];

export type FunnelTrafficControllerAllowanceData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Whose data to read. Omitted = the caller’s own. Any other id is Admin-only.
         */
        userId?: number;
    };
    url: '/api/funnel-traffic/allowance';
};

export type FunnelTrafficControllerAllowanceErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerAllowanceError = FunnelTrafficControllerAllowanceErrors[keyof FunnelTrafficControllerAllowanceErrors];

export type FunnelTrafficControllerAllowanceResponses = {
    200: FunnelTrafficAllowanceDto;
};

export type FunnelTrafficControllerAllowanceResponse = FunnelTrafficControllerAllowanceResponses[keyof FunnelTrafficControllerAllowanceResponses];

export type FunnelTrafficControllerFlowData = {
    body: FunnelTrafficQueryDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/funnel-traffic/pipes/{pipeId}/flow';
};

export type FunnelTrafficControllerFlowErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerFlowError = FunnelTrafficControllerFlowErrors[keyof FunnelTrafficControllerFlowErrors];

export type FunnelTrafficControllerFlowResponses = {
    200: FunnelTrafficFlowDto;
};

export type FunnelTrafficControllerFlowResponse = FunnelTrafficControllerFlowResponses[keyof FunnelTrafficControllerFlowResponses];

export type FunnelTrafficControllerEstimateData = {
    body: FunnelTrafficQueryDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/funnel-traffic/pipes/{pipeId}/flow/estimate';
};

export type FunnelTrafficControllerEstimateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerEstimateError = FunnelTrafficControllerEstimateErrors[keyof FunnelTrafficControllerEstimateErrors];

export type FunnelTrafficControllerEstimateResponses = {
    200: FunnelTrafficEstimateDto;
};

export type FunnelTrafficControllerEstimateResponse = FunnelTrafficControllerEstimateResponses[keyof FunnelTrafficControllerEstimateResponses];

export type FunnelTrafficControllerOptionsData = {
    body?: never;
    path: {
        pipeId: number;
    };
    query: {
        from: string;
        to: string;
    };
    url: '/api/funnel-traffic/pipes/{pipeId}/options';
};

export type FunnelTrafficControllerOptionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerOptionsError = FunnelTrafficControllerOptionsErrors[keyof FunnelTrafficControllerOptionsErrors];

export type FunnelTrafficControllerOptionsResponses = {
    200: FunnelTrafficOptionsDto;
};

export type FunnelTrafficControllerOptionsResponse = FunnelTrafficControllerOptionsResponses[keyof FunnelTrafficControllerOptionsResponses];

export type FunnelTrafficControllerCampaignOptionsData = {
    body?: never;
    path: {
        pipeId: number;
    };
    query: {
        from: string;
        to: string;
    };
    url: '/api/funnel-traffic/pipes/{pipeId}/campaign-options';
};

export type FunnelTrafficControllerCampaignOptionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerCampaignOptionsError = FunnelTrafficControllerCampaignOptionsErrors[keyof FunnelTrafficControllerCampaignOptionsErrors];

export type FunnelTrafficControllerCampaignOptionsResponses = {
    200: FunnelTrafficCampaignOptionsDto;
};

export type FunnelTrafficControllerCampaignOptionsResponse = FunnelTrafficControllerCampaignOptionsResponses[keyof FunnelTrafficControllerCampaignOptionsResponses];

export type FunnelTrafficControllerEstimateCampaignOptionsData = {
    body?: never;
    path: {
        pipeId: number;
    };
    query: {
        from: string;
        to: string;
    };
    url: '/api/funnel-traffic/pipes/{pipeId}/campaign-options/estimate';
};

export type FunnelTrafficControllerEstimateCampaignOptionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerEstimateCampaignOptionsError = FunnelTrafficControllerEstimateCampaignOptionsErrors[keyof FunnelTrafficControllerEstimateCampaignOptionsErrors];

export type FunnelTrafficControllerEstimateCampaignOptionsResponses = {
    200: FunnelTrafficEstimateDto;
};

export type FunnelTrafficControllerEstimateCampaignOptionsResponse = FunnelTrafficControllerEstimateCampaignOptionsResponses[keyof FunnelTrafficControllerEstimateCampaignOptionsResponses];

export type FunnelTrafficControllerPipeListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/pipes';
};

export type FunnelTrafficControllerPipeListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerPipeListError = FunnelTrafficControllerPipeListErrors[keyof FunnelTrafficControllerPipeListErrors];

export type FunnelTrafficControllerPipeListResponses = {
    200: Array<FunnelTrafficPipeDto>;
};

export type FunnelTrafficControllerPipeListResponse = FunnelTrafficControllerPipeListResponses[keyof FunnelTrafficControllerPipeListResponses];

export type FunnelTrafficControllerStepsData = {
    body: FunnelTrafficStepsQueryDto;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/steps';
};

export type FunnelTrafficControllerStepsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerStepsError = FunnelTrafficControllerStepsErrors[keyof FunnelTrafficControllerStepsErrors];

export type FunnelTrafficControllerStepsResponses = {
    200: FunnelTrafficStepsDto;
};

export type FunnelTrafficControllerStepsResponse = FunnelTrafficControllerStepsResponses[keyof FunnelTrafficControllerStepsResponses];

export type FunnelTrafficControllerEstimateStepsData = {
    body: FunnelTrafficStepsQueryDto;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/steps/estimate';
};

export type FunnelTrafficControllerEstimateStepsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerEstimateStepsError = FunnelTrafficControllerEstimateStepsErrors[keyof FunnelTrafficControllerEstimateStepsErrors];

export type FunnelTrafficControllerEstimateStepsResponses = {
    200: FunnelTrafficEstimateDto;
};

export type FunnelTrafficControllerEstimateStepsResponse = FunnelTrafficControllerEstimateStepsResponses[keyof FunnelTrafficControllerEstimateStepsResponses];

export type FunnelTrafficControllerScopeOptionsData = {
    body: FunnelTrafficScopeOptionsQueryDto;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/options';
};

export type FunnelTrafficControllerScopeOptionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerScopeOptionsError = FunnelTrafficControllerScopeOptionsErrors[keyof FunnelTrafficControllerScopeOptionsErrors];

export type FunnelTrafficControllerScopeOptionsResponses = {
    200: FunnelTrafficOptionsDto;
};

export type FunnelTrafficControllerScopeOptionsResponse = FunnelTrafficControllerScopeOptionsResponses[keyof FunnelTrafficControllerScopeOptionsResponses];

export type FunnelTrafficControllerScopeCampaignOptionsData = {
    body: FunnelTrafficScopeOptionsQueryDto;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/campaign-options';
};

export type FunnelTrafficControllerScopeCampaignOptionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerScopeCampaignOptionsError = FunnelTrafficControllerScopeCampaignOptionsErrors[keyof FunnelTrafficControllerScopeCampaignOptionsErrors];

export type FunnelTrafficControllerScopeCampaignOptionsResponses = {
    200: FunnelTrafficCampaignOptionsDto;
};

export type FunnelTrafficControllerScopeCampaignOptionsResponse = FunnelTrafficControllerScopeCampaignOptionsResponses[keyof FunnelTrafficControllerScopeCampaignOptionsResponses];

export type FunnelTrafficControllerEstimateScopeCampaignOptionsData = {
    body: FunnelTrafficScopeOptionsQueryDto;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/campaign-options/estimate';
};

export type FunnelTrafficControllerEstimateScopeCampaignOptionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerEstimateScopeCampaignOptionsError = FunnelTrafficControllerEstimateScopeCampaignOptionsErrors[keyof FunnelTrafficControllerEstimateScopeCampaignOptionsErrors];

export type FunnelTrafficControllerEstimateScopeCampaignOptionsResponses = {
    200: FunnelTrafficEstimateDto;
};

export type FunnelTrafficControllerEstimateScopeCampaignOptionsResponse = FunnelTrafficControllerEstimateScopeCampaignOptionsResponses[keyof FunnelTrafficControllerEstimateScopeCampaignOptionsResponses];

export type FunnelTrafficControllerSegmentsData = {
    body: FunnelTrafficSegmentsQueryDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/funnel-traffic/pipes/{pipeId}/segments';
};

export type FunnelTrafficControllerSegmentsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerSegmentsError = FunnelTrafficControllerSegmentsErrors[keyof FunnelTrafficControllerSegmentsErrors];

export type FunnelTrafficControllerSegmentsResponses = {
    200: FunnelTrafficSegmentsDto;
};

export type FunnelTrafficControllerSegmentsResponse = FunnelTrafficControllerSegmentsResponses[keyof FunnelTrafficControllerSegmentsResponses];

export type FunnelTrafficControllerEstimateSegmentsData = {
    body: FunnelTrafficSegmentsQueryDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/funnel-traffic/pipes/{pipeId}/segments/estimate';
};

export type FunnelTrafficControllerEstimateSegmentsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerEstimateSegmentsError = FunnelTrafficControllerEstimateSegmentsErrors[keyof FunnelTrafficControllerEstimateSegmentsErrors];

export type FunnelTrafficControllerEstimateSegmentsResponses = {
    200: FunnelTrafficEstimateDto;
};

export type FunnelTrafficControllerEstimateSegmentsResponse = FunnelTrafficControllerEstimateSegmentsResponses[keyof FunnelTrafficControllerEstimateSegmentsResponses];

export type FunnelTrafficControllerArrivalAnswersData = {
    body: FunnelTrafficArrivalQueryDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/funnel-traffic/pipes/{pipeId}/arrival-answers';
};

export type FunnelTrafficControllerArrivalAnswersErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerArrivalAnswersError = FunnelTrafficControllerArrivalAnswersErrors[keyof FunnelTrafficControllerArrivalAnswersErrors];

export type FunnelTrafficControllerArrivalAnswersResponses = {
    200: FunnelTrafficArrivalAnswersDto;
};

export type FunnelTrafficControllerArrivalAnswersResponse = FunnelTrafficControllerArrivalAnswersResponses[keyof FunnelTrafficControllerArrivalAnswersResponses];

export type FunnelTrafficControllerEstimateArrivalAnswersData = {
    body: FunnelTrafficArrivalQueryDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/funnel-traffic/pipes/{pipeId}/arrival-answers/estimate';
};

export type FunnelTrafficControllerEstimateArrivalAnswersErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerEstimateArrivalAnswersError = FunnelTrafficControllerEstimateArrivalAnswersErrors[keyof FunnelTrafficControllerEstimateArrivalAnswersErrors];

export type FunnelTrafficControllerEstimateArrivalAnswersResponses = {
    200: FunnelTrafficEstimateDto;
};

export type FunnelTrafficControllerEstimateArrivalAnswersResponse = FunnelTrafficControllerEstimateArrivalAnswersResponses[keyof FunnelTrafficControllerEstimateArrivalAnswersResponses];

export type FunnelTrafficControllerAnswerCombinationsData = {
    body: FunnelTrafficCombinationsQueryDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/funnel-traffic/pipes/{pipeId}/answer-combinations';
};

export type FunnelTrafficControllerAnswerCombinationsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerAnswerCombinationsError = FunnelTrafficControllerAnswerCombinationsErrors[keyof FunnelTrafficControllerAnswerCombinationsErrors];

export type FunnelTrafficControllerAnswerCombinationsResponses = {
    200: FunnelTrafficCombinationsDto;
};

export type FunnelTrafficControllerAnswerCombinationsResponse = FunnelTrafficControllerAnswerCombinationsResponses[keyof FunnelTrafficControllerAnswerCombinationsResponses];

export type FunnelTrafficControllerEstimateAnswerCombinationsData = {
    body: FunnelTrafficCombinationsQueryDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/funnel-traffic/pipes/{pipeId}/answer-combinations/estimate';
};

export type FunnelTrafficControllerEstimateAnswerCombinationsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerEstimateAnswerCombinationsError = FunnelTrafficControllerEstimateAnswerCombinationsErrors[keyof FunnelTrafficControllerEstimateAnswerCombinationsErrors];

export type FunnelTrafficControllerEstimateAnswerCombinationsResponses = {
    200: FunnelTrafficEstimateDto;
};

export type FunnelTrafficControllerEstimateAnswerCombinationsResponse = FunnelTrafficControllerEstimateAnswerCombinationsResponses[keyof FunnelTrafficControllerEstimateAnswerCombinationsResponses];

export type FunnelTrafficControllerSetupStateData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/setup';
};

export type FunnelTrafficControllerSetupStateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerSetupStateError = FunnelTrafficControllerSetupStateErrors[keyof FunnelTrafficControllerSetupStateErrors];

export type FunnelTrafficControllerSetupStateResponses = {
    200: FunnelTrafficSetupDto;
};

export type FunnelTrafficControllerSetupStateResponse = FunnelTrafficControllerSetupStateResponses[keyof FunnelTrafficControllerSetupStateResponses];

export type FunnelTrafficControllerCheckData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/setup/check';
};

export type FunnelTrafficControllerCheckErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerCheckError = FunnelTrafficControllerCheckErrors[keyof FunnelTrafficControllerCheckErrors];

export type FunnelTrafficControllerCheckResponses = {
    200: FunnelTrafficCheckResultDto;
};

export type FunnelTrafficControllerCheckResponse = FunnelTrafficControllerCheckResponses[keyof FunnelTrafficControllerCheckResponses];

export type FunnelTrafficControllerRunOrdersCheckData = {
    body: FunnelTrafficOrdersCheckQueryDto;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/orders-check';
};

export type FunnelTrafficControllerRunOrdersCheckErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerRunOrdersCheckError = FunnelTrafficControllerRunOrdersCheckErrors[keyof FunnelTrafficControllerRunOrdersCheckErrors];

export type FunnelTrafficControllerRunOrdersCheckResponses = {
    200: FunnelTrafficOrdersCheckDto;
};

export type FunnelTrafficControllerRunOrdersCheckResponse = FunnelTrafficControllerRunOrdersCheckResponses[keyof FunnelTrafficControllerRunOrdersCheckResponses];

export type FunnelTrafficControllerEstimateOrdersCheckData = {
    body: FunnelTrafficOrdersCheckQueryDto;
    path?: never;
    query?: never;
    url: '/api/funnel-traffic/orders-check/estimate';
};

export type FunnelTrafficControllerEstimateOrdersCheckErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type FunnelTrafficControllerEstimateOrdersCheckError = FunnelTrafficControllerEstimateOrdersCheckErrors[keyof FunnelTrafficControllerEstimateOrdersCheckErrors];

export type FunnelTrafficControllerEstimateOrdersCheckResponses = {
    200: FunnelTrafficEstimateDto;
};

export type FunnelTrafficControllerEstimateOrdersCheckResponse = FunnelTrafficControllerEstimateOrdersCheckResponses[keyof FunnelTrafficControllerEstimateOrdersCheckResponses];

export type AgentChangesControllerGetBatchData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/agent-changes/batches/{id}';
};

export type AgentChangesControllerGetBatchErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type AgentChangesControllerGetBatchError = AgentChangesControllerGetBatchErrors[keyof AgentChangesControllerGetBatchErrors];

export type AgentChangesControllerGetBatchResponses = {
    200: AgentChangeBatchDto;
};

export type AgentChangesControllerGetBatchResponse = AgentChangesControllerGetBatchResponses[keyof AgentChangesControllerGetBatchResponses];

export type PipeAgentControllerGetModelOptionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/pipe-agent/model-options';
};

export type PipeAgentControllerGetModelOptionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerGetModelOptionsError = PipeAgentControllerGetModelOptionsErrors[keyof PipeAgentControllerGetModelOptionsErrors];

export type PipeAgentControllerGetModelOptionsResponses = {
    200: AgentModelOptionsDto;
};

export type PipeAgentControllerGetModelOptionsResponse = PipeAgentControllerGetModelOptionsResponses[keyof PipeAgentControllerGetModelOptionsResponses];

export type PipeAgentControllerListSessionsData = {
    body?: never;
    path?: never;
    query: {
        /**
         * List the caller’s sessions for this pipe.
         */
        pipeId: number;
    };
    url: '/api/pipe-agent/sessions';
};

export type PipeAgentControllerListSessionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerListSessionsError = PipeAgentControllerListSessionsErrors[keyof PipeAgentControllerListSessionsErrors];

export type PipeAgentControllerListSessionsResponses = {
    200: Array<AgentSessionDto>;
};

export type PipeAgentControllerListSessionsResponse = PipeAgentControllerListSessionsResponses[keyof PipeAgentControllerListSessionsResponses];

export type PipeAgentControllerCreateSessionData = {
    body: CreateAgentSessionDto;
    path?: never;
    query?: never;
    url: '/api/pipe-agent/sessions';
};

export type PipeAgentControllerCreateSessionErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerCreateSessionError = PipeAgentControllerCreateSessionErrors[keyof PipeAgentControllerCreateSessionErrors];

export type PipeAgentControllerCreateSessionResponses = {
    201: AgentSessionDto;
};

export type PipeAgentControllerCreateSessionResponse = PipeAgentControllerCreateSessionResponses[keyof PipeAgentControllerCreateSessionResponses];

export type PipeAgentControllerGetSessionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipe-agent/sessions/{id}';
};

export type PipeAgentControllerGetSessionErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerGetSessionError = PipeAgentControllerGetSessionErrors[keyof PipeAgentControllerGetSessionErrors];

export type PipeAgentControllerGetSessionResponses = {
    200: AgentSessionDto;
};

export type PipeAgentControllerGetSessionResponse = PipeAgentControllerGetSessionResponses[keyof PipeAgentControllerGetSessionResponses];

export type PipeAgentControllerSwitchModelData = {
    body: SwitchAgentSessionModelDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipe-agent/sessions/{id}/model';
};

export type PipeAgentControllerSwitchModelErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerSwitchModelError = PipeAgentControllerSwitchModelErrors[keyof PipeAgentControllerSwitchModelErrors];

export type PipeAgentControllerSwitchModelResponses = {
    200: AgentSessionDto;
};

export type PipeAgentControllerSwitchModelResponse = PipeAgentControllerSwitchModelResponses[keyof PipeAgentControllerSwitchModelResponses];

export type PipeAgentControllerSendMessageData = {
    body: SendAgentMessageDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipe-agent/sessions/{id}/messages';
};

export type PipeAgentControllerSendMessageErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerSendMessageError = PipeAgentControllerSendMessageErrors[keyof PipeAgentControllerSendMessageErrors];

export type PipeAgentControllerSendMessageResponses = {
    201: AgentSessionDto;
};

export type PipeAgentControllerSendMessageResponse = PipeAgentControllerSendMessageResponses[keyof PipeAgentControllerSendMessageResponses];

export type PipeAgentControllerRespondToPromptData = {
    body: AgentPromptResponseDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipe-agent/sessions/{id}/prompt-response';
};

export type PipeAgentControllerRespondToPromptErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerRespondToPromptError = PipeAgentControllerRespondToPromptErrors[keyof PipeAgentControllerRespondToPromptErrors];

export type PipeAgentControllerRespondToPromptResponses = {
    201: AgentSessionDto;
};

export type PipeAgentControllerRespondToPromptResponse = PipeAgentControllerRespondToPromptResponses[keyof PipeAgentControllerRespondToPromptResponses];

export type PipeAgentControllerContinueRunData = {
    body: AgentRunOptionsDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipe-agent/sessions/{id}/continue';
};

export type PipeAgentControllerContinueRunErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerContinueRunError = PipeAgentControllerContinueRunErrors[keyof PipeAgentControllerContinueRunErrors];

export type PipeAgentControllerContinueRunResponses = {
    201: AgentSessionDto;
};

export type PipeAgentControllerContinueRunResponse = PipeAgentControllerContinueRunResponses[keyof PipeAgentControllerContinueRunResponses];

export type PipeAgentControllerResumeData = {
    body: AgentRunOptionsDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipe-agent/sessions/{id}/resume';
};

export type PipeAgentControllerResumeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerResumeError = PipeAgentControllerResumeErrors[keyof PipeAgentControllerResumeErrors];

export type PipeAgentControllerResumeResponses = {
    201: AgentSessionDto;
};

export type PipeAgentControllerResumeResponse = PipeAgentControllerResumeResponses[keyof PipeAgentControllerResumeResponses];

export type PipeAgentControllerStopData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/pipe-agent/sessions/{id}/stop';
};

export type PipeAgentControllerStopErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeAgentControllerStopError = PipeAgentControllerStopErrors[keyof PipeAgentControllerStopErrors];

export type PipeAgentControllerStopResponses = {
    201: AgentSessionDto;
};

export type PipeAgentControllerStopResponse = PipeAgentControllerStopResponses[keyof PipeAgentControllerStopResponses];

export type RuleGroupsControllerListData = {
    body?: never;
    path?: never;
    query?: {
        brandId?: number;
        pipeId?: number;
        group?: ConstVarGroup;
        search?: string;
        page?: number;
        pageSize?: number;
    };
    url: '/api/rule-groups';
};

export type RuleGroupsControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type RuleGroupsControllerListError = RuleGroupsControllerListErrors[keyof RuleGroupsControllerListErrors];

export type RuleGroupsControllerListResponses = {
    200: RuleGroupListResponseDto;
};

export type RuleGroupsControllerListResponse = RuleGroupsControllerListResponses[keyof RuleGroupsControllerListResponses];

export type RuleGroupsControllerCreateData = {
    body: CreateRuleGroupDto;
    path?: never;
    query?: never;
    url: '/api/rule-groups';
};

export type RuleGroupsControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type RuleGroupsControllerCreateError = RuleGroupsControllerCreateErrors[keyof RuleGroupsControllerCreateErrors];

export type RuleGroupsControllerCreateResponses = {
    200: RuleGroupDto;
};

export type RuleGroupsControllerCreateResponse = RuleGroupsControllerCreateResponses[keyof RuleGroupsControllerCreateResponses];

export type RuleGroupsControllerFindForPipeData = {
    body?: never;
    path?: never;
    query?: {
        brandId?: number;
        pipeId?: number;
        group?: ConstVarGroup;
        search?: string;
        page?: number;
        pageSize?: number;
    };
    url: '/api/rule-groups/for-pipe';
};

export type RuleGroupsControllerFindForPipeErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type RuleGroupsControllerFindForPipeError = RuleGroupsControllerFindForPipeErrors[keyof RuleGroupsControllerFindForPipeErrors];

export type RuleGroupsControllerFindForPipeResponses = {
    200: Array<RuleGroupDto>;
};

export type RuleGroupsControllerFindForPipeResponse = RuleGroupsControllerFindForPipeResponses[keyof RuleGroupsControllerFindForPipeResponses];

export type RuleGroupsControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/rule-groups/{id}';
};

export type RuleGroupsControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type RuleGroupsControllerRemoveError = RuleGroupsControllerRemoveErrors[keyof RuleGroupsControllerRemoveErrors];

export type RuleGroupsControllerRemoveResponses = {
    200: RuleGroupDto;
};

export type RuleGroupsControllerRemoveResponse = RuleGroupsControllerRemoveResponses[keyof RuleGroupsControllerRemoveResponses];

export type RuleGroupsControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/rule-groups/{id}';
};

export type RuleGroupsControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type RuleGroupsControllerFindOneError = RuleGroupsControllerFindOneErrors[keyof RuleGroupsControllerFindOneErrors];

export type RuleGroupsControllerFindOneResponses = {
    200: RuleGroupDto;
};

export type RuleGroupsControllerFindOneResponse = RuleGroupsControllerFindOneResponses[keyof RuleGroupsControllerFindOneResponses];

export type RuleGroupsControllerUpdateData = {
    body: UpdateRuleGroupDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/rule-groups/{id}';
};

export type RuleGroupsControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type RuleGroupsControllerUpdateError = RuleGroupsControllerUpdateErrors[keyof RuleGroupsControllerUpdateErrors];

export type RuleGroupsControllerUpdateResponses = {
    200: RuleGroupDto;
};

export type RuleGroupsControllerUpdateResponse = RuleGroupsControllerUpdateResponses[keyof RuleGroupsControllerUpdateResponses];

export type RuleGroupsControllerListRevisionsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        skip?: number;
        take?: number;
    };
    url: '/api/rule-groups/{id}/revisions';
};

export type RuleGroupsControllerListRevisionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type RuleGroupsControllerListRevisionsError = RuleGroupsControllerListRevisionsErrors[keyof RuleGroupsControllerListRevisionsErrors];

export type RuleGroupsControllerListRevisionsResponses = {
    200: EntityRevisionListDto;
};

export type RuleGroupsControllerListRevisionsResponse = RuleGroupsControllerListRevisionsResponses[keyof RuleGroupsControllerListRevisionsResponses];

export type PriceCategoriesControllerListData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Search by category name (partial)
         */
        search?: string;
        /**
         * Page number
         */
        page?: number;
        /**
         * Page size
         */
        pageSize?: number;
    };
    url: '/api/price-categories';
};

export type PriceCategoriesControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerListError = PriceCategoriesControllerListErrors[keyof PriceCategoriesControllerListErrors];

export type PriceCategoriesControllerListResponses = {
    200: PriceCategoryListDto;
};

export type PriceCategoriesControllerListResponse = PriceCategoriesControllerListResponses[keyof PriceCategoriesControllerListResponses];

export type PriceCategoriesControllerCreateData = {
    body: CreatePriceCategoryDto;
    path?: never;
    query?: never;
    url: '/api/price-categories';
};

export type PriceCategoriesControllerCreateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerCreateError = PriceCategoriesControllerCreateErrors[keyof PriceCategoriesControllerCreateErrors];

export type PriceCategoriesControllerCreateResponses = {
    200: PriceCategoryDto;
};

export type PriceCategoriesControllerCreateResponse = PriceCategoriesControllerCreateResponses[keyof PriceCategoriesControllerCreateResponses];

export type PriceCategoriesControllerKeysData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/price-categories/keys';
};

export type PriceCategoriesControllerKeysErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerKeysError = PriceCategoriesControllerKeysErrors[keyof PriceCategoriesControllerKeysErrors];

export type PriceCategoriesControllerKeysResponses = {
    200: unknown;
};

export type PriceCategoriesControllerRemoveData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/price-categories/{id}';
};

export type PriceCategoriesControllerRemoveErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerRemoveError = PriceCategoriesControllerRemoveErrors[keyof PriceCategoriesControllerRemoveErrors];

export type PriceCategoriesControllerRemoveResponses = {
    200: unknown;
};

export type PriceCategoriesControllerFindOneData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/price-categories/{id}';
};

export type PriceCategoriesControllerFindOneErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerFindOneError = PriceCategoriesControllerFindOneErrors[keyof PriceCategoriesControllerFindOneErrors];

export type PriceCategoriesControllerFindOneResponses = {
    200: PriceCategoryDto;
};

export type PriceCategoriesControllerFindOneResponse = PriceCategoriesControllerFindOneResponses[keyof PriceCategoriesControllerFindOneResponses];

export type PriceCategoriesControllerUpdateData = {
    body: UpdatePriceCategoryDto;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/price-categories/{id}';
};

export type PriceCategoriesControllerUpdateErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerUpdateError = PriceCategoriesControllerUpdateErrors[keyof PriceCategoriesControllerUpdateErrors];

export type PriceCategoriesControllerUpdateResponses = {
    200: PriceCategoryDto;
};

export type PriceCategoriesControllerUpdateResponse = PriceCategoriesControllerUpdateResponses[keyof PriceCategoriesControllerUpdateResponses];

export type PriceCategoriesControllerCurrenciesData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/price-categories/{id}/currencies';
};

export type PriceCategoriesControllerCurrenciesErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerCurrenciesError = PriceCategoriesControllerCurrenciesErrors[keyof PriceCategoriesControllerCurrenciesErrors];

export type PriceCategoriesControllerCurrenciesResponses = {
    200: PriceCategoryCurrenciesDto;
};

export type PriceCategoriesControllerCurrenciesResponse = PriceCategoriesControllerCurrenciesResponses[keyof PriceCategoriesControllerCurrenciesResponses];

export type PriceCategoriesControllerListRevisionsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        skip?: number;
        take?: number;
    };
    url: '/api/price-categories/{id}/revisions';
};

export type PriceCategoriesControllerListRevisionsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerListRevisionsError = PriceCategoriesControllerListRevisionsErrors[keyof PriceCategoriesControllerListRevisionsErrors];

export type PriceCategoriesControllerListRevisionsResponses = {
    200: EntityRevisionListDto;
};

export type PriceCategoriesControllerListRevisionsResponse = PriceCategoriesControllerListRevisionsResponses[keyof PriceCategoriesControllerListRevisionsResponses];

export type PriceCategoriesControllerUsageData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/price-categories/{id}/usage';
};

export type PriceCategoriesControllerUsageErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerUsageError = PriceCategoriesControllerUsageErrors[keyof PriceCategoriesControllerUsageErrors];

export type PriceCategoriesControllerUsageResponses = {
    200: PriceCategoryUsageDto;
};

export type PriceCategoriesControllerUsageResponse = PriceCategoriesControllerUsageResponses[keyof PriceCategoriesControllerUsageResponses];

export type PriceCategoriesControllerConvertOfferGroupsData = {
    body: ConvertOfferGroupsDto;
    path?: never;
    query?: never;
    url: '/api/price-categories/from-offer-groups';
};

export type PriceCategoriesControllerConvertOfferGroupsErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PriceCategoriesControllerConvertOfferGroupsError = PriceCategoriesControllerConvertOfferGroupsErrors[keyof PriceCategoriesControllerConvertOfferGroupsErrors];

export type PriceCategoriesControllerConvertOfferGroupsResponses = {
    200: ConvertOfferGroupsResultDto;
};

export type PriceCategoriesControllerConvertOfferGroupsResponse = PriceCategoriesControllerConvertOfferGroupsResponses[keyof PriceCategoriesControllerConvertOfferGroupsResponses];

export type PipeUsageControllerReportData = {
    body: PipeUsageBufferDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/pipes/{pipeId}/usage/report';
};

export type PipeUsageControllerReportErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeUsageControllerReportError = PipeUsageControllerReportErrors[keyof PipeUsageControllerReportErrors];

export type PipeUsageControllerReportResponses = {
    200: PipeUsageReportDto;
};

export type PipeUsageControllerReportResponse = PipeUsageControllerReportResponses[keyof PipeUsageControllerReportResponses];

export type PipeUsageControllerDeleteData = {
    body: PipeUsageDeleteDto;
    path: {
        pipeId: number;
    };
    query?: never;
    url: '/api/pipes/{pipeId}/usage/delete';
};

export type PipeUsageControllerDeleteErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type PipeUsageControllerDeleteError = PipeUsageControllerDeleteErrors[keyof PipeUsageControllerDeleteErrors];

export type PipeUsageControllerDeleteResponses = {
    200: PipeUsageDeleteResultDto;
};

export type PipeUsageControllerDeleteResponse = PipeUsageControllerDeleteResponses[keyof PipeUsageControllerDeleteResponses];

export type ChangelogControllerListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/changelog';
};

export type ChangelogControllerListErrors = {
    400: ErrorResponse400;
    /**
     * Internal server error
     */
    500: unknown;
};

export type ChangelogControllerListError = ChangelogControllerListErrors[keyof ChangelogControllerListErrors];

export type ChangelogControllerListResponses = {
    200: ChangelogDto;
};

export type ChangelogControllerListResponse = ChangelogControllerListResponses[keyof ChangelogControllerListResponses];
